export default {
  "termsOfUse": "Terms of use",
  "goToHome": "Return to the main page",
  "choose": "Choose",
  "close": "Close",
  "yes": "Yes",
  "no": "No",
  "moreInfo": "More information",
  "send": "Send",
  "sendProcess": "Sending",
  "sendSuccess": "Sent",
  "freeDownload": "Download our mobile application for free",
  "month": "Month",
  "year": "Year",
  "other": "Other",
  "backToStart": "Back to the start",
  "backToOverview": "Back to main menu",
  "or": "or",
  "czechLanguage": "Czech",
  "slovakLanguage": "Slovak",
  "englishLanguage": "English",
  "goNext": "Continue",
  "save": "Save",
  "show": "Show",
  "showAll": "Show all",
  "saveChanges": "Save changes",
  "saveChangesProcess": "Saving",
  "saveChangesSuccess": "Saved",
  "loginText": "Log in",
  "contact": "Contact",
  "done": "Finished",
  "finish": "Finish",
  "skip": "Skip",
  "legalDocuments": "Legal documents",
  "new": "New",
  "free": "Free of charge",
  "until": "by",
  "pilot": "Video call",
  "here": "here",
  "subscribe": "Subscribe",
  "agree": "I agree",
  "disagree": "I disagree",
  "alertInfo": {
    "title": "The uLékaře.cz service does not replace the emergency service.",
    "text": "In case of acute problems, call 155.",
    "iAgree": "Got it",
    "errorText": "This field is required."
  },
  "uLekare": {
    "title": "uLékaře.cz"
  },
  "partners": {
    "otherPartners": "Partners"
  },
  "questionForm": {
    "title": "Online Consultation",
    "subtitle": "What's troubling you, for how long, are you taking any medication, have you already been examined, ...",
    "modalTitle": "Attach photos, medical reports or any results.",
    "send": "Send to the doctor",
    "back": "Back to question",
    "sendTitle": "Your question has been sent",
    "next": "Continue",
    "question": {
      "placeholder": "Describe your problem here",
      "errorText": "You must ask the doctor a question, please fill it in."
    },
    "firstName": {
      "title": "First name",
      "placeholder": "Enter the name",
      "helpTextNotShowing": "Your first name",
      "errorText": "First name is required, please, fill it out.",
      "helpTextRealData": "Enter your real name for communication with the healthcare facility."
    },
    "lastName": {
      "title": "Last name",
      "placeholder": "Enter the surname",
      "helpText": "Your surname",
      "errorText": "Last name is required, please, fill it out.",
      "helpTextRealData": "Enter your real surname for communication with the healthcare facility."
    },
    "email": {
      "title": "Email",
      "placeholder": "name@example.cz",
      "helpText": "Our doctors will contact you by email.",
      "hrbHelpText": "We recommend entering a private email.",
      "errorText": "An email address is required, please, fill it out.",
      "errorEmailText": "The email address is in incorrect format.",
      "errorEmailNotExisting": "Please, enter the already existing email address.",
      "invalidBenefitEmail": "Invalid email"
    },
    "phone": {
      "title": "Phone number",
      "placeholder": "123 456 789",
      "helpText": "Our nurses will call you to book medical appointments",
      "errorText": "The phone number is required, please, fill it out.",
      "errorPhoneText": "Enter your phone number ({exampleNumber})."
    },
    "birthYear": {
      "title": "Year of birth",
      "titleRegistered": "Patient´s year of birth",
      "helpText": "Birth year of the person you are asking about.",
      "errorText": "Year of birth is required, please, fill it out.",
      "errorLengthText": "Write the year of birth in a four-digit year format",
      "errorBetweenText": "Write the actual year of birth"
    },
    "zipCode": {
      "title": "ZIP code",
      "helpText": "We will recommend where to schedule your appointment based on your ZIP code.",
      "errorText": "ZIP code is required, please, fill it out.",
      "errorZipCodeText": "ZIP code is in incorrect format."
    },
    "insuranceCompany": {
      "title": "Insurance company",
      "errorText": "It is required to fill in your insurance company",
      "selectInsuranceCompany": "Choose your insurance company"
    },
    "thankYou": {
      "title": "The question has been sent.",
      "perex": "Thank you for submitting your question. You will be notified once it has been answered."
    }
  },
  "fileUpload": {
    "initial": "Click to select files or drag and drop them.",
    "send": "Send",
    "uploadAgain": "Try again, please.",
    "addFiles": "Add photos, medical reports or results.",
    "acceptedTypes": "Allowed types are images (.jpg, .png). Maximum file size is 20 MB, maximum total size of all files is 100 MB.",
    "typeError": "FIle type not supported. Please upload the files in the specified formats .jpg, .png.",
    "sizeError": "Maximum allowed size exceeded. The maximum allowed file size is 20 MB, the maximum allowed size of all files together is 100 MB.",
    "totalSizeError": "The maximum total file size is 100 MB."
  },
  "footer": {
    "copyright": "&copy; 2007-{thisYear} uLékaře.cz, s.r.o.",
    "issn": "ISSN 1802-5544",
    "companyTitle": "The company uLékaře.cz",
    "companyList": [
      {
        "title": "Contact"
      },
      {
        "title": "Career",
        "linkType": "external",
        "target": "_blank",
        "forCompanies": "false"
      },
      {
        "title": "Advertising",
        "link": "https://www.ulekare.cz/inzerce",
        "linkType": "external",
        "target": "_blank",
        "forCompanies": "false"
      },
      {
        "title": "Health and prevention in the workplace",
        "partnerLink": "forCompanies",
        "thematicCounsellingLink": "forCompanies",
        "target": "_blank",
        "forCompanies": "false"
      },
      {
        "title": "Principles of personal data processing",
        "link": "personalDataProcessing",
        "partnerLink": "hrbPersonalDataProcessing",
        "thematicCounsellingLink": "thematicCounsellingPersonalDataProcessing",
        "forCompaniesLink": "forCompaniesPersonalDataProcessing"
      },
      {
        "title": "Terms of use",
        "link": "termsAndConditions",
        "partnerLink": "hrbTermsAndConditions",
        "thematicCounsellingLink": "thematicCounsellingTermsAndConditions",
        "forCompaniesLink": "forCompaniesTermsAndConditions"
      },
      {
        "title": "Cookies Policy",
        "link": "cookies",
        "partnerLink": "hrbCookies",
        "thematicCounsellingLink": "thematicCounsellingCookies",
        "forCompaniesLink": "forCompaniesCookies"
      },
      {
        "title": "Security",
        "link": "security"
      }
    ],
    "perex": {
      "forCompanies": "At the uLékaře.cz Virtual Hospital, we believe that health is yours. We help people manage their health through technology, a human touch, and medical expertise. Every day, our team of 350+ doctors of all specializations is available to more than 100,000 employees."
    },
    "mottos": [
      "A human touch",
      "Enthusiasm",
      "Expertise",
      "Innovation"
    ]
  },
  "dataProcessing": {
    "iAgree": "I agree to",
    "iAgreeWith": "I agree to",
    "privacyPolicy": "the processing of personal data",
    "privacyPolicyTitle": "Consent to the processing of my personal data, including special categories of personal data.",
    "newsletterProcessing": "receive news and information about discounts from uLékaře.cz.",
    "newsletterText": "I agree with receiving the uLékaře.cz Newsletter (news about the company and uLékaře.cz project or about the products and services of cooperating third parties). You can withdraw your consent by selecting this option in the Newsletter or at the address <a href='mailto:osobniudaje@ulekare.cz'>osobniudaje@ulekare.cz</a>.",
    "conferenceNewsletterAgreement": "being sent messages regarding conferences",
    "conferenceNewsletterTitle": "Consent to being sent informational emails (newsletters)",
    "conferenceDataTitle": "I consent to the processing of personal data.",
    "termsConditions": " the Terms of Use",
    "privacyPolicyInAccordance": "We process your data in accordance with the"
  },
  "termsAndConditions": {
    "title": "Terms of use"
  },
  "personalDataProcessing": {
    "title": "Consent to the processing of personal data"
  },
  "newsletter": {
    "title": "Newsletter agreement"
  },
  "error": {
    "universal": "An error occurred",
    "sms": "Current sms delivery time is 5&nbsp;minutes max. Thank you for your patience."
  },
  "errorLayout": {
    "title": "Oops! Something happened.",
    "text": "Sorry, this service is temporarily unavailable. We're working on fixing it. Please try again later.",
    "button": "Back to main page"
  },
  "meta": {
    "partnerNavigation": {
      "title": "Partner navigation"
    },
    "cookies": {
      "title": "Cookie statement"
    },
    "termsAndConditions": {
      "title": "Terms of use"
    },
    "personalDataProcessing": {
      "title": "Principles of personal data processing"
    },
    "emergency": {
      "title": "Emergency",
      "description": "The brief list of acute or life-threatening conditions that we want to alert the patients in order to direct the most urgent cases to emergency care."
    },
    "evaluation": {
      "order": {
        "title": "Doctor visit evaluation",
        "description": "Doctor visit evaluation"
      }
    },
    "mastercard": {
      "title": "Mastercard"
    },
    "sporthelp": {
      "title": "SportHelp"
    },
    "overview": {
      "title": "We offer help, we schedule appointments for you, and we promote health",
      "description": "Ask our medical professionals about your health problems or let us schedule a medical appointment straightaway. We help you to take care of your health. We are online, free and always available."
    },
    "hrbOrderPage": {
      "title": "We schedule you to a doctor",
      "description": "Are you looking for a doctor who examines you? Have you got no idea what doctor should you choose? Leave it up to us. We make appointments to medical professionals all over Czechia. It´s free and always available."
    },
    "hrbQuestionPage": {
      "title": "Ask in our online Consulting Room",
      "description": "Entrust yourself to our doctors, you will receive an answer to any of your questions regarding physical and mental health within 6 hours. Online, free and whenever you need."
    },
    "hrbPreventionPage": {
      "title": "The prevention",
      "description": "We help with prevention. Talk to our doctors about health care issues, get recommendations on prevention and schedule the necessary preventive examinations."
    },
    "login": {
      "title": "Login",
      "description": "Register and have 350 doctors of all specializations within reach. We'll help you schedule a doctor's appointment throughout the Czech Republic. To your health."
    },
    "aeskulab": {
      "title": "My lab results"
    },
    "dashboard": {
      "title": "Health online"
    },
    "dashboardQuestions": {
      "title": "Consultation"
    },
    "dashboardAppointments": {
      "title": "Doctor's appointment"
    },
    "dashboardArticles": {
      "title": "Discover Magazine"
    },
    "dashboardConsultations": {
      "title": "Answered by doctors"
    },
    "dashboardPrevention": {
      "title": "My prevention"
    },
    "dashboardProfile": {
      "title": "My health profile"
    },
    "lostPassword": {
      "title": "Forgot password"
    },
    "passwordReset": {
      "title": "Password reset"
    },
    "emailVerification": {
      "title": "Email verification"
    },
    "registration": {
      "title": "Registration"
    },
    "homepage": {
      "title": "uLékaře.cz - Healthy employees. From head to toe.",
      "description": "We create the healthiest work environments and provide top-notch data-driven health care. We systematically help companies maintain employee health over the long term."
    },
    "ePrescription": {
      "title": "How does ePrescription issuance work at ulékaře.cz",
      "description": "ePrescription rules..."
    }
  },
  "companies": {
    "menu": {
      "ourService": "Our services",
      "stories": "Reviews",
      "pricing": "Contact us",
      "faq": "FAQ",
      "iWant": "Health for my company"
    },
    "hero": {
      "title": "Health is every company's business",
      "subtitle": "An original employee benefit that makes caring for their health a lot simpler, saving both their and your company’s time.",
      "buttons": {
        "iWant": "Health for my company",
        "ourService": "Our services"
      },
      "items": [
        {
          "icon": "$checkCircle",
          "iconColor": "white",
          "text": "We give your employees health advice."
        },
        {
          "icon": "$checkCircle",
          "iconColor": "white",
          "text": "We arrange a doctor’s appointment, wherever."
        },
        {
          "icon": "$checkCircle",
          "iconColor": "white",
          "text": "We care for your healthy life - by prevention."
        }
      ]
    },
    "partnersCarousel": {
      "title": "We're trusted by both big and small",
      "subtitle": "+ more than 150 others"
    },
    "companyPresentation": {
      "title": "Our service",
      "benefitList": [
        {
          "icon": "doctor",
          "title": "350+ doctors of all specializations"
        },
        {
          "icon": "rodina",
          "title": "Care for the whole family"
        },
        {
          "icon": "clock",
          "title": "Over 14 years of experience"
        },
        {
          "icon": "phone",
          "title": "A convenient mobile app"
        },
        {
          "icon": "globus",
          "title": "We speak English too"
        }
      ],
      "boxContent": [
        {
          "image": "company_box_2.jpg",
          "text": "A general practitioner for adults or a pediatrician will answer your employee's question."
        },
        {
          "image": "company_box_1.jpg",
          "text": "We offer a second answer by a specialist, whenever needed. We cover all medical fields e.g. dermatology, orthopedics, gynecology, or psychology."
        },
        {
          "image": "company_box_3.jpg",
          "text": "If the doctor recommends the employee should see a doctor, our nurses will take care of everything. The place and date of the appointment are based on the employee's preferences."
        },
        {
          "image": "company_box_4.jpg",
          "text": "Our service includes arranging preventive check-ups and presentations at your company. We'll create materials for your internal communication on the topic of health."
        }
      ],
      "infoBox": {
        "title": "Did you know that...",
        "text": "With our service, your employees can avoid having to see a doctor in about 40 % of cases? Most health-related questions can be answered in their client zone, and we'll take care of everything else."
      }
    },
    "faq": {
      "title": "Frequently asked questions",
      "faqList": [
        {
          "title": "What can the uLékaře.cz Virtual Hospital do for your company?",
          "bodyText": "We know that when companies care for the health of their employees, it pays off. It saves time, reduces absenteeism, and ensures greater employee concentration and performance. With our service, employees can arrange everything quickly from wherever they want, and if they need to see a doctor, we'll make an appointment for a specific place and time.<br/><br/>We can provide employees advice remotely, plus often there's no need to see a doctor or waste time looking for information on the internet. We thus save the employer money that would otherwise be spent on the time an employee isn't working or on someone to do their work in their stead.<br/><br/>Prevention is the best approach, which is why we also provide a comprehensive preventive care programme and Health Days."
        },
        {
          "title": "What can the uLékaře.cz Virtual Hospital do for employees?",
          "bodyText": "The uLékaře.cz service has many benefits for users. After registering, they have access to 350 doctors of all specializations, including pediatricians and GPs, who are prepared to provide quick information regarding any health problem an employee or their family may be dealing with. Our team also has 50 nurses available on the phone to help find a new doctor or specialist where and when they are needed. Employees receive professional and discreet communication with a human touch from the entire medical team, in either Czech or English."
        },
        {
          "title": "How can I order the uLékaře.cz service for employees?",
          "bodyText": "If you have less than 100 employees, you can order the service for your company on-line. Our sales department is here for companies with a greater number of employees. We'll be happy to put together a quote for you."
        },
        {
          "title": "Does the service qualify for a tax credit?",
          "bodyText": "Yes, it is a tax-deductible expense under § 24 (1) of the Income Tax Act. According to the General Financial Directorate, it isn't a service provided to employees, but rather a service for the employer who can thus reduce employee absenteeism. This does not involve non-cash income for employees.<br/><br/>We are an on-line medical consultation service that is not a substitute for medical or other professional care. It involves providing advice and offering to find and make appointments with doctors and for examinations. Its goal is to properly direct patients so they receive care from the relevant specialist as soon as possible."
        },
        {
          "title": "How is service security ensured?",
          "bodyText": "Users make use of the uLékaře.cz Virtual Hospital service in their client zone, which is encrypted and therefore all health-related issues can be seen only by themselves and the doctor who is dealing with a given question. At the same time, we meet all the legislative requirements of the EU General Data Protection Regulation (GDPR) 2016/679 and we have obtained ISO/IEC 27001 certification in the field of information security management.<br/><br/>All requests are only dealt with by you and designated individuals on the uLékaře.cz team, or a medical facility of your choice. Even the doctor who is answering you sees, aside from your query, only your first name and age. Other information provided as part of your query can only be accessed by the medical team that is helping make your appointment or to further process your question. Your records are not shared with anyone else."
        },
        {
          "title": "Do employees have to change their GP after registering with the uLékaře.cz Virtual Hospital service?",
          "bodyText": "By registering with our service, you aren't changing your general practitioner. The doctors providing our consultation service will answer every query, and if the employee is interested, we'll make them an appointment with a doctor."
        },
        {
          "title": "Can this benefit shorten the waiting time for examinations, which are usually very long?",
          "bodyText": "Your appointment date always depends on how busy the health care system is. It depends on location and the capacity of local medical care. Often we're able to arrange the required examination more quickly than if you made the appointment yourself. This is because we make appointments with all medical facilities, both public and private, and have a very good overview of doctors' current capacities and waiting times throughout the Czech Republic."
        },
        {
          "title": "Will the employees pay the doctor you are making them an appointment with?",
          "bodyText": "It’s up to you. Our nurses can make appointments with both public and private medical facilities. They always look for the best doctor with respect to your preferred date and availability of doctors in the given specialization. You will be informed of any payment before you visit the doctor."
        },
        {
          "title": "Does the uLékaře.cz service arrange ePrescriptions?",
          "bodyText": "If you need an ePrescription, everything takes place as part of the brick-and-mortar care we make appointments for via uLékaře.cz. From the perspective of safe care and proper medication, this is the solution we currently prefer. For us, the most important thing is our clients' health."
        },
        {
          "title": "Can I also arrange the service for a manufacturing company?",
          "bodyText": "Yes, you can. Our service is for all employees regardless of the nature of the business or their job position. Our clients include both banks and manufacturers such as Continental, Unipetrol, Cemex, Metrans, MND, Ideal Standard, Lasvit, and many more."
        },
        {
          "title": "Can the service be offered to only a specific group of employees?",
          "bodyText": "We're proud of the fact that our service is for everyone. Our vision is the availability of our care to all. We know that we're helping everyone regardless of whether they're manual labourers or office workers. That's why we always offer our service only as a benefit for the entire company."
        },
        {
          "title": "How much work do HR personnel have to do on a regular basis in order for the service to be used by employees?",
          "bodyText": "Very little. After purchasing the service, it's important to let employees know that it's available and help them register so it's always at their disposal. We have communication materials available for this purpose that you can use. Once employees register in the client zone, we communicate directly with them."
        },
        {
          "title": "How will I know if my employees are using the service?",
          "bodyText": "From regular reports we'll send you. These include the number of employees registered for the service, the number of times individual services were used, as well as the most frequent specializations or regional use. Everything is of course fully anonymized."
        },
        {
          "title": "How do I pay?",
          "bodyText": "You start paying for the service once you sign the contract. We'll invoice you regularly at agreed-upon intervals."
        },
        {
          "title": "Can I change the services plan?",
          "bodyText": "Yes, you can change your plan at any time by writing <a href=\"mailto:zdravi@ulekare.cz\">zdravi@ulekare.cz</a>. Our corporate team will do what's needed."
        },
        {
          "title": "What if I want to cancel the contract?",
          "bodyText": "The contract is open-ended with a one-month notice period."
        }
      ]
    },
    "stories": [
      {
        "name": "Karolína Kašparová",
        "position": "Head of Operations, Bridgewater",
        "image": "karolina_kasparova.jpeg",
        "perex": "The uLékaře Virtual Hospital lets us consult a doctor regarding health problems in the entire family. The service is available 24 hours a day, can be anonymous, and can quickly connect the employee with the nearest doctor and arrange a personal consultation. Without having to sit around in a waiting room. Thank you."
      },
      {
        "name": "Radka Pučelíková",
        "position": "HR Manager, Aimtec",
        "image": "radka_pucelikova.png",
        "perex": "We introduced the service on 9 October 2018 as a benefit for all 185 employees. We appreciate that it saves time, addresses our employees' health problems (including when they're abroad), can find a specialist, teaches preventive behaviour, and covers their families too. We're glad that young people have also come to appreciate this service too."
      },
      {
        "name": "Scott Marlowe",
        "position": "HR Director, Česká Spořitelna",
        "image": "scott_marlowe.png",
        "perex": "The health of our employees is always an important topic for us. Since April 2020 we've been offering the uLékaře.cz Virtual hospital service to our employees and their families - 24-hour on-line medical consultation and the ability to make a doctor's appointment without the need for an in-person visit and long waiting times. We recommend it!"
      }
    ]
  },
  "conference": {
    "figureAlt": "\"HRajeme dál\" is an activity that helps incorporate caring for one's health and prevention among basic company strategies."
  },
  "emergency": {
    "title1": "When to seek emergency care",
    "perex": "This is a brief list of acute or life-threatening conditions that we want to alert the patients in order to direct the most urgent cases to an emergency care so to avoid delays in medical care by waiting for the doctor´s response in the online counselling. The utmost caution is needed in case of children.",
    "list": [
      {
        "title": "Injuries and bleeding",
        "body": [
          "heavy bleeding or <strong>bright red blood spurting from the wound</strong>",
          "heavy bleeding from the rectum or genital, in women heavy intermenstrual bleeding",
          "open or other obvious fracture",
          "<strong>open wound</strong> in chest or abdomen",
          "<strong>head injuries</strong> with loss of consciousness, behavioral changes, headache, vomiting, pupils of different sizes; speech, vision or movement disorders",
          "<strong>burns in children</strong>, especially on head and hands, genitals or on a larger area of the body of an adult",
          "injuries caused by an <strong>electric shock or lightning</strong>"
        ]
      },
      {
        "title": "Chest pain and chest sensations",
        "body": [
          "chest pain that <strong>persists</strong>, does not respond to common pain medications, escalating pain, crushing or searing pain and chest tightness",
          "<strong>pain that radiates</strong> into the left arm or neck",
          "pain or <strong>arrhythmia accompanied by changes of consciousness</strong>, fainting",
          "if you have similar symptoms repeatedly or you have a heart or circulatory system disease",
          "chest pain with shortness of breath and significant changes of blood pressure"
        ]
      },
      {
        "title": "Shortness of breath",
        "body": [
          "severe breathelessness, feeling <strong>shortness of breath</strong>",
          "<strong>gasping breath</strong> (fish breathing), wheezing or whistling exhale",
          "inability to finish the sentence without taking a breath, necessity to sit or lean on your hands to ease breathing, having to strain the chest muscles to breathe properly",
          "<strong>color changes</strong> of lips, ears or fingers into purple or blue"
        ]
      },
      {
        "title": "Headache",
        "body": [
          "<strong>unbearable, unusual, sudden</strong>, does not respond to medication",
          "wakes up at night or starts immediately after waking up",
          "sudden pain which was preceded by great physical exertion, including sexual activity",
          "pain accompanied by stiff neck, malaise, drowsiness, impaired consciousness, fever",
          "severe or worsening headache in the first following days after head injury, especially with impaired consciousness, vomiting, malaise",
          "accompanied <strong>by visual, speech and movement disorder</strong>"
        ]
      },
      {
        "title": "Abdominal pain and symptoms of indigestion",
        "body": [
          "<strong>severe or colic-like</strong> abdominal pain",
          "<strong>sudden inability to pass stool or gas</strong>, sharp pain",
          "black stool",
          "<strong>vomiting blood</strong>",
          "<strong>a lump on the abdomen</strong>, in the groin, on the testicles, which hurts, it cannot be pushed back (do not try to do it), has a different colour to the surrounding skin"
        ]
      },
      {
        "title": "Fainting, impaired consciousness, spasms",
        "body": [
          "sudden fainting, a fall after which a person does not wake up or behaves abnormally",
          "conditions with <strong>impaired consciousness, speech, vision, limb motility</strong>",
          "<strong>convulsions of a whole body</strong>"
        ]
      },
      {
        "title": "Infections and fevers",
        "body": [
          "conditions accompanied <strong>by fever above 40°C which cannot be reduced by the appropriate dose of medication</strong>",
          "<strong>chills in children, febrile seizure in children</strong>",
          "repeated <strong>uncontrollable vomiting and diarrhea in children</strong>, insufficient fluid intake in children",
          "infections accompanied by general changes in condition/behavior, such as excessive sleepiness, lethargy, inability to eat, drink"
        ]
      },
      {
        "title": "Allergies and swelling",
        "body": [
          "<strong>swelling of the face, neck and inside of the throat, swelling of the tongue</strong>",
          "<strong>shortness of breath</strong>",
          "<strong>difficulty swallowing</strong>",
          "whole-body symptoms such as rush or swelling",
          "unilateral, especially painful swelling of the limb, possibly accompanied by shortness of breath or dry cough"
        ]
      },
      {
        "title": "Dental emergency",
        "body": [
          "toothache with severe headache",
          "toothache with fever",
          "facial swelling on the affected side progressing to neck or accompanied by difficulty swallowing"
        ]
      },
      {
        "title": "Crimes",
        "body": [
          "If you’re being bullied, either physically or mentally, call 112",
          "if you suspect a crime, call 112",
          "should you or your family be in jeopardy due to a crime, call 112"
        ]
      },
      {
        "title": "Psyche",
        "body": [
          "in case of sudden confusion, behavioral changes, uncontrollable aggression, call an ambulance",
          "if you suspect an imminent suicide, call an ambulance"
        ]
      }
    ],
    "title2": "Call 155",
    "title": "When to seek emergency care"
  },
  "emergencyInfo": {
    "titleQuestion": "Before you ask a question",
    "titleonco-prevention": "Before you ask a question",
    "titleOrder": "Before you schedule an appointment",
    "subtitle": "Make sure that you don't have any of the following acute or life-threatening conditions.<br /><a href='{link}' target='_blank' class='black--text link--inline'>When to seek emergency care?</a>",
    "services": "In case of any acute or life-threatening conditions <a href=\"tel:155\" class=\"link--inline black--text\">call 155</a> or seek out emergency medical services immediately.",
    "continueQuestion": "Continue with your question",
    "continueOrder": "Continue with your appointment",
    "dynamicForms": {
      "text": "uLékaře.cz is not an emergency medical service. In life-threatening situations, call 155. {emergencyLink}",
      "linkText": "When to seek emergency care"
    }
  },
  "evaluation": {
    "title": "Feedback on the doctor's visit",
    "orderInfo": {
      "zz": "Medical Facility",
      "orderDate": "Date of booking",
      "doctor": "Doctor"
    },
    "error": {
      "title": "You can send the feedback on the doctor's visit only once.",
      "perex": "Thank you, we have already received your feedback."
    },
    "form": {
      "sendTitle": "Thank you for your feedback on the doctor's visit.",
      "title": "Were you satisfied with the doctor's visit?",
      "noVisit": "I did not visit the doctor.",
      "moreInfo": "More information",
      "evaluationError": "Please, send us your feedback.",
      "messageTitle": "Feel free to share with us anything else you would like to say."
    }
  },
  "partnerb2b": {
    "mastercard": {
      "hello": {
        "title": "On-line consultation service and&nbsp;scheduling a doctor’s appointment",
        "perex": "As the holder of a premium or company Mastercard<sup>®</sup> you can make full use of the services provided by uLékaře such as on-line consultation service, schedule an apoinment with doctors throughout the Czech Republic and take better are of your health."
      },
      "howItWorks": {
        "items": [
          {
            "icon": "chat",
            "title": "Ask whenever",
            "perex": "A doctor will answer your query within 12 hours.",
            "footer": "Often we're quicker."
          },
          {
            "icon": "calendar/date-31",
            "title": "Schedule an appointment with a doctor",
            "footer": "You can also schedule an appointment without submitting a query."
          }
        ]
      }
    },
    "eon": {
      "howItWorks": {
        "items": [
          {
            "title": "Ask whenever"
          }
        ]
      }
    },
    "sporthelp": {
      "hello": {
        "title": "Online medical consulation service and appointments to a doctor",
        "perex": "SportHelp is a comprehensive service for amateur sportsmen. It focuses primarily on caring for their health. Using the services of the Virtual Hospital uLékaře.cz is part of your SportHelp membership."
      },
      "howItWorks": {
        "items": [
          {
            "title": "Ask whenever"
          }
        ]
      },
      "question": {
        "perex": "One of our doctors will answer your query."
      },
      "faq": {
        "items": [
          {
            "title": "Can I ask about anything?",
            "bodyText": "YES, anything related to physical and mental health."
          },
          {
            "title": "Can you really schedule appointments with all doctors?",
            "bodyText": "YES, the nurses at uLékaře.cz can schedule you an appointment with a&nbsp;general practitioner and all specialists."
          },
          {
            "title": "Do have to switch doctors?",
            "bodyText": "NO, YOU DON’T, you can use our service to merely get an&nbsp;another medical opinion."
          },
          {
            "title": "Will my current doctor find out anything?",
            "bodyText": "NO, we never share your queries with anyone. Everything takes place on-line and solely between you and the doctor from the consultation service who is answering your question."
          },
          {
            "title": "Will I pay anything to use the service?",
            "bodyText": "No, using the uLékaře.cz Virtual Hospital service is part of your SportHelp membership."
          },
          {
            "title": "Will I pay something to the doctor you schedule me with?",
            "bodyText": "Nurses schedule appointments with both public and private healthcare facilities, and look for the best doctor with respect to your preferred date and availability of a&nbsp;doctor in the given specialization. You will be informed of any payments before you visit the&nbsp;doctor."
          },
          {
            "title": "How is confidentiality assured?",
            "bodyText": "Only the doctor answering your question will see the query, your first name, and age. Other information provided as part of your query can only be accessed by the medical team that is helping schedule your appointment or answering your query. Your queries/appointments are not shared with anyone else.<br/><br/> If you are attaching a medical report or other document, we recommend first blacking out visible personal information, and only then uploading it as an attachment to your query in order to maintain absolute anonymity on your end as well."
          },
          {
            "title": "But questions appear on the uLékaře.cz website, will mine be there too?",
            "bodyText": "No."
          },
          {
            "title": "Is using the service secure?",
            "bodyText": "YES, it is. The service complies with the&nbsp;General Data Protection Regulation&nbsp;(GDPR). All requests are only seen by you and designated individuals with the uLékaře.cz Virtual Hospital, or a medical facility you may choose."
          }
        ]
      }
    },
    "philips-sonicare": {
      "howItWorks": {
        "items": [
          {
            "title": "Ask whenever"
          }
        ]
      }
    }
  },
  "masterCard": {
    "faq": "Frequently asked questions",
    "useService": "Use service",
    "menu": {
      "question": "Query",
      "appointment": "Appointment",
      "contact": "Contact"
    },
    "howItWorks": {
      "title": "We're here for you non-stop",
      "items": [
        {
          "icon": "chat",
          "title": "Ask whenever",
          "perex": "A doctor will answer your query within 12 hours.",
          "footer": "Often we're quicker."
        },
        {
          "icon": "calendar/date-31",
          "title": "Schedule an appointment with a doctor",
          "perex": "A nurse will contact you, find a doctor, and schedule you an appointment.",
          "footer": "You can also schedule an appointment without submitting a query."
        }
      ]
    },
    "question": {
      "title": "Consult a doctor",
      "perex": "One of our doctors will answer your query."
    },
    "appointment": {
      "title": "Schedule an appointment with a doctor",
      "perex": "A nurse will contact you, find a doctor, and schedule you an appointment"
    },
    "authorization": {
      "title": "Mastercard<sup>®</sup> authorization",
      "subtitle": {
        "question": "We need to verify the first six digits of your <strong>Mastercard<sup>®</sup> Premium</strong>. No payment is involved, and after verification you will be able to use the services of the uLékaře.cz Virtual Hospital free of charge.",
        "appointment": "We need to verify the first six digits of your <strong>Mastercard<sup>®</sup> Premium</strong>. No payment is involved, and after verification you will be able to use the services of the uLékaře.cz Virtual Hospital free of charge."
      },
      "codeLabel": "Please enter the first 6 numbers from your card",
      "codeError": "The number entered is invalid. Please check that you are entering 6 numbers from your premium or company Mastercard<sup>®</sup>.",
      "sendButton": "Verify"
    }
  },
  "reauthorizationDashboard": {
    "heading": "Your free service will end in {daysLeft} days, on {dayFormat}.",
    "partnerText": "The uLékaře.cz service is still paid by {currentPartnerName}.",
    "prolongText": "Extend your uLékaře.cz benefits to keep them free.",
    "prolongFamilyText": "Remind your loved one that you would like to extend the service.",
    "buttonText": "Extend for free",
    "inDay": "day",
    "inDaysLow": "days",
    "inDaysHigh": "days",
    "selfPayNowHeading": "You're a self-payer now. But you don't have to be.",
    "selfPayNowPartnerText": "Who's gonna pay for uLékaře.cz? It could be your employer, insurance company, etc.",
    "selfPayNowProlongText": "Extend your benefits to get the service for free. Just like before.",
    "selfPayNowFamilyPartnerText": "Remind your loved one {currentPartnerName}.",
    "selfPayNowFamilyPartnerInfoText": "When they renew their uLékaře.cz service, you'll get all your benefits back for free."
  },
  "migraine": {
    "helloImageAlt": "Our specialized consultation service, the Migraine Line, can help you with headaches and other migraine-related symptoms. We'll give you advice on effective treatment options."
  },
  "psoriasis": {
    "helloImageAlt": "Our specialized consultation service, Outsmarting Psoriasis, will help you treat this disorder. We'll give you advice on effective treatment options."
  },
  "hrbPage": {
    "hello": {
      "title": "We're your guide to better health",
      "items": [
        {
          "text": "We're doctors working in every branch of medicine.",
          "icon": "doctor"
        },
        {
          "text": "We're available 24 hours a day, 7 days a week.",
          "icon": "clock"
        },
        {
          "text": "We're here for you and your family.",
          "icon": "rodina"
        }
      ]
    },
    "advisory": "Consultation",
    "order": "Appointment",
    "myHealth": "Prevention",
    "infolines": "Helplines",
    "contact": "Contact",
    "registration": "Sign up",
    "notification": {
      "title": "A health day will take place at your company from November 17-25"
    },
    "hrbArticles": {
      "title": "Prevention",
      "items": [
        {
          "icon": "shield",
          "title": "Prevention does not hurt",
          "perex": "Have your life under control thanks to regular care of your health. Learn what you can about prevention and its possibilities.",
          "linkName": "Find more"
        }
      ]
    },
    "serviceVideo": {
      "title": "We're never closed, and you don't have to knock",
      "videoUrl": "https://www.youtube.com/embed/K1XDGQ9yBno"
    },
    "counseling": {
      "title": "Consultation service",
      "question": "A general practitioner or pediatrician will answer your question within 12 hours.",
      "order": "If our professionals recommend you visit a doctor, wel'll schedule you an appointment.",
      "linkTitle": "Get advice"
    },
    "ordering": {
      "title": "Appointment",
      "perex": [
        "Describe your health problem or tell us what doctor you're looking for.",
        "We'll find a suitable professional in your vicinity.",
        "We'll schedule an appointment at your convenience."
      ],
      "linkTitle": "Schedule"
    },
    "prevention": {
      "title": "Prevention",
      "perex": [
        "Our preventive programmeme helps you avoid illness.",
        "We make sure that both you and your body are happy.",
        "To get started, all we need is a bit of basic information."
      ],
      "linkTitle": "I'm in"
    },
    "faq": {
      "title": "What would you like to know?",
      "faqList": [
        {
          "title": "Can I ask about anything?",
          "bodyText": "YES, anything related to physical and mental health."
        },
        {
          "title": "Can you really schedule appointments with all doctors?",
          "bodyText": "YES, the nurses at uLékaře.cz will book you an appointment with a general practitioner and all specialists."
        },
        {
          "title": "Do I need to switch doctors?",
          "bodyText": "NO, YOU DON’T, you can use our service to merely get a another medical opinion."
        },
        {
          "title": "Will my current doctor find out anything?",
          "bodyText": "NO, we never share your queries with anyone. Everything takes place on-line and solely between you and the consultation service doctor who is answering your question."
        },
        {
          "title": "Will I pay anything to use the service?",
          "bodyText": "NO, you won’t pay anything to use the on-line medical consultation service or scheduling an appointment with a doctor. You can use the service as much as you want as part of your employer’s subscription."
        },
        {
          "title": "Will I pay something to the doctor you schedule me with?",
          "bodyText": "Nurses schedule appointments with both public and private medical facilities, and look for the best doctor with respect to your preferred date and availability of a doctor in the given specialization. You will be informed of any payments before you visit the doctor."
        },
        {
          "title": "How is confidentiality assured?",
          "bodyText": "Only the doctor answering your query will see the question, your first name, and age. Other information provided as part of your query can only be accessed by the medical team that is helping make your appointment or answering your question.<br />Your questions/appointments are not shared with anyone else.<br />If you are attaching a medical report or other document, we recommend first blacking out visible personal information, and only then uploading it as an attachment to your query in order to maintain absolute anonymity on your end as well."
        },
        {
          "title": "But on www.ulekare.cz users’ questions are visible. Will mine be there too?",
          "bodyText": "NO, they won’t. Queries from individuals who have an active service thanks to their employer aren’t published on the website."
        },
        {
          "title": "Is using the service secure?",
          "bodyText": "YES, it is. The service complies with the General Data Protection Regulation (GDPR). All requests are only seen by you and designated individuals with the uLékaře.cz Virtual Hospital, or a medical facility you may choose."
        }
      ]
    },
    "employeeStories": {
      "title": "Stories from our consultation service",
      "stories": [
        {
          "name": "An another medical opinion helped.",
          "perex": "A mother of a 7yo son approached our counselling in hope to confirm a current medical treatment. Her son suffered from a persistent rash that didn´t respond to treatment their dermatologist recommended. He got a prescription for a drug intended for adults, the fact his mother learned in a pharmacy. Based on the photo of the affected place, a doctor in the counselling was able to confirm the current treatment."
        },
        {
          "name": "That was a weight off her mind. ",
          "perex": "To one of our user, her gynaecologist delivered a diagnosis using two abbreviations. Without any further explanation, she was sent to undergo more tests. The woman was immediately full of fear thinking that the abbreviations mean cancer. Doctors from our counselling calmed her down, explaining her diagnosis is so-called \"precancerous\" state. This is quite common and does not automatically mean that she suffers from cancer. More test had to be made to confirm this diagnosis. The woman was grateful, saying \" that was a weight off her mind\"."
        },
        {
          "name": "Straight from our counselling to a medical professional. ",
          "perex": "A young man turned to our counselling with a question concerning a mole on his abdomen. This mole seemed strange to him, and he attached a photo of the mole with approximate size. Specialists in our counselling could not determine its nature solely from a photo. However, it was obvious enough that the mole presents certain asymmetry and uneven edges. Based on an urgent recommendation to undergo an examination at a specialist, our nurse made an appointment at dermatology as soon as possible in his home town."
        }
      ]
    },
    "contactUs": {
      "title": "Client support",
      "subTitle": "Do you need help? Have you got no idea how to fill in a form?"
    },
    "covidLink": {
      "title": "Covid helpline",
      "callUs": "Contact us:",
      "tooltip": {
        "title": "How can we help?",
        "text": [
          "Disease symptoms",
          "Coronavirus and pregnancy",
          "Testing",
          "Preventive and health measures"
        ]
      }
    },
    "asistLink": {
      "title": "SOS psychological help",
      "subtitle": "psychological, legal and financial counselling.",
      "email": "info@e-a.cz",
      "phone": "+420 234 768 710"
    }
  },
  "hrbPageInactive": {
    "title": "We're sorry. The service is no longer available.<br/>If you would like to use the service again, please contact your HR department.",
    "subtitle": "You can use the service uLékaře.cz privately.",
    "getHelp": "Ask the doctor"
  },
  "authorization": {
    "title": "Service activation",
    "subtitle": "To use the service, please enter your corporate email address or the code you have received from your employer. Then follow the instructions.",
    "subtitleEmail": "To start using our services, please provide your work email address and follow the instructions.",
    "subtitleCode": "To start using the service, enter the code you received from your employer. Then follow the instructions.",
    "emailLabel": "Email",
    "codeLabel": "Code",
    "codeHrbError": "Invalid code",
    "codeLengthError": "Incorrect format. The code must contain 2-20 characters",
    "or": "or",
    "contactTitle": "Do you need help?",
    "sendMessage": "The request for using our services has been sent to your work email address <strong class='text-primary'>{email}</strong>, to confirm the request, please follow the link in the email.",
    "changeEmail": "Change email address",
    "final": {
      "thankYouTitle": "Service activation",
      "thankYouSubtitle": "Everything’s set.",
      "infoHeading": "Excellent! Activation was successful.",
      "infoText": "Enjoy your free service\nfully starting today."
    }
  },
  "checkToken": {
    "generateToken": "Send a new link",
    "expired": {
      "title": "Link expired",
      "perex": "For security reasons links expire after a certain time. Try having another link sent."
    },
    "invalid": {
      "title": "Invalid link",
      "perex": "The link you entered no longer works. It can be because it was already used, or due to a change in conditions."
    },
    "tokenCreated": {
      "title": "The link has been sent.",
      "perex": "We've sent you a new link to your corporate email. Click this link in the email to complete activation."
    }
  },
  "confirmation": {
    "title": "Email verification",
    "subtitle": "Please verify the email address for communication with the uLékaře.cz service.<br/>Confirm the link sent to the email address<strong class='text-primary'>{email}</strong>."
  },
  "hrbForm": {
    "title": "Use service uLékaře.cz",
    "problem": {
      "text": "Tell us about your symptoms and how long you've had them.",
      "placeholder": "The more information you give us, the more precise the doctor's answer can be.",
      "errorText": "Please, fill out this field."
    },
    "help": {
      "text": "What would you like to ask our doctors?",
      "placeholder": "Ask the doctor a question.",
      "errorText": "Please, fill out this field."
    },
    "medication": {
      "text": "Provide additional information regarding your health.",
      "placeholder": "For example, what other illnesses you're being treated for, what medications you're taking regularly, whether you have any allergies, and the results of any examinations.",
      "errorText": "Please, fill out this field."
    },
    "order": {
      "question": {
        "text": "What kind of health problems do you deal with? How can we help you?",
        "placeholder": "What kind of doctor do you want to make an appointment to?",
        "errorText": "Please, fill out this field."
      }
    },
    "agreements": {
      "iAgree": "By sending the form you agree to the ",
      "conditions": "Terms and Conditions",
      "service": "of the service uLékaře.cz."
    },
    "thankYou": {
      "question": {
        "title": "Thank you. Your question has been sent.",
        "perex": "We will forward your question to a doctor.<br/> You will receive a response via email.",
        "button": "A new question"
      },
      "appointment": {
        "title": "Thank you. Your order has been accepted.",
        "perex": "Please, wait for a nurse to call.",
        "button": "A new order"
      },
      "prevention": {
        "title": "Your registration in the preventive programme uLékaře.cz has been successful.",
        "content": {
          "start": "We are here to help you with your health by preventing diseases and severe health problems. We do care about the welfare of your body and soul.<br/><br/>In the upcoming months, you will be able to schedule annual exams and tests via the website. Specialized consultation will be also available, you will be able to ask anything about prevention and schedule an appointment.<br/><br/>You can look forward to educational articles and videos as well as a calendar to keep track of your appointments and vaccinations.",
          "thankYou": "Thank you.<br/><br/>Team uLékaře.cz"
        }
      }
    }
  },
  "masterCardFAQ": {
    "title": "Frequently asked questions and answers regarding the uLékaře.cz Virtual Hospital",
    "perex": "Perhaps you have questions related to using on-line medical consulting and scheduling an&nbsp;appointment with a&nbsp;doctor. Here are answers to the most frequent ones.",
    "list": [
      {
        "title": "Can I ask about anything?",
        "bodyText": "YES, anything related to physical and mental health."
      },
      {
        "title": "Can you really schedule appointments with all doctors?",
        "bodyText": "YES, the nurses at uLékaře.cz can schedule you an appointment with a&nbsp;general practitioner and all specialists."
      },
      {
        "title": "Do have to switch doctors?",
        "bodyText": "NO, YOU DON’T, you can use our service to merely get an&nbsp;another medical opinion."
      },
      {
        "title": "Will my current doctor find out anything?",
        "bodyText": "NO, we never share your queries with anyone. Everything takes place on-line and solely between you and the doctor from the consultation service who is answering your question."
      },
      {
        "title": "Will I pay anything to use the service?",
        "bodyText": "NO, you won’t pay anything to use the on-line medical consultation service or to schedule an appointment with a doctor. You can use the service for free if you have a premium or company Mastercard<sup>®</sup>.<br/><br/><strong>Premium cards:</strong><ul><li>Mastercard<sup>®</sup> Gold</li><li>Mastercard<sup>®</sup> Platinum</li><li>Mastercard<sup>®</sup> World</li><li>Mastercard<sup>®</sup> World Elite</li></ul><strong>Company cards:</strong><ul><li>Mastercard<sup>®</sup> Business</li><li>Mastercard<sup>®</sup> Corporate</li></ul>"
      },
      {
        "title": "Will I pay something to the doctor you schedule me with?",
        "bodyText": "Nurses schedule appointments with both public and private healthcare facilities, and look for the best doctor with respect to your preferred date and availability of a&nbsp;doctor in the given specialization. You will be informed of any payments before you visit the&nbsp;doctor."
      },
      {
        "title": "How is confidentiality assured?",
        "bodyText": "Only the doctor answering your question will see the query, your first name, and age. Other information provided as part of your query can only be accessed by the medical team that is helping schedule your appointment or answering your query. Your queries/appointments are not shared with anyone else.<br/><br/> If you are attaching a medical report or other document, we recommend first blacking out visible personal information, and only then uploading it as an attachment to your query in order to maintain absolute anonymity on your end as well."
      },
      {
        "title": "But questions appear on the uLékaře.cz website, will mine be there too?",
        "bodyText": "NO, THEY WON'T, questions from premium or company Mastercard<sup>®</sup> holders are not published on the site."
      },
      {
        "title": "Is using the service secure?",
        "bodyText": "YES, it is. The service complies with the&nbsp;General Data Protection Regulation&nbsp;(GDPR). All requests are only seen by you and designated individuals with the uLékaře.cz Virtual Hospital, or a medical facility you may choose."
      }
    ]
  },
  "preventionForm": {
    "title": "Tell us more about yourself",
    "subtitle": "If our doctors decide that your health problem requires you to see a doctor, we need more information in order to schedule you an appointment.",
    "birthDate": {
      "title": "Date of birth",
      "helpText": "Please enter your date of birth in the format dd,mm,yy, e.g. 21.1.1991",
      "errorText": "Please enter your date of birth.",
      "errorTextDate": "The date of birth format is incorrect.",
      "errorTextBirthDateRange": "Please enter the correct date of birth."
    },
    "gender": {
      "title": "Sex",
      "selectGender": "Select gender",
      "errorText": "Gender is required, please select.",
      "male": "Male",
      "female": "Female",
      "other": "Other"
    },
    "language": {
      "title": "Language",
      "selectLanguage": "Select the language for communication",
      "errorText": "The language for communication is required, please select."
    },
    "preventiveCheckUp": {
      "title": "Annual medical exams and vaccinations",
      "examinationTitle": "Please, choose the <strong>medical exams</strong> you have undergone (optional):",
      "examinationDate": "When did you undergo the exam the last time?",
      "vaccinationDate": "When was the last time you got vaccinated?",
      "examinationsSubtitle": "Were these tests included in the last exam?",
      "vaccinationTitle": "Please, choose <strong>vaccinations</strong> you have undergone so far (optional):",
      "nameExamination": "The name of the examination",
      "examinationSelectBtn": "Choose medical exams from the list",
      "vaccinationSelectBtn": "Choose a vaccination from the list.",
      "dateRange": {
        "range_1": "This year",
        "range_2": "Last year",
        "range_3": "The year before last ",
        "range_4": "I do not remember",
        "range_5": "Never"
      },
      "otherTitle": "The name of the medical examination",
      "selectYear": "Select year",
      "iAmNotSure": "I do not remember"
    },
    "address": {
      "title": "Address (optional)",
      "placeholder": "Share your location"
    },
    "registeredModal": {
      "title": "Thank you",
      "subtitle": "You have already registered for the prevention programme."
    }
  },
  "ulekareContacts": {
    "email": "info@ulekare.cz",
    "phone": "+420&nbsp;227&nbsp;072&nbsp;720",
    "hours": "Mon-Fri 8:00&nbsp;AM&nbsp;-&nbsp;5:00&nbsp;PM"
  },
  "authorizationPage": {
    "title": "Authorization successful",
    "successText": "We've successfully verified that you're entitled to the free service.",
    "prevention": {
      "title": "Thank you. The authorization was successful.",
      "subtitle": "Confirm the link sent to the email <strong class=\"text-primary\">{email}</strong>."
    }
  },
  "verification": {
    "title": "Login to the prevention programme was successful.",
    "subtitle": "Thank you for the email verification."
  },
  "errorModal": {
    "title": "Hmm, this page isn’t feeling well right now",
    "subtitle": "<p>Looks like we’re having a technical issue on our side.</p>\n\n<p><strong>What you can try:</strong></p>\n<ul>\n  <li>Refresh the page using Ctrl + F5 (Windows) or Cmd + Shift + R (macOS).</li>\n  <li>Log out and log back in.</li>\n</ul>\n<br/>\n<p>Still not working? Open the page in a private (incognito) window.</p>",
    "errorCodeReference": "Please mention the following error code in your communication:"
  },
  "renewPassword": {
    "title": "Password reset",
    "subtitle": "Create a new password for your account. We recommend creating a stronger password that contains at least one number and one letter.",
    "setPassword": "Enter password",
    "setPasswordAgain": "Enter your password again.",
    "newPassword": "New password",
    "changePassword": "Change Password",
    "minLengthError": "Password must contain at least 5 characters.",
    "requiredErrorText": "Password is required",
    "generatedError": {
      "start": "Password must",
      "minLength": "be minimum {length} characters length",
      "and": "and",
      "require": "contain",
      "oneChar": "letter",
      "oneNumber": "number",
      "specialChar": "special character"
    },
    "sameAsPasswordErrorText": "Passwords do not match.",
    "successMessage": "Password has been successfully changed.",
    "invalidToken": {
      "title": "The link is not valid.",
      "perex": "Please, generate a new link by clicking on \"forgotten password\" in the uLékaře.cz mobile app."
    },
    "usedToken": {
      "perex": "This link is no longer valid because it has already been used."
    },
    "expiredToken": {
      "title": "Unfortunately, the link has expired.",
      "perex": "Please, generate a new link by clicking on \"forgotten password\" in the uLékaře.cz mobile app."
    },
    "nextButton": "Log in to {service}"
  },
  "emailVerification": {
    "successMessage": "Email verified",
    "successMessagePerex": "We've successfully verified your email address. You can log in.",
    "button": "Continue on {service}",
    "invalidToken": "The link is not valid.",
    "usedToken": "This link is no longer valid because it has already been used.",
    "expiredToken": "Unfortunately, the link has expired."
  },
  "partnerNavigation": {
    "hello": {
      "title": "How you can start using the uLékaře.cz Virtual Hospital service.",
      "items": [
        {
          "icon": "compass",
          "text": "Log in or create an account."
        },
        {
          "icon": "glasses",
          "text": "You can then start using our service."
        }
      ]
    },
    "helloHrb": {
      "title": "Use the uLékaře.cz service.",
      "items": [
        {
          "icon": "compass",
          "text": "Find your employer by the company name."
        },
        {
          "icon": "glasses",
          "text": "Select the service you want to use."
        }
      ]
    },
    "partnerSignpost": {
      "title": "Do you have a free service?",
      "subtitle": "Who pays for the service?",
      "text": "You can have the service for free as a benefit from your employer, town, credit card company, non-profit organization, and other companies. Register and go to the benefit management section, where you will select your employer."
    },
    "tabs": [
      "Different benefit",
      "Mastercard<sup>®</sup>"
    ],
    "employer": {
      "title": "Find your employer by name.",
      "searchPlaceholder": "Enter your company name"
    },
    "results": {
      "noResultStart": "Can't find your employer?",
      "noResultContact": "Contact us",
      "noResultMiddle": "or",
      "noResultReadMore": "read more",
      "noResultEnd": "about the service."
    },
    "partnerTypes": [
      {
        "boxTitle": "The service is from my employer"
      },
      {
        "buttonText": "Choose",
        "title": "Click on your insurance company's logo.",
        "boxTitle": "The service is from my insurance company",
        "partnerGtmAction": "Click Go to insurance company",
        "boxes": [
          {
            "gtmLabel": "VoZP",
            "isExternalLink": "true",
            "image": "partner-vozp.png",
            "link": "kp.vozp.cz"
          },
          {
            "gtmLabel": "OZP",
            "isExternalLink": "true",
            "image": "partner-ozp.png",
            "link": "www.ozp.cz/vkol"
          }
        ]
      },
      {
        "buttonText": "Go to the service",
        "title": "Click on the logo to use the uLékaře.cz Virtual Hospital service.",
        "boxTitle": "The service is from Mastercard",
        "partnerGtmAction": "Click Mastercard box",
        "boxes": [
          {
            "gtmLabel": "Mastercard",
            "isExternalLink": "false",
            "image": "logos/mc_logo.png",
            "link": {
              "name": "hrbPage",
              "params": {
                "partnerUrl": "mastercard"
              }
            }
          }
        ]
      },
      {
        "buttonText": "Choose",
        "title": "Click on your partner's logo.",
        "boxTitle": "The service is a benefit",
        "partnerGtmAction": "Click go to partner",
        "boxes": [
          {
            "gtmLabel": "Fairsurence",
            "image": "partner-fairsurence.png",
            "isExternalLink": "false",
            "link": {
              "name": "hrbPage",
              "params": {
                "partnerUrl": "spolekpromaterstvi"
              }
            }
          }
        ]
      }
    ],
    "video": {
      "title": "We’re never closed, and you don’t have to knock."
    }
  },
  "unsupportedBrowser": {
    "title": "Your browser isn’t supported",
    "perex": "We’re sorry, but you’re using an older web browser that doesn’t fully support our service. To be able to make full use of the service, please use one of the following supported browsers or perform an update."
  },
  "login": {
    "banner": {
      "title": "Your data will remain secure.",
      "subtitle": "We are constantly improving our services so that your information remains only yours. That's our priority."
    },
    "socials": {
      "facebook": "Log in via Facebook",
      "google": "Log in via Google",
      "apple": "Log in via Apple"
    },
    "title": "Log in",
    "subtitle": "To use uLékaře.cz services, please log in",
    "loginError": "Invalid login data. Please try again.",
    "forgetPassword": "Forgotten password?",
    "password": {
      "title": "Password",
      "requiredError": "Password is required"
    },
    "remember": "Remember user",
    "login": "Log in",
    "noAccount": "Don't have an account yet?",
    "registration": "Sign up.",
    "registrationHeaderButton": "Sign up",
    "rateLimitError": "The number of login attempts has been exhausted. Please try again in 15 minutes."
  },
  "registration": {
    "title": "Sign up",
    "subtitleFirstStep": "You need to sign up to use the services of the uLékaře.cz Virtual Hospital",
    "subtitle": "Your details will be used for communication with our medical team",
    "addData": {
      "title": "Complete the information",
      "subtitle": "Your log in is successful but we need to update the information used for communication with uLékaře.cz medical team"
    },
    "emailError": "Your email is on uLékaře.cz already registered.",
    "email": {
      "errorEmailNotExisting": "Enter existing email address.",
      "errorInvalidDomain": "Used email domain is not allowed due to a frequent abuse. Try another email or create a new one.",
      "errorText": "Missing email.",
      "title": "Personal email"
    },
    "socials": {
      "facebook": "Sign up via Facebook",
      "google": "Sign up via Google",
      "apple": "Sign up via Apple"
    },
    "loginText": {
      "link": "Log in",
      "suffix": ", please",
      "question": "This email address has already been used to sign up."
    },
    "login": {
      "text": "Already have an account?",
      "link": "Log in."
    },
    "finishRegistration": "Complete sign up",
    "legal": {
      "text": "I agree with the {termsAndConds}.",
      "termsConditions": "Terms of Use",
      "privacyPolicy": "Principles of Personal Data Protection."
    }
  },
  "missingProfileData": {
    "title": "Complete your personal information",
    "titleLegal": "Consent confirmation",
    "text": "We could not retrieve your email address from the connected account. It is essential for the provision of our services. Please, fill it in below.",
    "textLegal": "Please confirm the following:"
  },
  "phoneVerification": {
    "title": "Phone number verification",
    "subtitle": "We have just sent a verification code to your phone number {phone}. Please enter it below.",
    "label": "SMS code",
    "changeNumber": "Change number",
    "inputError": "Code is mandatory",
    "codeError": "The code you entered is invalid. Do you need help? Contact us.",
    "sendAgain": "Send code again",
    "verify": "Verify",
    "error": {
      "error_timeout": {
        "title": "Please wait for the SMS verification code",
        "perex": "We recorded repeated phone number change requests. Please wait to avoid excess of incoming SMS messages."
      },
      "error_block": {
        "title": "Account temporarily suspended",
        "perex": "Phone number validation was canceled due to suspicious activity. The temporary suspension of your account is a safety precaution. Please, get in touch with our customer service",
        "callUs": "Speak to us",
        "writeUs": "Write us an email"
      }
    }
  },
  "phoneChange": {
    "title": "Change of phone number",
    "sendCode": "Send code"
  },
  "lostPassword": {
    "title": "Forgotten password",
    "subtitle": "Password reset link will be received when you registered using this email on our website or in the mobile app.",
    "button": "Reset password",
    "linkSentTitle": "Link sent",
    "linkSentPerex": "A password reset link has been sent to {email}. If you don't find it in your inbox, check the spam folder.",
    "sendLinkAgain": "Send link again",
    "finishRegistration": "Complete sign up"
  },
  "profileSection": {
    "menu": {
      "profile": "My account",
      "subscription": "Subscription",
      "logout": "Logout"
    },
    "badge": {
      "self": "self-pay",
      "premium": "covered"
    },
    "freeService": {
      "title": "Free service",
      "text": "Our service is often covered by partners, employers and insurance companies.",
      "button": "Am I eligible?"
    },
    "thankYou": "Service is covered by {partnerName}",
    "thankYouSelf": "You self-pay for our service",
    "thankYouHost": "Free service is shared by {host}"
  },
  "dashboard": {
    "menu": {
      "home": "Home",
      "questions": "Consultations",
      "appointments": "Appointments",
      "prevention": "Prevention",
      "explore": "Discover"
    },
    "personalInfoAssurance": {
      "prefix": "How should we communicate with you?",
      "email": "Email",
      "phone": "Phone"
    },
    "deactivatedUser": "<strong>Your account was deactivated.</strong> If you think this should not have happened, please write us at <a href=\"mailto:{email}\">{email}</a> or call us at {phone}.",
    "title": "Hello! 👋",
    "subtitle": "How can we help you?",
    "needAdvice": "Write a question",
    "needAppointment": "Schedule appointment",
    "needHelp": "Do you need advice?",
    "supportBox": {
      "openTitle": "Support",
      "title": "Customer support",
      "boxText": "We are here for you, whatever you need help with",
      "chat": {
        "title": "Customer chat",
        "textOnline": "We are online <br /> Whatever non-medical question or problem you have. We are here for you.",
        "textOffline": "We are offline <br /> We are online 8:00 - 17:00 (Mon-Fri)",
        "button": "Start chat",
        "icon": "chat"
      },
      "customerService": {
        "title": "Customer line",
        "subtitle": "8:00 - 17:00 (Mon-Fri)",
        "buttonEmail": {
          "text": "info@ulekare.cz",
          "subtitle": "Contact e-mail:"
        },
        "buttonPhone": {
          "text": "+420 227 072 720",
          "subtitle": "Toll line:"
        },
        "linkEmail": "mailto:info@ulekare.cz",
        "linkPhone": "tel:+420 227 072 720",
        "icon": "care",
        "tescoButtonPhone": {
          "text": "+420 800 100 211",
          "subtitle": "Toll-free line:"
        },
        "tescoLinkPhone": "tel:+420 800 100 211",
        "tescoButtonPhonePaid": "Toll-free line +420 227 072 720",
        "tescoLinkPhonePaid": "tel:+420 227 072 720"
      },
      "assistanceService": {
        "title": "SOS psychological help",
        "subtitle": "Psychological counselling",
        "buttonEmail": "info@e-a.cz",
        "buttonPhone": "+420 234 768 710",
        "linkEmail": "mailto:info@e-a.cz",
        "linkPhone": "tel:+420 234 768 710",
        "icon": "happy"
      },
      "covidService": {
        "title": "Covid infoline",
        "button": "+420 226 284 227",
        "linkEmail": "mailto:info@e-a.cz",
        "linkPhone": "tel:+420 226 284 227",
        "icon": "lungs"
      },
      "unavailableOn": "Please note that customer support and service of scheduling appointments will be available on a limited basis on {date}. Requests submitted may be processed with a delay. For general information, please email us at the address provided. \nThank you for your understanding.",
      "outageActive": "false",
      "outageDateISO": "2026-04-09"
    },
    "freeService": "Free service?",
    "requestSent": "Finish activation in the work email",
    "hint": {
      "subtitle": "surgeon, co-founder of the uLékaře.cz Virtual Hospital",
      "text": "\"Quickly arrange everything from the comfort of your home or from work. If you need to see a doctor in person, we'll help you schedule an appointment.<br/>Do you need advice? I or one of my 350 colleagues will be glad to help you.\""
    },
    "questions": {
      "myQuestions": "My questions",
      "updated": "We have an answer for you!",
      "resolvers": "Caring for you",
      "sla": "We'll answer by <strong class='black--text'>{hour}</strong>."
    },
    "appointments": {
      "myAppointments": "My appointments"
    },
    "labTests": {
      "draft": "Pick a place, date and time to provide your sample",
      "new": "Your samples are being analyzed by the laboratory",
      "done": "We have the interpretation of your blood tests!"
    },
    "videoCall": {
      "buttonText": "Schedule video call",
      "buttonTextMobile": "Video call"
    },
    "services": {
      "question": {
        "title": "Consultation 24/7",
        "subtitle": "with answer within {hours}h",
        "text": "Our doctors are here for you. All in one place. Any time.",
        "button": "Get advice"
      },
      "videoCall": {
        "title": "Video call",
        "subtitle": "with doctor",
        "text": "Consult our doctor on a video call (for up to 20 minutes) at a time of your choice.",
        "button": "Schedule video call"
      },
      "appointment": {
        "title": "Appointment",
        "subtitle": "throughout the Czech Republic",
        "text": "Our nurses will help you find the right doctor for all your needs.",
        "button": "Schedule appointment"
      },
      "prevention": {
        "title": "Prevention",
        "subtitle": "health in your hands",
        "text": "Supporting you in taking the optimum care of your health.",
        "existedButton": "Enter prevention"
      },
      "thematic_counseling": {
        "title": "Topic-based consultations",
        "text": "You can make use of our consultation services focused on a specific topic. Ask our experts about things that interest you.",
        "button": "Browse topics"
      },
      "hints": {
        "service_not_supported_in_this_language": {
          "text": "Service is not available in {language}. To use the service change the language in <a href=\"{link}\" class=\"link--inline\">your profile</a>.",
          "cs": "Czech",
          "en": "English",
          "sk": "Slovak"
        }
      },
      "labTest": {
        "title": "Lab tests",
        "subtitle": "health in your hands",
        "text": "With our help, take the best possible care of your health.",
        "button": "Fill in the questionnaire"
      },
      "videoTherapy": {
        "subtitle": "with a therapist",
        "title": "Video call",
        "text": "Have a discreet on-line talk. You’ll have 50 minutes to speak with a professional.",
        "button": "Pick a date and time for the video call",
        "textUnavailable": "The number of therapies has been exhausted. Contact your HR department for more information."
      }
    },
    "news": "New features",
    "recomended": "Recommended for you",
    "emailVerification": {
      "title": "Email address verification",
      "subtitle": "Check your inbox <strong>{email}</strong> and use the verification link in the email we have just sent you.",
      "text": [
        {
          "title": "Can't find the e-mail?",
          "list": [
            {
              "icon": "check_circle",
              "text": "Check your spam folder"
            },
            {
              "icon": "check_circle",
              "text": "Wait a few minutes and resend the e-mail"
            }
          ]
        },
        {
          "title": "Did you enter the wrong email?",
          "text": "Please start the sign up again"
        }
      ],
      "actions": {
        "right": {
          "type": "resend",
          "baseText": "Send email again"
        }
      }
    },
    "help": {
      "text": "Need help?",
      "hours": "Mon-Fri 8 a.m. - 5 p.m."
    }
  },
  "videoCall": {
    "infoStep": {
      "title": "Online session with a doctor",
      "perex": "When a few lines of text are not enough, talk to our doctor on video. Discuss any health problem without stepping into the doctor's office.",
      "list": {
        "first": "Make sure you have filled in your contact information and verified your phone number.",
        "second": "Pick the date and time that suits you. You can even squeeze one into a lunch break.",
        "third": "At the scheduled time, join the video session. The doctor will devote 20 minutes only to you."
      },
      "legal": [
        "We are brokering you a service from the following healthcare services provider:",
        "uLékaře.cz Health Care,&nbsp;s.r.o.<br/>with registered offices at&nbsp;Českomoravská 2408/1a, 190&nbsp;00&nbsp;Prague&nbsp;9 ID:&nbsp;096&nbsp;64&nbsp;777<br/>maintained&nbsp;at&nbsp;the&nbsp;Prague&nbsp;Municipal&nbsp;Court, file No&nbsp;C&nbsp;339989",
        "The&nbsp;\"Video call with&nbsp;a&nbsp;doctor\" healthcare service is&nbsp;not&nbsp;covered by public health insurance. It will be paid&nbsp;for&nbsp;by&nbsp;your employer.",
        "The&nbsp;\"Video call with&nbsp;a&nbsp;doctor\" service is a healthcare service provided remotely as&nbsp;a&nbsp;videoconference with a&nbsp;doctor, and&nbsp;only&nbsp;in the&nbsp;field&nbsp;of&nbsp;internal medicine."
      ],
      "button": "Pick video call slot"
    },
    "formStep": {
      "title": "Check your information",
      "legal": {
        "termsConditions": {
          "text": "I agree with the {legalText} of a Videoconference with a doctor from the healthcare services provider uLékaře.cz Health Care, s.r.o.",
          "legalText": "Terms and Conditions of the service"
        },
        "personalData": {
          "text": "We process your data in accordance with the {link}.",
          "legalText": "Principles of Personal Data Processing"
        }
      }
    },
    "iframeStep": {
      "title": "Choose a time slot"
    }
  },
  "tally": {
    "anxiety": {
      "infoStep": {
        "button": "Fill in the questionnaire"
      }
    },
    "wellbeing": {
      "dashboardBox": {
        "title": "Well-being test",
        "text": "How are you, really? Test your well-being."
      },
      "infoStep": {
        "title": "How are you doing?",
        "timeApproximation": "~2 minutes",
        "perex": "Well-being is a term that covers overall physical, mental, and emotional health. Well-being is affected by your health, relationships, and other aspects.",
        "list": [
          "Answer five short questions.",
          "You get your results immediately, along with tips to help you feel better."
        ],
        "garant": {
          "title": "Test guarantor",
          "name": "Mgr. Michaela Štěpánová",
          "specialization": "Psychology",
          "workplace": "Psychologist from uLékaře.cz"
        },
        "button": "Fill in the questionnaire"
      },
      "urls": {
        "b2b": "https://tally.so/r/3Evr8X"
      }
    },
    "insomnia": {
      "dashboardBox": {
        "title": "Insomnia test",
        "text": "How are you sleeping? Take our test."
      },
      "infoStep": {
        "title": "How's your sleep?",
        "timeApproximation": "~2 minutes",
        "perex": "Having trouble falling asleep lately? Or do you wake up during the night? Long-term insomnia can influence well-being and health.",
        "list": [
          "Spend 2 minutes answering eight short questions.",
          "As soon as you’re done you’ll see your results, including practical recommendations."
        ],
        "garant": {
          "title": "Test sponsor",
          "name": "Michaela Štěpánová, MSc.",
          "specialization": "Psychology",
          "workplace": "Psychologist from Soulody.hu"
        },
        "button": "Complete survey"
      },
      "urls": {
        "b2b": "https://tally.so/r/w4AD1X"
      }
    },
    "alcohol": {
      "infoStep": {
        "button": ""
      }
    },
    "depression": {
      "dashboardBox": {
        "title": "Depression risk test",
        "text": "Is it a bad mood, or depression? Take a test.",
        "button": "Complete the form"
      },
      "infoStep": {
        "title": "Bad mood, or depression?",
        "timeApproximation": "~2 minutes",
        "perex": "Have you felt exhausted recently, without energy, and nothing makes you happy? This on-line depression risk test can help you identify your feelings.",
        "list": [
          "Pick the answers that best match your current situation.",
          "As soon as you’re done you’ll see your results, including practical recommendations."
        ],
        "garant": {
          "title": "Test sponzor",
          "name": "Mgr. Michaela Štěpánová",
          "specialization": "Psychology",
          "workplace": "Psychologist from uLékaře.cz"
        },
        "button": "Complete the form"
      },
      "urls": {
        "b2b": "https://tally.so/r/mV4yAM"
      }
    },
    "liver": {
      "dashboardBox": {
        "title": "Healthy liver test",
        "text": "Take this test to see how well you’re caring for your liver.",
        "button": "Take the test"
      },
      "infoStep": {
        "title": "Are you taking proper care of your liver?",
        "timeApproximation": "~3 minutes",
        "perex": "This short test will tell you how your liver is doing and if it needs better care than it’s had till now.",
        "list": [
          "Pick the answers that you consider correct and match your health.",
          "As soon as you’re done you’ll see your results, including practical recommendations."
        ],
        "garant": {
          "title": "Test sponsor",
          "name": "Maj. Dr. Denisa Gottvaldová from uLékaře.cz",
          "specialization": "General medicine for adults",
          "workplace": "Bechyně Medical Services Centre"
        },
        "button": "Complete the form"
      },
      "urls": {
        "b2b": "https://tally.so/r/w8MBjl"
      }
    },
    "heart": {
      "dashboardBox": {
        "title": "Do you have a healthy heart?",
        "text": "A few questions will tell you what your heart wants.",
        "button": "Complete the form"
      },
      "infoStep": {
        "title": "How is your heart doing?",
        "timeApproximation": "~3 minutes",
        "perex": "This test will tell you whether our heart is healthy or if it’s already sounding the alarm.",
        "list": [
          "Spend 3 minutes answering ten short questions.",
          "As soon as you’re done you’ll see your results, including practical recommendations."
        ],
        "garant": {
          "title": "Test sponsor",
          "name": "Dr. Oleksii Bolotskykh",
          "specialization": "Adult cardiologist",
          "workplace": "Kardiologie na Bulovce, s.r.o."
        },
        "button": "Complete the form"
      },
      "urls": {
        "b2b": "https://tally.so/r/nGk6No"
      }
    },
    "movement": {
      "urls": {
        "b2b": "https://tally.so/r/mDyplb"
      },
      "infoStep": {
        "button": "Complete the form",
        "garant": {
          "workplace": "YOTAI private practice, National Theatre in Prague",
          "specialization": "Fascia specialist, expert in dance and sports medicine",
          "name": "MgA. Klára Lidová, Ph.D.",
          "title": "Test sponsor"
        },
        "list": [
          "Spend 2 minutes answering ten short questions.",
          "As soon as you’re done you’ll see your results, including practical tips."
        ],
        "perex": "This quick test will reveal whether you’re getting enough exercise, or if your body is calling for action.",
        "timeApproximation": "~2 minutes",
        "title": "Do you get enough exercise?"
      },
      "dashboardBox": {
        "button": "Take the test",
        "text": "Test your condition with a short on-line test.",
        "title": "Exercise and you"
      }
    },
    "skin": {
      "dashboardBox": {
        "title": "How do you tan?",
        "text": "Determine your phototype with a quick test.",
        "button": "Take the test"
      },
      "infoStep": {
        "title": "How well do you tan?",
        "timeApproximation": "~2 minutes",
        "perex": "Test whether your skin is safe, or suffering quietly in the sun.",
        "list": [
          "Spend two minutes answering eight short questions.",
          "As soon as you’re done you’ll see your results, including practical tips."
        ],
        "garant": {
          "title": "Test sponsor",
          "name": "MUDr. Tereza Marušiaková",
          "specialization": "Dermatovenerologist",
          "workplace": "Liberec Regional Hospital"
        },
        "button": "Complete the form"
      },
      "urls": {
        "b2b": "https://tally.so/r/wdXk9y"
      }
    },
    "adhd": {
      "urls": {
        "b2b": "https://tally.so/r/3q8Pod"
      },
      "infoStep": {
        "button": "Complete the form",
        "garant": {
          "workplace": "Psychological Services Centre, Ostrava",
          "specialization": "psychologist, psychotherapist",
          "name": "PhDr. Sylvie Navarová",
          "title": "Test sponsor"
        },
        "list": [
          "Answer 10 questions. Don’t take too long, choose the first thing that pops into your head.",
          "At the end of the test you’ll get useful self-help information."
        ],
        "perex": "Are your thoughts like bees or do you concentrate like a chess player? This short test will tell you more.",
        "timeApproximation": "~3 minutes",
        "title": "How’s your concentration?"
      },
      "dashboardBox": {
        "button": "Complete the test",
        "text": "Test your attention and ability to concentrate.",
        "title": "How’s your concentration?"
      }
    },
    "imunity": {
      "dashboardBox": {
        "title": "Immunity test",
        "button": "Complete the test"
      },
      "infoStep": {
        "title": "Do you have a strong immune system?",
        "timeApproximation": "~2 minutes",
        "perex": "Take a test that will tell you whether your immune system works like a shield or if it is defeated by every illness.",
        "list": [
          "Spend two minutes answering eight short questions.",
          "As soon as you’re done you’ll see your results, including practical tips."
        ],
        "garant": {
          "title": "Test sponsor",
          "name": "MUDr. Jana Emlerová",
          "specialization": "Allergy and clinical immunology specialist",
          "workplace": "GENNET Allergy and Clinical Immunology"
        },
        "button": "Complete the test"
      },
      "urls": {
        "b2b": "https://tally.so/r/n9kVYX"
      }
    },
    "circulation": {
      "dashboardBox": {
        "title": "Vessel Health Check",
        "text": "A few questions will reveal how your circulatory system is doing.",
        "button": "Complete the test"
      },
      "infoStep": {
        "title": "How can you improve your blood circulation?",
        "timeApproximation": "~2 minutes",
        "perex": "Find out whether your heart and blood vessels are working optimally or if they need a bit of help.",
        "list": [
          "Answer 10 short questions.",
          "You’ll immediately see your results plus handy tips on how to improve your blood circulation."
        ],
        "garant": {
          "title": "Test sponsor",
          "name": "MUDr. Markéta Hadrabová",
          "specialization": "General practitioner and haematologist",
          "workplace": ""
        },
        "button": "Complete the test"
      },
      "urls": {
        "b2b": "https://tally.so/r/wbPqxZ"
      }
    },
    "flexibility": {
      "dashboardBox": {
        "title": "Do you have a flexible body?",
        "text": "Test your flexibility with ten questions.",
        "button": "Complete the test"
      },
      "infoStep": {
        "title": "How flexible is your body?",
        "timeApproximation": "~2 minutes",
        "perex": "Find out whether your body is like a spring or more like a stiff board.",
        "list": [
          "Answer 10 short questions.",
          "Read your results and discover tips for better flexibility."
        ],
        "garant": {
          "title": "Test sponsor",
          "name": "MgA. Klára Lidová, Ph.D.",
          "specialization": "Fascia specialist, expert in dance and sports medicine",
          "workplace": "YOTAI private practice, National Theatre in Prague"
        },
        "button": "Complete the form"
      },
      "urls": {
        "b2b": "https://tally.so/r/medOeQ"
      }
    },
    "digitalhealth": {
      "dashboardBox": {
        "title": "Digital Health Test",
        "text": "Find out if the digital world is your servant or your master.",
        "button": "Complete the form"
      },
      "infoStep": {
        "title": "Do you control technology, or does it control you?",
        "timeApproximation": "~3 minutes",
        "perex": "Internet, applications, social networks... Excellent helpers, or tireless time thieves?",
        "list": [
          "Answer 10 questions to find out how you stand in the digital world.",
          "The result will tell you how to regain your lost balance (if needed)."
        ],
        "garant": {
          "title": "Test sponsor",
          "name": "Mgr. Michaela Štěpánová",
          "specialization": "Psychologist from uLékaře.cz",
          "workplace": "Psychology"
        },
        "button": "Complete the form"
      },
      "urls": {
        "b2b": "https://tally.so/r/GxxJyL"
      }
    },
    "sleephealth": {
      "dashboardBox": {
        "title": "Sleep Health Test",
        "text": "Take a test to see how well you’re sleeping.",
        "button": "Complete the form"
      },
      "infoStep": {
        "title": "Are you really sleeping well?",
        "timeApproximation": "~3 minutes",
        "perex": "Find out if you’re recharging your energy while you sleep, or if your body is just running on autopilot.",
        "list": [
          "Answer 10 short questions.",
          "Read your results and discover tips for better rest and more energy during the day."
        ],
        "garant": {
          "title": "Test sponsor",
          "name": "PhDr. Sylvie Navarová",
          "specialization": "Psychologist, psychotherapist",
          "workplace": "Psychological Services Centre, Ostrava"
        },
        "button": "Complete the form"
      },
      "urls": {
        "b2b": "https://tally.so/r/NprjBQ"
      }
    },
    "drinkfree": {
      "dashboardBox": {
        "title": "Alcohol and you",
        "text": "How’s your drinking? Take our test to find out.",
        "button": "Complete the form"
      },
      "infoStep": {
        "title": "Where do you stand with alcohol?",
        "timeApproximation": "~3 minutes",
        "perex": "Eight questions will give you insight into your relationship with alcohol – and what could change if you take a break.",
        "list": [
          "Choose the answer that describes you best.",
          "Read your results. (Note: This test is not a diagnostic tool.)"
        ],
        "garant": {
          "title": "Test sponsor",
          "name": "MUDr. Barbora Magdolenová",
          "specialization": "Psychiatrist",
          "workplace": "Brno Psychiatric Hospital"
        },
        "button": "Complete the form"
      },
      "urls": {
        "b2b": "https://tally.so/r/A7pXeN"
      }
    },
    "intimateHealth": {
      "dashboardBox": {
        "button": "Complete the form",
        "text": "Check your intimate health with 10 questions.",
        "title": "Your intimate health"
      },
      "infoStep": {
        "button": "Complete the form",
        "garant": {
          "name": "MUDr. Petra Polášková",
          "specialization": "Gynecologist",
          "title": "Test sponsor",
          "workplace": "FertilityPort Prague s.r.o."
        },
        "list": [
          "Choose the answer that best describes you for each question.",
          "You’ll immediately see your results along with practical tips."
        ],
        "perex": "Ten questions will give you insight into how you care for your intimate health – what you’re doing well and where a little extra attention could help.",
        "timeApproximation": "~3 minutes",
        "title": "How well do you care for your intimate health?"
      },
      "urls": {
        "b2b": "https://tally.so/r/68761k"
      }
    },
    "workbalance": {
      "dashboardBox": {
        "text": "10 questions to check your burnout risk.",
        "title": "Work, stress, and you"
      },
      "infoStep": {
        "button": "Complete the test",
        "garant": {
          "name": "Mgr. Michaela Štěpánová",
          "specialization": "Psychology",
          "title": "Test sponsor",
          "workplace": "Psychologist from uLékaře.cz"
        },
        "list": [
          "Choose the answer that best describes you for each question.",
          "You’ll immediately see your results along with practical tips."
        ],
        "perex": "This short test will help you see how you’re managing workload, stress, and energy. It’s not a diagnostic tool – just a way to reflect on yourself.",
        "timeApproximation": "~3 minutes",
        "title": "How do you handle work pressure?"
      },
      "urls": {
        "b2b": "https://tally.so/r/lbLD55"
      }
    },
    "foodstyle": {
      "dashboardBox": {
        "button": "Complete the test",
        "text": "What does your plate say about you?",
        "title": "Your plate check"
      },
      "infoStep": {
        "button": "Complete the test",
        "garant": {
          "name": "Mgr. Lucie Burdová",
          "specialization": "Consulting",
          "title": "Test sponsor",
          "workplace": "Nutritional therapist"
        },
        "list": [
          "Don’t answer how you think you should eat, but how you really eat.",
          "Check your result, including practical tips."
        ],
        "perex": "This quick test reveals whether your diet works as proper fuel or just as a quick fix for hunger.",
        "timeApproximation": "~3 minutes",
        "title": "Are you actually eating well?"
      },
      "urls": {
        "b2b": "https://tally.so/r/KYBOeK"
      }
    },
    "longevity": {
      "dashboardBox": {
        "button": "Complete the test",
        "text": "See if your habits support your body and mind.",
        "title": "Are you aging healthy?"
      },
      "infoStep": {
        "button": "Complete the test",
        "garant": {
          "name": "MUDr. Markéta Hadrabová",
          "specialization": "General practitioner and hematologist",
          "title": "Test sponsor"
        },
        "list": [
          "Choose the answer that best describes you.",
          "This test is not a diagnostic tool. Results are meant for guidance and inspiration."
        ],
        "perex": "Ten questions will show how you’re doing on your path to longevity.",
        "timeApproximation": "~3 minutes",
        "title": "How do you care for your future self?"
      },
      "urls": {
        "b2b": "https://tally.so/r/LZ6kgG"
      }
    },
    "firstaid": {
      "dashboardBox": {
        "button": "Complete the test",
        "text": "How would you respond in a real emergency?",
        "title": "First aid test"
      },
      "infoStep": {
        "button": "Complete the test",
        "garant": {
          "name": "Lucie Kadlečková",
          "specialization": "Founder",
          "title": "Test sponsor",
          "workplace": "První pomoc živě"
        },
        "list": [
          "Choose the answer that best describes you.",
          "Your score and tailored recommendations will be displayed right away."
        ],
        "perex": "Answer 10 questions to find out how you would react in a critical situation.",
        "timeApproximation": "~3 minutes",
        "title": "Would you know what to do in an emergency?"
      },
      "urls": {
        "b2b": "https://tally.so/r/aQl18v"
      }
    }
  },
  "profileAuthorization": {
    "chooseSubscription": "Choose subscription",
    "language": {
      "title": "Service settings",
      "text": "Select the language you want to use for the uLékaře.cz Virtual Hospital service.",
      "errorText": "Current language is not supported by the selected partner. Select another language."
    },
    "final": {
      "title": "Sign up completed successfully",
      "text": "Now you can start using uLékaře.cz services. Our doctors and nurses are here for your."
    },
    "possiblePartners": {
      "title": "It looks like you're entitled to this service for free",
      "textHrb": "Confirm one from the bellow shown emplyees or partners who pay for the service. Can't you choose? Change the partner.",
      "changePartner": "Change partner"
    },
    "hrbPartner": {
      "title": "Activate free service",
      "textBoth": "To activate free service, please enter the company email or the activation code that you received from {partner}.",
      "textEmail": "To activate free service, please enter the company email",
      "textCode": "To activate free service, please enter the activation code that you received from {partner}.",
      "tabs": [
        "With email",
        "With code"
      ],
      "email": "Company e-mail",
      "code": "Activation code",
      "codeError": "<strong>Unfortunately, this code is invalid.</strong><br>Please check the correctness of the code with your HR department.<br>If the code is correct, we will be happy to help you at",
      "emailError": "Invalid email address. Need help? Contact us.",
      "invalidEmployeeEmail": "This email address is not permitted for the selected employer-partner.",
      "benefitBlocked": "This email address has been used for a different employer/partner, and cannot be used for activation.",
      "clientSupport": "client support",
      "startTitle": "Active free service",
      "formTitle": "Enter company email address or code",
      "startUsing": "Enter company email address or code",
      "formDescription": "Please fill in the following information to check whether you’re entitled to free service.",
      "description": {
        "code": "Activation code",
        "email": "Activation email"
      }
    },
    "emailAuthorization": {
      "title": "Request to activate the free service sent",
      "subtitle": "The recipient of the company email <strong class= \"black--text\" >{email}</strong> will activate the service by clicking on the link in the email message.",
      "text": [
        {
          "title": "Didn’t get the email?",
          "list": [
            {},
            {
              "text ": "Delivery may take a while."
            }
          ]
        },
        {
          "title": "Did you provide an incorrect email address?",
          "link": {
            "type": "router",
            "routerAction": "replace",
            "name": "dashboard",
            "query": {
              "a_step": "authorization"
            },
            "textBefore": "Change it",
            "text": "here"
          }
        }
      ],
      "actions": {
        "left": {
          "type": "resend",
          "class": "light",
          "baseText": "Resend email"
        },
        "right": {
          "type": "continue"
        }
      }
    },
    "authorizationSignpost": {
      "title": "Who pays for the service?",
      "text": "Have uLékaře.cz services for free! Maybe your employer or one of our partners (insurance companies, credit card companies, etc.) will pay for it.",
      "employees": "Employers",
      "search": "Find your employer by name.",
      "searchSignText": "Start writing the name of the company you work for. We'll find it together.",
      "searchEmpty": {
        "title": "We could not find “{text}” in our list",
        "text": "If you believe that the company should join our list, feel free to {email}.",
        "emailText": "reach out"
      },
      "selfPay": "I pay myself"
    },
    "selfPay": {
      "title": "I pay myself",
      "text": "As a self-payer, you can enjoy:",
      "list": [
        {
          "icon": "shield",
          "text": "Personalized prevention plan "
        },
        {
          "icon": "news",
          "text": "Practical health tips & arcticles"
        },
        {
          "icon": "phone",
          "text": "Handy mobile application"
        }
      ]
    },
    "mastercard": {
      "title": "Verify your Mastercard<sup>®</sup> card",
      "codeInvalidError": "The number entered is not valid. Make sure you enter 6 numbers from your Premium or Business Mastercard<sup>®</sup> card.",
      "label": "First 6 digits of the card"
    },
    "external": {
      "titleSlot": "Free service verification failed.",
      "vozpText": "As a VoZP client, log in to the VoZP Client Portal and click on the uLékaře.cz logo. After you log in for the first time, you will have access to all our services.",
      "ozpText": "For OZP clients, the uLékaře.cz Virtual Hospital service is available 24/7 via the VITAKARTA. Please log in to your VITAKARTA account.",
      "drmaxText": "As a Dr. Max client, log in the the Benefits Card and click on the uLékaře.cz logo.",
      "mcText": "We need to verify the first six digits of your Mastercard<sup>®</sup> Premium card. No payment is involved, and after entering it successfully, you will be able to use uLékaře.cz Virtual Hospital services for free.",
      "fairsuranceText": "To activate the free service, please enter the authorization code you obtained from Fairsurance.",
      "sporthelpText": "{title}To activate the free service for members of SportHelp sports insurance, click on the link to the service that you'll find in your digital membership card in the Medical Consultation Service section of uLékaře.cz.",
      "defaultErrorText": "Authorization link cannot be applied as it has already expired. Thank you for understanding."
    },
    "chooseDifferentCompany": "Change partner"
  },
  "profile": {
    "title": "My account",
    "titleMobile": "Settings",
    "subtitle": "Manage your information.",
    "basicData": "Basic information",
    "emailNote": "You cannot change your email address.",
    "phoneNote": "Our nurses will use this number to contact you for additional information or scheduling a doctor's appointment.",
    "security": "Security",
    "currentPassword": "Current password",
    "invalidCurrentPassword": "Invalid current password",
    "currentPasswordUsedInHistory": "The new password cannot be the same as the old one.",
    "newPassword": "New password",
    "additionalInfo": "Additional information",
    "birthDateNote": "Your age will help the doctor give you better information.",
    "address": "Address",
    "addressNote": "We can use your address to find you a suitable doctor.",
    "family": "My family",
    "aboutApp": {
      "title": "About App",
      "appVersion": "App Version",
      "webVersion": "Content Version",
      "updates": {
        "title": "Update Availability",
        "webAvailable": "A content update is available: {newVersion}",
        "apply": "Update",
        "upToDate": "Your app and content are up to date.",
        "checking": "Checking for updates...",
        "error": "Something went wrong. Please restart the app."
      }
    },
    "applicationLock": "App lock",
    "moreOptions": "Other",
    "healthInsuranceProvider": {
      "title": "Health insurance company",
      "note": "We'll find a doctor who works with your insurer."
    },
    "applicationLanguage": {
      "title": "Application language",
      "message": "This language is used for web"
    },
    "serviceLanguage": {
      "title": "Service language",
      "message": "Answer from doctor will be in this language"
    },
    "changeLanguageNotification": {
      "text": "When saved the web language will be changed to",
      "cs": "Czech",
      "en": "English",
      "sk": "Slovak",
      "uk": "Ukrainian",
      "ru": "Russian"
    },
    "storeMessage": {
      "success": "Changes saved.",
      "error": "Changes not saved. Please check that the information you provided is correct.",
      "passwordError": "Changes have not been saved - original password incorrect."
    },
    "ucb": {
      "title": "Legal documents and information",
      "text": "Please note that UniCredit Bank Czech Republic and Slovakia, a.s. assumes no responsibility for the content and conduct of the service provided to employees. The use of this service by employees is voluntary and the responsibility for the delivery of the service in the form of medical advice rests with the service provider, uLékaře.cz, s.r.o., who is responsible for ensuring that the medical advice is provided exclusively by a person qualified to do so under applicable Czech law. Before using the medical advice service, employees are advised to properly read the {terms_and_conditions} of using the service.",
      "termsAndConditions": "terms and conditions"
    },
    "removeSection": {
      "title": "Account cancellation",
      "text": "Your account will be deactivated. If you change your mind, you can cancel the deactivation by logging into your account. After 30 days, you will not be able to return to your account.",
      "button": "Cancel account"
    },
    "removeDialog": {
      "title": "Are you really sure?",
      "areYouSure": {
        "text": "Your account will be deactivated. If you change your mind, you can cancel the deactivation by logging into your account. After 30 days, you will not be able to return to your account.",
        "yes": "Delete account",
        "no": "Stay healthy",
        "title": "Do you really want to cancel your account?"
      },
      "list": [
        {
          "icon": "chat-empty",
          "text": "You will lose your prevention guide. Taking care of your health will now be more difficult."
        },
        {
          "icon": "surgeon",
          "text": "You will say goodbye to more than 350 doctors and nurses who help you."
        },
        {
          "icon": "person-sad",
          "text": "You will lose valuable answers from doctors and an overview of your health."
        }
      ],
      "footer": "Do you have questions or need help? Our customer care team is here for you at {email} or {phone}.",
      "cancelButton": "Stay healthy",
      "deleteButton": "Cancel account",
      "confirmTitle": "Your account will be cancelled.",
      "confirmText": "If you change your mind, you can restore your account by logging in within the next 30 days using your current login information. <br/>If you have any questions, please contact our customer support at <a href=\"mailto: info@ulekare.cz\">info@ulekare.cz</a> or <a href=\"tel:00420227072720\">+420 227 072 720</a>.",
      "feedback": {
        "title": "Why are you leaving?",
        "checkboxes": {
          "no_or_low_use": "I no longer need the service or I use it little",
          "disappointed": "The services did not meet my expectations",
          "price_too_high": "The price is high for me",
          "better_alternative": "I use another service",
          "other": "Other reason / I prefer not to say"
        },
        "detailsLabel": "Tell us more",
        "confirm": "Delete account",
        "cancel": "Stay healthy"
      },
      "password": {
        "title": "Confirm account termination"
      }
    },
    "benefits": {
      "consultation_forum": {
        "chip": "Consultations",
        "tooltip": "Ask a doctor your question and get an answer online."
      },
      "booking": {
        "chip": "Appointments",
        "tooltip": "Our nurses will schedule your doctor's appointment."
      },
      "prevention_plan": {
        "chip": "My prevention",
        "tooltip": "Personalized check-ups and vaccinations."
      },
      "insurance_contributions": {
        "chip": "Insurance benefits",
        "tooltip": "Find out what insurer contributions you’re entitled to."
      },
      "health_tests": {
        "chip": "Medical tests",
        "tooltip": "Complete a short test and find out more about your health."
      },
      "video_call_therapist": {
        "chip": "Video call: therapist",
        "tooltip": "Book an on-line session with a therapist."
      },
      "content_explore": {
        "chip": "Discover",
        "tooltip": "Articles, podcasts, tests, and tips for healthier living."
      },
      "helpline_free": {
        "chip": "Toll-free line",
        "tooltip": "We’re here for you on workdays from 8:00 a.m. to 5:00 p.m."
      },
      "video_call_doctor": {
        "chip": "Video call: doctor",
        "tooltip": "Book a video call with a doctor."
      },
      "assistance_line": {
        "chip": "Assistance hotline"
      },
      "blood_tests_review": {
        "chip": "Blood tests + explanation",
        "tooltip": "Schedule a blood test and get your results explained by a doctor."
      }
    },
    "benefit": {
      "validTo": "Valid to",
      "availableServices": "Available for you",
      "title": "Service admin",
      "subtitle": "Your current free service configuration",
      "card": {
        "authorize": "Active",
        "prolong": "Expires soon",
        "pending": "Waiting for completion of service activation",
        "ended": "Expired",
        "family": "Active (family member)",
        "familyExpired": "Ask your family member about extending the free service"
      },
      "partnerSuggestions": {
        "title": "Change in free service provider",
        "subtitle": "Only one company or partner can cover your free service",
        "nosearch": {
          "title": "Don’t want to search? That’s OK.",
          "subtitle": "Perhaps you can have the service for free thanks to one of our six partners."
        }
      },
      "searchPlaceholder": "Enter company or partner name",
      "selectPartner": "Activate free service",
      "serviceNotActive": "Free service is not active",
      "b2c": {
        "title": "You don’t have a company or partner assigned that would cover the service for you.",
        "subtitle": "Enter the name of a company or partner to get free access to the service. A partner can be your insurance company, card issuer, or similar."
      },
      "authorization": {
        "none": "Other form of activation",
        "email": "Activation with e-mail",
        "codeOnly": "Activation with a code",
        "codeAndEmail": "Activation with code and email",
        "code": {
          "finished": {
            "buttonText": "Finished"
          }
        }
      },
      "prolong": {
        "buttonText": "Extend your free service"
      },
      "authorize": {
        "buttonText": "Activate your free service"
      },
      "goback": "Back",
      "partnerDetected": {
        "title": "It looks like you’re entitled to free service. Is that right?",
        "subtitle": "If yes, activate the free service."
      },
      "family": {
        "buttonText": "Current settings"
      },
      "ended": {
        "buttonText": "Extend your free service"
      },
      "info": {
        "ended": "Reactivate free service",
        "authorize": "Free service is active",
        "prolong": "Free service will soon expire",
        "family": "Free service is active thanks to family sharing"
      },
      "manage": {
        "buttonText": "Service settings"
      },
      "reauthorize": {
        "buttonText": "Extend your free service"
      },
      "showMore": "Show more",
      "showLess": "Show less"
    },
    "multifactor": {
      "label": "Two-factor authentication",
      "off": "Off",
      "offInfo": "Two-factor authentication disabled",
      "sms": "SMS verification",
      "smsInfo": "A verification code will be sent to your phone when signing in.",
      "email": "Email verification",
      "emailInfo": "You’ll receive a verification code by email when you try to sign in."
    },
    "appSecurity": "App Security",
    "cAppSecurity": {
      "biometry": {
        "description": "Secure app access with fingerprint or face scan",
        "title": "Biometric Lock"
      },
      "title": "App Security",
      "pin": {
        "title": "PIN Code",
        "description": "Protect app access with a six-digit PIN",
        "setup": {
          "enterTitle": "Set PIN",
          "enterSubtitle": "Enter a six-digit PIN",
          "confirmTitle": "Confirm PIN",
          "confirmSubtitle": "Re-enter PIN to confirm",
          "mismatch": "PINs do not match, please try again",
          "cancel": "Cancel"
        },
        "verify": {
          "title": "PIN Verification",
          "subtitle": "Enter your PIN to continue",
          "incorrect": "Incorrect PIN, please try again"
        }
      },
      "lock": {
        "title": "App is locked",
        "subtitle": "Verify your identity to continue",
        "biometricButton": "Unlock",
        "wrongPin": "Incorrect PIN, please try again"
      },
      "deviceNotSecure": {
        "title": "App unavailable",
        "body": {
          "android": "Your phone is not secured. To use this app, please set up a screen lock (PIN, password, fingerprint, or face recognition) in your device settings.",
          "ios": "Your phone is not secured. To use this app, please set up a screen lock (PIN, password, fingerprint, or face recognition) in Settings → Face ID & Passcode."
        },
        "button": "Open settings"
      },
      "deviceRooted": {
        "title": "App unavailable.",
        "body": {
          "android": "Your phone is rooted. For security reasons, this app cannot be used on rooted devices.",
          "ios": "Your phone is jailbroken. For security reasons, this app cannot be used on jailbroken devices."
        }
      }
    }
  },
  "passwordRenewal": {
    "title": "Update your password.",
    "subtitle": "You need to update your password because your password has expired.",
    "currentPassword": "Current password:",
    "newPassword": "New password:",
    "passwordRules": "The password must be at least 12 characters long and contain at least one letter, a number and a special character (-=%*+./![]@#$^&()?;) and must not use the same password you have used in the past",
    "confirmation": "Confirm your new password",
    "passwordsDontMatch": "Passwords do not match",
    "button": "Change password",
    "thankYouTitle": "Password has been changed",
    "thankYouSubtitle": "Your password has been successfully changed. Thank you for your cooperation!"
  },
  "subscription": {
    "signpost": {
      "title": "How do you want to use the service?",
      "b2cButton": "I want to become a client",
      "b2bButton": "I'm entitled to free service"
    }
  },
  "questions": {
    "answerDisclaimer": "Please note that the answer above is for information only. It involves general advice and information in the area of health, illness, or other health problems. The information provided above cannot be considered an individual diagnosis, treatment plan, or prevention plan, especially given the limited capabilities of on-line communication. Given that information from users cannot be complete and a&nbsp;physical examination is impossible, answers from individual doctors may differ in details depending on their experience and clinical practice. Use of the service is in no way a&nbsp;substitute for a personal examination by a doctor. If you have health problems, we recommend seeking medical or other specialized help depending on their nature. The doctor’s answer may have been translated using an automatic translation tool; it is always then checked thoroughly by a medical professional.",
    "title": "Consultations",
    "subtitle": "Keep track of your questions. Ask our doctors.",
    "noQuestion": {
      "title": "We are still waiting for your first question.",
      "subtitle": "How can we help you?",
      "infoList": [
        {
          "text": "You will quickly find out whether you can deal with a health problem yourself or if you need to seek medical help.",
          "icon": "suitcase"
        },
        {
          "text": "A doctor from our consultation service will advise you as to what sort of examination to undergo or the right specialist to see.",
          "icon": "surgeon-question"
        },
        {
          "text": "Our experts will help you understand the medical report or lab results.",
          "icon": "stop"
        },
        {
          "text": "Don't worry, we can help with your family's health problems too.",
          "icon": "temperature"
        }
      ]
    },
    "newQuestion": "New question",
    "newSolved": "Processing",
    "waitingForAnswer": "Waiting for an answer",
    "history": "Question history",
    "detail": {
      "title": "Question details",
      "sent": "Sent",
      "questionFormTitle": "Health problem description",
      "attachments": "Attachments",
      "helped": "Did the answer help you?"
    },
    "evaluation": {
      "title": "Thank you for your reaction",
      "text": "It will help us improve our services. Would you like to tell us anything else?",
      "label": "Additional comments and suggestions",
      "placeholder": "How can we improve the service?",
      "ok": "Answer helped",
      "nok": "Answer didn't help"
    },
    "thankYou": {
      "title": "Your question has been sent",
      "subtitle": "(The service will be delivered in the {language} language)",
      "cs": "Czech",
      "en": "English",
      "sk": "Slovak",
      "text": "Our generall practitioner is curently reviewing your request. We'll notify you via email as soon as your question is answered."
    },
    "status": {
      "waitingGpAnswer": "Your question is waiting to be answered by a GP.",
      "waitingSpecialistAnswer": "Your question is waiting to be answered by a specialist.",
      "answered": "Your question has been answered.",
      "transferToAppointment": "Your question has been transferred to appointment scheduling. We will contact you.",
      "declined": "Your question has been rejected.",
      "emergency": "Your question has been answered. It seems as a life-threatening condition and we recommend visiting the nearest emergency room."
    },
    "askedQuestions": "Submitted questions"
  },
  "appointments": {
    "title": "My appointments",
    "subtitle": "Keep track of your questions. Ask us to find you a suitable doctor.",
    "statuses": {
      "newDoctor": "We found a doctor.",
      "newZZ": "We've found health care facilities."
    },
    "noAppointments": {
      "title": "You don't have any appointments yet.",
      "subtitle": "And do you know how the service works?",
      "infoList": [
        {
          "text": "We schedule appointments with doctors throughout the Czech Republic.",
          "icon": "hospital"
        },
        {
          "text": "The next workday one of our nurses will contact you and discuss everything we need to find you a doctor.",
          "icon": "nurse"
        },
        {
          "text": "Don't waste time looking for a doctor, we'll do it for you.",
          "icon": "clock"
        }
      ]
    },
    "newAppointment": "New appointment",
    "activeAppointments": "Active appointments",
    "visitAppointments": "Don't forget to visit the doctor",
    "evaluateAppointments": "Rate your doctor visit",
    "history": "Appointment history",
    "evaluation": {
      "ok": "I was satisfied",
      "nok": "I wasn't satisfied",
      "noVisit": "Visit didn't happen"
    },
    "detail": {
      "title": "Appointment details",
      "sent": "Sent",
      "date": "Appointment date: ",
      "visitAt": "When to visit: ",
      "facility": "Medical facility: ",
      "address": "Address: ",
      "doctor": "Doctor: ",
      "phone": "Phone number: ",
      "note": "Note: ",
      "dateMandatory": "You must come on this date!",
      "unableToVisitInfo": "If you cannot make the scheduled doctor's appointment, please call {phone} or write us at <a href='mailto:{email}'>{email}</a>",
      "thankYou": "We trust that the doctor we recommended will help you with your health problems. Please let us know how it went. Thank you!",
      "additionalQuestion": "I have an additional question",
      "changeDate": "Change date",
      "cancelAppointment": "Cancel appointment",
      "helped": "How do you rate the order?",
      "noVisit": "Didn't happen"
    },
    "thankYou": {
      "title": "Your appointment request has been sent",
      "subtitle": "(The service will be delivered in the {language} language)",
      "cs": "Czech",
      "en": "English",
      "sk": "Slovak",
      "text": "A nurse will contact you the following workday from the number +420 227 072 720.",
      "others": {
        "text": "For the follow-up communication, please obtain the following information about the person:",
        "items": [
          {
            "icon": "register",
            "text": "national ID number & health insurance"
          },
          {
            "icon": "person-happy",
            "text": "current state of health"
          },
          {
            "icon": "news",
            "text": "medical exam history & requests"
          },
          {
            "icon": "clock",
            "text": "time availability"
          }
        ]
      }
    },
    "status": {
      "waiting": "Your scheduling request is waiting to be processed. Please wait for us to contact you.",
      "lookingForDoctor": "We're working on finding a suitable doctor.",
      "orderedForTime": "Your doctor's appointment is for {datetime}",
      "orderedForOpeningHours": "Your appointment has been scheduled. Visit the doctor during visiting hours.",
      "sendContact": "The doctor's contact information has been sent.",
      "done": "Your scheduling request has been processed.",
      "cancelled": "Appointment cancelled."
    },
    "previousAppointments": "Order history"
  },
  "prevention": {
    "title": "Start with prevention. For your health.",
    "subtitle": "Fill in a bit of information and get customized prevention. We'll help you avoid health problems and illnesses.",
    "birthDateNote": "Age is just a number. We need to know it to provide you with the right care.",
    "healthInsuranceProviderNote": "For making appointments with doctors cooperating with the insurer.",
    "personalization": {
      "banner": {
        "title": "Prevention that fits you",
        "subtitle": "Give us a&nbsp;few details about yourself, and get a&nbsp;prevention plan tailored just for you.",
        "button": "Get tailored prevention"
      },
      "title": "Check-up personalization by age",
      "text": "Turning this off will also show preventive check-ups that one usually undergoes when older."
    },
    "start": "Start with prevention",
    "thankYou": {
      "title": "And that's it! Thank you for filling everything in.",
      "text": "Taking preventive care of your own heath can help you avoid health problems and illnesses. You will receive regular tips and news via email on how to care for your health."
    },
    "summary": {
      "title": "Prevention",
      "subtitleDesktop": "We'll help you avoid health problems and illnesses.",
      "subtitleMobile": "Prevent health problems.",
      "showAll": "Show all",
      "intervalEnds": "Ending prescribed interval",
      "planned": "Planned",
      "plannedOn": "Planned at {time}",
      "timeline": {
        "title": "Next",
        "tooltip": "See the closest ending intervals of your check-ups and vaccinations. Make an appointment in time."
      },
      "examinations": {
        "title": "Preventive check-ups",
        "tooltip": "We'll give you a clear overview of your check-ups and their dates."
      },
      "vaccinations": {
        "title": "Vaccination",
        "tooltip": "We'll give you a clear overview of your vaccinations and their dates."
      },
      "others": {
        "title": "Other"
      },
      "tallyTests": {
        "title": "Thematic health tests"
      }
    },
    "list": {
      "examinations": {
        "recommended": "Compulsory check-ups",
        "optional": "Voluntary check-ups"
      },
      "vaccinations": {
        "recommended": "Compulsory vaccinations",
        "optional": "Voluntary vaccinations"
      }
    }
  },
  "labTests": {
    "rowTitle": "Your blood tests",
    "detail": {
      "title": "Lab test details",
      "questionFormTitle": "Health problem description",
      "healthFormTitle": "State of health",
      "attachments": "Attachments",
      "helped": "Did the answer help you?"
    },
    "status": {
      "draft": {
        "title": "Have the sample(s) taken at the lab",
        "text": "Your doctor will be sent the results of your tests.",
        "actionText": "Go to Unilabs"
      },
      "new": "We’re waiting for your lab test results.",
      "answered": "Finished! Read your results and explanation."
    }
  },
  "loginBanner": {
    "title": "We're your guide to better health.",
    "infoList": [
      {
        "icon": "doctor",
        "text": "General practitioners and specialists answer questions."
      },
      {
        "icon": "nurse",
        "text": "Nurses help make doctor's appointments"
      },
      {
        "icon": "shield",
        "text": "A secure environment that's fully in your hands."
      }
    ],
    "show": "How does the service work?",
    "hide": "Close"
  },
  "cookiesConsent": {
    "acceptAll": "Accept all",
    "basic": {
      "title": "Our website works like a doctor",
      "perex": "Our website uses cookie files, and thus works like a doctor who asks questions in order to be able to help you in the best possible way. We use them to collect {technical}, {analytical}, and {marketing} information in order to continually improve and hence be better able to help you all. Do you agree?",
      "technical": "technical",
      "analytical": "analytic",
      "marketing": "business",
      "customize": "Settings"
    },
    "settings": {
      "title": "Configuration of cookies",
      "description": "When you visit our website www.ulekare.cz, the site obtains or stores information in your browser, usually in the form of cookies. This can be information about you, your preference,s and the device you are using. This is usually used to improve the site, so it works as you expect. As a rule, information does not identify you as an individual, but overall can help adapt the environment to your needs. We respect your right to privacy, so you can decide not to accept some cookies, according to the options below. But keep in mind that by blocking some cookies, you can affect how the site works and what services are offered to you.",
      "link": "You can find our cookie statement {hereLink}.",
      "items": {
        "technical": {
          "title": "Technical cookies",
          "bodyText": "These are required to make our site work, so they cannot be switched off. They are usually set up in response to actions you have taken, such as requesting services related to security settings, logging in, filling out forms, and so on. You can set your browser to block cookies or send notifications about them. These cookies do not store any identifiable information."
        },
        "functional": {
          "title": "Functional cookies",
          "bodyText": "These cookies allow the site to be more effective and personal. They may be configured by us or the third-party providers whose services we use on the site. If you do not enable these cookies, some or all of these services may not work properly."
        },
        "analytics": {
          "title": "Analytical cookies",
          "bodyText": "These cookies are used to improve how the website works. They allow us to recognize and track the number of visitors and how they use the website. They help us improve the way the website works. These cookies do not collect information that could identify you."
        },
        "marketing": {
          "title": "Marketing cookies",
          "bodyText": "These are used to track website users' preferences for ad targeting, i.e., to display marketing and advertising messages (including on third-party sites) in accordance with these preferences. <strong>Marketing cookies use the tools of external companies. These marketing cookies will only be used with your consent.</strong>"
        }
      },
      "save": "Save settings"
    },
    "youtube": {
      "text": "We need to use functional cookies to show you this video. You can find more information in our {cookiePolicyLink}.",
      "cookiePolicyLinkText": "cookie policy",
      "accept": "Accept"
    }
  },
  "thematic_counselling": {
    "dashboard": {
      "title": "Focused on prevention",
      "hint": {
        "b2b": "How can you prevent cancer? {desktopBreakline}Which preventive check-ups are appropriate? Ask the specialists.",
        "b2c": "How can you prevent cancer? {desktopBreakline}Which preventive check-ups are appropriate? Get free advice."
      },
      "onco-prevention": {
        "title": "Oncological prevention",
        "short": "We want to help you with any concerns about the serious disease. Our doctors will gladly guide you.",
        "long": "Are you afraid that you have a higher risk of cancer in your family?<br>Which preventive check-ups are appropriate?<br>What can be detected by medical tests?<br>Our doctors will gladly guide you.",
        "footer": "⏱  Specialists from this advisory respond within 48 hours",
        "button": "Ask a doctor",
        "profileSectionButton": "Get consultation"
      },
      "final": {
        "title": "Your query has been sent.",
        "text": "It is now being attended to by our specialist, and we'll let you know by email as soon as your questions have been answered.",
        "button": "Finished"
      },
      "doctors": [
        {
          "name": "MUDr. František Rolinek",
          "specializations": [
            "General Practitioner"
          ],
          "institution": "MUDr. František Rolinek - clinic, Brno",
          "image": "TMP/mudr_frantisek_rolinek.jpeg"
        },
        {
          "name": "MUDr. Lenka Rudolfová",
          "specializations": [
            "General Practitioner"
          ],
          "institution": "AGEL Clinic, Prague",
          "image": "TMP/mudr_lenka_rudolfova.jpeg"
        }
      ]
    }
  },
  "TMP": {
    "fb": {
      "error": "We apologize for the inconvenience. We are facing some technical difficulties with FB login right now. We took contact with FB and are putting extra effort to solve the problems as soon as possible. For new registration please use some of the other methods. For login to your account please try again tomorrow."
    }
  },
  "placeholders": {
    "date": {
      "year": "YYYY",
      "month": "MM",
      "date": "DD"
    },
    "time": {
      "hour": "hh",
      "minute": "mm"
    }
  },
  "unavailableClinics": {
    "title": "We are updating the app for you",
    "description": "We are sorry for a brief service outage. We are deploying new app improvements at the moment. We will be back shortly."
  },
  "releaseNotes": {
    "title": "Welcome to your health zone at uLékaře.cz",
    "perex": "A long and healthy life is within your reach, all it takes is the first step. With us, prevention becomes an easy, natural part of your day. Ready to start?",
    "content": [
      {
        "icon": "date-question",
        "text": "When did you last see your GP, and when are you due for your next visit? Add your appointment, and we’ll make sure you don’t miss anything."
      },
      {
        "icon": "payment",
        "text": "Did you know you can save on preventive care for every family member? We have an overview of what your health insurance will reimburse."
      },
      {
        "text": "A quick health check with a recommendation at the end. Do you sleep well? How do you care for your body and mind? This short test will help you find out.",
        "icon": "report"
      }
    ],
    "primaryButtonText": "Start with prevention",
    "secondaryButtonText": "Test yourself"
  },
  "healthInsuranceProviderBenefits": {
    "dashboard": {
      "title": "Insurance company contributions",
      "text": "Find out what benefits your insurance company offers"
    },
    "title": "Select your insurance provider",
    "privateInsuranceProviders": "Private providers",
    "publicInsuranceProviders": "Public providers",
    "showDetail": "Show details",
    "hideDetail": "Hide details",
    "buttonText": "Save insurance provider and display",
    "empty": {
      "title": "No contributions",
      "text": "Unfortunately, the selected insurance provider offers no contributions"
    },
    "fullInfo": {
      "base": "For a complete list of bonuses and conditions, see {link}.",
      "linkText": "the insurance provider's website"
    },
    "footer": {
      "updated": "Updated {date}",
      "changeCompanyInSettings": "Change insurance provider in settings",
      "changeCompany": "Change insurance provider"
    }
  },
  "explore": {
    "title": "Discover",
    "searchTitle": "Back to Discover",
    "subtitle": "Read health tips, recommendations, or stories",
    "articles": {
      "title": "Articles",
      "titleDetail": "Article details",
      "shareText": "I'm sending an interesting article from uLékaře.cz",
      "footer": {
        "title": "Did a question occur to you while reading that you'd like to ask a doctor?",
        "textQuestion": "We'll be glad to answer any question regarding your health, the health of a family member, or this article.",
        "textQuestionOrder": "We'll be glad to answer any question regarding your health, the health of a family member, or this article. And if needed, we'll book your appointments with doctors all across the Czech Republic."
      }
    },
    "consultations": {
      "titleDetail": "Question details"
    }
  },
  "invitation": {
    "dashboard": {
      "title": "Family plan",
      "text": "uLékaře.cz service for your family. Free of charge.",
      "buttonText": "Share invite"
    },
    "title": "Keep your family healthy",
    "text": "Invite up to 5 of your family members and closest friends. Thanks to you, they’ll have free online care from doctors and nurses right at their fingertips.",
    "list": [
      {
        "icon": "link",
        "text": "Copy the invite link"
      },
      {
        "icon": "rodina",
        "text": "Send it to your family members."
      },
      {
        "icon": "confetti",
        "text": "Free service is available upon registration"
      }
    ],
    "shareLink": "Invite link",
    "copyCode": "Copy invite link",
    "codeCopied": "Copied",
    "familyTitle": "Manage your family",
    "remove": "Remove",
    "shareTitle": "uLékaře.cz free of charge.",
    "shareText": "{personName} is sharing the uLékaře.cz family plan with you. Register via the link and get it free of charge.",
    "emptyMemberName": "Family member"
  },
  "languageSwitcher": {
    "cz": "Čeština",
    "sk": "Slovenčina",
    "en": "English",
    "uk": "Українська",
    "ru": "Русский язык",
    "hu": "Magyar"
  },
  "medicalProcedure": {
    "editReport": "Edit",
    "markAsDone": "Mark as done",
    "notes": "Your notes",
    "notesPlaceholder": "Add your own notes ...",
    "uploadFiles": "Upload files",
    "information": "Information",
    "content": {
      "content1": "What can I expect?",
      "content2": "How should I prepare?",
      "content3": "Is the check-up covered?",
      "content4": "How should I do it?",
      "content5": "When should I do it?",
      "content6": "What if I find something irregular?",
      "content7": "How is it transmitted?",
      "content8": "Can it be prevented?",
      "content9": "What vaccine should I choose?"
    },
    "boxes": {
      "recommended": "Recommended",
      "male": "For men",
      "female": "For women",
      "from": "from",
      "interval": "Interval",
      "showDetail": "Show detail",
      "letsStart": "Let's start",
      "noRecords": "No records"
    },
    "examination": {
      "title": "Check-up detail",
      "add": "Log check-up",
      "listTitle": "My check-ups",
      "newFormPerex": "Log the check-up date. You can also save notes and files (photos, medical reports, etc.).",
      "editFormPerex": "Here you can edit the date, notes, and manage related files.",
      "optional": "Voluntary check-up",
      "recommended": "Compulsory check-up",
      "type": "Check-up",
      "nextBy": "Next check-up by",
      "next": "Next check-up",
      "last": "Last check-up",
      "new": "New check-up",
      "date": "Check-up date",
      "time": "Check-up time",
      "past": "Past",
      "pastMulti": "Past",
      "future": "Upcoming",
      "missedNotification": "The prescribed check-up interval has been exceeded.",
      "emptyNotification": "Here you can log and manage your check-ups.",
      "errorDateEmpty": "Please enter the check-up date.",
      "errorDateBoundsPast": "Please enter the date of already completed check-up.",
      "errorDateBoundsFuture": "The date must be in future.",
      "todayDateCheckboxLabel": "Check-up took place today",
      "errorTimeRequired": "Please enter the time of your checkup",
      "manageReports": "My check-ups",
      "emptyPlaceholder": {
        "title": "Log your first check-up",
        "perex": "Managing your check-ups was never easier"
      }
    },
    "vaccination": {
      "title": "Vaccination detail",
      "add": "Log vaccination",
      "listTitle": "My vaccinations",
      "newFormPerex": "Log the vaccination date. You can also save notes and files (photos, medical reports, etc.).",
      "editFormPerex": "Here you can edit the date, notes, and manage related files.",
      "optional": "Voluntary vaccination",
      "recommended": "Compulsory vaccination",
      "type": "Vaccination",
      "nextBy": "Next vaccination by",
      "next": "Next vaccination",
      "last": "Last vaccination",
      "new": "New vaccination",
      "date": "Vaccination date",
      "time": "Vaccination time",
      "past": "Past",
      "pastMulti": "Past",
      "future": "Upcoming",
      "missedNotification": "The prescribed vaccination interval has been exceeded.",
      "emptyNotification": "Here you can log and manage your vaccinations.",
      "errorDateEmpty": "Please enter the vaccination date.",
      "errorDateBoundsPast": "Please enter the date of already completed vaccination.",
      "errorDateBoundsFuture": "The date must be in the future.",
      "todayDateCheckboxLabel": "Vaccination took place today",
      "errorTimeRequired": "Please enter the time of your vaccination",
      "manageReports": "My vaccinations",
      "emptyPlaceholder": {
        "title": "Log your first vaccination",
        "perex": "Managing your vaccinations was never easier"
      }
    },
    "trash": {
      "title": "Do you really want to delete the record?",
      "text": "You will delete the record, including any notes and attachments.",
      "keep": "Keep record",
      "delete": "Delete"
    }
  },
  "intervals": {
    "months": {
      "single": "month",
      "plural": "months",
      "semi": "months"
    },
    "years": {
      "single": "year",
      "plural": "years",
      "semi": "years"
    }
  },
  "dateInput": {
    "errors": {
      "invalidFormatDate": "Please enter the date in a valid format between {min} and {max}",
      "invalidFormatMonth": "Please enter the month in a valid format between {min} and {max}"
    }
  },
  "timeInput": {
    "errors": {
      "invalidFormat": "Please enter the time in a valid format between 0:00 and 23:59",
      "required": "Please enter the time"
    }
  },
  "feedback": {
    "title": "How do you like uLékaře.cz?",
    "text": "Your feedback is our vitamin. Thanks to you, we keep the app in the best shape possible.",
    "label": "Do you have any ideas for improvement?",
    "placeholder": "Feel free to share them here...",
    "thankYou": {
      "title": "Thank you for the feedback",
      "text": "We do our best to make caring for your health easier."
    },
    "menu": "Feedback",
    "panelButton": "Provide feedback"
  },
  "newsletterAgreement": {
    "dashboard": {
      "title": "Healthy news",
      "text": "We'll send you news and discounts via email."
    },
    "title": "We'll send health to your mailbox.",
    "perex": "Your journey to long-term health starts here.",
    "content": [
      {
        "icon": "confetti",
        "text": "Regular wellness tips."
      },
      {
        "icon": "care",
        "text": "Valuable discounts on products that help you stay healthy."
      },
      {
        "icon": "news",
        "text": "Notification of new articles you'll enjoy reading."
      }
    ],
    "footer": {
      "text": "By clicking on the “Subscribe” button you agree to {link}.",
      "linkText": "receive marketing messages"
    }
  },
  "bloodReport": {
    "infoStep": {
      "title": "Your health with explanations",
      "perex": "Put your health under the microscope. Blood tests and detailed comments by a doctor will help you understand your body.",
      "list": [
        {
          "icon": "register",
          "text": "Describe your current health so recommendations by doctors fit like a glove."
        },
        {
          "icon": "calendar/date-31",
          "text": "We’ll recommend you a suitable test. Pick the time and place that suits you best to provide samples."
        },
        {
          "icon": "doctor",
          "text": "The results will arrive from the lab. Our doctor will explain them in plain language."
        }
      ],
      "legal": [
        "The Lab Test Interpretation service is a medical service provided remotely {link} , only in the field of internal medicine.",
        "Interpretation of lab results is a health service that is not covered by public health insurance.",
        "We process your personal data in accordance with {link}."
      ],
      "legalLinkTexts": [
        "by an independent health services provider",
        {},
        "the Principles of Personal Data Protection"
      ],
      "serviceText": "\nWe will arrange the service for you through the following health service providers:<br/>\n<br>\ntaking blood samples and providing lab results:<br/>\nUnilabs Diagnostics k.s.<br/>\nwith registered office at Evropská 2589/33b, Dejvice, 160&nbsp;00&nbsp;Prague&nbsp;6<br/>\nID: 604&nbsp;70&nbsp;488<br/>\nregistered with the Municipal Court in Prague, File&nbsp;No&nbsp;A&nbsp;76193<br/>\n<br>\ninterpretation of lab results:<br/>\nuLékaře.cz Health Care, s.r.o.<br/>\nwith registered office at Českomoravská 2408/1a, Libeň, 190&nbsp;00&nbsp;Prague&nbsp;9<br/>\nID: 096&nbsp;64&nbsp;777<br/>\nregistered with the Municipal Court in Prague, File No&nbsp;C&nbsp;339989\n      ",
      "agreements": {
        "termsAndConditions": {
          "text": "I agree with  {link} from health services provider uLékaře.cz Health Care, s.r.o.",
          "linkText": "the Terms and Conditions of the Lab Test Interpretation service "
        }
      }
    },
    "finalStep": {
      "title": "What’s next?",
      "text": "Thank you for the information. It will help doctors correctly evaluate the results of your tests. Now we’ll hand you over to Unilabs – our partner laboratory.",
      "button": "Go to Unilabs",
      "list": [
        {
          "title": "Step 1",
          "text": "Select a lab test"
        },
        {
          "title": "Step 2",
          "text": "Reserve a location, date, and time, come and provide a sample"
        },
        {
          "title": "Step 3",
          "text": "We’ll deliver your results, explained by a doctor"
        }
      ]
    }
  },
  "addressInput": {
    "country": "State",
    "postcode": "Postcode",
    "street": "Street and house number",
    "locationIncomplete": "Please enter your full address."
  },
  "videocall": {
    "chooseDate": "Select a date",
    "confirmReservation": "Confirm reservation",
    "reservationProgressing": "Confirmation in progress",
    "dayOfWeek": [
      "Sun",
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat"
    ],
    "month": [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "thankYou": {
      "info": "We have sent you all the necessary information by email.",
      "success": "Video call successfully scheduled 🎉",
      "close": "Close"
    }
  },
  "videoTherapy": {
    "infoStep": {
      "perex": "Mgr. Věra Kudličková Dušková will discuss work, relationship or psychological problems with you. A 50-minute private online session awaits you.",
      "title": "Feeling down?",
      "list": {
        "third": "Confirmed? Check your email for a link you’ll then use to start \nthe video call with a therapist.",
        "second": "Pick the date and time you’d like to meet the therapist on-line.",
        "first": "First, check your personal and contact details."
      },
      "legal": [
        "The service will be provided by a non-medical services provider:",
        "uLékaře.cz,\nwith registered office: Českomoravská 1a, 190 00 Prague 9, ID: 05341051,\nregistered with the Municipal Court in Prague, File No C 339989",
        "The Video Call With a Therapist service is paid for by your employer.",
        "The Video call With a Therapist service is a non-medical service provided remotely as a video call."
      ],
      "therapist": {
        "image": "mgr_vera_kudlickova_duskova.png",
        "name": "Mgr. Věra Kudličková Dušková",
        "specialization": "Psychologist from uLékaře.cz",
        "workplace": "Psychology"
      }
    },
    "formStep": {
      "legal": {
        "termsConditions": {
          "text": "I agree with {legalText} Video call With a Therapist provided by the uLékaře.cz service"
        }
      }
    },
    "pilot": "Video call with a therapist"
  },
  "homepage": {
    "hero": {
      "title": "Healthy</span><br/><span>employees.</span><br/><span style=\"opacity: .6\">Head to toe.</span>",
      "bottomText": "<div><span>We help your employees</span><br/>\n<span>extend healthy life. We thus help increase</span><br/>\n<span>your company's productivity and cut costs.<span/></div>"
    },
    "header": {
      "nav": {
        "login": "Log in",
        "link": [
          "What we do",
          "Why uLékaře.cz",
          "References",
          "Our service",
          "Career",
          "Contact"
        ]
      }
    },
    "data": {
      "title": "<span class=\"translucent\">Health is every</span><br />\n      company's business.",
      "card": [
        {
          "animationData": "data_01.json",
          "caption": "Savings Calculator",
          "header": "Save time, cut costs.",
          "paragraph": [
            "Searching for a doctor while at work and making calls to doctors’ offices increase costs and contribute to presentism.",
            "Thanks to the uLékaře.cz service, employees can resolve many of their problems quickly, online, and in a timely manner to potentially prevent more serious consequences.",
            "*The data is based on the average salary in the Czech Republic in June 2023."
          ]
        },
        {
          "animationData": "data_02.json",
          "caption": "Healthy Life",
          "header": "Employees age.",
          "paragraph": [
            "After age 50, employees spend more time seeing doctors.",
            "But companies need their employees to be physically and mentally healthy to an advanced age.",
            "By using the uLékaře.cz service, you’ll help your people stay healthy longer or detect disease in time."
          ]
        },
        {
          "animationData": "data_03.json",
          "caption": "Influences On Your Health Health",
          "header": "Health doesn’t happen a chance.",
          "paragraph": [
            "Health is affected much more by our habits and behaviour than by medical care.",
            "Our work and life environment, genetics, and socio-economic factors such as education, employment, and relationships also play a role.",
            "With the uLékaře.cz service you have an effective tool that motivates employees to lead a healthier life."
          ]
        }
      ]
    },
    "circle": {
      "card": [
        {
          "icon": "circle-placeholder-first.svg",
          "title": "We measure data",
          "desktop": [
            "We don’t guess when it comes to health, we measure it.",
            "We also help companies fulfil social responsibility goals as part of ESG and make reporting easier."
          ],
          "mobile": [
            "We don’t guess when it comes to health, we measure it."
          ],
          "cta": {
            "href": "https://sites.google.com/ulekare.cz/zdravijevase/v%C5%A1e-o-esg",
            "label": "More about ESG"
          }
        },
        {
          "icon": "circle-placeholder-second.svg",
          "title": "We educate",
          "desktop": [
            "We increase the awareness of HR and management regarding the importance of employee health and well-being. Through expert guidance we help create a healthy work environment and effective health care strategies.",
            "A community of healthy companies opens the door to all HR departments looking for support when it comes to caring for company health and other areas."
          ],
          "mobile": [
            "We increase the awareness of HR and management regarding the importance of employee health and well-being. Through expert guidance we help create a healthy work environment and effective health care strategies."
          ],
          "cta": {
            "href": "https://app.ulekare.cz/konference",
            "label": "More about the Community"
          }
        },
        {
          "icon": "circle-placeholder-third.svg",
          "title": "We take an active approach",
          "desktop": [
            "Based on your company’s data and needs, we take care of the practical steps that will bring you closer to better company health. We’ll put together a package of services such as on-line consultation, appointments, video calls with doctors, and Health Days.",
            "Subsequent education in the area of prevention is also based on data you will obtain from regular reports."
          ],
          "mobile": [
            "Based on your company’s data and needs, we take care of the practical steps that will bring you closer to better company health. We’ll put together a package of services such as on-line consultation, appointments, video calls with doctors, and Health Days."
          ],
          "cta": {
            "href": "https://www.ulekare.cz/sluzba",
            "label": "More about the service"
          }
        }
      ],
      "altText": "Circle of Health"
    },
    "community": {
      "main": {
        "header": {
          "caption": "Community of Healthy Companies",
          "heading": "A new level of HR:",
          "description": "health experts."
        }
      },
      "card": [
        {
          "img": "hobzova.png",
          "name": "Lucie Hobžová, Asahi Europe & International",
          "position": "HR Operations Lead"
        },
        {
          "img": "solcova.png",
          "name": "Šárka Šolcová, ZF Automotive Czech",
          "position": "Country LTOR Expert"
        },
        {
          "img": "svobodova.png",
          "name": "Jirina Svobodova, J&T Bank",
          "position": "Benefits Specialist"
        },
        {
          "img": "ryskova.png",
          "name": "Petra Ryšková, Axa",
          "position": "Senior HR Business Partner CEE"
        },
        {
          "img": "valtera.png",
          "name": "Jan Valtera, AB InBev",
          "position": "Project Manager"
        },
        {
          "img": "volfova.png",
          "name": "Lenka Volfová, Institute of Biostatistics\nand analyses",
          "position": "HR Manager and Business Partner"
        },
        {
          "img": "kruzikova.png",
          "name": "Lenka Kružíková, Innogy Czech Republic",
          "position": "Head of Human Resources"
        }
      ],
      "more": "More about the Community"
    },
    "service": {
      "card": [
        {
          "heading": "Tools for employees",
          "text": "On-line medical consultation, nurses to help make doctor’s appointments, smart prevention calendar, and other services – employees have handy health care tools.",
          "cta": {
            "href": "https://www.ulekare.cz/sluzba",
            "label": "More about the Service"
          }
        },
        {
          "heading": "Valuable data for HR",
          "text": "By using the uLékaře.cz service, you’ll find out what your people need help with. Based on the information we obtain, we’ll prepare a customized solution for your company.",
          "cta": {
            "label": "More about the Service"
          }
        }
      ]
    },
    "reference": {
      "item": [
        {
          "name": "Lenka Volfová",
          "position": "HR Manager and Business Partner, Institute of Biostatistics and Analyses, Ltd.",
          "text": [
            "We are satisfied with the uLékaře.cz service.",
            "It helps our employees take care of their health. Everything is straightforward, fast and professional. Because our employees' health is our priority.",
            "The health of all our 50 employees is all in one place."
          ],
          "video": "references_lenka-volfova"
        },
        {
          "name": "Lenka Kružíková",
          "position": "Senior Manager, Human Resources, Innogy ČR a.s.",
          "text": [
            "uLékaře.cz has everything you need.",
            "The service helps us care for company health, covers everything we want to focus on, and is available 24/7.",
            "The health of all our 1500 employees is all in one place."
          ],
          "video": "references_lenka-kruzikova"
        }
      ],
      "title": "<span class=\"translucent\">How happy are companies</span><br />\n        with the service?"
    },
    "claim": [
      {
        "text": [
          "We reduce <span class=\"text--black translucent\">absenteeism</span>",
          "<span class=\"text--black translucent\"> and company costs.</span>"
        ]
      },
      {
        "text": [
          "<span class=\"text--black translucent\">We increase</span> ESG scores",
          "<span>and productivity.</span>"
        ]
      },
      {
        "text": [
          "<span class=\"text--black translucent\">We improve the well-being</span>",
          "<span>and health of employees.</span>"
        ]
      }
    ],
    "vision": {
      "people": [
        {
          "name": "Martin Pospisil",
          "position": "CEO",
          "blurb": "Whether there are 20 or 20 thousand of you in your company, whether you work with your head or your hands, the uLékaře.cz helps with planning employee health. We’ve been caring for companies since 2018.",
          "video": "vision_martin"
        },
        {
          "name": "Magda Blažková",
          "position": "B2B Manager",
          "blurb": "Whether there are 20 or 20 thousand of you in your company, whether you work with your head or your hands, the uLékaře.cz helps with planning employee health. We’ve been caring for companies since 2018.",
          "video": "vision_magda"
        },
        {
          "name": "Tomáš Šebek",
          "position": "Co-founder",
          "blurb": "Whether there are 20 or 20 thousand of you in your company, whether you work with your head or your hands, the uLékaře.cz helps with planning employee health. We’ve been caring for companies since 2018.",
          "video": "vision_tomas"
        },
        {
          "name": "Tereza Čiháková",
          "position": "HR Generalist",
          "blurb": "Whether there are 20 or 20 thousand of you in your company, whether you work with your head or your hands, the uLékaře.cz helps with planning employee health. We’ve been caring for companies since 2018.",
          "video": "vision_tereza"
        },
        {
          "name": "Danica Fričová",
          "position": "General Practitioner",
          "blurb": "Whether there are 20 or 20 thousand of you in your company, whether you work with your head or your hands, the uLékaře.cz helps with planning employee health. We’ve been caring for companies since 2018.",
          "video": "vision_danica"
        }
      ]
    },
    "contact": {
      "title": "<span class=\"translucent\">Let’s talk about your</span><br /> company’s health.",
      "persona": {
        "img": "martin-cuba.png",
        "name": "Martin Čuba",
        "subtitle": "Hi, it's Martin.",
        "text": "Let’s arrange a no-obligation free consultation<br />\n        to talk about how you can<br />\n        measure company health<br />\n        and increase productivity."
      },
      "email": "partner@ulekare.cz",
      "phone": "phone:+420603841995",
      "phoneDisplay": "+420 603 841 995",
      "form": {
        "companyName": {
          "label": "Company Name",
          "placeholder": "Your Company, LLC",
          "error": "Please enter your company name."
        },
        "contactName": {
          "label": "Contact person",
          "placeholder": "Jan Healthy",
          "errorDigits": "The name must not contain any characters other than letters.",
          "error": "Please provide your first and last name."
        },
        "email": {
          "label": "Company e-mail",
          "placeholder": "firemni@mail.cz",
          "error": "Please enter your email in the correct format."
        },
        "phoneNumber": {
          "label": "Phone number",
          "placeholder": "123 456 789",
          "error": "The number must not contain any characters other than digits."
        },
        "consentLabel": "I agree to the <a class=\"text--primary\" style=\"color: #3ca091 !important;\" href=\"https://www.ulekare.cz/consent-to-the-processing-of-personal-data-for-hr-information-purposes\" target=\"_blank\">processing of personal data</a> for HR information purposes.",
        "submit": "Send",
        "footer": "By clicking 'Submit' you agree that we may contact you over the next 6 months with offers\n        suitable for your business.\n         <a\n          href=\"https://app.ulekare.cz/en/personal-data-processing\"\n          class=\"text--primary\"\n          style=\"color: #3ca091 !important;\"\n          data-section=\"kontakt\"\n          >Learn more about privacy.</a>",
        "thankYou": "Thank you for taking your employees' health seriously.",
        "thankYouSubtext": "We will get back to you within the next few business days.",
        "mobile": {
          "thankYou": "Thank you for your interest.",
          "thankYouSubtext": "We will get back to you within one business day.",
          "backToForm": "Back to the form"
        }
      },
      "letsTalk": {
        "heading": "Are you interested in what we can do? \nCall me or write.",
        "link": "Contacts"
      },
      "mail": {
        "subject": "We care about the health of your employees, we will hear from you soon.",
        "content": "Have a nice day,<br/><br/>\nThank you for your interest in the Health and Prevention in the Company service. We are glad that you care about the health of your employees. We will contact you no later than the next business day.<br/><br/>\nHealth<br/><br/>\nMartin Čuba, Business Development Manager<br/>\nemail: <a href=\"mailto:partner@ulekare.cz\">partner@ulekare.cz</a><br/>\nphone: <a href=\"tel:00420602413933\">+420 603 841 995</a>",
        "footer": {
          "copyright": "uLékaře.cz"
        }
      }
    },
    "iso": {
      "header": {
        "text": "more than 200 others"
      },
      "point": [
        "We undergo a regular external data security audit",
        "Data is encrypted and backed up regularly",
        "We control access to sensitive information and use two-step verification",
        "We undergo regular GDPR and information security training"
      ],
      "partner": [
        {
          "img": "cs.svg",
          "alt": "Česká spořitelna"
        },
        {
          "img": "aimtec.svg",
          "alt": "Aimtec"
        },
        {
          "img": "ikea.svg",
          "alt": "Ikea"
        },
        {
          "img": "tmobile.svg",
          "alt": "T-Mobile",
          "id": "tmobile"
        },
        {
          "img": "etnetera.svg",
          "alt": "Etnetera",
          "hideOnMobileSecond": "1"
        }
      ],
      "badge": [
        {
          "img": "isofirst.svg",
          "alt": "ISO 9001"
        },
        {
          "img": "isosecond.svg",
          "alt": "ISO/IEC 27001"
        }
      ]
    },
    "footer": {
      "value": [
        "A human touch.",
        "Enthusiasm.",
        "Expertise.",
        "Innovation."
      ],
      "about": "We create the healthiest work environments and provide top-notch data-driven health care. \n     We systematically help companies maintain employee health over the long term.",
      "copyright": "uLékaře.cz",
      "nav": {
        "link": [
          {
            "href": "https://app.ulekare.cz/en/terms-of-use",
            "label": "Terms of use"
          },
          {
            "href": "https://app.ulekare.cz/en/personal-data-processing",
            "label": "Principles of personal data processing"
          },
          {
            "href": "https://app.ulekare.cz/en/cookies",
            "label": "Cookie Policy"
          },
          {
            "href": "https://app.ulekare.cz/en/protection-of-whistleblowers",
            "label": "Whistleblower Protection"
          },
          {
            "label": "Security",
            "href": "https://app.ulekare.cz/en/security"
          },
          {
            "label": "Career"
          },
          {
            "label": "Contact"
          }
        ]
      },
      "aside": {
        "link": [
          {
            "href": "https://www.facebook.com/uLekare/",
            "label": "Facebook",
            "img": "facebook.svg"
          },
          {
            "href": "https://www.instagram.com/ulekare_cz/",
            "label": "Instagram",
            "img": "instagram.svg"
          },
          {
            "href": "https://cz.linkedin.com/company/ulekarecz",
            "label": "LinkedIn",
            "img": "linkedin.svg"
          },
          {
            "href": "https://www.youtube.com/@ulekare_cz",
            "label": "YouTube",
            "img": "youtube.svg"
          }
        ]
      },
      "logo": {
        "alt": "uLékaře.cz"
      }
    }
  },
  " profile": {
    "benefits": {
      "content_explore": {
        "chip": "Discover"
      }
    }
  },
  "profil": {
    "benefit": {
      "card": {
        "family": "Active (family member)"
      }
    }
  },
  "secondFactor": {
    "subtitleEmail": "Two-factor authentication via email",
    "label": "Enter the code you received to verify your sign-in.",
    "rememberDevice": "Don’t require on this device",
    "sendAgain": "Resend code",
    "verify": "Verify code",
    "subtitleSms": "Two-factor authentication via SMS",
    "error": {
      "input": "Enter the code.",
      "invalidCode": "Invalid code"
    }
  },
  "forms": {
    "Question": {
      "patient": {
        "title": "Basic information",
        "whoisAsking": {
          "self": {
            "label": "Myself"
          },
          "other": {
            "label": "Someone else"
          },
          "label": "Who am I asking about?"
        },
        "firstName": {
          "self": {
            "label": "First name",
            "help": "Enter your real first name for communication with the healthcare provider."
          },
          "other": {
            "label": "Other person's name",
            "help": "Enter your real first name for communication with the healthcare provider."
          }
        },
        "lastName": {
          "self": {
            "label": "Surname",
            "help": "Enter your real first name for communication with the healthcare provider."
          },
          "other": {
            "label": "Other person's last name",
            "help": "Enter your real first name for communication with the healthcare provider."
          }
        },
        "birthNumber": {
          "self": {
            "label": "Insurance number (10 digits)",
            "help": "The insurance number will make it easier for us to make an appointment at the surgery."
          },
          "other": {
            "label": "Insurance number (10 digits)",
            "help": "The insurance number will make it easier for us to make an appointment at the surgery."
          }
        },
        "birthDate": {
          "self": {
            "label": "Date of birth"
          },
          "other": {
            "label": "Other person's date of birth"
          }
        },
        "gender": {
          "self": {
            "label": "Sex",
            "help": "Select gender"
          },
          "other": {
            "label": "Sex",
            "help": "Select gender",
            "placeholder": "Select gender"
          }
        },
        "phone": {
          "self": {
            "label": "Telephone number",
            "help": "If necessary, a nurse will call you"
          },
          "other": {
            "label": "This person's phone number",
            "help": "If necessary, a nurse will call you."
          }
        },
        "address": {
          "self": {
            "label": "Address",
            "help": "Your address will help us find you a suitable doctor"
          },
          "other": {
            "label": "Address",
            "help": "Your address will help us find you a suitable doctor"
          }
        }
      },
      "questionBasic": {
        "title": "Describe the health problem",
        "questionWhat": {
          "label": "Describe the problem and all its symptoms. The more detailed the description, the more accurate the doctor's answer."
        },
        "questionHowWhen": {
          "label": "How did the problem start and when (date)? Is it recurring? How is it changing over time?"
        },
        "questionPastExamination": {
          "label": "Were you examined by a doctor and what was the result? Was treatment provided (including at home)? Describe it, and whether it helped."
        },
        "healthIssueQuestion": {
          "label": "Ask the doctor a question regarding the described health problem."
        },
        "questionSolutionCountry": {
          "label": "What country would you like help in?"
        },
        "attachments": {
          "label": "Attach photos, medical reports, and the results of any examinations.",
          "help": "Maximum file size is 20 MB, and the maximum total size of all files is 100 MB. You can upload .jpg, .png, pdf, MP3, .avi, or mp4 files."
        }
      },
      "questionAdditional": {
        "title": "Additional information for the doctor",
        "questionAnotherSickness": {
          "self": {
            "label": "Are you being treated for a chronic/other illness?"
          },
          "other": {
            "label": "Is he/she being treated for a chronic/other illness?"
          }
        },
        "questionAnotherSicknessDetails": {
          "self": {
            "label": "Please write what illness you are being treated for."
          },
          "other": {
            "label": "Please state which condition they are being treated for."
          }
        },
        "questionMedications": {
          "self": {
            "label": "Do you regularly take any medications or medicinal products (including birth control)?"
          },
          "other": {
            "label": "Does he/she regularly take any medications or medicinal products (including birth control)?"
          }
        },
        "questionMedicationsDetails": {
          "self": {
            "label": "Provide the names and dosages of medications and/or medicinal products (including birth control) you use."
          },
          "other": {
            "label": "Provide the names and dosages of the medications and/or medicinal products (including birth control) they use."
          }
        },
        "questionAllergies": {
          "self": {
            "label": "Do you have any allergies (especially to medications or medicinal products)?"
          },
          "other": {
            "label": "Does he/she have any allergies (especially to medications or medicinal products)?"
          }
        },
        "questionAllergiesDetails": {
          "self": {
            "label": "Tell us what you're allergic to and the symptoms."
          },
          "other": {
            "label": "Please state what they are allergic to and how it manifests."
          }
        },
        "questionLifestyle": {
          "self": {
            "label": "Specify other factors affecting your health such as smoking, alcohol intake, obesity, unhealthy lifestyle, an arduous profession, stress, etc."
          },
          "other": {
            "label": "Specify the factors that may affect this person's health, such as smoking, alcohol consumption, being overweight, an unhealthy lifestyle, a physically demanding job, stress, etc."
          }
        },
        "questionContact": {
          "label": "If the doctor recommends a face-to-face visit, would you like a nurse to contact you to offer to help with the appointment?",
          "yes": "Yes, I would like to be contacted by a nurse.",
          "no": "No, I do not want the nurse to call."
        }
      }
    },
    "Order": {
      "patient": {
        "title": "Basic information",
        "whoisAsking": {
          "label": "Appointment for",
          "self": {
            "label": "For me"
          },
          "other": {
            "label": "For another person"
          }
        },
        "firstName": {
          "self": {
            "label": "Name",
            "help": "Enter your real first name for communication with the healthcare provider."
          },
          "other": {
            "label": "Other person's name",
            "help": "Enter your real first name for communication with the healthcare provider."
          }
        },
        "lastName": {
          "self": {
            "label": "Surname",
            "help": "Enter your real first name for communication with the healthcare provider."
          },
          "other": {
            "label": "Other person's last name",
            "help": "Enter your real first name for communication with the healthcare provider."
          }
        },
        "birthNumber": {
          "self": {
            "label": "Insurance number (10 digits)",
            "help": "The insurance number will make it easier for us to make an appointment at the doctor's office."
          },
          "other": {
            "label": "Insurance number (10 digits)",
            "help": "The insurance number will make it easier for us to make an appointment at the doctor's office."
          }
        },
        "birthDate": {
          "self": {
            "label": "Date of birth"
          },
          "other": {
            "label": "Other person's date of birth"
          }
        },
        "gender": {
          "self": {
            "label": "Sex",
            "help": "Select gender"
          },
          "other": {
            "label": "Sex",
            "help": "Select gender"
          }
        },
        "phone": {
          "self": {
            "label": "Telephone number",
            "help": "If necessary, a nurse will call you."
          },
          "other": {
            "label": "Telephone number",
            "help": "If necessary, a nurse will call you."
          }
        },
        "address": {
          "self": {
            "label": "Address",
            "help": "Your address will help us find you a suitable doctor"
          },
          "other": {
            "label": "Other person's adress",
            "help": "Your address will help us find you a suitable doctor."
          }
        },
        "orderHealthInsurance": {
          "self": {
            "label": "Health insurance company",
            "help": "We're looking for a doctor who works with the insurer."
          },
          "other": {
            "label": "Health insurance company",
            "help": "We're looking for a doctor who works with the insurer."
          }
        }
      },
      "orderBasic": {
        "title": "Schedule an appointment",
        "orderWhat": {
          "label": "What health problem will the appointment concern?",
          "placeholder": "E.g. find a new doctor, make an appointment with an existing one, advise where to go..."
        },
        "orderSpecialist": {
          "label": "What type of doctor or specialist are you looking for?"
        },
        "attachments": {
          "label": "Attach a request form or medical report, if you have one.",
          "help": "Maximum file size is 20 MB, and the maximum total size of all files is 100 MB. You can upload .jpg, .png, pdf, MP3, .avi, or mp4 files."
        },
        "orderLocality": {
          "label": "Where would you like to find a doctor?"
        },
        "orderTimeAvailability": {
          "label": "When would you like to make the appointment for?"
        },
        "orderContact": {
          "label": "How do you want to help with your appointment?",
          "yes": "I prefer to take care of the whole ordering process.",
          "no": "I prefer sending contacts."
        }
      }
    },
    "goPrev": "Previous",
    "goNext": "Next",
    "submit": "Send",
    "AccountDelete": {
      "password": {
        "perex": "For security reasons, please confirm your account termination by entering your password."
      }
    }
  },
  "getApp": "Download the app",
  "servicePage": {
    "header": {
      "more": ""
    },
    "issn": {
      "links": [
        {},
        {},
        {},
        {},
        {
          "text": "Security",
          "link": "https://app.ulekare.cz/en/security"
        }
      ]
    }
  },
  "orderForm": {
    "thankYou": {
      "title": "The order has been submitted.",
      "perex": "Thank you for your order. You will be notified once it has been processed."
    }
  },
  "common": {
    "ok": "Continue"
  },
  "medicalProcedures": {
    "prevention": [
      {
        "id": "1f4a68b9-205e-48ed-8382-e792dfa29341",
        "icon": "doctor",
        "title": "General practitioner",
        "perex": "A check-up with your GP is the most important step of your health care journey. The scope and focus of the check-up depend on your age, current health, and risk factors.",
        "expectation": "During the check-up, the doctor will examine your vision, hearing, and skin, check your vaccinations, measure blood pressure and waist size, and examine your heart, lungs, thyroid, abdomen, and blood vessels in the legs. The doctor will ask about any mental or hereditary illnesses in your family, assess your overall health, and identify risk factors. The check-up also includes a urine test using a test strip. At the first visit, lipoprotein(a) is also measured. For men, a rectal exam is performed.\n\nAfter leaving pediatric care, blood tests for blood sugar, cholesterol, kidney function, and heart health are done every 2 years (or sooner if needed). \n\nAn ECG is done when leaving pediatric care or during a new GR registration. For people with cardiovascular risk, an ECG is done every 4 years between ages 30 and 40.\n\nFrom age 40, people with cardiovascular risk have an ECG every 2 years, while those without risk have one every 4 years. The doctor also helps ensure patients take part in age-appropriate screening programs, such as mammograms for women from age 45, prostate checks, and lung screening.\n\nFrom age 45, if risk factors are present (e.g., overweight, diabetes), liver function is checked every 2 years. Tests for hidden blood in the stool or a colonoscopy are also performed.\n\nFrom age 50, additional checks include kidney function, PSA for men, lipoprotein(a) for postmenopausal women, and heart stress tests if needed. Patients with certain risk factors may have lab tests for NT-proBNP every 2 years to detect heart failure early.\n\nPatients over 50 with a family history of heart failure, obesity, diabetes, or other risk factors now have laboratory tests for NT-proBNP every two years based on individual risk. This marker helps with early detection and monitoring of heart failure.\n\nFor people aged 65–80, the risk of dementia is assessed. Men in this age group are also screened for abdominal aortic aneurysm.",
        "preparation": "Before a blood test, you should fast from midnight the night before and drink only plain water in the morning. A morning urine sample can be taken at home, using a sterile container. Make an appointment in advance so the doctor can prepare requests for blood tests and any other necessary examinations. Allow about 30 minutes for the check-up.",
        "isItPaid": "Preventive check-ups performed by GPs are covered by public health insurance. Check-ups are done every two years."
      },
      {
        "id": "891f7c68-bae0-4040-9907-333177a0ac1a",
        "icon": "tooth",
        "title": "Dentist",
        "perex": "Regular dental check-ups are essential for keeping your teeth healthy. They help prevent problems that often initially have no symptoms.",
        "expectation": "The dentist will examine your teeth, gums, oral mucosa, and periodontal health. They will assess your oral hygiene and, if needed, remove tartar or recommend professional dental cleaning. Intraoral (bitewing) X-rays are used to detect cavities and other problems, as well as an extra-oral (panoramic) X-ray once every two years.",
        "preparation": "Before your visit, brush your teeth thoroughly, including between the teeth. Allow about 15–30 minutes for the check-up.",
        "isItPaid": "Preventive dental check-ups are covered by public health insurance. You are entitled to one check-up per year. If your dentist determines it is necessary for your health, you may also be entitled to a second (routine) check-up."
      },
      {
        "id": "0f1bf426-6f77-40d4-933b-f5a1ee275be8",
        "icon": "female-reproductive-system",
        "title": "Gynaecology",
        "perex": "During this examination, the doctor will check the reproductive organs, note your last period date, and perform a Pap smear (cytology test).",
        "expectation": "During the examination, the doctor will review your personal and family medical history and usually ask for the date of your last period. The examination includes a colposcopy (using a special microscope), tests for viruses or bacteria, a Pap smear, and preventive HPV testing for women aged 35, 45, and 55.\n\nThe doctor will also provide guidance on breast self-examination, and perform a breast exam for women with a family history of breast cancer. The gynecologist will also check participation in recommended screening programs, such as mammogram and colorectal cancer screening.",
        "preparation": "Perform intimate hygiene, ideally right before visiting the doctor. Allow about 20 minutes for the check-up.",
        "isItPaid": "Preventive gynecological check-ups are covered by public health insurance. You are entitled to one examination per year."
      },
      {
        "id": "362e63be-2a2b-4e69-ba01-a2eb5397eb79",
        "icon": "breasts",
        "title": "Breast exam",
        "perex": "A check of the breasts and underarms to help detect any signs of cancer early.",
        "expectation": "Mammography is a safe and effective way to take detailed X-ray images of the breasts with minimal radiation. During the exam, you stand while your breasts are gently compressed to capture the most tissue possible. A technician will guide you through the procedure, and a doctor will review and interpret the images.\n\nFor younger women, women with dense breast tissue, or when additional examination is needed, a breast, underarm, and collarobe area ultrasound may be performed. This examination is completely safe and painless, and results are available immediately. It is done lying down, with the doctor moving the ultrasound probe over the breast while viewing the images on a monitor.",
        "preparation": "No special preparation is needed, but it is recommended not to use body lotions or solid antiperspirants. The examination usually takes about 20 minutes.",
        "isItPaid": "For women under 45, an ultrasound is recommended. It is generally not covered by public health insurance unless prescribed by a doctor, though some insurers may offer a contribution. Costs may vary. Check your insurer’s contributions section for details.\n\nFor women over 45, mammography is the recommended screening method, with ultrasound used as a supplementary test when needed. Mammography is covered by health insurance, and you are entitled to one exam every two years."
      },
      {
        "id": "f129ba70-51b5-4820-bc79-6a89072d1ae4",
        "icon": "rectum",
        "title": "Colonoscopy",
        "perex": "This is an examination of the large intestine and rectum using an endoscope, which also allows the doctor to take tissue samples from the lining.",
        "expectation": "A colonoscopy is a preventive and treatment procedure used to spot early changes in the lining of the large intestine, take tissue samples for testing, and remove certain growths. The doctor uses an endoscope, which is gently inserted through the rectum into the large intestine. The procedure is done privately and with respect for your comfort and dignity.\n\nSome people may find the exam uncomfortable or slightly painful, so mild sedatives are usually given. It can also be done under general anesthesia if needed. After the procedure, you will rest briefly at the clinic. You should not drive afterward, so it’s best to arrange for someone to take you home.",
        "preparation": "About a week before the procedure, you will be recommended to follow a light diet. Three days prior, stick to soft foods, and the day before, consume only clear liquids along with a laxative solution to fully clear your intestines.\n\nA blood test is needed to check your blood count and clotting. If you take blood-thinning medication, inform your doctor beforehand so your treatment can be adjusted. The colonoscopy itself usually takes around 20–30 minutes.",
        "isItPaid": "Preventive colonoscopy is available for everyone aged 45 to 74. If the first colonoscopy shows no findings, the next screening is free after 10 years. If any findings are detected, your doctor will recommend when the next exam should take place. A referral is required for the procedure, usually provided by your GP. Women can also obtain a referral from their gynecologist."
      },
      {
        "id": "1b8fefd5-9ca2-4d5e-afd4-9dbe46c456d4",
        "icon": "eye",
        "title": "Eye exam",
        "perex": "During an eye check-up, the doctor focuses on detecting serious eye conditions, which often have no symptoms and may go unnoticed.",
        "expectation": "The doctor will check your eyes and surrounding areas, including the eyelids and conjunctiva. They will test your vision, determine if you need glasses, measure eye pressure, and examine the back of your eyes. Extra attention is given to people with high blood pressure, diabetes, or a family history of eye conditions like cataracts or glaucoma. With specialized equipment, the doctor can also assess vision problems in more detail and detect other eye conditions. The examination is painless and straightforward.",
        "preparation": "No special preparation is needed. The examination usually takes about 30 minutes.",
        "isItPaid": "Eye examinations are covered by public health insurance at any age, whether for routine preventive care, specific concerns, or a referral from another doctor, such as your general practitioner. For patients aged 45 to 61 who have not yet had an eye exam, general practitioners recommend regular preventive visits. A referral for a preventive eye exam can be issued by your doctor once every four years."
      },
      {
        "id": "467fff1e-a3fe-4403-ba24-670816ec556c",
        "icon": "testicles",
        "title": "Testicular self-examination",
        "perex": "Testicular cancer most often affects men between the ages of 15 and 35, and it can develop and spread quickly. While treatment is effective, early detection is key. This is why regular testicular self-exams are especially important during these years and should not be skipped.",
        "how": "The best time to examine your testicles is after a warm shower, when the skin of the scrotum is relaxed. First, look at them and then gently feel them. Watch for any changes in size, shape, or skin appearance, as well as any new lumps. Examine each testicle separately using both hands. Don’t forget to check the epididymis (the area behind the testicle), which should feel similar on both sides.",
        "when": "Check your testicles at least once a month, especially if you are between the ages of 15 and 35. Picking the same day each month can help make self-examination part of your routine.",
        "findConcerningQuestion": "If you notice changes in the size or color of your testicles, feel pain, or find any lumps or other unusual changes, see a urologist or your GP."
      },
      {
        "id": "df6a924b-8b1f-44be-a564-c055c11b8a27",
        "icon": "breasts-self-care",
        "title": "Breast self-examination",
        "perex": "A breast self-examination is a simple and quick way to help detect any potential issues early. It only takes a few minutes and can play an important role in early detection of breast cancer.",
        "how": "Stand in front of a mirror. For women with larger breasts, it may be easier to perform the exam lying down. Check the breast tissue from the front, side, and while leaning forward, paying attention to any differences or changes.\n\nTo feel the breast, raise the arm on the side you’re checking and use the opposite hand to examine it – left hand checks the right breast, right hand checks the left. Look for changes in size, shape, or the nipples, and gently press to check for any discharge.\n\nPalpate the breast systematically: from top to bottom, from the sternum outward, using circular motions and wedge-shaped strokes from the nipple outward. Don’t forget to check the area under the collarbone and the armpits.",
        "when": "Do the examination after the end of your menstrual cycle, on day five to ten of the cycle. If you do not have periods, choose one consistent day each month for your regular check-up.",
        "findConcerningQuestion": "If you notice anything unusual, even a small change, see your gynecologist or your GP."
      },
      {
        "id": "c109b192-3a5b-4bc3-9125-ddddcea8a822",
        "icon": "prostate",
        "title": "Prostate examination",
        "perex": "Prostate health can be checked by your GP or a urologist. A more detailed, targeted examination is done by a urologist, who will also examine the male reproductive organs and review your family medical history.",
        "expectation": "The doctor will visually inspect and gently feel the bladder and lower back area. The prostate is examined through the rectum. Blood tests may be done to measure prostate-specific antigen (PSA) levels, and urine tests may also be performed; sometimes semen or testosterone levels are checked. An ultrasound may be included as part of the urological exam. The procedure may feel slightly uncomfortable but is not painful.",
        "preparation": "Perform intimate hygiene, ideally right before visiting the doctor. Allow about 15–30 minutes for the check-up.",
        "isItPaid": "Preventive prostate examinations are covered by public health insurance for men aged 50–69. For men outside this age range, routine preventive prostate exams are not covered, though some insurance providers may contribute. More information can be found in your insurer’s contributions section. Costs can vary, so it is best to check directly with your urologist’s office. It is recommended to have the examination once a year, or sooner if you have risk factors."
      },
      {
        "id": "ec177bfa-7bbf-40f2-a68c-22ab20737315",
        "icon": "dermatology",
        "title": "Examination of moles",
        "perex": "A dermatologist examines your moles by looking at them and, if needed, using a dermatoscope. If any mole looks suspicious and requires further testing, the doctor will take a tissue sample for microscopic histological examination.",
        "expectation": "The dermatologist will examine your skin, paying special attention to your moles. Suspicious moles are checked with a dermatoscope, a magnifying device that can also be connected to a computer to compare images with previous exams.\n\nIf a mole looks potentially cancerous, the doctor may remove it and send it for microscopic testing. Results are usually available at your next visit or may be shared by phone.\n\nMoles may also be removed for cosmetic reasons or if they are in areas prone to irritation, such as under a belt or bra strap.",
        "preparation": "No special preparation is needed for the exam. The check-up usually takes about 20 minutes. If moles are being removed, the visit may take longer.",
        "isItPaid": "Preventive mole examinations are not covered by public health insurance, though some insurers may provide a contribution. For more details, check your insurer’s contributions section. Costs vary, so contact your dermatologist’s office for exact pricing. A preventive check-up is recommended once a year."
      },
      {
        "id": "f268c41e-244e-42f6-a079-5d44d189b8bf",
        "icon": "brush",
        "title": "Dental hygiene",
        "perex": "Dental hygiene helps prevent tooth decay, gum disease (periodontitis), and oral infections. During the visit, dental plaque, tartar, and surface stains are removed from the teeth.",
        "expectation": "The dental hygienist will check your teeth and gums, focusing on the tissues that support your teeth. They will remove plaque, stains, and tartar from the teeth and from just below the gum line, then professionally clean and polish your teeth. Fluoride may also be applied if needed.\n\nYou will also receive guidance and hands-on instruction in proper brushing and the use of dental care tools. This helps lower the risk of oral and gum diseases, including periodontitis.",
        "preparation": "Before your appointment, brush your teeth thoroughly, including between the teeth. Bring along any dental care tools you normally use. Allow about 30–60 minutes for the check-up.",
        "isItPaid": "Dental hygiene visits are not covered by public health insurance, though some insurers may offer a contribution. For details, check your insurer’s contributions section. Costs may vary. Contact your dental office for exact pricing. It is recommended to have a dental hygiene visit twice a year."
      }
    ],
    "vaccination": [
      {
        "id": "77812777-eb63-42d8-a61e-1006038a4bdc",
        "icon": "vaccine",
        "name": "Tetanus",
        "perex": "Tetanus, also called lockjaw, is a serious illness that is a frequent cause of death, primarily in developing countries. This illness is caused by Clostridium tetani bacteria, which are routinely present in human and animal intestines, especially those of farm animals.\nThanks to high vaccination rates, it has largely disappeared.",
        "prevention": "Vaccination is effective prevention against tetanus. The first dose is given to children as part of a combined vaccine. In adulthood, boosters are given every 10-15 years up to the age of 59, after that every 10 years is recommended.",
        "vaccineChoice": "We recommend the Vacteta vaccine, which is funded by public health insurance. For those without insurance, it costs around CZK 200-500."
      },
      {
        "id": "39ee715f-b4d8-4f76-9cc8-14ff327c0d07",
        "icon": "vaccine",
        "name": "Whooping cough",
        "perex": "Whooping cough is a highly infectious disease caused by Bordetella pertussis bacteria. It is also sometimes called \"100-day-cough\" or \"pertussis\". It occurs throughout the world. Unvaccinated children up to the age of six are most at risk, but infection is possible at any age.",
        "prevention": "Vaccination is the most effective prevention against whooping cough. Vaccination for this disease is part of mandatory vaccines for children. It is usually given as part of a combined vaccine, and a booster is recommended at least once during one's lifetime.",
        "vaccineChoice": "We recommend the Adacel vaccine, which is funded for children by public health insurance. When not covered by insurance, it costs around CZK 1000. Some insurance companies may pay a contribution for vaccination."
      },
      {
        "id": "1c9d2dc9-bdd6-488d-968e-4626579aeb45",
        "icon": "vaccine",
        "name": "Flu",
        "perex": "The flu is a contagious viral disease that afflicts a large part of the population every year. Old people, children, and the chronically ill are at greatest risk. Symptoms include extreme fatigue, fever, cough, muscle and joint pain, and headaches. The flu occurs primarily during the winter season, and lasts roughly 1-2 weeks.",
        "prevention": "Effective prevention includes boosting the immune system by eating a balanced diet, adequate vitamin intake and drinking enough fluids, getting a reasonable amount of exercise, sleeping well, hardening the organism, and proper hygiene. Getting an annual flu vaccine also helps.",
        "vaccineChoice": "We recommend the Vaxigrip Tetra vaccine, which patients pay for themselves. The price of one vaccine is approximately CZK 400-600. Some insurance companies may pay a contribution for vaccination."
      },
      {
        "id": "c9827908-b47c-4fe1-b4ad-fdaa154a74de",
        "icon": "vaccine",
        "name": "Tick-borne encephalitis",
        "perex": "Tick-borne encephalitis is a viral disease that afflicts the human nervous system. The Czech Republic is considered a high-risk country due to high infection rates.",
        "prevention": "Appropriate prevention includes wearing suitable clothing outdoors, using repellents, and upon returning home examining the body for any ticks that may have attached themselves.\nVaccination is effective prevention against tick-borne encephalitis. The ideal time for vaccination is in the winter, prior to the arrival of spring. The vaccine is given in 3 doses, and a booster is then given after 3 and 5 years.\nHaving had the illness provides immunity, but in the case of younger people it may not last for the rest of one's life, while for older people the assumption is that it does. Antibody levels can be checked by taking a blood sample.",
        "vaccineChoice": "We recommend the FSME-IMMUN vaccine, which patients pay for themselves. The price of one vaccine is approximately CZK 800-1200. Some insurance companies may pay a contribution for vaccination. Starting at age 50, vaccination is paid for by public health insurance."
      },
      {
        "id": "d83a0b4c-ff51-40d6-8df4-8521e7c0055f",
        "icon": "vaccine",
        "name": "Pneumococcus",
        "perex": "Pneumococcus is a very serious disease. The Streptococcus pneumoniae bacteria can cause pneumonia, infection of the organism, meningitis, or inner ear infections in children.",
        "prevention": "Vaccination is effective prevention against pneumococcus. Up to the age of 59 one dose is given, another dose is given between the ages 60-64, and after the age of 65 two doses are given.\nAdditional recommendations include boosting one's immune system, leading a healthy lifestyle, and avoiding large groups of people, especially during times of greater incidence of respiratory disease.",
        "vaccineChoice": "We recommend the Prevenar 13 vaccine, which patients pay for themselves. The price of one vaccine is approximately CZK 1500. Some insurance companies may pay a contribution for vaccination. Starting at age 65, vaccination is paid for by public health insurance."
      },
      {
        "id": "645eddeb-539d-4374-a300-234cd724bb94",
        "icon": "vaccine",
        "name": "Meningococcus B",
        "perex": "Meningococcal disease can cause meningitis, sepsis, high fever, and even death. The Czech Republic has low infection rates, but the death rate is high. Children up to the age of 5 and young people up to the age of 25 are primarily at risk. There are 13 meningococcal disease serotypes.",
        "prevention": "Vaccination is effective prevention against meningococcus. The vaccine is given in two doses at least one month apart, with boosters depending on the vaccine type.\nAdditional recommendations include boosting one's immune system, leading a healthy lifestyle, getting enough sleep and rest, eliminating stress, quitting smoking, and so on.",
        "vaccineChoice": "We recommend the Bexsero vaccine, which patients pay for themselves. The price of one vaccine is approximately CZK 2000. Some insurance companies may pay a contribution for vaccination."
      },
      {
        "id": "7a1affc9-805a-4935-9f52-6dc627bbf4c5",
        "icon": "vaccine",
        "name": "Meningococcus A, C, Y, W-135",
        "perex": "Meningococcal disease can cause meningitis, sepsis, high fever, and even death. The Czech Republic has low infection rates, but the death rate is high. Children up to the age of 5 and young people up to the age of 25 are primarily at risk. There are 13 meningococcal disease serotypes.",
        "prevention": "Vaccination is effective prevention against meningococcus. The vaccine is given in one dose.\nAdditional recommendations include boosting one's immune system, leading a healthy lifestyle, getting enough sleep and rest, eliminating stress, quitting smoking, and so on.",
        "vaccineChoice": "We recommend the Menveo or Nimenrix vaccine, which patients pay for themselves. The price of one vaccine is approximately CZK 1200. Some insurance companies may pay a contribution for vaccination."
      },
      {
        "id": "3b6bf48f-9cb6-4d9e-b2be-6b72b103d648",
        "icon": "vaccine",
        "name": "Hepatitis A",
        "perex": "Hepatitis A is an acute infectious disease of the liver caused by a virus, and is also called the \"dirty hands disease\". It is present throughout the world, especially in countries with low standards of hygiene. In these countries, children are primarily at risk, though are often symptom-free. In the adult population infection has a more prominent nature, but the disease has no permanent consequences.",
        "prevention": "Prevention includes adequate personal hygiene and clean sources of food and water. Vaccination is effective prevention against hepatitis, and is given in two doses spaced a year apart.\nVaccination can take place in combination with vaccination against hepatitis type B, hence A+B together.",
        "vaccineChoice": "We recommend the Havrix 1440 or Vaqta Adult vaccines, which patients pay for themselves. The price of one vaccine is approximately CZK 1200-1600. \nFor vaccination against hepatitis A+B, we recommend the Twinrix Adult vaccine, which patients pay for themselves. The price of one vaccine is approximately CZK 1900. Some insurance companies may pay a contribution for vaccination."
      },
      {
        "id": "6a17b093-b6a3-4f38-9b49-2435267d0101",
        "icon": "vaccine",
        "name": "Hepatitis B",
        "perex": "Hepatitis A is a serious infectious disease of the liver caused by a virus. The disease is chronic and can cause cirrhosis of the liver or cancer. The Hepatitis B virus is much more infectious than the HIV virus. Hepatitis B occurs throughout the world. Illness is serious and lasts longer than in the case of Hepatitis A.",
        "prevention": "Vaccination is effective prevention against Hepatitis B. The first dose is given to newborns, with another two doses given 1 and 6 months later. Adults who weren't vaccinated as children can also be vaccinated. Vaccination can take place in combination with vaccination against hepatitis type A, hence A+B together.",
        "vaccineChoice": "We recommend the Engerix B-20 vaccine, which is funded by public health insurance. When not covered by insurance, it costs around CZK 1000. \nFor vaccination against hepatitis A+B, we recommend the Twinrix Adult vaccine, which patients pay for themselves. The price of one vaccine is approximately CZK 1900. Some insurance companies may pay a contribution for vaccination."
      },
      {
        "id": "c0d340b9-8279-4cfa-a918-ca9f0b40db65",
        "icon": "vaccine",
        "name": "Measles, mumps, rubella",
        "perex": "Measles, mumps, and rubella are very infectious viral diseases.",
        "prevention": "Vaccination is effective prevention. It is applied in childhood as part of compulsory vaccination, and is given as a combined measles, mumps, rubella vaccine. \nA booster shot can be given in adulthood if you work in a high-risk profession, travel, or have been in contact with an infected person.",
        "vaccineChoice": "We recommend MMR or Priorix vaccines, which for children are covered by public health insurance. When not covered by insurance, it costs around CZK 700-900. Some insurance companies may pay a contribution for vaccination."
      },
      {
        "id": "d206f02a-78a5-4e55-abe9-699de87259f2",
        "icon": "vaccine",
        "name": "Chicken pox",
        "perex": "Chicken pox is a highly infectious disease. It occurs most often during childhood and is usually not severe. However, infection is dangerous for pregnant women. \nThe disease occurs primarily during the winter season, and is the most common infectious disease in the Czech Republic.",
        "prevention": "Vaccination is effective prevention against chicken pox. Vaccination can reduce the likelihood of having shingles during one's lifetime. \nTwo doses are given, at least six weeks apart.",
        "vaccineChoice": "We recommend the Varilix vaccine, which patients pay for themselves. The price of one vaccine is approximately CZK 1500-1700. Some insurance companies may pay a contribution for vaccination."
      },
      {
        "id": "815351d8-b0ea-4c5c-832b-0c6ff3e36320",
        "icon": "vaccine",
        "name": "HPV infection",
        "perex": "HPV infection among the most widespread sexual diseases. More than a hundred HPV types are known, and about 40 of them afflict the sexual organs. Many of those infected are symptom-free, and thus easily continue to spread the virus.",
        "prevention": "Effective prevention of HPV infection includes a healthy lifestyle, eliminating stress, quitting smoking, and avoiding unprotected sex. It also advisable to avoid having multiple sexual partners and long-term use of hormonal contraception. \nVaccination is also an effective form of prevention, for both men and women. An ideal time for vaccination is prior to the commencement of an active sexual life. The vaccine is given in three doses, including to adults who were not vaccinated in childhood.",
        "vaccineChoice": "We recommend the Gardasil or Gardasil 9 vaccine, which patients pay for themselves. The price of one vaccine is approximately CZK 2000-3900. Some insurance companies may pay a contribution for vaccination."
      },
      {
        "id": "94a7f086-8aee-418a-a1b4-5f6de0396aa1",
        "icon": "vaccine",
        "name": "COVID-19",
        "perex": "COVID-19 is a highly contagious disease caused by a new type of coronavirus, SARS-CoV-2. This disease is present worldwide. Those infected have various symptoms, and in most cases are mild to moderate, without the need for hospitalization.",
        "prevention": "Effective prevention of COVID-19 includes adequate hand hygiene, avoiding larger groups of people, wearing a respirator, and boosting one's immune system. Vaccination can also help with prevention, and in the case of infection may reduce the severity of the illness. The vaccine is given in one to two doses (depending on the vaccine type), with a third dose given at least five months later. A fourth dose is recommended mainly for those over the age of 60 and at-risk patients, at least four months after the previous dose.",
        "vaccineChoice": "We recommend the Comirnaty, Spikevax, Janssen, Vaxzevria, or Novavax vaccines. Vaccination is covered by public health insurance. When not covered by insurance, it costs around CZK 400."
      }
    ]
  },
  "selfReactivated": {
    "title": "Welcome back!",
    "perex": "Your account is active again, and we’re happy to have you with us on your journey to better health. If you need anything, our customer support team will be glad to help at <a href=\"mailto:info@ulekare.cz\">info@ulekare.cz\n</a> or <a href=\"tel:00420227072720\">+420 227 072 720</a>.",
    "primaryButtonText": "Continue with uLékaře.cz"
  },
  "ePrescription": {
    "title1": "How does ePrescription issuance",
    "perex": "A doctor will assess your health condition as part of your inquiry. Based on that, they may recommend facilitating an ePrescription. Receiving an ePrescription isn’t guaranteed – the doctor will only issue it if it’s safe and appropriate. The uLékaře.cz service doesn’t issue ePrescriptions directly, but we’ll connect you with a healthcare provider who can issue one. Before the ePrescription is actually issued, a nurse will call you to verify the necessary information.",
    "disclaimer": {
      "b2b": "A doctor may recommend facilitating an ePrescription. A consultation with a nurse is required before it can be issued. Receiving an ePrescription isn’t guaranteed.  {disclaimerLink}",
      "b2c": "A doctor may recommend facilitating an ePrescription. A consultation with a nurse is required before it can be issued. Receiving an ePrescription isn’t guaranteed. {disclaimerLink}"
    },
    "disclaimerLink": "More",
    "list": [
      {
        "title": "Reasons you may not receive an ePrescription",
        "subtitle": "For example:",
        "body": [
          "Information about your health condition required to recommend facilitating an ePrescription is missing from your request.",
          "An in-person examination with a doctor is necessary.",
          "The case is more complex or non-standard.",
          "The prescription of this medication requires a doctor with a different specialty than a GP.",
          "The necessary information could not be verified.",
          "The request concerns another person (ePrescriptions cannot be requested on behalf of a partner, parent, child, or any other person)."
        ]
      },
      {
        "title": "How the process works",
        "body": [
          "Submit a question within your account (you can mention that you are interested in obtaining an ePrescription).",
          "The doctor will review the information you have provided.",
          "If appropriate, the doctor will recommend facilitating an ePrescription.",
          "Before the ePrescription is issued, a nurse will contact you to verify your information.",
          "If it is not possible to recommend facilitating an ePrescription, you will receive guidance on the next steps, such as visiting your GP or a specialist."
        ]
      },
      {
        "title": "What this means for you",
        "body": [
          "Our consultation service offers the possibility of facilitating an ePrescription.",
          "Receiving it isn’t guaranteed – the doctor decides if it’s appropriate to issue.",
          "Issuing an ePrescription is not immediate and requires a short processing time.",
          "We want to help you as best as we can, while always prioritizing correct and safe care."
        ]
      },
      {
        "title": "Can you pick up an ePrescription abroad?",
        "subtitle": [
          "It is possible to collect medication with a Czech ePrescription in certain EU countries, including: Poland, Croatia, Spain, Greece, Estonia, Finland, Lithuania, and Latvia.",
          "To pick up your medication abroad, you will need:"
        ],
        "body": [
          "A valid ID (national ID card or passport)",
          "The ePrescription identifier"
        ],
        "footer": "Medications must be paid for in full. You can request reimbursement from your health insurance provider."
      }
    ],
    "title2": "work at uLékaře.cz",
    "questionDisclaimer": {
      "b2b": "A doctor may recommend facilitating an ePrescription. A consultation with a nurse is required before it can be issued. Receiving an ePrescription isn’t guaranteed.  {disclaimerLink}",
      "b2c": "A doctor may recommend facilitating an ePrescription. A consultation with a nurse is required before it can be issued. Receiving an ePrescription isn’t guaranteed. {disclaimerLink}"
    },
    "orderDisclaimer": {
      "b2b": "An e-prescription can be issued based on a doctor’s recommendation during the consultation service. This is not possible within the appointment booking service. {disclaimerLink}",
      "b2c": "An e-prescription can be issued based on a doctor’s recommendation during the consultation service. This is not possible within the appointment booking service. {disclaimerLink}"
    },
    "questionDisclaimerLink": "More",
    "orderDisclaimerLink": "Ask a doctor"
  },
  "tallyTest": {
    "latestTest": {
      "pill": "NEW TEST"
    }
  },
  "questionPriceInfo": {
    "b2b": "You will pay for asking a question. {price} {currency}, you will receive the doctor's answer within {hours} h. {termsLink}",
    "b2bDiscount": "You will pay for asking a question. {price} {currency} (discount {discountPercent} % from {partnerName}), you will receive the doctor's answer within {hours} h.",
    "b2c": "You will pay for asking a question. {price} {currency}, you will receive the doctor's answer within {hours} h. {termsLink}",
    "b2cLink": "More information"
  },
  "vitalSigns": {
    "boxTitle": "Health Scanner",
    "boxSubtitle": "Measurement of Vital Signs",
    "boxText": "Quick facial scan and historical data.",
    "boxBadge": "New",
    "page": {
      "title": "Health Scanner",
      "comingSoon": {
        "title": "Coming soon",
        "text": "The vital signs measurement feature is in the process of development. You’ll be able to try it soon."
      },
      "subtitle": "Regular measurements help you keep track of your health.",
      "tabs": {
        "newMeasurement": "New measurement",
        "overview": "Measurement history"
      },
      "measure": {
        "idle": {
          "startButton": "Start measurement"
        },
        "inProgress": {
          "loading": "Loading camera and measurement module...",
          "cancel": "Cancel measurement"
        },
        "results": {
          "title": "Measurement results",
          "disclaimer": "The values are indicative only and do not replace a medical diagnosis. If you have health concerns, consult a doctor.",
          "saveFailed": "Something went wrong while saving. If you would like your measurement results to be saved, please try again.",
          "saveBasic": "Save results",
          "completeProfile": "Learn more",
          "measureAgain": "Measure again",
          "backToDashboard": "View measurement history",
          "basicGroupTitle": "Basic measurement",
          "advancedGroupTitle": "Additional measurement"
        },
        "errors": {
          "no-camera": "The camera is not available. Please allow access to your camera and try again.",
          "unsupported": "Your browser does not support the measurement of vital signs.",
          "license": "Measurement is temporarily unavailable. Please try again later.",
          "network": "The results could not be saved. Please check your connection and try again.",
          "unknown": "An unexpected error occurred. Please try again.",
          "retry": "Try again"
        }
      },
      "overview": {
        "categoryTitle": "Name of category",
        "categoryDescription": "Information on category",
        "cardSubtitle": "Overview of measurement results",
        "ranges": {
          "month": "Month",
          "week": "Week",
          "year": "Year"
        },
        "openInfo": "Show level descriptions",
        "closeInfo": "Hide description",
        "prevMonth": "Previous month",
        "nextMonth": "Next month",
        "emptyTitle": "No data yet",
        "emptyDescription": "Start with your first measurement in the New Measurement tab. After a few measurements, charts will appear here.",
        "prevPeriod": "Previous period",
        "nextPeriod": "Next period"
      }
    },
    "disclaimer": {
      "line1": "This service uses AI to process data, including health data. Learn more about the terms, data protection and limitations {tocLink}.",
      "tocLink": "here",
      "line2": "uLékaře.cz is not a substitute for emergency services. In life-threatening situations, always call 155. {emergencyLink}",
      "emergencyLink": "When should I seek urgent medical care?"
    },
    "healthRisksForm": {
      "title": "Additional information",
      "description": "Please enter your basic personal details so that we can calculate advanced health metrics.",
      "yes": "Yes",
      "no": "No",
      "placeholder": {
        "choose": "Select"
      },
      "gender": {
        "question": "What is your sex?",
        "male": "Male",
        "female": "Female",
        "other": "Other"
      },
      "age": {
        "question": "How old are you?"
      },
      "bodyHeight": {
        "question": "How tall are you?"
      },
      "bodyWeight": {
        "question": "How much do you weigh?"
      },
      "isSmoker": {
        "question": "Do you smoke?"
      },
      "physicalActivity": {
        "question": "How often do you exercise?",
        "sedentary": "I don't exercise",
        "lightlyActive": "1–2 times a week",
        "moderately": "3–4 times a week",
        "veryActive": "5–6 times a week",
        "extraActive": "Daily"
      },
      "hypertensionTreated": {
        "question": "Are you being treated for high blood pressure?"
      },
      "hasDiabetes": {
        "question": "Are you being treated for diabetes?"
      },
      "cholesterol": {
        "question": "What is your total cholesterol level?",
        "hint": "Please enter a value only if you know it (mmol/L)."
      },
      "cholesterolHdl": {
        "question": "What is your HDL cholesterol level?",
        "hint": "Please enter a value only if you know it (mmol/L)."
      },
      "submit": "Calculate and save",
      "cancel": "Back to results",
      "validation": {
        "required": "Please answer this question.",
        "age": "Please enter your age.",
        "bodyHeight": "Please enter your height in cm.",
        "bodyWeight": "Please enter your weight in kg.",
        "cholesterol": "Please enter a value in mmol/L (range 0.5–20)."
      },
      "formHeading": "Additional information for risk assessment",
      "descriptionToggle": "Show help"
    },
    "charts": {
      "heartRate": {
        "title": "Heart rate (bpm)"
      },
      "hrvSdnn": {
        "title": "Heart rate variability (ms)"
      },
      "breathingRate": {
        "title": "Respiratory rate (breaths/min)"
      },
      "bloodPressure": {
        "title": "Blood pressure (mmHg)"
      },
      "wellnessScore": {
        "title": "Fitness (%)"
      },
      "physicalConditionScore": {
        "title": "AI Body Proportion Index"
      },
      "waistToHeightRatio": {
        "title": "Waist-to-height ratio"
      },
      "vascularAge": {
        "title": "Vascular age"
      },
      "cvdRisk": {
        "title": "Cardiovascular risk (%)"
      }
    },
    "metrics": {
      "heartRate": {
        "label": "Heart rate",
        "unit": "bpm",
        "levels": {
          "1": {
            "status": "Optimal",
            "description": "Indicates very good fitness and healthy heart function. The risk of health complications is low, and the heart is functioning efficiently and strongly.",
            "range": "50–70 bpm"
          },
          "2": {
            "status": "Within the normal range, but higher",
            "description": "Your heart rate is still within the normal range, but the heart is already working faster than would be ideal. If your heart rate remains elevated over a long period, it may be related to lower fitness, stress or fatigue.",
            "range": "71–85 bpm"
          },
          "3": {
            "status": "High",
            "description": "Your heart rate is at the upper end of the normal range, which indicates that your heart is under greater strain. The risk of health problems increases if this condition persists over a longer period.",
            "range": "86–100 bpm"
          },
          "4": {
            "status": "Abnormal",
            "description": "Values outside the normal range may indicate a more serious problem. It is important to monitor this condition and consult a doctor if the symptoms persist.",
            "range": "<50 / >100 bpm"
          },
          "5": {
            "status": "Urgent",
            "description": "Your heart rate is outside the safe range and may indicate a serious health problem. It is important to seek medical attention as soon as possible to determine the cause and help prevent potential complications.",
            "range": "<40 / >120 bpm"
          }
        }
      },
      "hrvSdnn": {
        "label": "Heart rate variability",
        "unit": "ms",
        "levels": {
          "1": {
            "status": "High variability",
            "description": "Indicates a healthy autonomic nervous system and a good ability to adapt. The risk of stress and overexertion is low.",
            "range": ">70 ms"
          },
          "2": {
            "status": "Moderate variability",
            "description": "Your autonomic nervous system handles everyday strain well, but your resilience to stress is not at its highest. There is room for improvement through lifestyle changes.",
            "range": "40–70 ms"
          },
          "3": {
            "status": "Low variability",
            "description": "Indicates that the autonomic nervous system may be fatigued and the body's ability to adapt is reduced. The risk of stress, fatigue and overexertion is increased.",
            "range": "20–40 ms"
          },
          "4": {
            "status": "Very low variability",
            "description": "The autonomic nervous system may be under significant strain, and the body may be experiencing prolonged stress. If heart rate variability remains very low over a prolonged period, there may be a risk of exhaustion and health complications.",
            "range": "<20 ms"
          },
          "5": {
            "status": "Urgent",
            "description": "Heart rate variability is extremely low, which may indicate acute physical strain or a serious imbalance in the autonomic nervous system. We recommend seeking medical attention as soon as possible.",
            "range": "<10 ms"
          }
        }
      },
      "breathingRate": {
        "label": "Respiratory rate",
        "unit": "breaths/min",
        "levels": {
          "1": {
            "status": "Optimal",
            "description": "Breathing is healthy and regular, and the body is receiving sufficient oxygen. This indicates good fitness and a well-balanced nervous system.",
            "range": "12–16 breaths/min"
          },
          "2": {
            "status": "Mildly elevated",
            "description": "Your respiratory rate is within the normal range, but it indicates increased activity in the body. It may be associated with fatigue, stress or mild restlessness.",
            "range": "17–20 breaths/min"
          },
          "3": {
            "status": "Elevated",
            "description": "Your breathing is faster than is healthy at rest. The body may be under strain, stressed or not fully rested. Persistently rapid breathing may also be a sign of certain medical conditions.",
            "range": "21–24 breaths/min"
          },
          "4": {
            "status": "Abnormal",
            "description": "Breathing that is too slow or too fast may be a sign of a health problem and requires attention, especially if it persists over time.",
            "range": "≤11 / ≥25 breaths/min"
          },
          "5": {
            "status": "Urgent",
            "description": "Your respiratory rate is outside the safe range and may indicate serious respiratory failure or acute physical strain. It is important to seek medical attention as soon as possible to prevent potential complications.",
            "range": "<8 / >30 breaths/min"
          }
        }
      },
      "bloodPressure": {
        "label": "Blood pressure",
        "unit": "mmHg",
        "levels": {
          "1": {
            "status": "Optimal",
            "description": "The values indicate optimal blood pressure with minimal strain on the blood vessels and heart. The risk of complications is minimal.",
            "range": "SBP <120 and DBP <80"
          },
          "2": {
            "status": "Within the normal range, but higher",
            "description": "Your blood pressure is within the healthy range, but there is room for slight improvement. With a little exercise and adequate rest, you can keep it healthy in the long term.",
            "range": "SBP 120–129 and DBP 80–84"
          },
          "3": {
            "status": "High",
            "description": "The values are still below the threshold for hypertension, but they indicate increased strain. The risk of developing high blood pressure is increased.",
            "range": "SBP 130–139 and DBP 85–89"
          },
          "4": {
            "status": "Hypertension",
            "description": "The values indicate hypertension, which places significant long-term strain on the heart and blood vessels. The risk of health complications is high.",
            "range": "SBP ≥140 or DBP ≥90"
          },
          "5": {
            "status": "Urgent – severe hypertension",
            "description": "Blood pressure is markedly elevated and may indicate severe hypertension. This condition places the heart, blood vessels and other organs at risk in the long term. It is important to seek medical attention as soon as possible to determine the cause and bring your blood pressure under control.",
            "range": "SBP ≥160 or DBP ≥100"
          }
        }
      },
      "wellnessScore": {
        "label": "Fitness",
        "unit": "/100",
        "levels": {
          "1": {
            "status": "Excellent condition",
            "description": "The result indicates that both body and mind are functioning in harmony. Your energy levels, overall health and mental well-being are at a very good level.",
            "range": "80–100%"
          },
          "2": {
            "status": "Sustainable Condition",
            "description": "The result indicates good physical and mental health, with occasional fluctuations. There is room for minor lifestyle improvements.",
            "range": "60–79%"
          },
          "3": {
            "status": "At Risk",
            "description": "The result indicates more frequent fatigue, stress or a lack of balance. This is a warning sign that your body and mind need more attention.",
            "range": "40–59%"
          },
          "4": {
            "status": "Critical condition",
            "description": "Your body and mind appear to be under prolonged strain and exhaustion. The risk of health and mental health complications is high.",
            "range": "0–39%"
          }
        }
      },
      "physicalConditionScore": {
        "label": "AI Body Proportion Index",
        "levels": {
          "1": {
            "status": "Optimal weight",
            "description": "The AIBPI indicates that your body weight is consistent with good health. The risk of complications is low, and the body is in a healthy balance.",
            "range": "18.5–24.9"
          },
          "2": {
            "status": "Overweight",
            "description": "The AIBPI indicates a slight increase in body weight that is not yet critical but may place additional strain on the body over time. This is a sign that some minor lifestyle changes may be needed.",
            "range": "25–29.9"
          },
          "3": {
            "status": "Obesity",
            "description": "The AIBPI indicates a higher degree of excess weight, which may increase the risk of health complications. A conscious and systematic lifestyle change is needed.",
            "range": "30–34.9"
          },
          "4": {
            "status": "Severe obesity",
            "description": "The AIBPI indicates a high risk of health complications. It is essential to make lifestyle changes and, in many cases, seek professional support.",
            "range": "≥35"
          }
        }
      },
      "waistToHeightRatio": {
        "label": "Waist-to-height ratio",
        "levels": {
          "1": {
            "status": "Optimal ratio",
            "description": "Indicates a healthy distribution of body fat and a low risk of cardiovascular and metabolic diseases.",
            "range": "≤0.50"
          },
          "2": {
            "status": "Increased Risk",
            "description": "A sign that you have a higher amount of abdominal fat, which slightly increases health risks.",
            "range": "0.51–0.59"
          },
          "3": {
            "status": "High risk",
            "description": "Abdominal fat accumulation significantly increases the risk of metabolic and cardiovascular diseases.",
            "range": "0.60–0.69"
          },
          "4": {
            "status": "Very high risk",
            "description": "An extremely high proportion of abdominal fat, which poses a serious health risk and requires attention.",
            "range": "≥0.70"
          }
        }
      },
      "vascularAge": {
        "label": "Vascular age",
        "unit": "years",
        "levels": {
          "1": {
            "status": "Optimal",
            "description": "Your blood vessels are healthy and have good elasticity. The risk of cardiovascular disease is low.",
            "range": "Vascular age ≤ Chronological age"
          },
          "2": {
            "status": "Mildly elevated",
            "description": "Your blood vessels are under mild strain, suggesting that their elasticity may be starting to decline. Preventive measures are recommended to help slow vascular ageing.",
            "range": "1–5 years older"
          },
          "3": {
            "status": "Elevated",
            "description": "Your blood vessels are losing elasticity and are under increased strain. The risk of cardiovascular problems is beginning to increase.",
            "range": "6–10 years older"
          },
          "4": {
            "status": "High",
            "description": "Your blood vessels are noticeably stiffened and weakened, which significantly increases the risk of cardiovascular disease. This condition requires action to improve vascular health and prevent further deterioration.",
            "range": "More than 10 years older"
          }
        }
      },
      "cvdRisk": {
        "label": "Cardiovascular risk",
        "unit": "%",
        "levels": {
          "1": {
            "status": "Low risk",
            "description": "Risk factors are either absent or very low. Blood pressure, body weight, lifestyle and other indicators are within the normal range.",
            "range": "<5%"
          },
          "2": {
            "status": "Mildly elevated risk",
            "description": "Some indicators (e.g. blood pressure, body weight or lack of physical activity) are beginning to suggest increased strain on the heart. The risk is still low, but it should not be ignored.",
            "range": "5–7%"
          },
          "3": {
            "status": "Increased Risk",
            "description": "The values indicate increased strain — blood pressure, cholesterol, excess weight or smoking are already having a significant impact on vascular health. The risk of developing disease is real.",
            "range": "7.5–19.9%"
          },
          "4": {
            "status": "High risk",
            "description": "Risk factors are accumulating — high blood pressure, high cholesterol, overweight, smoking or diabetes significantly increase the risk of cardiovascular disease.",
            "range": "≥20%"
          }
        }
      }
    }
  },
  "vitalSignsAgreement": {
    "title": "Acceptance of the Terms of Use",
    "perex": "Please review the updated Terms of Use, which contain information about this AI-powered service.",
    "dataProcessing": "We also inform you that we process your personal data in accordance with the {privacyLink}.",
    "termsLinkText": "Terms of Use",
    "privacyLinkText": "Privacy Policy",
    "agreeCheckbox": "I agree to the {termsLink}",
    "confirmButton": "I understand"
  },
  "security": {
    "title": "Information Security within the Company",
    "content": [
      {
        "title": "Certifications and Audits",
        "text": "We are certified to ISO/IEC 27001, which confirms that our information security management system meets internationally recognised standards. This certification helps us ensure the confidentiality, integrity and availability of our information. In addition, we undergo regular external audits that independently verify our compliance with security procedures and policies."
      },
      {
        "title": "Data Storage and Encryption",
        "text": "Our company takes data security very seriously and uses a wide range of measures to protect our customers’ data. Your data is stored on Amazon Web Services (AWS) servers in the Frankfurt region, allowing us to benefit from the robust security infrastructure of one of the world’s leading cloud platforms. Data in transit to the user is encrypted using the TLS protocol. Data at rest is encrypted using AES-256. Customer data is stored on encrypted servers that are not accessible from the outside world. We use a Virtual Private Cloud (VPC), where only application components within the same internal network can access the data, so the data is not transmitted over the public internet."
      },
      {
        "title": "Penetration tests",
        "text": "Regular penetration testing is carried out by an independent company, enabling us to objectively identify and address potential vulnerabilities in our systems. These tests simulate real-world attacks and contribute to the continuous improvement of our protection against security threats."
      },
      {
        "title": "Backup",
        "text": "Regular data backups are a key component of our strategy to ensure data availability and integrity. Data is primarily hosted in our AWS data centre, with backups stored in a separate AWS data centre within the EU. In this way, we are able to restore data in the event of loss or corruption."
      },
      {
        "title": "Monitoring",
        "text": "IT systems are monitored online, and our administrators are immediately notified of any issues. We also maintain logs that can help us identify any issues that may arise."
      },
      {
        "title": "Code",
        "text": "Every line of code released to production is reviewed by other developers to ensure it is functional and secure. The libraries we use are regularly audited and updated. We use the Git version control system to track changes."
      },
      {
        "title": "Two-Factor Authentication (2FA)",
        "text": "We use two-factor authentication (2FA) to access sensitive data in our applications, requiring an additional verification factor alongside a standard password. This significantly strengthens access security and reduces the risk of unauthorised access. Users of the service also have the option to enable two-factor authentication (2FA) in their client area to enhance the security of their account further."
      },
      {
        "title": "Payment Information",
        "text": "We do not store any payment information or card numbers. To process payments we use external providers who are certified to PCI DSS (Payment Card Industry Data Security Standard). This ensures that all transactions are carried out in accordance with the highest security standards."
      },
      {
        "title": "GDPR compliance",
        "text": "We store data in compliance with the General Data Protection Regulation (GDPR). This legal framework ensures that our users’ personal data is processed lawfully, fairly and transparently. Terms of use form part of every service provided, and users have access to them and must explicitly agree before using the service. Similarly, users are provided with a Privacy Policy on our website, which describes in detail how their data is processed and protected. We have implemented all necessary processes and measures to ensure the protection of our users’ rights and compliance of our activities with these regulations."
      },
      {
        "title": "Training of Employees",
        "text": "We regularly provide our staff with training on information security and GDPR. These training sessions cover current procedures and best practices in data protection and are aimed at increasing awareness of potential security risks and how to prevent them. Employees are also familiarised with procedures for the proper handling and protection of personal data to ensure that our activities are always in compliance with legal requirements and standards. In this way, we ensure that every member of our team is equipped with the knowledge and skills necessary to maintain a high level of information security."
      },
      {
        "title": "Use of AI Tools and Regulatory Compliance",
        "text": "We use modern artificial intelligence tools only in a manner that complies with the requirements of the AI Act and applicable legislation. When using these tools, we place the utmost emphasis on information security, personal data protection, and data confidentiality. No AI tool is used in a way that would allow it to learn from client data or internal sensitive information without proper security and oversight."
      }
    ],
    "note": "To report a security vulnerability or for any enquiries, please contact us at <strong>security@ulekare.cz.</strong>"
  },
  "insuranceBenefits": {
    "items": [
      {
        "slug": "vzp",
        "updateDate": "30.3.2026",
        "companyBenefitsLink": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky",
        "gendersCount": "3",
        "genders": [
          {
            "name": "Men",
            "benefitsCount": "15",
            "benefits": [
              {
                "type": "Physical activity and dental hygiene",
                "icon": "move",
                "benefit": "Up to 500 CZK for physical and sports activities or dental hygiene for people aged 18 to 65",
                "description": "The contribution is intended for regular, long-term physical and sports activities, or those provided by a physical therapist, as well as dental hygiene (treatment and instruction). For more information, visit the health insurance company’s website here: link.",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/odmena-za-prevenci/pohyb-a-dentalni-hygiena/dospely"
              },
              {
                "type": "Rehabilitation treatments",
                "benefit": "A contribution of up to 1,000 CZK for insured person (over 18 years of age)",
                "description": "The contribution covers spa-style rehabilitation and wellness activities not covered by health insurance. These include, for example, massages, saunas, swimming, salt caves, cryochambers, and Kneipp paths. \nFor more information, visit the health insurance company’s website here: link.",
                "icon": "heart",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/odmena-za-prevenci/rehabilitacni-procedury"
              },
              {
                "type": "Vaccination",
                "benefit": "Up to CZK 14 900 for various types of vaccination",
                "description": "This contribution is for vaccination that is not funded by public health insurance, i.e., where the insured pays for the vaccine as well as its application in full. The contribution does not apply to payment of any difference between funding from public health insurance and a payment to a doctor.\nMore information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/ockovani/dospely"
              },
              {
                "type": "Support for people with diabetes",
                "benefit": "Up to 6,000 CZK for people with diabetes",
                "description": "This is a contribution to educational stays, instrumental foot treatments, and one selected spa-type rehabilitation procedure or therapy.\nFor more information, visit the health insurance company's website here: link.",
                "icon": "diabetes",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/podpora-pri-nemoci/diabetes-mellitus"
              },
              {
                "type": "Special diets",
                "benefit": "Up to 8,000 CZK for a gluten-free diet and up to 12,000 CZK for a low-protein diet for insured individuals under 26 years of age",
                "description": "The contribution for gluten-free foods, for gluten-free lunches in the school cafeteria, or for low-protein, lactose-free, or gluten-free foods. \nFor more information, visit the health insurance company’s website here: link.",
                "icon": "zdravy-talir",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/podpora-pri-nemoci/specialni-diety"
              },
              {
                "type": "Support during cancer treatment or alopecia",
                "benefit": "A benefit of up to 2,000 CZK for insured persons of any age undergoing cancer treatment or suffering from alopecia",
                "description": "The contribution can be used to purchase a wig, hairpiece, or special prosthetic bra following a mastectomy, or to cover the cost of a cooling cap during chemotherapy.\nFor more information, visit the health insurance company’s website here: link.",
                "icon": "care",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/podpora-pri-nemoci/prispevek-na-pomucky-pri-onkologicke-lecbe-nebo-alopecii"
              },
              {
                "type": "Smoking cessation",
                "benefit": "Up to CZK 2 500: as part of prevention of cardiovascular and other serious diseases, you can receive a contribution toward quitting smoking",
                "description": "A contribution for Champix, a prescription medication, or for over-the-counter products (e.g., Defumoxan) purchased at a pharmacy (i.e., for nicotine substitution therapy in the following forms: patches, lozenges, orally disintegrating films, oral sprays, chewing gum).\n More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "smoke",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/prevence/odvykani-koureni"
              },
              {
                "type": "Examination of skin marks",
                "benefit": "Up to CZK 500 for the examination of skin marks with a dermatoscope by a GP or dermatologist",
                "description": "A contribution for skin cancer (melanoma) prevention. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "skin",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/prevence-onemocneni/vysetreni-koznich-znamenek"
              },
              {
                "type": "Ultrasound breast exam",
                "benefit": "Up to CZK 500 for an ultrasound breast exam (sonography)",
                "description": "A contribution for an ultrasound breast exam (sonography), which must be performed by an accredited mammography screening centre. More information (in Czech only) is available on the insurance company's website here: link",
                "icon": "ribbon",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/prevence-onemocneni/ultrazvukove-vysetreni-prsou"
              },
              {
                "type": "Cancer prevention",
                "benefit": "Up to CZK 3000 for comprehensive preventive cancer screening",
                "description": "A contribution for comprehensive cancer screening at comprehensive oncology centres. This contribution is intended for those insured with VZP, starting at age 35 with no upper age limit.\n More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "ribbon",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/prevence/komplexni-onkologicka-prohlidka"
              },
              {
                "type": "For active blood donors",
                "benefit": "Up to 3,000 CZK for rehabilitation/reconditioning activities and up to 1,000 CZK for dental hygiene",
                "description": "A contribution of up to 3,000 CZK for rehabilitation/reconditioning activities and up to 1,000 CZK for dental hygiene (treatment and instruction).  For more information, visit the health insurance company’s website here: link.",
                "icon": "bloodtest",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/darci/darci-krve"
              },
              {
                "type": "For inactive blood donors",
                "benefit": "Up to 500 CZK for rehabilitation/reconditioning activities",
                "description": "A contribution of up to 500 CZK for rehabilitation/reconditioning activities.  For more information, visit the health insurance company’s website here: link.",
                "icon": "bloodtest",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/darci/darci-krve"
              },
              {
                "type": "Psycho-social support",
                "benefit": "Up to CZK 5000 to increase the availability of psycho-social support from a selected therapist",
                "description": "The contribution is intended for insured persons aged 7 years and older for a session with a selected therapist according to the published list for a maximum of 10 sessions. \n More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://dusevnizdravi.vzp.cz/informace-o-prispevku/"
              },
              {
                "type": "Memory training/testing for seniors",
                "benefit": "Up to CZK 500 for cognitive aids or memory testing",
                "description": "If you are over the age of 65, you can take advantage of a contribution for cognitive aids recommended by the Czech Alzheimer Society for memory training or memory testing in a selected chain of pharmacies. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/podpurne-programy/trenink-testovani-pameti-pro-seniory"
              },
              {
                "type": "Psychosocial support for war refugees from Ukraine",
                "benefit": "Up to CZK 5,000 to increase the availability of psychosocial support at a selected therapeutic service provider included in the project",
                "description": "The contribution is provided for a maximum of 10 sessions at a maximum amount of CZK 500 per session for ages 7 and up. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://dusevnizdravi.vzp.cz/informace-o-prispevku-ua/"
              }
            ]
          },
          {
            "name": "Women",
            "benefitsCount": "18",
            "benefits": [
              {
                "type": "Physical activity and dental hygiene",
                "benefit": "Up to 500 CZK for physical and sports activities or dental hygiene for people aged 18 to 65",
                "description": "The contribution is intended for regular, long-term physical and sports activities, or those provided by a physical therapist, as well as dental hygiene (treatment and instruction).\n\nFor more information, visit the health insurance company’s website here: link.",
                "icon": "move",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/odmena-za-prevenci/pohyb-a-dentalni-hygiena/dospely"
              },
              {
                "type": "Rehabilitation treatments",
                "benefit": "A contribution of up to 1,000 CZK for insured person (over 18 years of age)",
                "description": "The contribution covers spa-style rehabilitation and wellness activities not covered by health insurance. These include, for example, massages, saunas, swimming, salt caves, cryochambers, and Kneipp paths. \nFor more information, visit the health insurance company’s website here: link.",
                "icon": "heart",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/odmena-za-prevenci/rehabilitacni-procedury"
              },
              {
                "type": "Vaccination",
                "benefit": "Up to CZK 14 900 for various types of vaccination",
                "description": "This contribution is for vaccination that is not funded by public health insurance, i.e., where the insured pays for the vaccine as well as its application in full. The contribution does not apply to payment of any difference between funding from public health insurance and a payment to a doctor.\n More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/ockovani/dospely"
              },
              {
                "type": "Support for people with diabetes",
                "benefit": "Up to 6,000 CZK for people with diabetes",
                "description": "his is a contribution to educational stays, instrumental foot treatments, and one selected spa-type rehabilitation procedure or therapy.\nFor more information, visit the health insurance company's website here: link.",
                "icon": "diabetes",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/podpora-pri-nemoci/diabetes-mellitus"
              },
              {
                "type": "Special diets",
                "benefit": "Up to 8,000 CZK for a gluten-free diet and up to 12,000 CZK for a low-protein diet for insured individuals under 26 years of age",
                "description": "The contribution for gluten-free foods, for gluten-free lunches in the school cafeteria, or for low-protein, lactose-free, or gluten-free foods. \nFor more information, visit the health insurance company’s website here: link.",
                "icon": "zdravy-talir",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/podpora-pri-nemoci/specialni-diety"
              },
              {
                "type": "Support during cancer treatment or alopecia",
                "benefit": "A benefit of up to 2,000 CZK for insured persons of any age undergoing cancer treatment or suffering from alopecia",
                "description": "The contribution can be used to purchase a wig, hairpiece, or special prosthetic bra following a mastectomy, or to cover the cost of a cooling cap during chemotherapy.\nFor more information, visit the health insurance company’s website here: link.",
                "icon": "care",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/podpora-pri-nemoci/prispevek-na-pomucky-pri-onkologicke-lecbe-nebo-alopecii"
              },
              {
                "type": "Smoking cessation",
                "benefit": "Up to CZK 2 500: as part of prevention of cardiovascular and other serious diseases, you can receive a contribution toward quitting smoking",
                "description": "A contribution for Champix, a prescription medication, or for over-the-counter products (e.g., Defumoxan) purchased at a pharmacy (i.e., for nicotine substitution therapy in the following forms: patches, lozenges, orally disintegrating films, oral sprays, chewing gum).\n More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "smoke",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/prevence/odvykani-koureni"
              },
              {
                "type": "Examination of skin marks",
                "benefit": "Up to CZK 500 for the examination of skin marks with a dermatoscope by a GP or dermatologist",
                "description": "A contribution for skin cancer (melanoma) prevention. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "skin",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/prevence-onemocneni/vysetreni-koznich-znamenek"
              },
              {
                "type": "Ultrasound breast exam",
                "benefit": "Up to CZK 500 for an ultrasound breast exam (sonography)",
                "description": "A contribution for an ultrasound breast exam (sonography), which must be performed by an accredited mammography screening centre. More information (in Czech only) is available on the insurance company's website here: link",
                "icon": "ribbon",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/prevence-onemocneni/ultrazvukove-vysetreni-prsou"
              },
              {
                "type": "Cancer prevention",
                "benefit": "Up to CZK 3000 for comprehensive preventive cancer screening",
                "description": "A contribution for comprehensive cancer screening at comprehensive oncology centres. This contribution is intended for those insured with VZP, starting at age 35 with no upper age limit.\n More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "ribbon",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/prevence/komplexni-onkologicka-prohlidka"
              },
              {
                "type": "For active blood donors",
                "benefit": "Up to 3,000 CZK for rehabilitation/reconditioning activities and up to 1,000 CZK for dental hygiene",
                "description": "A contribution of up to 3,000 CZK for rehabilitation/reconditioning activities and up to 1,000 CZK for dental hygiene (treatment and instruction).  For more information, visit the health insurance company’s website here: link.",
                "icon": "bloodtest",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/darci/darci-krve"
              },
              {
                "type": "For inactive blood donors",
                "benefit": "Up to 500 CZK for rehabilitation/reconditioning activities",
                "description": "A contribution of up to 500 CZK for rehabilitation/reconditioning activities.  For more information, visit the health insurance company’s website here: link.",
                "icon": "bloodtest",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/darci/darci-krve"
              },
              {
                "type": "Psycho-social support",
                "benefit": "Up to CZK 5000 to increase the availability of psycho-social support from a selected therapist",
                "description": "The contribution is intended for insured persons aged 7 years and older for a session with a selected therapist according to the published list for a maximum of 10 sessions. \n More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://dusevnizdravi.vzp.cz/informace-o-prispevku/"
              },
              {
                "type": "For pregnant women and mothers",
                "benefit": "Up to CZK 5 000 for selected services and aids",
                "description": "During pregnancy and up to 12 months after delivery, you can use your financial contribution for selected services such as: screening, a delivery preparation course, lactation aids, a breath monitor, etc.\n More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "pregnant",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/k-porodu-a-po-porodu/tehotne-do-12-mesicu"
              },
              {
                "type": "Contribution for premature babies",
                "benefit": "Up to CZK 3000 toward the purchase of formula, mother's milk from a bank, rehabilitation care for these children",
                "description": "In support of healthy development of children and prevention of the possible consequences of premature cessation of development in the womb, a contribution is provided for premature babies with a birth weight of up to 1500 g. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "birth",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/k-porodu-a-po-porodu/nedonosene"
              },
              {
                "type": "Donation for a baby with a cleft lip",
                "benefit": "Up to 4,500 CZK toward the purchase of nostrils at a pharmacy or hospital",
                "description": "A contribution for infants under 12 months of age to purchase nostrils at a pharmacy or hospital.  For more information, visit the health insurance company’s website here: link.",
                "icon": "birth",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/k-porodu-a-po-porodu/novorozenec-s-rozstepem-rtu"
              },
              {
                "type": "Memory training/testing for seniors",
                "benefit": "Up to CZK 500 for cognitive aids or memory testing",
                "description": "If you are over the age of 65, you can take advantage of a contribution for cognitive aids recommended by the Czech Alzheimer Society for memory training or memory testing in a selected chain of pharmacies. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/podpurne-programy/trenink-testovani-pameti-pro-seniory"
              },
              {
                "type": "Psychosocial support for war refugees from Ukraine",
                "benefit": "Up to CZK 5,000 to increase the availability of psychosocial support at a selected therapeutic service provider included in the project",
                "description": "The contribution is provided for a maximum of 10 sessions at a maximum amount of CZK 500 per session for ages 7 and up. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://dusevnizdravi.vzp.cz/informace-o-prispevku-ua/"
              }
            ]
          },
          {
            "name": "Children",
            "benefitsCount": "11",
            "benefits": [
              {
                "type": "Physical activity and dental hygiene",
                "benefit": "Up to 2,000 CZK for physical activities for children aged 0–18.",
                "description": "A contribution for children aged 0–18, e.g., baby swimming and infant bathing classes organized by clubs, associations, or other groups; regular long-term physical and sports activities organized by clubs, associations, sports clubs, etc., such as aerobics, track and field, floorball, soccer, hockey, gymnastics, ski courses organized by schools, etc. The subsidy can also be used for dental hygiene (ages 1–18).\n\nFor more information, visit the health insurance company’s website here: link.",
                "icon": "sport",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/odmena-za-prevenci/pohyb-a-dentalni-hygiena/deti"
              },
              {
                "type": "Support for people with diabetes",
                "benefit": "Up to 3,000 CZK for people with diabetes",
                "description": "his is a contribution to educational stays and selected spa-type rehabilitation procedure or therapy.\nFor more information, visit the health insurance company's website here: link.",
                "icon": "diabetes",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/podpora-pri-nemoci/diabetes-mellitus"
              },
              {
                "type": "Vaccination",
                "benefit": "Up to CZK 9,500 for various types of vaccination",
                "description": "This contribution is for vaccination that is not funded by public health insurance, i.e., where the insured pays for the vaccine as well as its application in full. The contribution does not apply to payment of any difference between funding from public health insurance and a payment to a doctor.\n More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/ockovani"
              },
              {
                "type": "Special diets",
                "benefit": "Up to 8,000 CZK for a gluten-free diet and up to 12,000 CZK for a low-protein diet for insured individuals under 26 years of age",
                "description": "The contribution for gluten-free foods, for gluten-free lunches in the school cafeteria, or for low-protein, lactose-free, or gluten-free foods. \nFor more information, visit the health insurance company’s website here: link.",
                "icon": "zdravy-talir",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/podpora-pri-nemoci/specialni-diety"
              },
              {
                "type": "Contribution for lightweight casts and splints for children",
                "benefit": "Up to 1,500 CZK for lightweight and ultra-lightweight casts",
                "description": "This benefit is intended for children under 18 years of age for lightweight casts made of plastic, resin, and carbon fiber. For more information, visit the health insurance company’s website here: link.",
                "icon": "person-happy",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/podpora-pri-nemoci/odlehcene-sadry-a-fixace"
              },
              {
                "type": "Examination of skin marks",
                "benefit": "Up to CZK 500 for the examination of skin marks with a dermatoscope by a GP or dermatologist",
                "description": "A contribution for skin cancer (melanoma) prevention. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "skin",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/prevence-onemocneni/vysetreni-koznich-znamenek"
              },
              {
                "type": "Contribution for aids for cancer treatment or alopecia",
                "benefit": "Up to CZK 2,000 for aids",
                "description": "Contribution to patients who have undergone oncological treatment or insured patients with a diagnosis of alopecia. \n More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/podpora-pri-nemoci/prispevek-na-pomucky-pri-onkologicke-lecbe-nebo-alopecii"
              },
              {
                "type": "Contribution for premature babies",
                "benefit": "Up to CZK 3000 toward the purchase of formula, mother's milk from a bank, rehabilitation care for these children",
                "description": "In support of healthy development of children and prevention of the possible consequences of premature cessation of development in the womb, a contribution is provided for premature babies with a birth weight of up to 1500 g. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "birth",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/k-porodu-a-po-porodu/nedonosene"
              },
              {
                "type": "Donation for a baby with a cleft lip",
                "benefit": "Up to 4,500 CZK toward the purchase of nostrils at a pharmacy or hospital",
                "description": "A contribution for infants under 12 months of age to purchase nostrils at a pharmacy or hospital.  For more information, visit the health insurance company’s website here: link.",
                "icon": "birth",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/k-porodu-a-po-porodu/novorozenec-s-rozstepem-rtu"
              },
              {
                "type": "Psycho-social support",
                "benefit": "Up to CZK 5,000 to increase the availability of psycho-social support from a selected therapist",
                "description": "The contribution is intended for insured persons aged 7 years and older for a session with a selected therapist according to the published list for a maximum of 10 sessions. \n More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://dusevnizdravi.vzp.cz/informace-o-prispevku/"
              },
              {
                "type": "Psychosocial support for war refugees from Ukraine",
                "benefit": "Up to CZK 5,000 to increase the availability of psychosocial support at a selected therapeutic service provider included in the project",
                "description": "The contribution is provided for a maximum of 10 sessions at a maximum amount of CZK 500 per session for ages 7 and up. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://dusevnizdravi.vzp.cz/informace-o-prispevku-ua/"
              }
            ]
          }
        ]
      },
      {
        "slug": "zpmv",
        "updateDate": "27.1.2026",
        "companyBenefitsLink": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence",
        "gendersCount": "3",
        "genders": [
          {
            "name": "Men",
            "benefitsCount": "31",
            "benefits": [
              {
                "type": "Vaccination",
                "benefit": "Up to CZK 2 000 for vaccination",
                "description": "We contribute up to CZK 2 000 for all vaccination not covered by public health insurance (or outside the age range where it is covered).\n More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/ockovani-pro-dospele"
              },
              {
                "type": "Sports and physical activities for adults\n",
                "benefit": "Up to CZK 500 for sports activities",
                "description": "We contribute up to CZK 500 to sports activities intended for adults. This includes long-term activities and sports that develop strength, coordination, flexibility, and core strength, helping to improve or maintain fitness.\n More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "sport",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/sportovni-pohybove-aktivity-pro-dospele"
              },
              {
                "type": "Preventive examination for athletes",
                "benefit": "Up to CZK 500 for athletes for preventive medical examinations",
                "description": "We contribute up to CZK 500 for a preventive examination required by sports clubs and associations. The examination is usually includes a basic internal examination, basic history, assessment of blood and urine tests, basic examination of the musculoskeletal apparatus, anthropometry or resting spirometry; body composition analysis using the bioimpedance method, resting and active ECG (on a treadmill or stationary bicycle).\nMore information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "sport",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/sportovni-preventivni-prohlidka"
              },
              {
                "type": "Overweight and obesity prevention",
                "benefit": "Up to CZK 500 for an examination that includes body composition analysis, particularly using the bioelectric impedance method.",
                "description": "We contribute up to CZK 500 for and examination that includes body composition analysis, particularly using the bioelectrical impedance method. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "weight",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/prevence-nadvahy-a-obezity"
              },
              {
                "type": "Prevention of colon and anal cancer\n",
                "benefit": "Up to CZK 500 for an examination for the timely detection of malignant cancer of the colon and anus",
                "description": "We contribute up to CZK 500 for screening for timely detection of malignant cancer of the colon and anus so that chances of recovery are as great as possible. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "rectum",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/prevence-karcinomu-tlusteho-streva-a-konecniku"
              },
              {
                "type": "Skin cancer prevention",
                "benefit": "Up to CZK 500 for an examination using a dermatoscope",
                "description": "We contribute up to CZK 500 for an examination using a dermatoscope, which is used for timely detection of malignant skin cancer. \n More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "skin",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/prevence-karcinomu-kuze"
              },
              {
                "type": "Medical devices\n",
                "benefit": "Up to CZK 500 beyond the scope of other preventive programmes for the purchase of medical devices",
                "description": "We contribute up to CZK 500 for the purchase of medical devices related to a chronic illness that are not covered by public health insurance. For example diabetes, respiratory diseases (Asthma), Chronic gastrointestinal diseases, Chronic urinary system diseases and others. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "birth",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/zdravotnicke-prostredky"
              },
              {
                "type": "Support for specific diets",
                "benefit": "Up to CZK 2 000 for the purchases of special foods and meals suitable for allergies or intolerances",
                "description": "We contribute up to CZK 2 000 for adults with food intolerance beyond the scope of other preventive programmes for the purchase of special foods and meals suitable for allergies or intolerance. For example: in the case of coeliac disease, phenylketonuria, etc. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/specificke-diety"
              },
              {
                "type": "Dietary recommendations by a nutritional therapist ",
                "benefit": "Up to CZK 500 for the services of a nutritional therapist ",
                "description": "We contribute up to CZK 500 for the services of a nutritional therapist, who will make dietary recommendations to achieve and maintain healthy weight. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "weight",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/sestaveni-jidelnicku-nutricnim-terapeutem"
              },
              {
                "type": "Dental hygiene for adults",
                "benefit": "Up to CZK 500 for dental hygiene",
                "description": "We contribute up to CZK 500 for training in proper dental cleaning as part of an unpaid dental hygiene service by a dental hygienist. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "brush",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/dentalni-hygiena-pro-dospele"
              },
              {
                "type": "Comprehensive oncology examination",
                "benefit": "Up to CZK 2 000 for preventive oncological examinations ",
                "description": "We contribute up to CZK 2 000 for preventive oncological examinations within the offer of the Comprehensive Cancer Centres. \nMore information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "ribbon",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/komplexni-onkologicke-vysetreni"
              },
              {
                "type": "Telemonitoring",
                "benefit": "Up to CZK 2 000 for clients participating in telemonitoring programmes",
                "description": "We contribute up to CZK 2 000 beyond the scope of other preventive programmes to clients participating in telemonitoring programmes. For example telemonitoring for clients with chronic heart failure, telemonitoring for clients with suspected heart rhythm disturbances or being treated for heart arrhythmia, and others. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "register",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/telemonitoring"
              },
              {
                "type": "Clinical psychology - Adults",
                "benefit": "Up to CZK 4 000 for examinations in the field of clinical psychology",
                "description": "We contribute up to CZK 4 000 for up to 10 examinations (i.e. up to CZK 400 per examination) in the field of clinical psychology, which are not covered by public health insurance and whose purpose is primarily to help manage stress and the psychological problems arising from it. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/klinicka-psychologie-dospeli"
              },
              {
                "type": "Clinical speech therapy - Adults",
                "benefit": "Up to CZK 4 000 for examinations in the field of clinical speech therapy",
                "description": "We contribute up to CZK 4 000 for up to 10 examinations (i.e. up to CZK 400 per examination) in the field of clinical speech therapy. (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/klinicka-logopedie-dospeli"
              },
              {
                "type": "Wigs, bras, and other items for cancer patients\n",
                "benefit": "Up to CZK 2 000 for the purchase of a wig or headscarf, medicinal products containing panthenol for the treatment of burns after radiation therapy (radiotherapy), etc.",
                "description": "We contribute up to CZK 2 000 beyond the scope of other preventive programmes for patients who are undergoing or have undergone anti-cancer treatment (chemotherapy), toward the purchase of a wig or a kerchief. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/paruky-podprsenky-a-dalsi-prostredky-pro-onkologicke-pacienty"
              },
              {
                "type": "Educational stays for clients with Type II diabetes",
                "benefit": "Up to CZK 2000 for clients with Type II diabetes for educational stays",
                "description": "We contribute up to CZK 2 000 to adults who are undergoing or have undergone cancer treatment (chemotherapy), radiation therapy, or surgery for the purchase of a wig or scarf, medicinal products containing panthenol for the treatment of burns after radiation therapy (radiotherapy), etc. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "diabetes",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacni-pobyty-pro-klienty-s-diabetem-ii-typu"
              },
              {
                "type": "Cognitive function testing and memory training aids\n\n",
                "benefit": "Up to CZK 500 for examinations whose primary purpose is timely diagnosis of memory impairment due to Alzheimer's disease or other forms of dementia",
                "description": "We contribute up to CZK 500 for examinations whose primary purpose is timely diagnosis of memory impairment due to Alzheimer's disease or other forms of dementia. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "doctor",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/vysetreni-kognitivnich-funkci-a-pomucky-pro-trenovani-pameti"
              },
              {
                "type": "Traffic psychological examination",
                "benefit": "Up to CZK 500 for an examination by a traffic psychologist",
                "description": "We contribute up to CZK 500 for an examination by a traffic psychologist.\nA traffic psychology examination is mandatory for some groups of driver's licences, or can be requested by a GP. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "doctor",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/dopravne-psychologicke-vysetreni"
              },
              {
                "type": "Course for parents – children's dental care\n",
                "benefit": "Up to CZK 500 to pay for a course for parents focused on caring for children's teeth, including on-line courses",
                "description": "We contribute up to CZK 500 to pay for a course for parents focused on caring for children's teeth, including on-line courses.\n The course must be given by a professional, i.e. a dentist, dental hygienist, nurse, etc. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "tooth",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/kurz-pro-rodice-pece-o-detske-zuby"
              },
              {
                "type": "Nutritional counselling for special diets",
                "benefit": "Up to CZK 2 000 for the creation of a special diet, for example due to a newly diagnosed food intolerance or allergy",
                "description": "We contribute up to CZK 2 000 to clients who need a special diet, for example due to a newly diagnosed food intolerance or allergy. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "weight",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/nutricni-poradenstvi-v-souvislosti-se-specifickou-dietou"
              },
              {
                "type": "Educational recuperative stays for clients with multiple sclerosis",
                "benefit": "Up to CZK 2 000 for clients with multiple sclerosis for educational recuperative stays",
                "description": "We contribute up to CZK 2 000 for clients with multiple sclerosis for educational recuperative stays organized in cooperation with professional associations, clinics, or foundations lasting at least 3 days (2 nights). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacne-rekondicni-pobyty-pro-klienty-s-roztrousenou"
              },
              {
                "type": "Educational stays for clients with Type I diabetes",
                "benefit": "Up to CZK 2 000 for clients with Type I diabetes for educational stays",
                "description": "We contribute up to CZK 2 000 for clients with Type I diabetes for educational stays lasting at least 3 days (2 nights) organized by patient organizations such as the Association and Friends of Diabetic Children and the Alliance of Patients with Diabetes CR. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "diabetes",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacni-pobyty-pro-klienty-s-diabetem-i-typu"
              },
              {
                "type": "Support for screening examinations",
                "benefit": "Up to CZK 500 for outpatient rehabilitation",
                "description": "We contribute up to CZK 500 towards outpatient rehabilitation. The contribution can be drawn after verification of completion of at least one screening examination from January 1, 2026. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "doctor",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/podpora-screeningovych-vysetreni"
              },
              {
                "type": "Psychotherapy",
                "benefit": "Up to CZK 4 000 for a psychotherapist",
                "description": "We contribute up to CZK 4 000 for up to 10 sessions (consultations) with a psychotherapist (up to CZK 400 per session). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/psychoterapie"
              },
              {
                "type": "Educational stays for clients with autistic spectrum disorders",
                "benefit": "Up to CZK 2 000 for clients diagnosed with an autistic spectrum disorder for educational stays",
                "description": "We contribute up to CZK 2 000 for clients diagnosed with an autistic spectrum disorder for educational stays lasting at least 3 days (2 nights) that are organized in cooperation with professional associations, clinics, or non-profit organizations. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacni-pobyty-pro-klienty-s-poruchou-autistickeho-spektra"
              },
              {
                "type": "Educational course for clients with obesity",
                "benefit": "Up to CZK 2 000 for an educational course or stay",
                "description": "We contribute up to CZK 2 000 to our clients for an educational course or stay of at least 3 days (2 nights) intended to improve their health – weight loss and maintenance of a healthy weight, and lifestyle changes. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "weight",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacni-kurz-pro-klienty-s-obezitou"
              },
              {
                "type": "Reconditioning stays for clients with rheumatoid arthritis",
                "benefit": "Up to CZK 2 000 for insured persons with rheumatoid arthritis for convalescent stays",
                "description": "We contribute up to CZK 2 000 to insured persons with rheumatoid arthritis for convalescent stays that are organized in cooperation with professional societies, clinical workplaces or foundations, lasting at least 3 days (2 nights). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/komplexni-onkologicke-vysetreni"
              },
              {
                "type": "Obesity treatment support\n",
                "benefit": "Up to CZK 2 000 for clients who successfully complete long-term treatment for obesity",
                "description": "We contribute up to CZK 2 000 to clients who successfully complete long-term obesity treatment with a contracted health care provider or nutritional therapist for further treatment or further weight reduction under the supervision of a health care professional. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "weight",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/podpora-lecby-obezity"
              },
              {
                "type": "Donor Program ",
                "benefit": "Up to CZK 10 000 for blood, bone marrow, and organ donors",
                "description": "We contribute up to CZK 10 000 for donors of blood or blood components, bone marrow, and organs. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/program-pro-darce-krve-nebo-jejich-soucasti-kostni-drene-a-organu"
              },
              {
                "type": "Program to Support Professions - Law Enforcement Personnel",
                "benefit": "Up to 1,000 CZK for insured individuals employed by law enforcement agencies",
                "description": "We provide a contribution of up to 1,000 CZK to insured individuals employed by the Fire and Rescue Service of the Czech Republic, the Police of the Czech Republic, the Prison Service of the Czech Republic, or the Customs Administration of the Czech Republic, to cover preventive medical examinations and other health-promoting activities. For more information, please visit the health insurance company’s website here: link.",
                "icon": "siren",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/program-na-podporu-profesi-zamestnanci-bezpecnostnich-sboru"
              },
              {
                "type": "Breast cancer prevention",
                "benefit": "Up to CZK 500 for breast cancer screening",
                "description": "We contribute up to CZK 500 for screening for timely detection of malignant breast cancer so that chances of recovery are as great as possible. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "ribbon",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/prevence-karcinomu-prsu"
              }
            ]
          },
          {
            "name": "Women",
            "benefitsCount": "43",
            "benefits": [
              {
                "type": "Examination during pregnancy",
                "benefit": "Up to CZK 3 000to female clients for an examination during pregnancy",
                "description": "We contribute up to CZK 3 000 to female clients who are pregnant in 2026 or who gave birth between January 1, 2026, and December 31, 2026 (up to 6 months after giving birth) for examinations that are not covered by public health insurance. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "pregnant",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/vysetreni-v-tehotenstvi"
              },
              {
                "type": "Vaccination",
                "benefit": "Up to CZK 2 000 for vaccination",
                "description": "We contribute up to CZK 2 000 for all vaccination not covered by public health insurance (or outside the age range where it is covered).\nMore information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/ockovani-pro-dospele"
              },
              {
                "type": "Sports and physical activities for adults\n",
                "benefit": "Up to CZK 500 for sports activities",
                "description": "We contribute up to CZK 500 to sports activities intended for adults. This includes long-term activities and sports that develop strength, coordination, flexibility, and core strength, helping to improve or maintain fitness.\nMore information (in Czech only) is available on the insurance company's website here: link.\" More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "sport",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/sportovni-pohybove-aktivity-pro-dospele"
              },
              {
                "type": "Genetic tests for women from 19 years of age using hormonal contraception\n",
                "benefit": "Až 500 Kč na preventivní vyšetření rizika tromboembolické nemoci ",
                "description": "We contribute up to CZK 500 for preventive screening for the risk of thromboembolic disease (TEN) when using hormonal contraception or hormone replacement therapy. This involves screening for thrombophilic mutations, Leiden mutation, and FII mutation. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "doctor",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/geneticke-vysetreni-pro-zeny-od-19-let"
              },
              {
                "type": "Prenatal course",
                "benefit": "Up to CZK 3 000 to female clients for a prenatal course",
                "description": "We contribute up to CZK 3 000 to female clients who are pregnant in 2026 or who gave birth between January 1, 2026, and December 31, 2026 (up to 6 months after giving birth) for prenatal course. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "pregnant",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/predporodni-kurz"
              },
              {
                "type": "Vitamins and food supplements during pregnancy and after childbirth",
                "benefit": "Up to CZK 1 000 to female clients for vitamins and food supplements",
                "description": "We contribute up to CZK 1 000 to female clients who are pregnant in 2026 or who gave birth between January 1, 2026, and December 31, 2026 (up to 6 months after giving birth) for vitamins and food supplements. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "pill",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/vitaminy-a-mineraly-pro-tehotne-nebo-zeny-po-porodu"
              },
              {
                "type": "Breastfeeding aids",
                "benefit": "Up to CZK 3 000 to female clients for breastfeeding aids",
                "description": "We contribute up to CZK 3 000 to female clients who are pregnant in 2026 or who gave birth between January 1, 2026, and December 31, 2026 (up to 6 months after giving birth) for breastfeeding aids. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "birth",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/pomucky-pro-kojeni"
              },
              {
                "type": "Lactation consultant services, analysis and purchase of breast milk",
                "benefit": "Up to CZK 3 000 to female clients for lactation consultant services, analysis, and purchase of breast milk",
                "description": "We contribute up to CZK 3 000 to insured women who are pregnant in 2026 or who gave birth between January 1, 2026, and December 31, 2026 (up to 6 months after giving birth) for the services of a lactation consultant, the purchase of breast milk, and breast milk analysis. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "doctor",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/sluzby-laktacni-poradkyne-analyza-a-nakup-materskeho-mleka"
              },
              {
                "type": "Preventive examination for athletes",
                "benefit": "Up to CZK 500 for athletes for preventive medical examinations",
                "description": "We contribute up to CZK 500 for a preventive examination required by sports clubs and associations. The examination is usually includes a basic internal examination, basic history, assessment of blood and urine tests, basic examination of the musculoskeletal apparatus, anthropometry or resting spirometry; body composition analysis using the bioimpedance method, resting and active ECG (on a treadmill or stationary bicycle). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "sport",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/sportovni-preventivni-prohlidka"
              },
              {
                "type": "Overweight and obesity prevention",
                "benefit": "Up to CZK 500 for an examination that includes body composition analysis, particularly using the bioelectric impedance method.",
                "description": "We contribute up to CZK 500 for and examination that includes body composition analysis, particularly using the bioelectrical impedance method. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "weight",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/prevence-nadvahy-a-obezity"
              },
              {
                "type": "Breast cancer prevention",
                "benefit": "Up to CZK 500 for breast cancer screening",
                "description": "We contribute up to CZK 500 for screening for timely detection of malignant breast cancer so that chances of recovery are as great as possible. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "ribbon",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/prevence-karcinomu-prsu"
              },
              {
                "type": "Prevention of colon and anal cancer",
                "benefit": "Up to CZK 500 for an examination for the timely detection of malignant cancer of the colon and anus",
                "description": "We contribute up to CZK 500 for screening for timely detection of malignant cancer of the colon and anus so that chances of recovery are as great as possible. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "rectum",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/prevence-karcinomu-tlusteho-streva-a-konecniku"
              },
              {
                "type": "Skin cancer prevention",
                "benefit": "Up to CZK 500 for an examination using a dermatoscope",
                "description": "We contribute up to CZK 500 for an examination using a dermatoscope, which is used for timely detection of malignant skin cancer.\nMore information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "skin",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/prevence-karcinomu-kuze"
              },
              {
                "type": "Medical devices\n",
                "benefit": "Up to CZK 500 beyond the scope of other preventive programmes for the purchase of medical devices",
                "description": "We contribute up to CZK 500 for the purchase of medical devices related to a chronic illness that are not covered by public health insurance. For example diabetes, respiratory diseases (Asthma), Chronic gastrointestinal diseases, Chronic urinary system diseases and others. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "birth",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/zdravotnicke-prostredky"
              },
              {
                "type": "Support for specific diets",
                "benefit": "Up to CZK 2 000 for the purchases of special foods and meals suitable for allergies or intolerances",
                "description": "We contribute up to CZK 2 000 for adults with food intolerance beyond the scope of other preventive programmes for the purchase of special foods and meals suitable for allergies or intolerance. For example: in the case of coeliac disease, phenylketonuria, etc. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/specificke-diety"
              },
              {
                "type": "Dietary recommendations by a nutritional therapist ",
                "benefit": "Up to CZK 500 for the services of a nutritional therapist ",
                "description": "We contribute up to CZK 500 for the services of a nutritional therapist, who will make dietary recommendations to achieve and maintain healthy weight. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "weight",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/sestaveni-jidelnicku-nutricnim-terapeutem"
              },
              {
                "type": "Dental hygiene for adults",
                "benefit": "Up to CZK 500 for dental hygiene",
                "description": "We contribute up to CZK 500 for training in proper dental cleaning as part of an unpaid dental hygiene service by a dental hygienist. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "brush",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/dentalni-hygiena-pro-dospele"
              },
              {
                "type": "Exercises for pregnant women and women after childbirth\n",
                "benefit": "Up to CZK 3 000 to female clients for exercise classes for pregnant women and women after childbirth",
                "description": "We contribute up to CZK 3 000 to female clients who are pregnant in 2026 or who give birth between January 1, 2026, and December 31, 2026 (up to 6 months after giving birth) for postnatal exercise classes. We also accept online courses. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/cviceni-pro-tehotne-a-zeny-po-porodu"
              },
              {
                "type": "Comprehensive oncology examination",
                "benefit": "Up to CZK 2 000 for preventive oncological examinations ",
                "description": "We contribute up to CZK 2 000 for preventive oncological examinations within the offer of the Comprehensive Cancer Centres. \nMore information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "ribbon",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/komplexni-onkologicke-vysetreni"
              },
              {
                "type": "Telemonitoring\n",
                "benefit": "Up to CZK 2 000 for clients participating in telemonitoring programmes",
                "description": "We contribute up to CZK 2 000 beyond the scope of other preventive programmes to clients participating in telemonitoring programmes. For example telemonitoring for clients with chronic heart failure, telemonitoring for clients with suspected heart rhythm disturbances or being treated for heart arrhythmia, and others. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "register",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/telemonitoring"
              },
              {
                "type": "Clinical psychology - Adults",
                "benefit": "Up to CZK 4 000 for examinations in the field of clinical speech therapy",
                "description": "We contribute up to CZK 4 000 for up to 10 examinations (i.e. up to CZK 400 per examination) in the field of clinical speech therapy. (in Czech only) is available on the insurance company's website here: link.",
                "icon": "doctor",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/klinicka-psychologie-dospeli"
              },
              {
                "type": "Clinical speech therapy - Adults",
                "benefit": "Up to CZK 4 000 for various examinations in the field of clinical speech therapy",
                "description": "We contribute up to CZK 4 000 for various examinations in the field of clinical speech therapy More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "doctor",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/klinicka-logopedie-dospeli"
              },
              {
                "type": "Cervical cancer prevention",
                "benefit": "Up to CZK 500 for a preventive uncovered examination for timely detection of (ideally) pre-cancerous conditions",
                "description": "We contribute up to CZK 500 for a preventive uncovered examination for timely detection of (ideally) pre-cancerous conditions. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "ribbon",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/prevence-karcinomu-delozniho-hrdla"
              },
              {
                "type": "Massage during pregnancy",
                "benefit": "Up to CZK 3 000 to female clients for massage during pregnancy",
                "description": "We contribute up to CZK 3 000 to female clients who are pregnant in 2026 or who give birth between January 1, 2026, and December 31, 2026 (up to 6 months after giving birth) for a massage for pregnant women.\nMore information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "pregnant",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/masaz-pro-tehotne"
              },
              {
                "type": "Support for multiples",
                "benefit": "Up to CZK 500 extra for each newborn from a multiple pregnancy for various aids",
                "description": "We contribute up to CZK 500 extra for each newborn from a multiple pregnancy born between January 1 and December 31, 2026, once a year for breastfeeding aids, the purchase of breast milk, or the purchase of a breathing monitor.\nMore information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "birth",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/podpora-vicercat"
              },
              {
                "type": "Dental hygiene for pregnant women\n",
                "benefit": "Up to CZK 3 000 to female clients for dental hygiene",
                "description": "We contribute up to CZK 3 000 to female clientswho are pregnant in 2026 or who give birth between January 1, 2026, and December 31, 2026 (up to 6 months after giving birth) for dental hygiene, including training (instruction) in proper tooth cleaning as part of a non-covered service. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "tooth",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/dentalni-hygiena-pro-tehotne"
              },
              {
                "type": "Wigs, bras, and other items for cancer patients",
                "benefit": "Up to CZK 2 000 for the purchase of a wig or headscarf, medicinal products containing panthenol for the treatment of burns after radiation therapy (radiotherapy), etc.",
                "description": "We contribute up to CZK 2 000 beyond the scope of other preventive programmes for patients who are undergoing or have undergone anti-cancer treatment (chemotherapy), toward the purchase of a wig or a kerchief. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/paruky-podprsenky-a-dalsi-prostredky-pro-onkologicke-pacienty"
              },
              {
                "type": "Educational stays for clients with Type II diabetes",
                "benefit": "Up to CZK 2 000 for clients with Type II diabetes for educational stays",
                "description": "We contribute up to CZK 2 000 for clients with Type II diabetes for educational stays organized by patient organizations such as the Alliance of Patients with Diabetes CR. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "diabetes",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacni-pobyty-pro-klienty-s-diabetem-ii-typu"
              },
              {
                "type": "Cognitive function testing and memory training aids\n\n",
                "benefit": "Up to CZK 500 for examinations whose primary purpose is timely diagnosis of memory impairment due to Alzheimer's disease or other forms of dementia",
                "description": "We contribute up to CZK 500 for examinations whose primary purpose is timely diagnosis of memory impairment due to Alzheimer's disease or other forms of dementia. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "doctor",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/vysetreni-kognitivnich-funkci-a-pomucky-pro-trenovani-pameti"
              },
              {
                "type": "Traffic psychological examination",
                "benefit": "Up to CZK 500 for an examination by a traffic psychologist",
                "description": "We contribute up to CZK 500 for an examination by a traffic psychologist.\nA traffic psychology examination is mandatory for some groups of driver's licences, or can be requested by a GP. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "doctor",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/dopravne-psychologicke-vysetreni"
              },
              {
                "type": "Course for parents – children's dental care\n",
                "benefit": "Up to CZK 500 to pay for a course for parents focused on caring for children's teeth, including on-line courses",
                "description": "We contribute up to CZK 500 to pay for a course for parents focused on caring for children's teeth, including on-line courses.\n The course must be given by a professional, i.e. a dentist, dental hygienist, nurse, etc. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "tooth",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/kurz-pro-rodice-pece-o-detske-zuby"
              },
              {
                "type": "Nutritional counselling for special diets",
                "benefit": "Up to CZK 2 000 for the creation of a special diet, for example due to a newly diagnosed food intolerance or allergy",
                "description": "We contribute up to CZK 2 000 to clients who need a special diet, for example due to a newly diagnosed food intolerance or allergy. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "weight",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/nutricni-poradenstvi-v-souvislosti-se-specifickou-dietou"
              },
              {
                "type": "Educational recuperative stays for clients with multiple sclerosis",
                "benefit": "Up to CZK 2 000 for clients with multiple sclerosis for educational recuperative stays",
                "description": "We contribute up to CZK 2 000 for clients with multiple sclerosis for educational recuperative stays organized in cooperation with professional associations, clinics, or foundations lasting at least 3 days (2 nights). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacne-rekondicni-pobyty-pro-klienty-s-roztrousenou"
              },
              {
                "type": "Educational stays for clients with Type I diabetes",
                "benefit": "Up to CZK 2000 for clients with Type I diabetes for educational stays",
                "description": "We contribute up to CZK 2 000 for clients with Type I diabetes for educational stays lasting at least 3 days (2 nights) organized by patient organizations such as the Association and Friends of Diabetic Children and the Alliance of Patients with Diabetes CR. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "diabetes",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacni-pobyty-pro-klienty-s-diabetem-i-typu"
              },
              {
                "type": "Support for screening examinations",
                "benefit": "Up to CZK 500 for outpatient rehabilitation",
                "description": "We contribute up to CZK 500 towards outpatient rehabilitation. The contribution can be drawn after verification of completion of at least one screening examination from January 1, 2026. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "doctor",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/podpora-screeningovych-vysetreni"
              },
              {
                "type": "Psychotherapy",
                "benefit": "Up to CZK 4 000 for a psychotherapist",
                "description": "We contribute up to CZK 4 000 for up to 10 sessions (consultations) with a psychotherapist (up to CZK 400 per session). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/psychoterapie"
              },
              {
                "type": "Educational stays for clients with autistic spectrum disorders",
                "benefit": "Up to CZK 2 000 for clients diagnosed with an autistic spectrum disorder for educational stays",
                "description": "Up to CZK 2 000 for clients diagnosed with an autistic spectrum disorder for educational stays lasting at least 3 days (2 nights) that are organized in cooperation with professional associations, clinics, or non-profit organizations. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacni-pobyty-pro-klienty-s-poruchou-autistickeho-spektra"
              },
              {
                "type": "Educational course for clients with obesity",
                "benefit": "Up to CZK 2 000 for an educational course or stay",
                "description": "We contribute up to CZK 2 000 to our clients for an educational course or stay of at least 3 days (2 nights) intended to improve their health – weight loss and maintenance of a healthy weight, and lifestyle changes. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "weight",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacni-kurz-pro-klienty-s-obezitou"
              },
              {
                "type": "Reconditioning stays for clients with rheumatoid arthritis",
                "benefit": "Up to CZK 2 000 for insured persons with rheumatoid arthritis for convalescent stays",
                "description": "We contribute up to CZK 2 000 to insured persons with rheumatoid arthritis for convalescent stays that are organized in cooperation with professional societies, clinical workplaces or foundations, lasting at least 3 days (2 nights). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/rekondicni-pobyty-pro-klienty-s-revmatoidni-artritidou"
              },
              {
                "type": "Interpretation of mammogram images using artificial intelligence\n",
                "benefit": "Up to CZK 100 for the interpretation of mammogram results using artificial intelligence",
                "description": "We contribute up to CZK 100 for the interpretation of mammogram results using artificial intelligence for our clients aged 40 to 45.\nThis involves the use of artificial intelligence (AI) for additional interpretation of mammogram results.  More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "register",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/treti-cteni-mamografickeho-snimku-umelou-inteligenci"
              },
              {
                "type": "Obesity treatment support\n",
                "benefit": "Up to CZK 2 000 for clients who successfully complete long-term treatment for obesity",
                "description": "We contribute up to CZK 2 000 to clients who successfully complete long-term obesity treatment with a contracted health care provider or nutritional therapist for further treatment or further weight reduction under the supervision of a health care professional. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/podpora-lecby-obezity"
              },
              {
                "type": "Birth support",
                "benefit": "Up to CZK 3 000 to insured women for birth support services.",
                "description": "We contribute up to CZK 3 000 to insured women who are pregnant in 2026 or who give birth between January 1, 2026, and December 31, 2026 (up to 6 months after giving birth) for the service of accompanying them during childbirth. This is a non-covered service provided by a birth assistant chosen by the insured woman. The birth assistant must be a registered practitioner. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "pregnant",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/doprovod-k-porodu"
              },
              {
                "type": "Donor Program ",
                "benefit": "Up to CZK 10 000 for blood, bone marrow, and organ donors",
                "description": "We contribute up to CZK 10 000 for donors of blood or blood components, bone marrow, and organs. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/program-pro-darce-krve-nebo-jejich-soucasti-kostni-drene-a-organu"
              }
            ]
          },
          {
            "name": "Children",
            "benefitsCount": "33",
            "benefits": [
              {
                "type": "Vaccination for children",
                "benefit": "Up to CZK 2 000 for vaccination for children",
                "description": "We contribute up to CZK 2 000 for children for all vaccination not covered by public health insurance (or outside the age range where it is covered).\nMore information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/ockovani-pro-deti"
              },
              {
                "type": "Massage for newborns and infants up to 1 year old, first aid course for children",
                "benefit": "Up to  CZK 1 500 for a massage for newborns and infants or a first aid course for children ",
                "description": "We contribute up to CZK 1 500 for massages for newborns and infants. It helps relieve tummy ache and contributes to overall calmness and better sleep. The payment receipt must state that it is for a massage for newborns or infants. We also contribute to a first aid course for children organized by a healthcare professional (including online courses). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/masaz-pro-novorozence-a-kojence-do-1-roku-kurz-prvni-pomoci"
              },
              {
                "type": "Care products for newborns and infants up to 1 year old\n",
                "benefit": "Up to CZK 1 500 for newborns and infants",
                "description": "We contribute up to CZK 1 500 for the purchase of products for safety, monitoring healthy development, and to ensure a safe environment for newborns and infants Especially for the following items: Thermometer, mucus extractor, nursing pillow, baby monitor, scales, breath monitor, etc.\nMore information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "birth",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/pomucky-pro-novorozence-a-kojence-do-1-roku"
              },
              {
                "type": "Sports activities for children",
                "benefit": "Up to CZK 1 000 for physical activities for children",
                "description": "We contribute up to CZK 1 000 per year to children aged two and older for organized sports and physical activities designed for children. In particular, the following activities: Organized exercise for children, Sports clubs and courses, Exercise for children with parents, and others. \nMore information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "move",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/sportovni-pohybove-aktivity-pro-deti"
              },
              {
                "type": "Health or sports retreat for children\n",
                "benefit": "Up to CZK 500 for Health or sports retreat for children",
                "description": "We contribute up to CZK 500 per child for recreational activities. These include school and kindergarten trips (stays involving active outdoor activities organized by schools or kindergartens), sports camps, and ski lessons. The stay must last at least four days. We do not accept: sightseeing, knowledge, educational, artistic, hobby, language stays, etc. - without a focus on physical activity. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "tent",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/ozdravny-nebo-sportovni-pobyt-pro-deti"
              },
              {
                "type": "Amblyopia screening examination \n",
                "benefit": "Up to CZK 1 500 for children from 6 months to 10 years of age for an examination used for the timely detection of amblyopia",
                "description": "We contribute up to CZK 1 500 for children from 6 months to 10 years of age for an examination used for the timely detection of amblyopia, with a PlusOptix device by a medical services provider. \nMore information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "doctor",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/screeningove-vysetreni-tupozrakosti"
              },
              {
                "type": "Fixed or removable dental braces",
                "benefit": "Up to CZK 1 500 for dental braces",
                "description": "We contribute up to CZK 1 500 to children under 18 years of age for fixed and removable dental braces. The contribution can be drawn once every two years. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "braces",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/fixni-nebo-snimatelna-rovnatka-zubu"
              },
              {
                "type": "Preventive examination for child athletes",
                "benefit": "Up to CZK 1 500 for child athletes for a preventive examination",
                "description": "We contribute up to CZK 1500 for child athletes for a preventive examination required by sports clubs and associations. The examination is usually includes a basic internal examination, basic history, assessment of blood and urine tests, basic examination of the musculoskeletal apparatus, anthropometry or resting spirometry; body composition analysis using the bioimpedance method, resting and active ECG (on a treadmill or stationary bicycle). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "sport",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/sportovni-preventivni-prohlidka-pro-deti"
              },
              {
                "type": "Prevention of overweight and obesity among children\n",
                "benefit": "Up to CZK 1 500 for an examination that includes body composition analysis, primarily using the bioelectric impedance method",
                "description": "We contribute up to CZK 1 500 for an examination that includes body composition analysis, primarily using the bioelectric impedance method. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "weight",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/prevence-nadvahy-a-obezity-u-deti"
              },
              {
                "type": "Medical devices\n",
                "benefit": "Up to CZK 1 500 the purchase of medical devices",
                "description": "We contribute up to CZK 1 500 for the purchase of medical devices related to a chronic illness that are not covered by public health insurance. For example diabetes, respiratory diseases (asthma), and others. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "birth",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/zdravotnicke-prostredky"
              },
              {
                "type": "Support for specific diets",
                "benefit": "Up to CZK 2 000 toward the purchase of special foods and meals suitable for allergies or intolerance",
                "description": "We contribute up to CZK 2 000 for children with food intolerance beyond the scope of other preventive programmes for the purchase of special foods and meals suitable for allergies or intolerance. For example: in the case of coeliac disease, phenylketonuria, etc. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/specificke-diety"
              },
              {
                "type": "Organized exercise or swimming with infants up to age 1",
                "benefit": "Up to CZK 1 500 for physical activities for even the smallest children",
                "description": "We contribute up to CZK 1500 for physical activities for even the smallest children: organized swimming with infants, including bath conditioning, organized exercise with infants. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "sport",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/organizovane-cviceni-nebo-plavani-s-kojencem-do-1-roku"
              },
              {
                "type": "Genetic testing when using hormonal contraception for girls aged 12 and older\n",
                "benefit": "Up to CZK 1 500 for a preventive genetic analysis of the risk of venous thromoboembolism (VET)",
                "description": "We contribute up to CZK 1500 for a preventive genetic analysis to determine the risk of venous thromoboembolism (VET) in case of use of hormonal contraceptives by girls aged 12 and up. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "doctor",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/geneticke-vysetreni-pro-divky-od-12-let"
              },
              {
                "type": "Dietary recommendations by a nutritional therapist for children",
                "benefit": "Up to CZK 1 500 for the services of a nutritional therapist ",
                "description": "We contribute up to CZK 1 500 for the services of a nutritional therapist, who will make dietary recommendations to achieve and maintain healthy weight. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "weight",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/sestaveni-jidelnicku-nutricnim-terapeutem-pro-deti"
              },
              {
                "type": "Children's sports summer",
                "benefit": "Up to CZK 500 for summer stays involving sports",
                "description": "We contribute up to CZK 500 to children aged 6 to 15 for a summer sports and exercise camp held in July and August 2026, lasting at least 4 consecutive days (overnight stay is not a requirement). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "sport",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/detske-sportovni-leto-0"
              },
              {
                "type": "Clinical psychology - children",
                "benefit": "Up to CZK 4 000 for examinations in the field of clinical psychology that aren't covered by public health insurance",
                "description": "We contribute up to CZK 4 000 for up to 10 examinations (i.e. up to CZK 400 per examination) in the field of clinical psychology that are not covered by public health insurance and whose purpose is primarily to diagnose, for example, autism spectrum disorders (ASD), or behavioral or learning disorders that may result in problems with education or social integration. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "doctor",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/klinicka-psychologie-deti"
              },
              {
                "type": "Clinical speech therapy - children",
                "benefit": "Up to CZK 4 000 for examinations in the field of clinical speech therapy",
                "description": "We contribute up to CZK 4 000 for up to 10 examinations (i.e. up to CZK 400 per examination) in the field of clinical speech therapy. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "doctor",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/klinicka-logopedie-deti"
              },
              {
                "type": "Special nutrition for premature babies",
                "benefit": "Up to CZK 2 000 toward the purchase of formula for premature infants up to the age of one year with a birth weight of up to 1500 g.",
                "description": "We contribute up to CZK 2 000 toward the purchase of formula for premature infants up to the age of one year with a birth weight of up to 1500 g. The formula must be purchased in a pharmacy or on-line pharmacy. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "weight",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/specialni-vyziva-pro-nedonosene-deti"
              },
              {
                "type": "Wigs, bras, and other items for cancer patients\n\n",
                "benefit": "Up to CZK 2 000 for the purchase of a wig or headscarf, medicinal products containing panthenol for the treatment of burns after radiation therapy (radiotherapy), etc.",
                "description": "We contribute up to CZK 2 000 beyond the scope of other preventive programmes for patients who are undergoing or have undergone anti-cancer treatment (chemotherapy), toward the purchase of a wig or a kerchief. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/paruky-podprsenky-a-dalsi-prostredky-pro-onkologicke-pacienty"
              },
              {
                "type": "Educational stays for clients with Type II diabetes",
                "benefit": "Up to CZK 2 000 for clients with Type II diabetes for educational stays",
                "description": "We contribute up to CZK 2 000 for clients with Type II diabetes for educational stays organized by patient organizations such as the Alliance of Patients with Diabetes CR. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "suitcase",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacni-pobyty-pro-klienty-s-diabetem-ii-typu"
              },
              {
                "type": "Nutritional counselling for special diets",
                "benefit": "Up to CZK 2 000 for the creation of a special diet, for example due to a newly diagnosed food intolerance or allergy",
                "description": "We contribute up to CZK 2 000 to clients who need a special diet, for example due to a newly diagnosed food intolerance or allergy. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "nutrition",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/nutricni-poradenstvi-v-souvislosti-se-specifickou-dietou"
              },
              {
                "type": "Educational recuperative stays for clients with multiple sclerosis",
                "benefit": "Up to CZK 2 000 for clients with multiple sclerosis for educational recuperative stays",
                "description": "We contribute up to CZK 2 000 for clients with multiple sclerosis for educational recuperative stays organized in cooperation with professional associations, clinics, or foundations lasting at least 3 days (2 nights). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacne-rekondicni-pobyty-pro-klienty-s-roztrousenou"
              },
              {
                "type": "Educational stays for clients with Type I diabetes",
                "benefit": "Up to CZK 2 000 for clients with Type I diabetes for educational stays",
                "description": "We contribute up to CZK 2 000 for clients with Type I diabetes for educational stays lasting at least 3 days (2 nights) organized by patient organizations such as the Association and Friends of Diabetic Children and the Alliance of Patients with Diabetes CR. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "diabetes",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacni-pobyty-pro-klienty-s-diabetem-i-typu"
              },
              {
                "type": "Psychotherapy",
                "benefit": "Up to CZK 4 000 for a psychotherapist",
                "description": "We contribute up to CZK 4 000 for up to 10 sessions (consultations) with a psychotherapist (up to CZK 400 per session). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/psychoterapie"
              },
              {
                "type": "Educational stays for clients with autistic spectrum disorders",
                "benefit": "Up to CZK 2 000 for clients diagnosed with an autistic spectrum disorder for educational stays",
                "description": "Up to CZK 2 000 for clients diagnosed with an autistic spectrum disorder for educational stays lasting at least 3 days (2 nights) that are organized in cooperation with professional associations, clinics, or non-profit organizations. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacni-pobyty-pro-klienty-s-poruchou-autistickeho-spektra"
              },
              {
                "type": "Educational course for clients with obesity",
                "benefit": "Up to CZK 2 000 for an educational course or stay",
                "description": "We contribute up to CZK 2 000 to our insured for an educational course or stay lasting at least 3 days (2 nights), which is designed to improve health - losing weight and maintaining a healthy weight and changing lifestyle. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "weight",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacni-kurz-pro-klienty-s-obezitou"
              },
              {
                "type": "Prevention of obesity-related complications",
                "benefit": "Up to CZK 4 000 for children aged 12 and over who successfully complete long-term treatment for obesity",
                "description": "We contribute up to CZK 4 000 to children aged 12 and over who successfully complete long-term obesity treatment with a contracted health care provider or nutritional therapist for further treatment or further weight reduction under the supervision of a health care professional. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "weight",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/prevence-komplikaci-spojenych-s-obezitou"
              },
              {
                "type": "Reconditioning stays for clients with rheumatoid arthritis",
                "benefit": "Up to CZK 2 000 for insured persons with rheumatoid arthritis for convalescent stays",
                "description": "We contribute up to CZK 2 000 to insured persons with rheumatoid arthritis for convalescent stays that are organized in cooperation with professional societies, clinical workplaces or foundations, lasting at least 3 days (2 nights). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "briefcase",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/rekondicni-pobyty-pro-klienty-s-revmatoidni-artritidou"
              },
              {
                "type": "Dental hygiene for children\n",
                "benefit": "Up to CZK 1 500 for dental hygiene",
                "description": "We contribute up to CZK 1 500 per child for dental hygiene, including training (instruction) in proper tooth brushing as part of a non-covered service. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "brush",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/dentalni-hygiena-pro-deti"
              },
              {
                "type": "Skin cancer prevention",
                "benefit": "Up to CZK 1 500 for an examination using a dermatoscope",
                "description": "We contribute up to CZK 1 500 for children for an examination using a dermatoscope, which is used for timely detection of malignant skin cancer The payment receipt must specify a dermatoscope examination.\n More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "skin",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/prevence-karcinomu-kuze-pro-deti"
              },
              {
                "type": "Prevention of cervical cancer for girls aged 15 and older\n",
                "benefit": "Up to CZK 1 500 for a preventive uncovered examination for timely detection of (ideally) pre-cancerous conditions",
                "description": "We contribute up to CZK 1 500 for a preventive uncovered examination for timely detection of (ideally) pre-cancerous conditions. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "ribbon",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/prevence-karcinomu-delozniho-hrdla-od-15-let"
              },
              {
                "type": "Speech therapy aids",
                "benefit": "Up to CZK 2 000 for speech therapy aids prescribed by a clinical speech therapist",
                "description": "We contribute up to CZK 2 000 towards speech therapy aids prescribed by a clinical speech therapist. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "chat",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/logopedicke-pomucky"
              },
              {
                "type": "Telemedicine",
                "benefit": "Up to CZK 2000 for clients participating in telemonitoring programmes",
                "description": "We contribute up to CZK 2 000 beyond the scope of other preventive programmes to clients participating in telemonitoring programmes. For example telemonitoring for clients with chronic heart failure, telemonitoring for clients with suspected heart rhythm disturbances or being treated for heart arrhythmia, and others. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "register",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/program-telemedicina"
              }
            ]
          }
        ]
      },
      {
        "slug": "cpzp",
        "updateDate": "28.1.2026",
        "companyBenefitsLink": "https://www.cpzp.cz/preventivni-programy",
        "gendersCount": "3",
        "genders": [
          {
            "name": "Men",
            "benefitsCount": "27",
            "benefits": [
              {
                "type": "Vaccination",
                "benefit": "Up to CZK 1 000 for various types of vaccination",
                "description": "We contribute up to CZK 1 000 this can be used for all infectious disease vaccinations not covered by public health insurance. The contribution can be used for any dose/vaccine in a vaccination cycle. The contribution does not apply to vaccine surcharges. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.cpzp.cz/preventivni-program/14"
              },
              {
                "type": "Regular movement",
                "benefit": "Up to CZK 700 for physical activities for ages 18 and up",
                "description": "We contribute up to CZK 700 to regular physical activity as part of the prevention of cardiovascular disease and obesity for our insured clients aged 18 and over. Options for use: Regular physical activity, including swimming (does not apply to skiing, massages, saunas, solariums, and other regenerative activities). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "move",
                "url": "https://www.cpzp.cz/preventivni-program/36"
              },
              {
                "type": "Sports check-up",
                "benefit": "Up to CZK 500 for a sports check-up",
                "description": "We contribute up to CZK 500 towards the cost of a sports medical examination carried out by a healthcare provider. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "sport",
                "url": "https://www.cpzp.cz/preventivni-program/22"
              },
              {
                "type": "Optic nerve examination",
                "benefit": "Up to CZK 300 for an optical nerve examination",
                "description": "We contribute up to CZK 300 for optical nerve examination, on the following: GDx – nerve fibre analyzer, HRT – Heidelberg Retina Tomography, OCT – Optical Coherent Tomography. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "eye",
                "url": "https://www.cpzp.cz/preventivni-program/18"
              },
              {
                "type": "Skin cancer prevention",
                "benefit": "Up to CZK 500 for diagnosis of pigment spots.",
                "description": "We contribute up to CZK 500 for diagnosis of pigment spots. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "skin",
                "url": "https://www.cpzp.cz/preventivni-program/17"
              },
              {
                "type": "Health 65+\n",
                "benefit": "Up to CZK 500 for clients aged 65 and up for the purchase of food supplements and vitamins at a pharmacy",
                "description": "We contribute up to CZK 500 to insured persons aged 65 and over for the purchase of food supplements and vitamins at a pharmacy. The contribution can be used in particular to support immunity, prevent joint deterioration, and improve memory. We only accept purchases made at a pharmacy (or pharmacy e-shop). The contribution can only be used for products that are taken orally (i.e., it cannot be used for vitamins in the form of injections, for example). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "pill",
                "url": "https://www.cpzp.cz/preventivni-program/33"
              },
              {
                "type": "Laser eye surgery",
                "benefit": "Up to CZK 1 000 for laser eye surgery",
                "description": "We contribute up to CZK 1 000 for laser eye surgery - elimination of far-sightedness and near-sightedness, and for laser cataract surgery. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "eye",
                "url": "https://www.cpzp.cz/preventivni-program/21"
              },
              {
                "type": "High blood pressure",
                "benefit": "A contribution of up to CZK 500 for the purchase of a forearm blood pressure monitor.",
                "description": "We contribute up to CZK 500 to our clients for the purchase of a forearm blood pressure monitor. The contribution is intended for chronically ill patients diagnosed with hypertension. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "move",
                "url": "https://www.cpzp.cz/preventivni-program/54"
              },
              {
                "type": "Cholesterol",
                "benefit": "Up to CZK 200 for the purchase of food supplements containing Omega 3 fatty acids.",
                "description": "We contribute up to CZK 200 to our chronically ill clients with a \"hyperlipidemia\" diagnosis a for the purchase of food supplements containing Omega 3 fatty acids. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "pill",
                "url": "https://www.cpzp.cz/preventivni-program/55"
              },
              {
                "type": "Colon cancer prevention",
                "benefit": "Up to CZK 500 for colon cancer prevention",
                "description": "We contribute up to CZK 500 towards colon cancer prevention – examinations provided by healthcare providers. The contribution applies to all methods not covered by public health insurance (e.g. Septin9). The contribution is not intended for home tests purchased at pharmacies or for hydrocolon therapy. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "rectum",
                "url": "https://www.cpzp.cz/preventivni-program/24"
              },
              {
                "type": "Erectile dysfunction",
                "benefit": "Up to CZK 500 for medications with the following active ingredient: Avanafil, Sildenafil, Tadalafil, Vardenafil.",
                "description": "We contribute up to CZK 500 towards prescription drugs containing the following active ingredients: Avanafil, Sildenafil, Tadalafil, Vardenafil. The drugs must be purchased at a pharmacy. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "pill",
                "url": "https://www.cpzp.cz/preventivni-program/51"
              },
              {
                "type": "Prostate cancer prevention",
                "benefit": "Up to CZK 500 for a PSA test for men 40 and over for prostate cancer prevention",
                "description": "We contribute up to CZK 500 to men aged 40 and over for prostate cancer prevention, specifically for PSA testing, in cases where it is not covered by public health insurance. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "testicles",
                "url": "https://www.cpzp.cz/preventivni-program/52"
              },
              {
                "type": "Shock wave",
                "benefit": "Up to CZK 500 for shock wave therapy",
                "description": "We contribute up to 500 for shock wave therapy performed by a medical services provider. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.cpzp.cz/preventivni-program/69"
              },
              {
                "type": "Obesity prevention",
                "benefit": "Up to CZK 500 for obesity prevention",
                "description": "We contribute up to CZK 500 for prevention of obesity. This contribution may be used to pay an obesitologist, dietologist, general practitioner or a nutritional therapist for purposes of reducing excess weight and obesity. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "weight",
                "url": "https://www.cpzp.cz/preventivni-program/71"
              },
              {
                "type": "Dental hygiene",
                "benefit": "Up to CZK 500 for dental hygiene",
                "description": "We contribute up to CZK 500 for dental hygiene performed by a dentist or healthcare professional with professional qualifications to perform dental hygiene. The contribution is provided until the financial limit is exceeded. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "brush",
                "url": "https://www.cpzp.cz/preventivni-program/80"
              },
              {
                "type": "Lightweight cast\n",
                "benefit": "Up to CZK 1 000 to cover the cost of lightweight and light casts",
                "description": "We contribute up to CZK 1 000 for the purchase of lightweight or light casts made of plastic, resin, and carbon fiber (e.g., Opencast) from a healthcare provider or purchased at a medical supply store. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "osteoporosis",
                "url": "https://www.cpzp.cz/preventivni-program/81"
              },
              {
                "type": "Orthopedic insoles\n",
                "benefit": "Up to CZK 500 for the purchase of orthopedic insoles",
                "description": "We contribute up to CZK 500 to our clients with orthopedic foot defects for the purchase of orthopedic insoles at a pharmacy, medical supply store, specialty store, or from the manufacturer. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.cpzp.cz/preventivni-program/82"
              },
              {
                "type": "Steps for health",
                "benefit": "Up to CZK 1 000 for steps taken in the \"Zdraví v mobilu\" [Mobile Health] app",
                "description": "We contribute up to CZK 1,000 for steps walked in the Zdraví v mobilu (Health on Your Mobile) app. The contribution motivates ČPZP policyholders to engage in regular physical activity – walking. The program is based on the use of a pedometer in the \"Zdraví v mobilu\" app. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.cpzp.cz/preventivni-program/68"
              },
              {
                "type": "Diabetes",
                "benefit": "Up to CZK 1 000 to prevent deterioration of diabetes",
                "description": "We contribute up to CZK 1 000 for the prevention of diabetes complications. The contribution is intended for one of the selected services or aids, such as: needles for insulin pens, test and diagnostic strips, insulin pump accessories, etc. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "diabetes",
                "url": "https://www.cpzp.cz/preventivni-program/32"
              },
              {
                "type": "Celiac disease, hereditary metabolic disorders\n",
                "benefit": "A contribution of up to CZK 1 000 to those with coeliac disease for a gluten-free diet and a contribution for a low-protein diet for clients with hereditary metabolic disorders.",
                "description": "We contribute up to CZK 1 000 to clients with coeliac disease for a gluten-free diet and a contribution for a low-protein diet for clients with hereditary metabolic disorders. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "diabetes",
                "url": "https://www.cpzp.cz/preventivni-program/70"
              },
              {
                "type": "Smoking cessation",
                "benefit": "Up to CZK 2 000 for smoking cessation.",
                "description": "We contribute up to CZK 2 000 to insured persons for smoking cessation.The contribution is intended for: the purchase of over-the-counter medicines and support products purchased at a pharmacy and medicines for smoking cessation. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "smoke",
                "url": "https://www.cpzp.cz/preventivni-program/35"
              },
              {
                "type": "Wig contribution",
                "benefit": "Up to CZK 2 000 for a wig",
                "description": "We contribute up to CZK 2 000 towards the purchase of wigs for cancer patients who are undergoing or have undergone chemotherapy treatment for cancer, and for insured persons diagnosed with alopecia. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.cpzp.cz/preventivni-program/59"
              },
              {
                "type": "Cancer prevention program\n",
                "benefit": "Up to CZK 2 000 for comprehensive preventive cancer screening",
                "description": "We contribute up to CZK 2 000 to our clients aged 35 and over for comprehensive oncological preventive examinations performed at specialized facilities where it is possible to undergo preventive oncological examinations. The examination includes laboratory and other tests necessary to detect possible cancer. The scope and price of the examination are determined by the individual facilities. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "ribbon",
                "url": "https://www.cpzp.cz/preventivni-program/57"
              },
              {
                "type": "Bonus Plus",
                "benefit": "Up to CZK 500 in an additional preventive program for selected activities",
                "description": "We contribute up to CZK 500 per year in the \"Bonus Plus\" additional programme for selected activities, such as healthcare services provided in healthcare facilities, oral hygiene products, eyeglass frames, sunscreen, sports protective equipment and more. The purpose of the program is to motivate ČPZP policyholders to protect and take maximum care of their health and to reward them for their loyalty to ČPZP. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "shield",
                "url": "https://www.cpzp.cz/preventivni-program/29"
              },
              {
                "type": "Contribution for mental health",
                "benefit": "Up to CZK 6 000 for mental health",
                "description": "We contribute up to CZK 6 000 to our clients for a program aimed at increasing the availability of psychosocial support. The contribution is intended for insured persons undergoing psychosocial intervention with a selected specialist – a private therapist with the appropriate qualifications. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.cpzp.cz/preventivni-program/73"
              },
              {
                "type": "BabyGen",
                "benefit": "Up to CZK 4 000 for genetic testing before planned pregnancy/parenthood",
                "description": "We contribute up to CZK 4 000 towards genetic testing prior to planned pregnancy/parenthood. This involves genetic analysis of serious hereditary diseases, which leads to the detection and minimization of the risks of giving birth to a child with these diseases. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "doctor",
                "url": "https://www.cpzp.cz/preventivni-program/77"
              },
              {
                "type": "Donor Program ",
                "benefit": "Up to CZK 6 000 for blood and bone marrow donors",
                "description": "We contribute up to CZK 6 000 for blood and bone marrow donors. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.cpzp.cz/preventivni-programy/4"
              }
            ]
          },
          {
            "name": "Women",
            "benefitsCount": "30",
            "benefits": [
              {
                "type": "Vaccination",
                "benefit": "Up to CZK 1 000 for various types of vaccination",
                "description": "We contribute up to CZK 1 000 this can be used for all infectious disease vaccinations not covered by public health insurance. The contribution can be used for any dose/vaccine in a vaccination cycle. The contribution does not apply to vaccine surcharges. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.cpzp.cz/preventivni-program/14"
              },
              {
                "type": "Regular movement",
                "benefit": "Up to CZK 700 for physical activities for ages 18 and up",
                "description": "We contribute up to CZK 700 to regular physical activity as part of the prevention of cardiovascular disease and obesity for our insured clients aged 18 and over. Options for use: Regular physical activity, including swimming (does not apply to skiing, massages, saunas, solariums, and other regenerative activities). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "move",
                "url": "https://www.cpzp.cz/preventivni-program/36"
              },
              {
                "type": "Sports check-up",
                "benefit": "Up to CZK 500 for a sports check-up",
                "description": "We contribute up to CZK 500 towards the cost of a sports medical examination carried out by a healthcare provider. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "sport",
                "url": "https://www.cpzp.cz/preventivni-program/36"
              },
              {
                "type": "Breast cancer prevention",
                "benefit": "Up to CZK 500 for breast cancer prevention",
                "description": "We contribute up to CZK 500 to pay for breast cancer prevention - for women aged 30 - 40 and up for a mammography or ultrasound examination. The examination must be performed at an accredited facility. A list of currently selected medical facilities is available on the website of the Association of Czech Breast Radiologists (www.mamo.cz). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "breasts",
                "url": "https://www.cpzp.cz/preventivni-program/15"
              },
              {
                "type": "Optic nerve examination",
                "benefit": "Up to CZK 300 for an optical nerve examination",
                "description": "We contribute up to CZK 300 for optical nerve examination, on the following: GDx – nerve fibre analyzer, HRT – Heidelberg Retina Tomography, OCT – Optical Coherent Tomography. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "eye",
                "url": "https://www.cpzp.cz/preventivni-program/18"
              },
              {
                "type": "Skin cancer prevention",
                "benefit": "Up to CZK 500 for diagnosis of pigment spots",
                "description": "We contribute up to CZK 500 for diagnosis of pigment spots. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "skin",
                "url": "https://www.cpzp.cz/preventivni-program/17"
              },
              {
                "type": "Health 65+\n",
                "benefit": "Up to CZK 500 for clients aged 65 and up for the purchase of food supplements and vitamins at a pharmacy",
                "description": "We contribute up to CZK 500 to insured persons aged 65 and over for the purchase of food supplements and vitamins at a pharmacy. The contribution can be used in particular to support immunity, prevent joint deterioration, and improve memory. We only accept purchases made at a pharmacy (or pharmacy e-shop). The contribution can only be used for products that are taken orally (i.e., it cannot be used for vitamins in the form of injections, for example). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "pill",
                "url": "https://www.cpzp.cz/preventivni-program/33"
              },
              {
                "type": "Laser eye surgery",
                "benefit": "Up to CZK 1 000 for laser eye surgery",
                "description": "We contribute up to CZK 1 000 for laser eye surgery - elimination of far-sightedness and near-sightedness, and for laser cataract surgery. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "eye",
                "url": "https://www.cpzp.cz/preventivni-program/21"
              },
              {
                "type": "High blood pressure",
                "benefit": "A contribution of up to CZK 500 for the purchase of a forearm blood pressure monitor",
                "description": "We contribute up to CZK 500 to our clients for the purchase of a forearm blood pressure monitor. The contribution is intended for chronically ill patients diagnosed with hypertension. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "move",
                "url": "https://www.cpzp.cz/preventivni-program/54"
              },
              {
                "type": "Cholesterol",
                "benefit": "Up to CZK 200 for the purchase of food supplements containing Omega 3 fatty acids",
                "description": "We contribute up to CZK 200 to our chronically ill clients with a \"hyperlipidemia\" diagnosis a for the purchase of food supplements containing Omega 3 fatty acids. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "pill",
                "url": "https://www.cpzp.cz/preventivni-program/55"
              },
              {
                "type": "Colon cancer prevention",
                "benefit": "Up to CZK 500 for colon cancer prevention",
                "description": "We contribute up to CZK 500 towards colon cancer prevention – examinations provided by healthcare providers. The contribution applies to all methods not covered by public health insurance (e.g. Septin9). The contribution is not intended for home tests purchased at pharmacies or for hydrocolon therapy. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "rectum",
                "url": "https://www.cpzp.cz/preventivni-program/24"
              },
              {
                "type": "Shock wave",
                "benefit": "Up to CZK 500 for shock wave therapy",
                "description": "We contribute up to 500 for shock wave therapy performed by a medical services provider. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.cpzp.cz/preventivni-program/69"
              },
              {
                "type": "Obesity prevention",
                "benefit": "Up to CZK 500 for obesity prevention",
                "description": "We contribute up to CZK 500 for prevention of obesity. This contribution may be used to pay an obesitologist, dietologist, general practitioner or a nutritional therapist for purposes of reducing excess weight and obesity. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "weight",
                "url": "https://www.cpzp.cz/preventivni-program/71"
              },
              {
                "type": "Dental hygiene",
                "benefit": "Up to CZK 500 for dental hygiene",
                "description": "We contribute up to CZK 500 for dental hygiene performed by a dentist or healthcare professional with professional qualifications to perform dental hygiene. The contribution is provided until the financial limit is exceeded. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "brush",
                "url": "https://www.cpzp.cz/preventivni-program/80"
              },
              {
                "type": "Lightweight cast\n",
                "benefit": "Up to CZK 1 000 to cover the cost of lightweight and light casts",
                "description": "We contribute up to CZK 1 000 for the purchase of lightweight or light casts made of plastic, resin, and carbon fiber (e.g., Opencast) from a healthcare provider or purchased at a medical supply store. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "osteoporosis",
                "url": "https://www.cpzp.cz/preventivni-program/81"
              },
              {
                "type": "Orthopedic insoles\n",
                "benefit": "Up to CZK 500 for the purchase of orthopedic insoles",
                "description": "We contribute up to CZK 500 to our clients with orthopedic foot defects for the purchase of orthopedic insoles at a pharmacy, medical supply store, specialty store, or from the manufacturer. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.cpzp.cz/preventivni-program/82"
              },
              {
                "type": "Birth +",
                "benefit": "Up to CZK 500 for premium services related to childbirth covered by the healthcare provider.",
                "description": "We contribute up to CZK 500 to pregnant women for premium services related to childbirth covered by a healthcare provider. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "pregnant",
                "url": "https://www.cpzp.cz/preventivni-program/85"
              },
              {
                "type": "Steps for health",
                "benefit": "Up to CZK 1 000 for steps taken in the \"Zdraví v mobilu\" [Mobile Health] app",
                "description": "We contribute up to CZK 1,000 for steps walked in the Zdraví v mobilu (Health on Your Mobile) app. The contribution motivates ČPZP policyholders to engage in regular physical activity – walking. The program is based on the use of a pedometer in the \"Zdraví v mobilu\" app. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.cpzp.cz/preventivni-program/68"
              },
              {
                "type": "Diabetes",
                "benefit": "Up to CZK 1 000 to prevent deterioration of diabetes",
                "description": "We contribute up to CZK 1 000 for the prevention of diabetes complications. The contribution is intended for one of the selected services or aids, such as: needles for insulin pens, test and diagnostic strips, insulin pump accessories, etc. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "diabetes",
                "url": "https://www.cpzp.cz/preventivni-program/32"
              },
              {
                "type": "Celiac disease, hereditary metabolic disorders\n",
                "benefit": "A contribution of up to CZK 1 000 to those with coeliac disease for a gluten-free diet and a contribution for a low-protein diet for clients with hereditary metabolic disorders.",
                "description": "We contribute up to CZK 1 000 to clients with coeliac disease for a gluten-free diet and a contribution for a low-protein diet for clients with hereditary metabolic disorders. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "diabetes",
                "url": "https://www.cpzp.cz/preventivni-program/70"
              },
              {
                "type": "Motherhood manager/Pregnancy +",
                "benefit": "Up to CZK 3 000 for motherhood and pregnancy",
                "description": "We contribute up to CZK 3 000 to pregnant women for a peaceful motherhood and pregnancy. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "pregnant",
                "url": "https://www.cpzp.cz/preventivni-program/38"
              },
              {
                "type": "Woman after childbirth",
                "benefit": "Up to CZK 1 000 after childbirth",
                "description": "We contribute up to CZK 1 000 to women after childbirth. The contribution is intended for women after the birth of a baby up to 1 year of age, and for lactation consultants up to 6 months after childbirth. In the case of multiple births, the contribution cannot be increased. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "birth",
                "url": "https://www.cpzp.cz/preventivni-program/37"
              },
              {
                "type": "Smoking cessation",
                "benefit": "Up to CZK 2 000 for smoking cessation.",
                "description": "We contribute up to CZK 2 000 to insured persons for smoking cessation.The contribution is intended for: the purchase of over-the-counter medicines and support products purchased at a pharmacy and medicines for smoking cessation. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "smoke",
                "url": "https://www.cpzp.cz/preventivni-program/35"
              },
              {
                "type": "Wig contribution",
                "benefit": "Up to CZK 2000 for a wig",
                "description": "We contribute up to CZK 2 000 towards the purchase of wigs for cancer patients who are undergoing or have undergone chemotherapy treatment for cancer, and for insured persons diagnosed with alopecia. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.cpzp.cz/preventivni-program/59"
              },
              {
                "type": "Cancer prevention programme",
                "benefit": "Up to CZK 2000 for comprehensive preventive cancer screening.",
                "description": "We contribute up to CZK 2 000 to our clients aged 35 and over for comprehensive oncological preventive examinations performed at specialized facilities where it is possible to undergo preventive oncological examinations. The examination includes laboratory and other tests necessary to detect possible cancer. The scope and price of the examination are determined by the individual facilities. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "ribbon",
                "url": "https://www.cpzp.cz/preventivni-program/57"
              },
              {
                "type": "Keeping going",
                "benefit": "Up to CZK 2 000 for the purchase of a prosthetic bra, swimsuit, prosthesis, or for rehabilitation stay",
                "description": "Up to CZK 2 000 for women undergoing treatment for malignant breast disease, intended for the purchase of a prosthetic bra in a specialized store or for a reconditioning stay organized by patient organizations. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.cpzp.cz/preventivni-program/72"
              },
              {
                "type": "Bonus Plus",
                "benefit": "Up to CZK 500 in an additional preventive program for selected activities",
                "description": "We contribute up to CZK 500 per year in the \"Bonus Plus\" additional programme for selected activities, such as healthcare services provided in healthcare facilities, oral hygiene products, eyeglass frames, sunscreen, sports protective equipment and more. The purpose of the program is to motivate ČPZP policyholders to protect and take maximum care of their health and to reward them for their loyalty to ČPZP. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "shield",
                "url": "https://www.cpzp.cz/preventivni-program/29"
              },
              {
                "type": "Contribution for mental health",
                "benefit": "Up to CZK 6 000 for mental health",
                "description": "We contribute up to CZK 6 000 to our clients for a program aimed at increasing the availability of psychosocial support. The contribution is intended for insured persons undergoing psychosocial intervention with a selected specialist – a private therapist with the appropriate qualifications. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.cpzp.cz/preventivni-program/73"
              },
              {
                "type": "BabyGen",
                "benefit": "Up to CZK 4 000 for genetic testing before planned pregnancy/parenthood",
                "description": "We contribute up to CZK 4 000 towards genetic testing prior to planned pregnancy/parenthood. This involves genetic analysis of serious hereditary diseases, which leads to the detection and minimization of the risks of giving birth to a child with these diseases. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "doctor",
                "url": "https://www.cpzp.cz/preventivni-program/77"
              },
              {
                "type": "Donor Program ",
                "benefit": "Up to CZK 6 000 for blood and bone marrow donors",
                "description": "We contribute up to CZK 6 000 for blood and bone marrow donors. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.cpzp.cz/preventivni-programy/4"
              }
            ]
          },
          {
            "name": "Children",
            "benefitsCount": "20",
            "benefits": [
              {
                "type": "Vaccination",
                "benefit": "Up to CZK 1 500 for various types of vaccination",
                "description": "We contribute up to CZK 1 500 for all vaccinations against infectious diseases not covered by public health insurance. ČPZP provides legal guardians of children and young people up to the age of 17 with a contribution towards preventive vaccinations as part of preventive programs for children and young people. The contribution is provided for any dose/vaccine in the vaccination cycle. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.cpzp.cz/preventivni-program/30"
              },
              {
                "type": "Summer camps",
                "benefit": "Up to CZK 1 500 for summer camps",
                "description": "We contribute up to CZK 1 500 to summer camps for children aged 3 and above. The contribution will only be recognized if the camp lasts at least 4 calendar days and can be applied to camps organized during the summer holidays. The contribution also applies to suburban camps. The contribution can only be provided for camps held in the Czech Republic. The contribution will be made after the summer camp has been completed. Applications for the contribution can only be submitted until September 30, 2026, inclusive. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "tent",
                "url": "https://www.cpzp.cz/preventivni-program/3"
              },
              {
                "type": "Kindergartens and outdoor schools, ski training courses\n",
                "benefit": "Up to CZK 500 for kindergartens and outdoor schools, ski training courses",
                "description": "We contribute up to CZK 500 to parents and legal guardians of children for open-air pre-schools and schools. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "tent",
                "url": "https://www.cpzp.cz/preventivni-program/2"
              },
              {
                "type": "Sports activities",
                "benefit": "Up to CZK 700 for sports activities, sports courses, and membership in sports clubs and teams.",
                "description": "We contribute up to CZK 700 to sports clubs (organized by schools and other entities), sports courses, and membership in sports clubs and teams for children and young people aged 3 and above. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "sport",
                "url": "https://www.cpzp.cz/preventivni-program/56"
              },
              {
                "type": "Protective helmet",
                "benefit": "Up to CZK 500 for a protective helmet",
                "description": "We contribure up to CZK 500 to parents and legal guardians of children a contribution for the purchase of a protective helmet for children. The contribution applies to a protective helmet for sports purchased at a brick-and-mortar shop or the shop's e-shop. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "helmet",
                "url": "https://www.cpzp.cz/preventivni-program/27"
              },
              {
                "type": "Healthy child",
                "benefit": "Up to CZK 500 for products for healthy child development and exercise for children up to two years of age",
                "description": "We contribute up to CZK 500 to legal guardians of children under 2 years of age, including contributions for products for healthy child development and exercise for children. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.cpzp.cz/preventivni-program/7"
              },
              {
                "type": "Eye examination",
                "benefit": "Up to CZK 500 for an eye examination using the Plusoptix device",
                "description": "We contribute up to CZK 500 to parents legal guardians of children for eye examinations using Plusoptix devices at healthcare providers. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "eye",
                "url": "https://www.cpzp.cz/preventivni-program/6"
              },
              {
                "type": "Sports check-up",
                "benefit": "Up to CZK 500 for a medical sports check-up",
                "description": "We contribute up to CZK 500 to parents and legal guardians of children to pay for a medical sports check-up performed by a medical services provider. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "doctor",
                "url": "https://www.cpzp.cz/preventivni-program/11"
              },
              {
                "type": "Obesity prevention",
                "benefit": "Up to CZK 500 for obesity prevention",
                "description": "We contribute up to CZK 500 to parents legal guardians of children a contribution for obesity prevention. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "weight",
                "url": "https://www.cpzp.cz/preventivni-program/25"
              },
              {
                "type": "Skin cancer prevention",
                "benefit": "Up to CZK 500 for diagnosis of pigment spots.",
                "description": "We contribute up to CZK 500 for diagnosis of pigment spots. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "skin",
                "url": "https://www.cpzp.cz/preventivni-program/13"
              },
              {
                "type": "Monitor 24",
                "benefit": "Up to CZK 500 for breath and baby monitors for children up to the age of 2",
                "description": "We contribute up to CZK 500 to legal guardians of children under 2 years of age for a breath monitor and baby monitor (the contribution can also be used to purchase a replacement pad for the breath monitor). ",
                "icon": "phone",
                "url": "https://www.cpzp.cz/preventivni-program/63"
              },
              {
                "type": "Thrombosis prevention",
                "benefit": "Up to CZK 1 000 for thrombosis prevention for girls aged 12 and up",
                "description": "We contribute up to CZK 1 000 to parents and legal guardians of children and youths for a thrombosis prevention for girls aged 12 and up (a contribution for genetic DNA testing to determine the likelihood of thrombophilia complications - especially in relation to the use of hormonal contraceptives). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.cpzp.cz/preventivni-program/12"
              },
              {
                "type": "Lightweight cast\n",
                "benefit": "Up to CZK 1 000 to cover the cost of lightweight and light casts",
                "description": "We contribute up to CZK 1 000 for the purchase of lightweight or light casts made of plastic, resin, and carbon fiber (e.g., Opencast) from a healthcare provider or purchased at a medical supply store. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "osteoporosis",
                "url": "https://www.cpzp.cz/preventivni-program/78"
              },
              {
                "type": "Orthopedic insoles\n",
                "benefit": "Up to CZK 500 for the purchase of orthopedic insoles",
                "description": "We contribute up to CZK 500 to our clients with orthopedic foot defects for the purchase of orthopedic insoles at a pharmacy, medical supply store, specialty store, or from the manufacturer. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.cpzp.cz/preventivni-program/79"
              },
              {
                "type": "Diabetes",
                "benefit": "Up to CZK 2 000 to prevent deterioration of diabetes",
                "description": "We contribute up to CZK 2 000 to parents and legal guardians of children for products for diabetics. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "diabetes",
                "url": "https://www.cpzp.cz/preventivni-program/8"
              },
              {
                "type": "Celiac disease, hereditary metabolic disorders\n",
                "benefit": "Up to CZK 4000 for a gluten-free diet and a low-protein diet for children with hereditary metabolic disorders",
                "description": "We contribute up to CZK 4 000 to parents and legal guardians of children with coeliac disease for a gluten-free diet and a contribution for a low-protein diet for children with hereditary metabolic disorders. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "gluten",
                "url": "https://www.cpzp.cz/preventivni-program/9"
              },
              {
                "type": "Vitamins for children",
                "benefit": "Free. This product does not count toward the overall limit of CZK 1500 for preventive programmes for children and youth.",
                "description": "ČPZP provides vitamins to the legal guardians of children and youths between the ages of 3 to 15 (inclusive), which can be picked up at a branch. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "pill",
                "url": "https://www.cpzp.cz/preventivni-program/10"
              },
              {
                "type": "Wig contribution",
                "benefit": "Up to CZK 2000 for a wig",
                "description": "We contribute up to CZK 2 000 towards the purchase of wigs for cancer patients who are undergoing or have undergone chemotherapy treatment for cancer, and for insured persons diagnosed with alopecia. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.cpzp.cz/preventivni-program/61"
              },
              {
                "type": "Bonus plus",
                "benefit": "Up to CZK 500 in an additional preventive program for selected activities",
                "description": "We contribute up to CZK 500 per year in the \"Bonus Plus\" additional programme for selected activities, such as healthcare services provided in healthcare facilities, oral hygiene products, eyeglass frames, sunscreen, sports protective equipment and more. The purpose of the program is to motivate ČPZP policyholders to protect and take maximum care of their health and to reward them for their loyalty to ČPZP. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "shield",
                "url": "https://www.cpzp.cz/preventivni-program/29"
              },
              {
                "type": "Contribution for mental health",
                "benefit": "Up to CZK 6 000 for mental health for children aged 7 and older",
                "description": "We contribute up to CZK 6 000 to mental health care for children aged 7 and older. The contribution is intended for insured persons aged 7 and older for psychosocial intervention provided by a selected specialist – a private therapist with the appropriate qualifications. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.cpzp.cz/preventivni-program/74"
              }
            ]
          }
        ]
      },
      {
        "slug": "ozp",
        "updateDate": "2.2.2026",
        "companyBenefitsLink": "https://www.ozp.cz/benefity/benefityozp",
        "gendersCount": "3",
        "genders": [
          {
            "name": "Men",
            "benefitsCount": "19",
            "benefits": [
              {
                "type": "Dental hygiene",
                "benefit": "Up to CZK 1 000 for dental hygiene",
                "description": "We contribute up to CZK 1 000 a year for dental hygiene for adults. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "brush",
                "url": "https://www.ozp.cz/benefity/benefityozp"
              },
              {
                "type": "Flu vaccine (up to 65 years)",
                "benefit": "Up to CZK 500 for a flu vaccine that isn't covered by public health insurance",
                "description": "We contribute up to CZK 500 to adults up to 65 years of age for flu vaccination. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.ozp.cz/benefity/kupon-na-ockovani-chripka"
              },
              {
                "type": "Other vaccination",
                "benefit": "Up to CZK 1 000 for vaccination",
                "description": "We contribute up to CZK 1 000 for vaccinations that are not covered by public health insurance. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.ozp.cz/benefity/kupon-na-ockovani"
              },
              {
                "type": "STOP skin cancer",
                "benefit": "Up to CZK 800 for preventive skin cancer examination",
                "description": "We contribute up to CZK 800 for preventive skin cancer examination. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "skin",
                "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-rakovine-kuze"
              },
              {
                "type": "Nutritional consulting for selected chronically ill clients",
                "benefit": "Up to CZK 1 000 for nutritional counseling for selected chronically ill clients",
                "description": "We contribute up to CZK 1 000 for nutritional counseling for selected chronically ill clients. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "nutrition",
                "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/pece-o-vybrane-chronicky-nemocne-klienty"
              },
              {
                "type": "A contribution for clients on a low-protein diet",
                "benefit": "Up to CZK 5 000 for a low-protein diet",
                "description": "We contribute up to CZK 5 000 to clients with a hereditary metabolic disorder - phenylketonuria for low protein foods. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "nutrition",
                "url": "https://www.ozp.cz/benefity/prispevek-pro-klienty-s-nizkobilkovinnou-dietou"
              },
              {
                "type": "Contributions for cancer patients",
                "benefit": "Up to CZK 4 000 for clients with cancer for selected aids",
                "description": "We contribute up to CZK 4 000 to oncologically ill clients for wigs, epitheses, lymphatic drainage after breast ablation, ostomy aids, incontinence aids, respirators and masks. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "ribbon",
                "url": "https://www.ozp.cz/benefity/prispevky-pro-onkologicky-nemocne"
              },
              {
                "type": "STOP smoking",
                "benefit": "Up to CZK 2 000 for smoking cessation ",
                "description": "We contriubte up to CZK 2 000 for smoking cessation. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "smoke",
                "url": "https://www.ozp.cz/benefity/stop-koureni"
              },
              {
                "type": "STOP mouth cancer",
                "benefit": "Up to CZK 700 for preventive mouth cancer examination",
                "description": "We contribute up to 700 CZK to adults from 25 years of age for preventive examinations for oral cancer. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-rakovine-dutiny-ustni"
              },
              {
                "type": "STOP heart attack",
                "benefit": "Up to CZK 1 200 for a preventive examination of the risk of heart attack",
                "description": "We contribute up to CZK 1 200 to adults aged 30 to 55 for preventive heart attack risk examinations. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "heart-attack",
                "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-infarktu"
              },
              {
                "type": "STOP prostate cancer",
                "benefit": "Up to CZK 1 200 for a preventive prostate cancer examination ",
                "description": "We contribute up to CZK 1 200 to adults aged 40 to 49 for preventive prostate cancer examination. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "prostate",
                "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-rakovine-prostaty"
              },
              {
                "type": "STOP cancer of the colon and rectum",
                "benefit": "Up to CZK 500 for preventive colon and rectum cancer examination",
                "description": "We contribute up to CZK 500 to adults aged 40 to 44 for preventive examination for colon and rectal cancer. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "rectum",
                "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-rakovine-konecniku"
              },
              {
                "type": "Prevention of Alzheimer's disease",
                "benefit": "Up to CZK 500 for prevention of Alzheimer's disease",
                "description": "We contribute up to 500 CZK to adults aged 40 and over for the prevention of Alzheimer's disease. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/prevence-alzheimerovy-nemoci"
              },
              {
                "type": "STOP kidney cancer and abdominal tumors",
                "benefit": "Up to CZK 1 150 for preventive kindey cancer and abdominal tumors examination",
                "description": "We contribute up to CZK 1 150 to adults aged 40 and over for preventive examinations for kidney cancer and abdominal tumors. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-nadorum-brisnich-organu"
              },
              {
                "type": "STOP osteoporosis",
                "benefit": "Up to CZK 1 000 for prevention of osteoporosis",
                "description": "We contribute up to CZK 1 000 to adults aged 50 and over for osteoporosis prevention. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "osteoporosis",
                "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-osteoporoze"
              },
              {
                "type": "Vitamins for seniors",
                "benefit": "Up to CZK 500 on vitamins for seniors",
                "description": "We contribute up to CZK 500 to seniors over 70 for vitamins and medicinal supplements. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "pill",
                "url": "https://www.ozp.cz/benefity/kupon-na-vitaminy"
              },
              {
                "type": "For donors",
                "description": "The target group comprises blood donors, organ donors, and bone marrow donors. In return for donating, you will receive credits that you can then use for various support programmes. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.ozp.cz/benefity/pro-darce"
              },
              {
                "type": "Attractive insurance packages from Vitalitas",
                "benefit": "We have excellent insurance products for you and your children",
                "description": "The Vitalitas insurance company offers attractive travel insurance and accident insurance packages for children: Zvonek and Gina. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "suitcase",
                "url": "https://www.vitalitas.cz/"
              },
              {
                "type": "Other benefits",
                "benefit": "Discover the world of attractive benefits offered by OZP",
                "description": "VITAKARTA - an on-line counter, on-line overview submission for small businesses, doctors' atlas, and other on-line services. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "payment",
                "url": "https://www.ozp.cz/elektronicka-komunikace/informace/vitakarta-online-informace"
              }
            ]
          },
          {
            "name": "Women",
            "benefitsCount": "20",
            "benefits": [
              {
                "type": "Dental hygiene",
                "benefit": "Up to CZK 1 000 for dental hygiene",
                "description": "We contribute up to CZK 1 000 a year for dental hygiene for adults. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "brush",
                "url": "https://www.ozp.cz/benefity/benefityozp"
              },
              {
                "type": "Flu vaccine (up to 65 years)",
                "benefit": "Up to CZK 500 for a flu vaccine that isn't covered by public health insurance",
                "description": "We contribute up to CZK 500 to adults up to 65 years of age. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.ozp.cz/benefity/kupon-na-ockovani-chripka"
              },
              {
                "type": "Other vaccination",
                "benefit": "Up to CZK 1 000 for vaccination",
                "description": "We contribute up to CZK 1 000 for vaccinations that are not covered by public health insurance. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.ozp.cz/benefity/kupon-na-ockovani"
              },
              {
                "type": "STOP skin cancer",
                "benefit": "Up to CZK 800 for preventive skin cancer examination",
                "description": "We contribute up to CZK 800 for preventive skin cancer examination. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "skin",
                "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-rakovine-kuze"
              },
              {
                "type": "Nutritional consulting for selected chronically ill clients",
                "benefit": "Up to CZK 1 000 for nutritional counseling for selected chronically ill clients",
                "description": "We contribute up to CZK 1 000 for nutritional counseling for selected chronically ill clients. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "nutrition",
                "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/pece-o-vybrane-chronicky-nemocne-klienty"
              },
              {
                "type": "A contribution for clients on a low-protein diet",
                "benefit": "Up to CZK 5 000 for a low-protein diet",
                "description": "We contribute up to CZK 5 000 to clients with a hereditary metabolic disorder - phenylketonuria for low protein foods. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "nutrition",
                "url": "https://www.ozp.cz/benefity/prispevek-pro-klienty-s-nizkobilkovinnou-dietou"
              },
              {
                "type": "Contributions for cancer patients",
                "benefit": "Up to CZK 4 000 for clients with cancer for selected aids",
                "description": "We contribute up to CZK 4 000 to oncologically ill clients for wigs, epitheses, lymphatic drainage after breast ablation, ostomy aids, incontinence aids, respirators and masks. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "ribbon",
                "url": "https://www.ozp.cz/benefity/prispevky-pro-onkologicky-nemocne"
              },
              {
                "type": "STOP smoking",
                "benefit": "Up to CZK 2 000 for smoking cessation",
                "description": "We contriubte up to CZK 2 000 for smoking cessation. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "smoke",
                "url": "https://www.ozp.cz/benefity/stop-koureni"
              },
              {
                "type": "STOP mouth cancer",
                "benefit": "Up to CZK 700 for preventive mouth cancer examination",
                "description": "We contribute up to 700 CZK to adults from 25 years of age for preventive examinations for oral cancer. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-rakovine-dutiny-ustni"
              },
              {
                "type": "STOP heart attack",
                "benefit": "Up to CZK 1 200 for a preventive examination of the risk of heart attack",
                "description": "We contribute up to CZK 1 200 to adults aged 30 to 55 for preventive heart attack risk examinations. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "heart-attack",
                "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-infarktu"
              },
              {
                "type": "STOP breast cancer",
                "benefit": "Up to CZK 1 200 for brest cancer prevention",
                "description": "We contribute up to CZK 1 200 to women aged 40 and over for breast cancer prevention + CZK 100 for AI analysis of images. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "breasts",
                "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-rakovine-prsu"
              },
              {
                "type": "STOP cancer of the colon and rectum",
                "benefit": "Up to CZK 500 for preventive colon and rectum cancer examination",
                "description": "We contribute up to CZK 500 to adults aged 40 to 44 for preventive examination for colon and rectal cancer. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "rectum",
                "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-rakovine-konecniku"
              },
              {
                "type": "Prevention of Alzheimer's disease",
                "benefit": "Up to CZK 500 for prevention of Alzheimer's disease",
                "description": "We contribute up to 500 CZK to adults aged 40 and over for the prevention of Alzheimer's disease. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/prevence-alzheimerovy-nemoci"
              },
              {
                "type": "STOP kidney cancer and abdominal tumors",
                "benefit": "Up to CZK 1 150 for preventive kindey cancer and abdominal tumors examination",
                "description": "We contribute up to CZK 1 150 to adults aged 40 and over for preventive examinations for kidney cancer and abdominal tumors. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-nadorum-brisnich-organu"
              },
              {
                "type": "STOP osteoporosis",
                "benefit": "Up to CZK 1 000 for prevention of osteoporosis",
                "description": "We contribute up to CZK 1 000 to adults aged 50 and over for osteoporosis prevention. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "osteoporosis",
                "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-osteoporoze"
              },
              {
                "type": "Vitamins for seniors",
                "benefit": "Up to CZK 500 on vitamins for seniors",
                "description": "We contribute up to CZK 500 to seniors over 70 for vitamins and medicinal supplements. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "pill",
                "url": "https://www.ozp.cz/benefity/kupon-na-vitaminy"
              },
              {
                "type": "For donors",
                "description": "The target group comprises blood donors, organ donors, and bone marrow donors. In return for donating, you will receive credits that you can then use for various support programmes. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.ozp.cz/benefity/pro-darce"
              },
              {
                "type": "Attractive insurance packages from Vitalitas",
                "benefit": "We have excellent insurance products for you and your children",
                "description": "The Vitalitas insurance company offers attractive travel insurance and accident insurance packages for children: Zvonek and Gina. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "suitcase",
                "url": "https://www.vitalitas.cz/"
              },
              {
                "type": "Other benefits",
                "benefit": "Discover the world of attractive benefits offered by OZP",
                "description": "VITAKARTA - an on-line counter, on-line overview submission for small businesses, doctors' atlas, and other on-line services. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "payment",
                "url": "https://www.ozp.cz/elektronicka-komunikace/informace/vitakarta-online-informace"
              },
              {
                "type": "Contribution for pregnant women and newborns",
                "benefit": "Up to CZK 6 000 for expecting mothers and their babies",
                "description": "We contribute up to CZK 6 000 to expectant mothers and their babies. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "pregnant",
                "url": "https://www.ozp.cz/benefity/maminky-a-novorozenci"
              }
            ]
          },
          {
            "name": "Children",
            "benefitsCount": "13",
            "benefits": [
              {
                "type": "Dental hygiene",
                "benefit": "Up to CZK 1 000 for dental hygiene",
                "description": "We contribute up to CZK 1 000 to children for dental hygiene. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "brush",
                "url": "https://www.ozp.cz/benefity/kupon-na-dentalni-hygienu"
              },
              {
                "type": "Sports activities",
                "benefit": "Up to CZK 1 000 for children aged 6 to 14 for sports activities",
                "description": "We contribute up to CZK 1 000 to children aged 6 - 14 for sports activities. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "muscle",
                "url": "https://www.ozp.cz/benefity/kupon-na-sportovni-aktivity"
              },
              {
                "type": "Flu vaccine ",
                "benefit": "Up to CZK 500 for a flu vaccine that isn't covered by public health insurance",
                "description": "We contribute up to CZK 500 to children for flu vaccination. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.ozp.cz/benefity/kupon-na-ockovani-chripka"
              },
              {
                "type": "Other vaccination",
                "benefit": "Up to CZK 1 000 for vaccination",
                "description": "We contribute up to CZK 1 000 for vaccinations that are not covered by public health insurance. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.ozp.cz/benefity/kupon-na-ockovani"
              },
              {
                "type": "A contribution for clients on a low-protein diet",
                "benefit": "Up to CZK 5000 for clients on a low-protein diet",
                "description": "This programme focuses on supporting OZP clients on a low-protein diet, hence with a hereditary metabolic disorder, phenylketonuria. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "nutrition",
                "url": "https://www.ozp.cz/benefity/prispevek-pro-klienty-s-nizkobilkovinnou-dietou"
              },
              {
                "type": "STOP skin cancer",
                "benefit": "Up to CZK 800 for preventive skin cancer examination",
                "description": "We contribute up to CZK 800 for preventive skin cancer examination. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "skin",
                "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-rakovine-kuze"
              },
              {
                "type": "\nContribution to therapeutic stays for children",
                "benefit": "Up to CZK 10,000 for children with chronic respiratory and dermatological diseases (LOP) or children with obesity",
                "description": "We contribute up to CZK 10 000 for a climatic (seaside/high mountain) or spa stay (which is not covered by public health insurance) with a minimum length of stay of 15 days (14 nights). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "suitcase",
                "url": "https://www.ozp.cz/benefity/ozdravne-pobyty-pro-deti"
              },
              {
                "type": "A contribution for clients on a low-protein diet",
                "benefit": "Up to CZK 5 000 for a low-protein diet",
                "description": "We contribute up to CZK 5 000 to clients with a hereditary metabolic disorder - phenylketonuria for low protein foods. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "nutrition",
                "url": "https://www.ozp.cz/benefity/prispevek-pro-klienty-s-nizkobilkovinnou-dietou"
              },
              {
                "type": "Contributions for cancer patients",
                "benefit": "Up to CZK 4 000 for clients with cancer for selected aids",
                "description": "We contribute up to CZK 4 000 to oncologically ill clients for wigs, epitheses, lymphatic drainage after breast ablation, ostomy aids, incontinence aids, respirators and masks. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "ribbon",
                "url": "https://www.ozp.cz/benefity/prispevky-pro-onkologicky-nemocne"
              },
              {
                "type": "Contribution for children with obesity",
                "benefit": "Up to CZK 1 000 for children with obesity",
                "description": "We contribute up to CZK 1 000 to children diagnosed with E 66 – obesity. You can use the contribution for specialized counseling services for children with obesity, physical activities for children, special health stays (excluding treatment in children's health resorts, which is covered by health insurance), or psychotherapeutic and psychological support activities at PZS. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.ozp.cz/benefity/prispevky-na-prevenci/prispevek-pro-deti-s-obezitou"
              },
              {
                "type": "STOP smoking",
                "benefit": "Up to CZK 2 000 for smoking cessation",
                "description": "We contriubte up to CZK 2 000 for smoking cessation. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "smoke",
                "url": "https://www.ozp.cz/benefity/stop-koureni"
              },
              {
                "type": "Attractive insurance packages from Vitalitas",
                "benefit": "We have excellent insurance products for you and your children",
                "description": "The Vitalitas insurance company offers attractive travel insurance and accident insurance packages for children: Zvonek and Gina. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "suitcase",
                "url": "https://www.vitalitas.cz/"
              },
              {
                "type": "Other benefits",
                "benefit": "Discover the world of attractive benefits offered by OZP",
                "description": "VITAKARTA - an on-line counter, on-line overview submission for small businesses, doctors' atlas, and other on-line services. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "payment",
                "url": "https://www.ozp.cz/elektronicka-komunikace/informace/vitakarta-online-informace"
              }
            ]
          }
        ]
      },
      {
        "slug": "vozp",
        "updateDate": "29.1.2026",
        "companyBenefitsLink": "https://www.vozp.cz/prispevky-na-prevenci",
        "gendersCount": "3",
        "genders": [
          {
            "name": "Men",
            "benefitsCount": "15",
            "benefits": [
              {
                "type": "Vaccination",
                "benefit": "Up to CZK 1 000 for vaccination",
                "description": "We contribute up to CZK 1 000 to insured persons aged 18 and over for any vaccination not covered by public health insurance (with the exception of vaccination against human papillomavirus – HPV), for any dose in the vaccination cycle. The contribution cannot be provided for the co-payment of a partially covered vaccine. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.vozp.cz/prispevek/ockovani-pro-dospele"
              },
              {
                "type": "Calorie Tables Application\n",
                "benefit": "Up to CZK 899 for the Calorie Tables app",
                "description": "We contribute up to CZK 899 to our clients aged 18 and over for an annual subscription to the premium version of the Calorie Tables app. The contribution can only be provided for the Premium version for individuals with a minimum annual validity (not, for example, for a monthly subscription or family subscription). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "phone",
                "url": "https://www.vozp.cz/prispevek/aplikace-kaloricke-tabulky"
              },
              {
                "type": "Dental hygiene",
                "benefit": "Up to CZK 500 for dental hygiene",
                "description": "We contribute up to CZK 500 to all clients for dental hygiene (treatment or instruction). The contribution does not apply to a dental checkup or other non-hygiene procedures, dental products, or other goods. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "brush",
                "url": "https://www.vozp.cz/prispevek/dentalni-hygiena"
              },
              {
                "type": "Regular exercise",
                "benefit": "Up to CZK 700 for regular physical activities",
                "description": "We contribure up to CZK 700 to our clients from 18 years of age for regular physical activities such as: fitness exercises, core training, fitness, aerobics, spinning, tabata, bodybuilding, bodyforming, firefighting, yoga, pilates, tai-chi, calanetics, zumba, and others. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "move",
                "url": "https://www.vozp.cz/prispevek/pravidelny-pohyb"
              },
              {
                "type": "Swimming",
                "benefit": "Up to CZK 700 for swimming",
                "description": "We contribute up to CZK 700 to all clients for swimming as follows: Season tickets (including chip or card credit recharge), swimming lessons, swimming lessons for parents with children (in this case the contribution applies only to the child). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "water",
                "url": "https://www.vozp.cz/prispevek/plavani"
              },
              {
                "type": "Joint supplements for seniors",
                "benefit": "Up to CZK 500 for clients aged 65 and over for the purchase of food supplements intended exclusively for the support of joint health",
                "description": "We contribute up to CZK 500 to our clients aged 65 and over for the purchase of dietary supplements intended exclusively to support joint health and proper function and to prevent osteoarthritis (products containing collagen, glucosamine sulfate, chondroitin sulfate, methylsulfonylmethane – MSM, etc.) purchased at a pharmacy. The contribution is not intended for supplements other than joint supplements. Therefore, it cannot be used, for example, for products to prevent bone loss (osteoporosis), vitamins, magnesium, etc. The contribution can only be used for dietary supplements, not for registered medicines (medicinal products). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "nutrition",
                "url": "https://www.vozp.cz/prispevek/kloubni-vyziva-pro-seniory"
              },
              {
                "type": "Prostate cancer prevention",
                "benefit": "Up to CZK 300 for prostate cancer prevention",
                "description": "We contribute up to CZK 300 to men aged 40 and over for preventive PSA blood tests or prostate ultrasound examinations, if these are not covered by public health insurance. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "prostate",
                "url": "https://www.vozp.cz/prispevek/prevence-karcinomu-prostaty"
              },
              {
                "type": "Examination of skin marks",
                "benefit": "Up to CZK 400 for skin mole examinations",
                "description": "We contribute up to CZK 400 to all our clients for dermatoscopic examination of skin lesions. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "skin",
                "url": "https://www.vozp.cz/prispevek/vysetreni-koznich-znamenek"
              },
              {
                "type": "Colorectal cancer prevention",
                "benefit": "Up to CZK 300 for the purchase of a self-test for the prevention of cancer of the colon and rectum",
                "description": "We contribute up to CZK 300 to all insured persons for the purchase of a self-collection test for the prevention of colon and rectal cancer, or to insured persons under 45 years of age for screening tests for the prevention of colorectal cancer performed in a healthcare facility (from the age of 45, the test is covered by public health insurance). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "rectum",
                "url": "https://www.vozp.cz/prispevek/prevence-kolorektalniho-karcinomu"
              },
              {
                "type": "Smoking cessation",
                "benefit": "Up to CZK 400 for smoking cessation",
                "description": "We contribute up to CZK 400 to our clients aged 16 and over on the basis of confirmation of treatment or completion of treatment issued by a smoking cessation center. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "smoke",
                "url": "https://www.vozp.cz/prispevek/odvykani-koureni"
              },
              {
                "type": "Breast cancer prevention",
                "benefit": "Up to CZK 800 for breast cancer prevention",
                "description": "We contribute up to CZK 800 to men aged 30 and over for sonographic examinations. Once every 2 years. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "breasts",
                "url": "https://www.vozp.cz/prispevek/prevence-karcinomu-prsu"
              },
              {
                "type": "Wig for oncological treatment/alopecia",
                "benefit": "Up to CZK 1 000 for a wig in case of chemotherapy or autoimmune alopecia",
                "description": "We contribute up to CZK 1 000 to our clients who have undergone or are undergoing treatment for cancer, or to insured persons diagnosed with autoimmune alopecia. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.vozp.cz/prispevek/paruka-pri-chemoterapii"
              },
              {
                "type": "Prevention of memory/cognitive function disorders",
                "benefit": "Up to CZK 300 for a preventive diagnosis of memory/cognitive function disorders",
                "description": "We contribute up to CZK 300 to our clients aged 18 and over for preventive examinations of memory/cognitive function disorders (targeted psychiatric or psychological examinations using MMSE, AKT, MoCA), professionally guided memory training, cognitive aids recommended by the Czech Alzheimer's Society, Feuerstein's instrumental enrichment therapy for people with brain damage provided by a certified specialist – see the list of authorized persons (available at www.cogito-centrum.cz in the team section – our experts). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "brain",
                "url": "https://www.vozp.cz/prispevek/prevence-poruch-pameti"
              },
              {
                "type": "Mindwell Therapy Programs",
                "benefit": "Free program",
                "description": "Upon meeting the conditions for inclusion in the program, the VoZP client will receive an activation code that replaces payment when purchasing the program on the Mindwell website. The program is intended for VoZP policyholders over the age of 18 and is suitable for people with mild to moderate depression or anxiety. It is not suitable for people with acute problems. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.vozp.cz/prispevek/mindwell"
              },
              {
                "type": "For donors",
                "benefit": "Reward of up to CZK 5 000 for blood and bone marrow donors",
                "description": "The target group is blood donors and bone marrow donors. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.vozp.cz/prispevek/prispevky-pro-darce-krve-a-kostni-drene"
              }
            ]
          },
          {
            "name": "Women",
            "benefitsCount": "18",
            "benefits": [
              {
                "type": "Vaccination",
                "benefit": "Up to CZK 1 000 for vaccination",
                "description": "We contribute up to CZK 1 000 to insured persons aged 18 and over for any vaccination not covered by public health insurance (with the exception of vaccination against human papillomavirus – HPV), for any dose in the vaccination cycle. The contribution cannot be provided for the co-payment of a partially covered vaccine. More information (in Czech only) is available on the insurance company's website here: link. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.vozp.cz/prispevek/ockovani-pro-dospele"
              },
              {
                "type": "Calorie Tables Application\n",
                "benefit": "Up to CZK 899 for the Calorie Tables app",
                "description": "We contribute up to CZK 899 to our clients aged 18 and over for an annual subscription to the premium version of the Calorie Tables app. The contribution can only be provided for the Premium version for individuals with a minimum annual validity (not, for example, for a monthly subscription or family subscription). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "phone",
                "url": "https://www.vozp.cz/prispevek/aplikace-kaloricke-tabulky"
              },
              {
                "type": "Dental hygiene",
                "benefit": "Up to CZK 500 for dental hygiene",
                "description": "We contribute up to CZK 500 to all clients for dental hygiene (treatment or instruction). The contribution does not apply to a dental checkup or other non-hygiene procedures, dental products, or other goods. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "brush",
                "url": "https://www.vozp.cz/prispevek/dentalni-hygiena"
              },
              {
                "type": "Prevention during pregnancy",
                "benefit": "Up to CZK 2 000 for women during pregnancy and after childbirth",
                "description": "We contribute up to CZK 2 000 to women during pregnancy and after childbirth for various courses, screening, dental hygiene, lactation consultant services, etc.More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "pregnant",
                "url": "https://www.vozp.cz/prispevek/prevence-v-tehotenstvi"
              },
              {
                "type": "Food supplements during pregnancy",
                "benefit": "Up to CZK 500 to pregnant women for food supplements",
                "description": "We contribute CZK 500 to pregnant women for dietary supplements suitable for use during pregnancy purchased at a pharmacy (vitamins, multivitamins, folic acid, iron, fiber, probiotics – live cultures, etc.). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "pill",
                "url": "https://www.vozp.cz/prispevek/doplnky-stravy-pro-tehotne"
              },
              {
                "type": "Newborn package",
                "benefit": "Newborn baby package",
                "description": "A package for every newborn registered with VoZP. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "birth",
                "url": "https://www.vozp.cz/prispevek/novorozenecky-balicek"
              },
              {
                "type": "Baby care",
                "benefit": "Up to CZK 2 000 for various baby care products",
                "description": "We contribute up to CZK 2 000 as a one-off payment to each child from birth to six months of age for the following products, as selected by the legal guardian. E.g.: breastfeeding and feeding aids: nipple shields, nursing pillows, breast pumps, etc. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "birth",
                "url": "https://www.vozp.cz/prispevek/pece-o-miminko"
              },
              {
                "type": "Exercise and recovery",
                "benefit": "Up to CZK 700 for regular physical activities",
                "description": "We contribure up to CZK 700 to our clients from 18 years of age for regular physical activities such as: fitness exercises, core training, fitness, aerobics, spinning, tabata, bodybuilding, bodyforming, firefighting, yoga, pilates, tai-chi, calanetics, zumba, and others. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "move",
                "url": "https://www.vozp.cz/prispevek/pravidelny-pohyb"
              },
              {
                "type": "Swimming",
                "benefit": "Up to CZK 700 for swimming",
                "description": "We contribute up to CZK 700 to all clients for swimming as follows: Season tickets (including chip or card credit recharge), swimming lessons, swimming lessons for parents with children (in this case the contribution applies only to the child). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "water",
                "url": "https://www.vozp.cz/prispevek/plavani"
              },
              {
                "type": "Joint supplements for seniors",
                "benefit": "Up to CZK 500 for clients aged 65 and over for the purchase of food supplements intended exclusively for the support of joint health",
                "description": "We contribute up to CZK 500 to our clients aged 65 and over for the purchase of dietary supplements intended exclusively to support joint health and proper function and to prevent osteoarthritis (products containing collagen, glucosamine sulfate, chondroitin sulfate, methylsulfonylmethane – MSM, etc.) purchased at a pharmacy. The contribution is not intended for supplements other than joint supplements. Therefore, it cannot be used, for example, for products to prevent bone loss (osteoporosis), vitamins, magnesium, etc. The contribution can only be used for dietary supplements, not for registered medicines (medicinal products). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "nutrition",
                "url": "https://www.vozp.cz/prispevek/kloubni-vyziva-pro-seniory"
              },
              {
                "type": "Breast cancer prevention",
                "benefit": "Up to CZK 800 for breast cancer prevention ",
                "description": "We contribute up to CZK 800 to women aged 30 and over for sonographic or mammographic examinations (from the age of 45, breast cancer prevention examinations are covered by public health insurance every two years; in this case, the contribution is intended for the intervening years).\n More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "breasts",
                "url": "https://www.vozp.cz/prispevek/prevence-karcinomu-prsu"
              },
              {
                "type": "Examination of skin marks",
                "benefit": "Up to CZK 400 for diagnosis of skin marks",
                "description": "We contribute up to CZK 400 to all our clients for dermatoscopic examination of skin lesions. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "skin",
                "url": "https://www.vozp.cz/prispevek/vysetreni-koznich-znamenek"
              },
              {
                "type": "Colorectal cancer prevention",
                "benefit": "Up to CZK 300 for the purchase of a self-test for the prevention of cancer of the colon and rectum",
                "description": "We contribute up to CZK 300 to all insured persons for the purchase of a self-collection test for the prevention of colon and rectal cancer, or to insured persons under 45 years of age for screening tests for the prevention of colorectal cancer performed in a healthcare facility (from the age of 45, the test is covered by public health insurance). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "rectum",
                "url": "https://www.vozp.cz/prispevek/prevence-kolorektalniho-karcinomu"
              },
              {
                "type": "Smoking cessation",
                "benefit": "Up to CZK 400 for smoking cessation",
                "description": "We contribute up to CZK 400 to our clients aged 16 and over on the basis of confirmation of treatment or completion of treatment issued by a smoking cessation center. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "smoke",
                "url": "https://www.vozp.cz/prispevek/odvykani-koureni"
              },
              {
                "type": "Wig for oncological treatment/alopecia",
                "benefit": "Up to CZK 1 000 for a wig in case of chemotherapy or autoimmune alopecia",
                "description": "We contribute up to CZK 1 000 to our clients who have undergone or are undergoing treatment for cancer, or to insured persons diagnosed with autoimmune alopecia. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.vozp.cz/prispevek/paruka-pri-chemoterapii"
              },
              {
                "type": "Prevention of memory/cognitive function disorders",
                "benefit": "Up to CZK 300 for a preventive diagnosis of memory/cognitive function disorders",
                "description": "We contribute up to CZK 300 to our clients aged 18 and over for preventive examinations of memory/cognitive function disorders (targeted psychiatric or psychological examinations using MMSE, AKT, MoCA), professionally guided memory training, cognitive aids recommended by the Czech Alzheimer's Society, Feuerstein's instrumental enrichment therapy for people with brain damage provided by a certified specialist – see the list of authorized persons (available at www.cogito-centrum.cz in the team section – our experts). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "brain",
                "url": "https://www.vozp.cz/prispevek/prevence-poruch-pameti"
              },
              {
                "type": "Mindwell Therapy Programs",
                "benefit": "Free program",
                "description": "Upon meeting the conditions for inclusion in the program, the VoZP client will receive an activation code that replaces payment when purchasing the program on the Mindwell website. The program is intended for VoZP policyholders over the age of 18 and is suitable for people with mild to moderate depression or anxiety. It is not suitable for people with acute problems. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.vozp.cz/prispevek/mindwell"
              },
              {
                "type": "For donors",
                "benefit": "Reward of up to CZK 5 000 for blood and bone marrow donors",
                "description": "The target group is blood donors and bone marrow donors. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.vozp.cz/prispevek/prispevky-pro-darce-krve-a-kostni-drene"
              }
            ]
          },
          {
            "name": "Children",
            "benefitsCount": "20",
            "benefits": [
              {
                "type": "Vaccination",
                "benefit": "Up to CZK 2 000 for vaccination for children",
                "description": "We contribute up to CZK 2 000 to our clients under the age of 18 for any vaccination not covered by public health insurance (with the exception of vaccination against human papillomavirus HPV), for any dose of the vaccination cycle. The contribution cannot be provided for the co-payment of a partially covered vaccine. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.vozp.cz/prispevek/ockovani-pro-deti"
              },
              {
                "type": "Dental hygiene",
                "benefit": "Up to CZK 500 for dental hygiene",
                "description": "We contribute up to CZK 500 to all clients for dental hygiene (treatment or instruction). The contribution does not apply to a dental checkup or other non-hygiene procedures, dental products, or other goods. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "brush",
                "url": "https://www.vozp.cz/prispevek/dentalni-hygiena"
              },
              {
                "type": "Prescription glasses for children",
                "benefit": "Up to CZK 500 for prescription glasses for children",
                "description": "We contribute up to CZK 500 to our clients aged 6 to 16 for prescription glasses (frames and lenses). The contribution does not apply to separately purchased accessories, contact lenses, or sunglasses without prescription lenses. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "glasses",
                "url": "https://www.vozp.cz/prispevek/dioptricke-bryle-pro-deti"
              },
              {
                "type": "Braces",
                "benefit": "Up to CZK 1 500 for dental braces for children",
                "description": "We contribute up to CZK 1 500 to our clients under the age of 18 for fixed and removable orthodontic appliances (including foil appliances) or their reconstruction (additional components) during the active and retention phases of treatment. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "braces",
                "url": "https://www.vozp.cz/prispevek/zubni-rovnatka-pro-deti"
              },
              {
                "type": "Papilloma virus vaccination",
                "benefit": "Up to CZK 1 500 for vaccination against human papilloma virus (HPV)",
                "description": "We contribute up to CZK 1 500 to our clients aged 15 to 18 for vaccination against human papillomavirus (HPV) as recommended by a doctor (for insured persons aged 11 to 15, this vaccination is covered by public health insurance). The contribution cannot be provided for the co-payment of a partially covered vaccine.  More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.vozp.cz/prispevek/ockovani-proti-papilomaviru"
              },
              {
                "type": "Vitamins for children",
                "benefit": "Up to CZK 300 for vitamins for children",
                "description": "We contribute up to CZK 300 to insured persons under the age of 18 for vitamin or multivitamin supplements appropriate for the applicant's age and purchased at a pharmacy (the product must contain at least one vitamin). The contribution can only be used for dietary supplements, not for registered medicines (medicinal products). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "pill",
                "url": "https://www.vozp.cz/prispevek/prispevek-na-vitaminy"
              },
              {
                "type": "Prevention of tooth cavities for children",
                "benefit": "Up to CZK 300 for dental prevention for children",
                "description": "We contribute up to CZK 300 to insured persons aged 6 to 14 for fissure sealing, i.e., a purely preventive procedure consisting of sealing the gaps between the cusps on the chewing surfaces of the lateral teeth. The contribution does not apply to any other dental procedures (no type of filling). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "tooth-flawed",
                "url": "https://www.vozp.cz/prispevek/prevence-zubniho-kazu-u-deti"
              },
              {
                "type": "Physical activities for children",
                "benefit": "Up to CZK 1 000 for physical activities for children",
                "description": "We contribute up to CZK 1 000 to insured persons under the age of 18 for regular exercise and sports activities. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "sport",
                "url": "https://www.vozp.cz/prispevek/pohybove-aktivity-pro-deti"
              },
              {
                "type": "Swimming",
                "benefit": "Up to CZK 700 for swimming",
                "description": "We contribute up to CZK 700 to all clients for swimming as follows: Season tickets (including chip or card credit recharge), swimming lessons, swimming lessons for parents with children (in this case the contribution applies only to the child). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "water",
                "url": "https://www.vozp.cz/prispevek/plavani"
              },
              {
                "type": "Sports and recuperative stays",
                "benefit": "Up to CZK 1 000 for children for a sports or recuperative stay",
                "description": "We contribute up to CZK 1 000 to clients from age 4 to their 18th birthday for a sports or recuperative stay (ski lessons, sports meet, open-air-school) or summer sports camp. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "tent",
                "url": "https://www.vozp.cz/prispevek/sportovni-a-ozdravne-pobyty"
              },
              {
                "type": "Sports helmet for children",
                "benefit": "Up to CZK 500 for a protective helmet",
                "description": "We contribute up to CZK 500 to clients up to their 16th birthday for a protective sports helmet. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "sport",
                "url": "https://www.vozp.cz/prispevek/sportovni-prilba-pro-deti"
              },
              {
                "type": "Sports check-up for children",
                "benefit": "Up to CZK 500 for a medical sports check-up",
                "description": "We contribute up to CZK 500 to our clients under the age of 18 for medical examinations required for membership in a sports organization, club, or association. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "doctor",
                "url": "https://www.vozp.cz/prispevek/sportovni-prohlidka-pro-deti"
              },
              {
                "type": "Skin lesion examination",
                "benefit": "Up to CZK 400 for skin lesion examination\n",
                "description": "We contribute up to CZK 400 to all our clients for dermatoscopic examination of skin lesions. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "dermatology",
                "url": "https://www.vozp.cz/prispevek/vysetreni-koznich-znamenek"
              },
              {
                "type": "Smoking cessation",
                "benefit": "Up to CZK 400 for smoking cessation",
                "description": "We contribute up to CZK 400 to our clients aged 16 and over on the basis of confirmation of treatment or completion of treatment issued by a smoking cessation center. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "smoke",
                "url": "https://www.vozp.cz/prispevek/odvykani-koureni"
              },
              {
                "type": "Wig for oncological treatment/alopecia",
                "benefit": "Up to CZK 1 000 for a wig in case of chemotherapy or autoimmune alopecia",
                "description": "We contribute up to CZK 1 000 to our clients who have undergone or are undergoing treatment for cancer, or to insured persons diagnosed with autoimmune alopecia. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.vozp.cz/prispevek/paruka-pri-chemoterapii"
              },
              {
                "type": "Colorectal cancer prevention",
                "benefit": "Up to CZK 300 for the purchase of a self-test for the prevention of cancer of the colon and rectum",
                "description": "We contribute up to CZK 300 to all insured persons for the purchase of a self-collection test for the prevention of colon and rectal cancer, or to insured persons under 45 years of age for screening tests for the prevention of colorectal cancer performed in a healthcare facility (from the age of 45, the test is covered by public health insurance). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "rectum",
                "url": "https://www.vozp.cz/prispevek/prevence-kolorektalniho-karcinomu"
              },
              {
                "type": "Support for child development and prevention of mental disorders",
                "benefit": "Up to CZK 1 000 for support for child development and prevention of mental disorders",
                "description": "We contribute up to CZK 1 000 to insured persons aged 1 to 18 for any of the forms of support for child development and mental disorder prevention listed below that are not covered by public health insurance. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "chat-unrelated",
                "url": "https://www.vozp.cz/prispevek/podpora-rozvoje-deti-a-prevence-dusevnich-poruch"
              },
              {
                "type": "The Simple Steps product",
                "benefit": "Up to CZK 800 for children from one year of age until their 16th birthday who have been diagnosed with an autistic spectrum disorder",
                "description": "We contribute up to CZK 800 to children from one year of age until their 16th birthday who have been diagnosed with (or are suspected of having) an autistic spectrum disorder, for which the Simple Steps on-line learning platform for autism therapy will be purchased. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.vozp.cz/prispevek/produkt-simple-steps"
              },
              {
                "type": "Field counselling for children in a pre-school and school facility",
                "benefit": "Up to CZK 500 for the field services of a clinical psychologist, children's psychiatrist, or clinical speech therapist",
                "description": "We contribute up to CZK 500 to our clients aged 3 to 20 for field services provided by a clinical psychologist, child psychiatrist, or clinical speech therapist, fully covered by the insured person and arranged by an educational-psychological counseling center or a special educational center. These are requested visits to a clinical psychologist, child psychiatrist, or clinical speech therapist fully covered by the insured person, which are provided exclusively at the insured person's preschool or school (field services). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.vozp.cz/prispevek/terenni-poradenstvi-pro-deti"
              },
              {
                "type": "Consultation for parents of children with a mental disorder",
                "benefit": "Up to CZK 500 for consulting services from a children's psychiatrist, clinical psychologist, or clinical speech therapist",
                "description": "We contribute up to CZK 500 to our clients under the age of 18 for counseling or consultation services not covered by public health insurance with a child psychiatrist, clinical psychologist, or clinical speech therapist regarding further treatment for children undergoing treatment (the contribution is not intended for the therapy itself or for the examination of the child, but only for consultations with the parent/legal guardian about the treatment process). The contribution can be provided for one or more services, but up to a maximum total amount of CZK 500. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.vozp.cz/prispevek/poradenstvi-pro-rodice-deti-s-dusevni-poruchou"
              }
            ]
          }
        ]
      },
      {
        "slug": "rbp",
        "updateDate": "29.1.2026",
        "companyBenefitsLink": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
        "gendersCount": "3",
        "genders": [
          {
            "name": "Men",
            "benefitsCount": "29",
            "benefits": [
              {
                "type": "Vaccination",
                "benefit": "Up to CZK 1 000 for vaccination",
                "description": "We contribute up to CZK 1 000 towards any preventive vaccination not covered by public health insurance (e.g., typhoid fever, shingles, influenza, tick-borne encephalitis, pneumococcal disease, measles, rabies, meningitis, hepatitis, chickenpox, etc., including vaccinations for travelers). This does not apply to desensitization (\"allergy vaccination\"). The documents must clearly show the type of vaccine and the date of administration. To claim the contribution, provide proof of payment for the vaccine and a photocopy of the vaccination card. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Celiac disease",
                "benefit": "Up to CZK 1 000 for a gluten-free diet for clients with celiac disease",
                "description": "We contribute up to CZK 1 000 towards a gluten-free diet for insured persons with celiac disease. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "gluten",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Low-protein diet",
                "benefit": "Up to CZK 1 000 for a low-protein diet",
                "description": "We contribute up to CZK 1 000 for a low-protein diet (phenylketonuria, maple syrup urine disease, homocystinuria, isovaleric aciduria, propionic and methylmalonic aciduria, tyrosinemia, glutaric aciduria type 1, urea cycle disorders). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "nutrition",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Contribution for wigs - Alopecia",
                "benefit": "Up to CZK 1 000 for a wig for clients with alopecia",
                "description": "We contribute up to CZK 1 000 for clients with alopecia to purchase a wig. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Diabetics",
                "benefit": "Up to CZK 1 000 for clients with diabetes",
                "description": "We contribute up to CZK 1,000 to clients with diabetes for the purchase of a season ticket for physical activities (50% of the price), test strips for detecting glucose in urine, a glucometer, diagnostic strips and accessories for an insulin pump, the purchase of a sensor for non-invasive immediate blood glucose measurement, products for better sensor fixation (tapes, self-adhesive bandages), and podiatric treatment (machine pedicure) performed by providers listed on the websites of the Czech Podiatric Society, the Czech Podological Society, and the Association of Professional Pedicurists. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "stamp",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Cryochamber",
                "benefit": "Up to CZK 700 for a visit to the cryochamber",
                "description": "We contribute up to CZK 700 to insured persons for visits to a cryochamber to strengthen the immune system and regenerate your body. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Sauna ",
                "benefit": "Up to CZK 700 for sauna use",
                "description": "We contribute up to CZK 700 for sauna use during the periods January–April and September–December. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Users of MY213",
                "benefit": "Up to CZK 700 for insured persons who actively use the my213 app",
                "description": "We contribute up to CZK 700 to our clients who are actively using the my213 app and have submitted a request for reimbursement of preventive care from the \"my213 Users\" package exclusively through the app, we offer: season tickets for physical activities, diagnostic examinations or treatments and more. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Contribution for registered athletes",
                "benefit": "Up to CZK 500 for registered athletes",
                "description": "We contribute up to CZK 500 to pay for a regular sports check-up or registration and membership fees. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "sport",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Contribution for a special examination",
                "benefit": "Up to CZK 500 for a special examination",
                "description": "We contribute up to CZK 500 for a special examination. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Smoking cessation",
                "benefit": "Up to CZK 500 for smoking cessation",
                "description": "We contribute up to CZK 500 for the purchase of over-the-counter medicinal and supportive products purchased in a pharmacy: adhesive strips, lozenges, oral sprays, chewing gum, etc.\n More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "smoke",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Prostate contributions",
                "benefit": "Up to CZK 500 for prostate products",
                "description": "We contribute up to CZK 500 to men over 45 years of age for the purchase of selected medicinal products at a pharmacy for benign prostatic hyperplasia. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "prostate",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Father present during childbirth",
                "benefit": "Up to CZK 500 to have the father present during childbirth",
                "description": "We contribute up to CZK 500 towards the cost of procedures or services that support the mother's mental well-being during childbirth and her stay in the maternity hospital, e.g., instruction for the father during childbirth, payment for a premium room for the father and mother, etc. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "birth",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Bonus 90+",
                "benefit": "Up to CZK 1 500 for loyal insured 90+",
                "description": "If you take proper care of your health and are a loyal RBP insured, we can appreciate it. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Wig contribution",
                "benefit": "Up to CZK 3 000 for a wig",
                "description": "We contribute up to CZK 3 000 towards wigs for insured men who are undergoing (or have undergone) chemotherapy treatment for cancer. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Comprehensive cancer examination",
                "benefit": "Up to CZK 4 000 for comprehensive preventive cancer screening.",
                "description": "We contribute up to CZK 4 000 towards a comprehensive oncological preventive examination performed at one of the Comprehensive Oncology Centers. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "ribbon",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Genes213 ",
                "benefit": "Up to CZK 4 000 for planned pregnancy",
                "description": "We contribute up to CZK 4 000 towards the cost of testing for the most common mutations in five genes (cystic fibrosis, spinal muscular atrophy, congenital deafness, phenylketonuria, fragile X syndrome) for clients who are planning to have children. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "pregnant",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Mental Hygiene - Mojra",
                "benefit": "Up to CZK 5 000 for online psychological help",
                "description": "We contribute up to CZK 5 000 to insured persons for online psychological assistance from psychologists and psychotherapists, up to a maximum of CZK 5 000 per year. Consultations are offered to insured persons in 30-minute sessions. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Mental well-being",
                "benefit": "Up to CZK 5 000 for mental well-being",
                "description": "We contribute up to CZK 5 000 to our clients for professional therapeutic assistance in difficult life situations (stress, trauma, conflicts). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Blood and bone marrow donors",
                "benefit": "Up to CZK 6 500 for blood and bone marrow donors",
                "description": "Do you want to help and save lives? Or are you already doing so and are a blood and/or bone marrow donor? You too can obtain bonus contributions if you donate for free. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Spa stays for the chronically ill",
                "benefit": "Up to CZK 10 000 for a spa stay for the chronically ill",
                "description": "We contribute up to CZK 10 000 towards spa stays for chronically ill patients (insured persons with type 1 diabetes, type 2 diabetes or hypertension and a BMI over 30) who are at least 19 years of age at the time of application. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "payment",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Travel insurance discount",
                "benefit": "Up to 30% discount on travel insurance",
                "description": "Insure yourself for travel with a discount of up to 30%. You can arrange travel insurance for medical expenses abroad with a coverage limit of up to CZK 100 million online. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "globus",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Swimming at pools for free or at a discount",
                "benefit": "You will have admission to selected swimming pools either for free or at a discount",
                "description": "You will have free or 50% discounted admission to selected swimming pools throughout the Czech Republic. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "water",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Implant contribution (age 60+)",
                "benefit": "Up to CZK 1 000 to pay for the implant",
                "description": "We contribute up to CZK 1 000 to cover the cost of an implant (not applicable to dentures, crowns, etc.). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "tooth",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Nice smile (age 60+)",
                "benefit": "Up to CZK 1 000 for the purchase of fixing and cleaning agents for complete dentures ",
                "description": "We contribute up to CZK 1 000 for the purchase of fixing and cleaning agents for complete dentures in pharmacies and reimbursement of additional payments for complete dentures and their repairs. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "tooth",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Dental hygiene (age 60+)",
                "benefit": "Up to CZK 700 for dental hygiene",
                "description": "We contribute up to CZK 700 for dental Hygiene. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "brush",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Better memory (age 60+)",
                "benefit": "Up to CZK 500 for mental health prevention",
                "description": "We contribute up to CZK 500 to the prevention of mental health disorders (memory training courses, memory training aids recommended by the Czech Alzheimer's Society). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Season ticket for sports activities",
                "benefit": "Up to CZK 500 for a pass for physical activities",
                "description": "We contribute up to CZK 500 towards a pass for physical activities – a contribution of 50% of the price of a pass for swimming in indoor pools and fitness activities, i.e. spinning, gym, active weight training machines, yoga, aerobics. The following are not covered: solariums, massages, all types of dance, judo, karate, kickboxing, one-day passes, ski passes, etc. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "muscle",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Medicinal products (age 60+)",
                "benefit": "Up to CZK 500 for the purchase of joint supplements and selected medicinal products for benign prostatic hyperplasia",
                "description": "We contribute up to CZK 500 towards the purchase of joint supplements, vitamins, and medicinal products for benign prostatic hyperplasia at pharmacies. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "pills",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              }
            ]
          },
          {
            "name": "Women",
            "benefitsCount": "32",
            "benefits": [
              {
                "type": "Vaccination",
                "benefit": "Up to CZK 1 000 for vaccination",
                "description": "We contribute up to CZK 1 000 towards any preventive vaccination not covered by public health insurance (e.g., typhoid fever, shingles, influenza, tick-borne encephalitis, pneumococcal disease, measles, rabies, meningitis, hepatitis, chickenpox, etc., including vaccinations for travelers). This does not apply to desensitization (\"allergy vaccination\"). The documents must clearly show the type of vaccine and the date of administration. To claim the contribution, provide proof of payment for the vaccine and a photocopy of the vaccination card. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Celiac disease",
                "benefit": "Up to CZK 1 000 for a gluten-free diet for clients with celiac disease",
                "description": "We contribute up to CZK 1 000 towards a gluten-free diet for insured persons with celiac disease. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "gluten",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Low-protein diet",
                "benefit": "Up to CZK 1 000 for a low-protein diet",
                "description": "We contribute up to CZK 1 000 for a low-protein diet (phenylketonuria, maple syrup urine disease, homocystinuria, isovaleric aciduria, propionic and methylmalonic aciduria, tyrosinemia, glutaric aciduria type 1, urea cycle disorders). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "nutrition",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Contribution for wigs - Alopecia",
                "benefit": "Up to CZK 1 000 for a wig for clients with alopecia",
                "description": "We contribute up to CZK 1 000 for clients with alopecia to purchase a wig. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Diabetics",
                "benefit": "Up to CZK 1 000 for clients with diabetes",
                "description": "We contribute up to CZK 1,000 to clients with diabetes for the purchase of a season ticket for physical activities (50% of the price), test strips for detecting glucose in urine, a glucometer, diagnostic strips and accessories for an insulin pump, the purchase of a sensor for non-invasive immediate blood glucose measurement, products for better sensor fixation (tapes, self-adhesive bandages), and podiatric treatment (machine pedicure) performed by providers listed on the websites of the Czech Podiatric Society, the Czech Podological Society, and the Association of Professional Pedicurists. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "stamp",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Cryochamber",
                "benefit": "Up to CZK 700 for a visit to the cryochamber",
                "description": "We contribute up to CZK 700 to insured persons for visits to a cryochamber to strengthen the immune system and regenerate your body. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Sauna ",
                "benefit": "Up to CZK 700 for sauna use",
                "description": "We contribute up to CZK 700 for sauna use during the periods January–April and September–December. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Users of MY213",
                "benefit": "Up to CZK 700 for insured persons who actively use the my213 app",
                "description": "We contribute up to CZK 700 to our clients who are actively using the my213 app and have submitted a request for reimbursement of preventive care from the \"my213 Users\" package exclusively through the app, we offer: season tickets for physical activities, diagnostic examinations or treatments and more. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Contribution for registered athletes",
                "benefit": "Up to CZK 500 for registered athletes",
                "description": "We contribute up to CZK 500 to pay for a regular sports check-up or registration and membership fees. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "sport",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Contribution for a special examination",
                "benefit": "Up to CZK 500 for a special examination",
                "description": "We contribute up to CZK 500 for a special examination. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Smoking cessation",
                "benefit": "Up to CZK 500 for smoking cessation",
                "description": "We contribute up to CZK 500 for the purchase of over-the-counter medicinal and supportive products purchased in a pharmacy: adhesive strips, lozenges, oral sprays, chewing gum, etc.\n More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "smoke",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Osteoporosis and menopause",
                "benefit": "Up to CZK 500 for osteoporosis and menopause products",
                "description": "We contribute up to CZK 500 to women over 40 for the purchase of selected hormonal and non-hormonal preparations for the prevention of osteoporosis and negative menopausal symptoms, purchased only in pharmacies. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "pill",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Post-childbirth ",
                "benefit": "Up to CZK 1 000 for products after childbirth",
                "description": "We contribute up to CZK 1 000 towards the purchase of breastfeeding aids within one year of giving birth (purchased at a pharmacy or specialist breastfeeding store, this can be used to buy absorbent breast pads and special bras including pads, nipple protectors and formers, nursing caps and pillows, breast pumps, breast milk storage containers, warmers, and sterilizers). Purchase of sanitary pads containing nanosilver. Exercise for women up to 6 months after giving birth. Women under the age of 18 are also eligible for this bonus. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "birth",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "For pregnant women",
                "benefit": "Up to CZK 1 000 for pregnant women",
                "description": "We contribute up to CZK 1 000 towards psychoprophylaxis and prenatal exercise classes, i.e. preparing women for childbirth, purchasing vitamins from pharmacies during pregnancy, and more. Women under the age of 18 are also eligible for this contribution. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "pregnant",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "For multiples",
                "benefit": "Up to CZK 1213 for multiples",
                "description": "We contribute up to CZK 1 213 to mothers of multiples. You can use this for any preventive programs/financial contributions intended for children and young people under the age of 18. You will receive the bonus at any time from the birth of the multiples until they reach the age of 18. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "birth",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Bonus 90+",
                "benefit": "Up to CZK 1 500 for loyal insured 90+",
                "description": "If you take proper care of your health and are a loyal RBP insured, we can appreciate it. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Wig contribution for oncology patients",
                "benefit": "Up to CZK 3 000 for a wig",
                "description": "We contribute up to CZK 3 000 towards wigs for insured men who are undergoing (or have undergone) chemotherapy treatment for cancer. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Comprehensive cancer examination",
                "benefit": "Up to CZK 4 000 for comprehensive preventive cancer screening.",
                "description": "We contribute up to CZK 4 000 towards a comprehensive oncological preventive examination performed at one of the Comprehensive Oncology Centers. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "ribbon",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Genes213 ",
                "benefit": "Up to CZK 4 000 for planned pregnancy",
                "description": "We contribute up to CZK 4 000 towards the cost of testing for the most common mutations in five genes (cystic fibrosis, spinal muscular atrophy, congenital deafness, phenylketonuria, fragile X syndrome) for clients who are planning to have children. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "pregnant",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "HPV vaccination",
                "benefit": "Up to CZK 4 000 for HPV vaccination",
                "description": "We contribute up to CZK 4 000 to women under 30 years of age for vaccination against human papillomavirus (prevention against cervical cancer, genital warts, and anal cancer). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Mental Hygiene - Mojra",
                "benefit": "Up to CZK 5 000 for online psychological help",
                "description": "We contribute up to CZK 5 000 to insured persons for online psychological assistance from psychologists and psychotherapists, up to a maximum of CZK 5 000 per year. Consultations are offered to insured persons in 30-minute sessions. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Mental well-being",
                "benefit": "Up to CZK 5 000 for mental well-being",
                "description": "We contribute up to CZK 5 000 to our clients for professional therapeutic assistance in difficult life situations (stress, trauma, conflicts). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Blood and bone marrow donors",
                "benefit": "Up to CZK 6 500 for blood and bone marrow donors",
                "description": "Do you want to help and save lives? Or are you already doing so and are a blood and/or bone marrow donor? You too can obtain bonus contributions if you donate for free. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Spa stays for the chronically ill",
                "benefit": "Up to CZK 10 000 for a spa stay for the chronically ill",
                "description": "We contribute up to CZK 10 000 towards spa stays for chronically ill patients (insured persons with type 1 diabetes, type 2 diabetes or hypertension and a BMI over 30) who are at least 19 years of age at the time of application. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "payment",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Travel insurance discount",
                "benefit": "Up to 30% discount on travel insurance",
                "description": "Insure yourself for travel with a discount of up to 30%. You can arrange travel insurance for medical expenses abroad with a coverage limit of up to CZK 100 million online. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "globus",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Swimming at pools for free or at a discount",
                "benefit": "You will have admission to selected swimming pools either for free or at a discount",
                "description": "You will have free or 50% discounted admission to selected swimming pools throughout the Czech Republic. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "water",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Implant contribution (age 60+)",
                "benefit": "Up to CZK 1 000 to pay for the implant",
                "description": "We contribute up to CZK 1 000 to cover the cost of an implant (not applicable to dentures, crowns, etc.). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "tooth",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Nice smile (age 60+)",
                "benefit": "Up to CZK 1 000 for the purchase of fixing and cleaning agents for complete dentures ",
                "description": "We contribute up to CZK 1 000 for the purchase of fixing and cleaning agents for complete dentures in pharmacies and reimbursement of additional payments for complete dentures and their repairs. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "tooth",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Dental hygiene (age 60+)",
                "benefit": "Up to CZK 700 for dental hygiene",
                "description": "We contribute up to CZK 700 for dental Hygiene. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "brush",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Better memory (age 60+)",
                "benefit": "Up to CZK 500 for mental health prevention",
                "description": "We contribute up to CZK 500 to the prevention of mental health disorders (memory training courses, memory training aids recommended by the Czech Alzheimer's Society). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Season ticket for sports activities",
                "benefit": "Up to CZK 500 for a pass for physical activities",
                "description": "We contribute up to CZK 500 towards a pass for physical activities – a contribution of 50% of the price of a pass for swimming in indoor pools and fitness activities, i.e. spinning, gym, active weight training machines, yoga, aerobics. The following are not covered: solariums, massages, all types of dance, judo, karate, kickboxing, one-day passes, ski passes, etc. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "muscle",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Medicinal products (age 60+)",
                "benefit": "Up to CZK 500 for the purchase of joint supplements and selected medicinal products for benign prostatic hyperplasia",
                "description": "We contribute up to CZK 500 towards the purchase of joint supplements, vitamins, and medicinal products for benign prostatic hyperplasia at pharmacies. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "pills",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              }
            ]
          },
          {
            "name": "Children",
            "benefitsCount": "30",
            "benefits": [
              {
                "type": "Open-air pre-school and school",
                "benefit": "Up to CZK 1 000 for open-air pre-schools and schools",
                "description": "We contribute up to CZK 1 000 to children who attend kindergarten and school until the end of compulsory education. For stays organized by kindergarten and school outside the summer holidays, lasting at least 5 days with overnight stays. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "tent",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Dental hygiene",
                "benefit": "Up to CZK 1 000 for dental hygiene",
                "description": "We contribute up to CZK 1 000 to children for dental hygiene procedures and cannot be used to purchase dental hygiene products (e.g., toothbrushes, interdental brushes, or dental floss). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Vaccination",
                "benefit": "Up to CZK 1 000 for vaccination",
                "description": "We contribute up to CZK 1 000 towards any preventive vaccination not covered by public health insurance (e.g., typhoid fever, shingles, influenza, tick-borne encephalitis, pneumococcal disease, measles, rabies, meningitis, hepatitis, chickenpox, etc., including vaccinations for travelers). This does not apply to desensitization (\"allergy vaccination\"). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Celiac disease",
                "benefit": "Up to CZK 1 000 for a gluten-free diet for clients with celiac disease",
                "description": "We contribute up to CZK 1 000 towards a gluten-free diet for insured persons with celiac disease. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "gluten",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Low-protein diet",
                "benefit": "Up to CZK 1 000 for a low-protein diet",
                "description": "We contribute up to CZK 1 000 for a low-protein diet (phenylketonuria, maple syrup urine disease, homocystinuria, isovaleric aciduria, propionic and methylmalonic aciduria, tyrosinemia, glutaric aciduria type 1, urea cycle disorders). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "nutrition",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Contribution for wigs - Alopecia",
                "benefit": "Up to CZK 1 000 for a wig for clients with alopecia",
                "description": "We contribute up to CZK 1 000 for clients with alopecia to purchase a wig. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Braces",
                "benefit": "Up to CZK 1000 for braces",
                "description": "We contribute up to CZK 1 000 towards the cost of fixed or removable braces, including ongoing adjustments and repairs. The contribution can only be used for services that are not covered by public health insurance and are in accordance with the specified treatment plan. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "braces",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Diabetics",
                "benefit": "Up to CZK 1 000 for children with diabetes",
                "description": "We contribute up to CZK 1,000 to children with diabetes for the purchase of a season ticket for physical activities (50% of the price), test strips for detecting glucose in urine, a glucometer, diagnostic strips and accessories for an insulin pump, the purchase of a sensor for non-invasive immediate blood glucose measurement, products for better sensor fixation (tapes, self-adhesive bandages), and podiatric treatment (machine pedicure) performed by providers listed on the websites of the Czech Podiatric Society, the Czech Podological Society, and the Association of Professional Pedicurists. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "stamp",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Users of MY213",
                "benefit": "Up to CZK 1 000 for insured persons who actively use the my213 app",
                "description": "We contribute up to CZK 1 000 to our clients who are actively using the my213 app and have submitted a request for reimbursement of preventive care from the \"my213 Users\" package exclusively through the app, we offer: season tickets for physical activities, diagnostic examinations or treatments and more. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Sauna ",
                "benefit": "Up to CZK 700 for sauna use for children age 3 and above",
                "description": "We contribute up to CZK 700 and sauna sessions for children aged 3 and above during the periods January–April and September–December. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Swimming lessons",
                "benefit": "Up to CZK 500 for swimming",
                "description": "We contribute up to CZK 500 for swimming lessons organized by a school or pre-school for all children until the end of compulsory school attendance. Organized swimming lessons for children up to the age of three. \n More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "water",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Registered athletes",
                "benefit": "Up to CZK 500 for registered athletes",
                "description": "We contribute up to CZK 500 for a sports check-up, membership and registration fees.\n More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "register",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Obesity",
                "benefit": "Up to CZK 500 against obesity",
                "description": "We contribute up to CZK 500 towards activities in the STOB program. Consultations on weight loss and obesity with an obesity specialist, dietitian, and nutrition therapist (not a nutritionist). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "weight",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Special examination",
                "benefit": "Up to CZK 500 for a special examination",
                "description": "We contribute up to CZK 500 for an examination of skin pigment changes. Can be used once a year. \n More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "doctor",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Thrombosis",
                "benefit": "Up to CZK 500 for diagnosis of thrombosis risk",
                "description": "We contribute up to CZK 500 for a genetic diagnosis of the risk of thrombosis based on information regarding gene mutations. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Lightweight cast",
                "benefit": "Up to CZK 1 000 to cover the cost of lightweight and light plaster casts",
                "description": "We contribute up to CZK 1 000 towards lightweight and light casts made of plastic, resin, and carbon fiber. This does not apply to fixation braces. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "osteoporosis",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Bonus 90+",
                "benefit": "Up to CZK 1 500 for loyal insured 90+",
                "description": "If you take proper care of your health and are a loyal RBP insured, we can appreciate it. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Contribution for summer camp",
                "benefit": "Up to CZK 1 500 for summer camp",
                "description": "We contribute up to CZK 1 500 to children aged 3 and above until they finish elementary school for a summer camp in the Czech Republic or Slovakia. For 2026, the contribution can be used for a holiday stay taking place between July 1 and August 31, 2026. It must last at least 7 days and be organized by a kindergarten, school, sports or interest organization. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "tent",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Sports day camp",
                "benefit": "Up to CZK 1 500 for a sports day camp",
                "description": "We contribute up to CZK 1 500 to children aged 3 and above until the end of primary school for a summer sports and exercise camp. For 2026, the contribution can be applied to camps held between July 1 and August 31, 2026. The camp must last at least five consecutive days and be organized by a kindergarten, school, sports club, or hobby organization. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "tent",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Babies up to age one",
                "benefit": "Up to CZK 2 000 for babies up to the age of one year",
                "description": "We contribute up to CZK 2 000 towards the purchase of a breathing monitor for children under 6 months of age (can also be used for rental), aids and supplies for the baby's own use purchased in pharmacies - infant formula (can also be purchased from the manufacturer), baby diapers, wet wipes, probiotics, drops for flatulence, diaper rash creams, powders, vitamin D according to the List of Products for Children Under 1 Year of Age, baby monitors, and baby supplies—mucus extractors and bottle sterilizers. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "birth",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "For cancer patients",
                "benefit": "Up to CZK 3 000 for cancer patients",
                "description": "We contribute up to CZK 3 000 towards wigs for children and young people undergoing (or who have undergone) chemotherapy treatment, and towards breast prostheses for girls who have undergone breast removal surgery due to cancer. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "ribbon",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "HPV vaccination",
                "benefit": "Up to CZK 4 000 for vaccination against HPV",
                "description": "We contribute up to CZK 4 000 to girls aged 15 and over (prevention of cervical cancer, genital warts, and anal cancer) and boys aged 15 and over (prevention of genital warts and anal cancer). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Mental Hygiene - Mojra",
                "benefit": "Up to CZK 5 000 for online psychological help",
                "description": "We contribute up to CZK 5 000 to insured persons aged 7 and above for online psychological assistance from psychologists and psychotherapists, up to a maximum of CZK 5 000 per year. Consultations are offered to insured persons in 30-minute intervals in the agreed number. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Mental well-being",
                "benefit": "Up to CZK 5 000 for mental well-being",
                "description": "We contribute up to CZK 5 000 to insured persons aged 7 and over for professional therapeutic assistance in difficult life situations following stress, trauma, and unresolved conflicts that complicate the quality of life, interpersonal relationships, and harmonious coexistence of each of us, provided by a clinical psychologist (specialization 901), who can be verified in the register of healthcare providers here, or a therapist who is a member of the Czech Association of Psychotherapists (ČAP). For other specialists not listed - psychotherapists - proof of completion of psychotherapy training will be required and eligibility for the contribution will be assessed on an individual basis. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Recuperative spa retreat",
                "benefit": "Up to CZK 10 000 for a recuperative spa retreat",
                "description": "We contribute up to CZK 10 000 to children aged 6 to 15 with upper respiratory tract diseases, allergies, and dermatoses. This contribution is for a 14-day therapeutic spa stay. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "payment",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Seaside recuperative retreat",
                "benefit": "Up to CZK 10 000 for a seaside recuperative retreat",
                "description": "We contribute up to CZK 10 000 to children aged 6 to 15 with recurring upper respiratory tract diseases, allergies, and dermatoses. This is a contribution of up to CZK 10 000 for a 15-day seaside health stay. The stay can be individual with a travel agency or organized, e.g., a summer camp, or individual accompanied by parents or close family. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "payment",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Recuperative retreat in the mountains",
                "benefit": "Up to CZK 10 000 for a recuperative retreat in the mountains",
                "description": "We contribute up to CZK 10 000 to children aged 6 to 15 with recurrent upper respiratory tract diseases and allergies. The stays are primarily intended for children suffering from respiratory diseases. The stay can be individual with a travel agency, or organized, e.g., a summer camp, or individual accompanied by parents or a close person. This is a contribution for 14 days. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "payment",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Newborn package",
                "benefit": "Small gifts for mom and baby",
                "description": "Parents will receive small gifts for mother and child as a token of appreciation upon presenting proof of the newborn's birth at a branch. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "birth",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Travel insurance discount",
                "benefit": "Up to 30% discount on travel insurance",
                "description": "Insure yourself for travel with a discount of up to 30%. You can arrange travel insurance for medical expenses abroad with a coverage limit of up to CZK 100 million online. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "globus",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Swimming at pools for free or at a discount",
                "benefit": "You will have admission to selected swimming pools either for free or at a discount",
                "description": "You will have free or 50% discounted admission to selected swimming pools throughout the Czech Republic. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "water",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              }
            ]
          }
        ]
      },
      {
        "slug": "skoda",
        "updateDate": "30.1.2026",
        "companyBenefitsLink": "https://www.zpskoda.cz/zdravotni-programy-2023",
        "gendersCount": "3",
        "genders": [
          {
            "name": "Men",
            "benefitsCount": "26",
            "benefits": [
              {
                "type": "Dental hygiene",
                "benefit": "Up to CZK 700 for dental hygiene",
                "description": "We contribute up to CZK 700 towards the cost of dental hygiene and other dental care paid for in excess of the basic public health insurance fund. (This does not apply to cosmetic procedures, such as teeth whitening, decorative dental accessories, etc.)  More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "tooth-flawed",
                "url": "https://www.zpskoda.cz/pece-o-chrup"
              },
              {
                "type": "SPORT contribution",
                "benefit": "Up to CZK 700 for physical activities",
                "description": "We contribute up to CZK 700 for regular sports activities, including swimming and sauna use, except for FBfit Mladá Boleslav, online courses, membership fees, and sports facility rentals and activities paid for with a MultiSport card. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "move",
                "url": "https://www.zpskoda.cz/sport"
              },
              {
                "type": "Smoking cessation",
                "benefit": "Up to CZK 1 000 for smoking cessation",
                "description": "We contribute up to CZK 500 twice a year, always after completion of treatment lasting at least three months, only at facilities listed at www.slzt.cz under Centers for Tobacco Addiction; the contribution can be reimbursed upon submission of a report on the treatment results and verifiable proof of payment.  More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "smoke",
                "url": "https://www.zpskoda.cz/odvykani-koureni"
              },
              {
                "type": "Modern diagnostic and treatment methods",
                "benefit": "Up to CZK 2 000 for various diagnostic and treatment methods",
                "description": "We contribute up to CZK 2 000 toward diagnostic and treatment methods, such as varicose vein surgery (laser), endoscopic carpal tunnel surgery, podiatric examinations, and more. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.zpskoda.cz/mdlm"
              },
              {
                "type": "Mental health care support",
                "benefit": "Up to CZK 4 000 for mental health care",
                "description": "We contribute up to CZK 4 000 towards psychological or psychotherapeutic counseling provided by a certified specialist in psychology/psychotherapy registered with the Czech Association for Psychotherapy, excluding services covered by health insurance (including online counseling). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.zpskoda.cz/dusevni-zdravi"
              },
              {
                "type": "Nutritional counselling support",
                "benefit": "Up to CZK 2 000 for dietary counselling",
                "description": "We contribute up to CZK 2 000 to our clients with a BMI above 30 or below 18.5, a contribution for the preparation of a diet plan by a nutrition therapist, obesity specialist, diabetologist, general practitioner, or nutrition consultant with a valid professional qualification certificate (can also be used for the \"Diabetes Uncovered\" program). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "cabbage",
                "url": "https://www.zpskoda.cz/zdrave-stravovani-metabolicke-poruchy"
              },
              {
                "type": "Low-protein diet and other rare metabolic disorders",
                "benefit": "Up to CZK 12 000 for a low-protein diet",
                "description": "We contribute up to CZK 12 000 to insured persons who have been prescribed a low-protein diet due to a metabolic disorder or specific diagnosis (maple syrup urine disease, homocystinuria, isovaleric aciduria, propionic and methylmalonic aciduria, tyrosinemia, glutaric aciduria type 1, urea cycle disorders). When claiming for the first time, it is necessary to provide confirmation from the attending physician justifying the necessity of this diet. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "nutrition",
                "url": "https://www.zpskoda.cz/zdrave-stravovani-metabolicke-poruchy"
              },
              {
                "type": "Celiac disease",
                "benefit": "Up to CZK 5 000 for a gluten-free diet",
                "description": "We contribute up to CZK 5 000 once a year for a gluten-free diet beyond the scope of the health insurance plan. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "gluten",
                "url": "https://www.zpskoda.cz/zdrave-stravovani-metabolicke-poruchy"
              },
              {
                "type": "Corrective laser operations",
                "benefit": "Up to CZK 4 000 for laser eye operations",
                "description": "We contribute up to CZK 4 000 toward laser eye surgery. Once a year. CZK 2 000 for each eye.. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "eye",
                "url": "https://www.zpskoda.cz/ostatni"
              },
              {
                "type": "OCT examination",
                "benefit": "Up to CZK 800 for an OCT eye exam",
                "description": "We contribute up to CZK 800 toward OCT eye examinations. Can be provided twice a year. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "eye",
                "url": "https://www.zpskoda.cz/ostatni"
              },
              {
                "type": "Intraocular operations",
                "benefit": "Up to CZK 2 000 for eye operation",
                "description": "We contribute up to CZK 2 000 toward intraocular surgery using multifocal lenses, extended focus lenses, lenses for astigmatism correction, or intraocular lenses (CZK 1 000 per eye). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "eye",
                "url": "https://www.zpskoda.cz/ostatni"
              },
              {
                "type": "Plastic plaster",
                "benefit": "Up to CZK 300 for plastic plaster",
                "description": "We contribute up to CZK 300 towards plastic plaster casts. This contribution can be provided once a year. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.zpskoda.cz/ostatni"
              },
              {
                "type": "SPORT Senior contribution",
                "benefit": "Up to CZK 700 for physical activities, sports injury prevention equipment, etc.",
                "description": "We contribute up to CZK 700 to seniors over 65 for physical activities, including swimming and sauna, pedicures for diabetics, aids for preventing sports injuries, Nordic walking poles, specific aids for memory training, and prevention of Alzheimer's disease. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "move",
                "url": "https://www.zpskoda.cz/sport"
              },
              {
                "type": "Vaccination against shingles",
                "benefit": "Up to CZK 4 000 for vaccination against shingles",
                "description": "We contribute up to CZK 4 000 toward shingles vaccinations (CZK 2 000 per dose). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.zpskoda.cz/ockovani"
              },
              {
                "type": "Package of other vaccinations",
                "benefit": "Up to CZK 1 000 for vaccination",
                "description": "We contribute up to CZK 1 000 towards various vaccinations that are not covered by public health insurance. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.zpskoda.cz/ockovani"
              },
              {
                "type": "Meningococcus",
                "benefit": "Up to CZK 3 600 for vaccination against meningococus",
                "description": "We contribute up to CZK 3 600 for vaccination against meningococcus. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.zpskoda.cz/ockovani"
              },
              {
                "type": "Hepatitis",
                "benefit": "Up to CZK 2 400 for vaccination",
                "description": "We contribute up to CZK 2 400 for vaccination against hepatitis. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.zpskoda.cz/ockovani"
              },
              {
                "type": "Tick-borne encephalitis",
                "benefit": "Up to CZK 2 100 for vaccination",
                "description": "We contribute up to CZK 2 100 toward tick-borne encephalitis vaccinations for clients under 50 years of age. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.zpskoda.cz/ockovani"
              },
              {
                "type": "Flu",
                "benefit": "Up to CZK 400 for vaccination",
                "description": "We contribute up to CZK 400 towards flu vaccinations for clients under 65 years of age. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.zpskoda.cz/ockovani"
              },
              {
                "type": "Prevention of thyroid disease",
                "benefit": "Annual contribution",
                "description": "We contribute once a year to blood tests for thyroid hormone levels.",
                "icon": "shield-exclamation-marks",
                "url": "https://www.zpskoda.cz/prevence-zavaznych-onemocneni"
              },
              {
                "type": "A programme for the detection of tumours in the area of the abdominal cavity and the kidneys",
                "benefit": "Annual contribution",
                "description": "We contribute once a year to preventive sonographic examinations of the upper and lower abdomen. The program is intended primarily for insured persons with a positive family history of cancer or at risk of developing this disease. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.zpskoda.cz/prevence-zavaznych-onemocneni"
              },
              {
                "type": "Colon and anal cancer prevention",
                "benefit": "Annual contribution",
                "description": "We contribute once a year to insured persons (aged 35 to 45) who are not covered by occult blood testing as part of preventive check-ups. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "rectum",
                "url": "https://www.zpskoda.cz/prevence-zavaznych-onemocneni"
              },
              {
                "type": "Contribution for cancer patients or other seriously ill patients",
                "benefit": "Up to CZK 4 000 for a wig or cooling cap after chemotherapy ",
                "description": "We contribute up to CZK 4 000 to our clients who have undergone active oncological treatment (or treatment for other systemic diseases) resulting in hair loss. This can be used once a year to purchase a wig or cooling cap after chemotherapy.",
                "icon": "care",
                "url": "https://www.zpskoda.cz/ostatni"
              },
              {
                "type": "FREE travel insurance",
                "benefit": "FREE travel insurance for blood donors who have donated blood within the last 12 months",
                "description": "Travel insurance for blood donors from our partner VITALITAS pojišťovna a. s. covers medical expenses worldwide for up to 30 days. A copy of your blood donor card showing donations made within the last 12 months is required. ",
                "icon": "briefcase",
                "url": "https://www.zpskoda.cz/pro-darce-krve"
              },
              {
                "type": "Recuperative stay in the Czech Republic for bone marrow and organ donors ",
                "benefit": "Up to CZK 10 000 for recuperative stays at one of our partner spa facilities",
                "description": "We contribute up to CZK 10 000 towards a recuperative stay for bone marrow donors and donors of vital organs for transplantation at one of our contracted spa facilities, as selected and agreed with the spa care representative. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "tent",
                "url": "https://www.zpskoda.cz/pro-darce-krve"
              },
              {
                "type": "For donors",
                "benefit": "Up to CZK 5 000 for those who show solidarity with the health of others",
                "description": "We contribute up to CZK 5 000 to blood, bone marrow, and organ donors. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "bloodtest",
                "url": "https://www.zpskoda.cz/pro-darce-krve"
              }
            ]
          },
          {
            "name": "Women",
            "benefitsCount": "36",
            "benefits": [
              {
                "type": "Dental hygiene",
                "benefit": "Up to CZK 700 for dental hygiene",
                "description": "We contribute up to CZK 700 towards the cost of dental hygiene and other dental care paid for in excess of the basic public health insurance fund. (This does not apply to cosmetic procedures, such as teeth whitening, decorative dental accessories, etc.)  More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "tooth-flawed",
                "url": "https://www.zpskoda.cz/pece-o-chrup"
              },
              {
                "type": "Detailed morphological examination of the fetus",
                "benefit": "Up to CZK 1 000 for a fetal examination in the 20th - 22nd week of pregnancy ",
                "description": "We contribute up to CZK 1 000 towards fetal examinations in the 20th to 22nd week of pregnancy – no referral from a gynecologist required. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "pregnant",
                "url": "https://www.zpskoda.cz/maminky-deti"
              },
              {
                "type": "Newborn package",
                "benefit": "Newborn baby package ",
                "description": "A beautiful backpack for girls and boys filled with products from SKIP HOP (bottle with silicone straw, cookie cup) and a Thermoval Baby digital thermometer, all worth CZK 2 500. Upon request, you can also receive free annual accident insurance for newborns from the Zvonek program offered by our partner VITALITAS pojišťovna a. s. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "birth",
                "url": "https://www.zpskoda.cz/maminky-deti"
              },
              {
                "type": "After childbirth",
                "benefit": "Up to CZK 1 600 after childbirth",
                "description": "Contribution of up to CZK 1 600 for a stay in a maternity hospital in a premium room, car seat, presence of a loved one during childbirth, lactation counseling and aids (nursing and absorbent bras, nursing pillow, etc.), diapers, wet wipes, baby swimming, breath monitor. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "birth",
                "url": "https://www.zpskoda.cz/maminky-deti"
              },
              {
                "type": "Contribution during pregnancy",
                "benefit": "Up to CZK 500 for physical activities, various products, massages, vitamins, prenatal courses, and more",
                "description": "We contribute up to CZK 500 to pregnant women for physical activities, vitamins, dietary supplements, stretch mark prevention products, massages, dental hygiene products, dental hygienist treatments, sunglasses with UV filters, orthopedic shoes and insoles purchased at a pharmacy or medical supply store, sunscreen with UV filters, and prenatal classes. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "pregnant",
                "url": "https://www.zpskoda.cz/maminky-deti"
              },
              {
                "type": "Thyroid gland examination during pregnancy",
                "benefit": "Fully covered by health services providers",
                "description": "This contribution is intended for pregnant women for thyroid gland examination, and is entirely covered by health services providers. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.zpskoda.cz/maminky-deti"
              },
              {
                "type": "Non-invasive pre-natal testing",
                "benefit": "Up to CZK 4 000 for non-invasive pre-natal testing",
                "description": "This contribution is for a NIPT in indicated cases upon recommendation by a gynaecologist and geneticist. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "pregnant",
                "url": "https://www.zpskoda.cz/maminky-deti"
              },
              {
                "type": "First-trimester screening",
                "benefit": "Up to CZK 1 200 for fist-trimester screening",
                "description": "We contribute up to CZK 1 200 towards first trimester screening – without a gynecologist's referral, at a specialized accredited facility. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "pregnant",
                "url": "https://www.zpskoda.cz/maminky-deti"
              },
              {
                "type": "Mental health care support",
                "benefit": "Up to CZK 4 000 for mental health care",
                "description": "We contribute up to CZK 4 000 towards psychological or psychotherapeutic counseling provided by a certified specialist in psychology/psychotherapy registered with the Czech Association for Psychotherapy, excluding services covered by health insurance (including online counseling). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.zpskoda.cz/dusevni-zdravi"
              },
              {
                "type": "Modern diagnostic and treatment methods",
                "benefit": "Up to CZK 2 000 for various diagnostic and treatment methods",
                "description": "We contribute up to CZK 2 000 toward diagnostic and treatment methods, such as varicose vein surgery (laser), endoscopic carpal tunnel surgery, podiatric examinations, and more. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.zpskoda.cz/mdlm"
              },
              {
                "type": "Smoking cessation",
                "benefit": "Up to CZK 1 000 for smoking cessation",
                "description": "We contribute up to CZK 500 twice a year, always after completion of treatment lasting at least three months, only at facilities listed at www.slzt.cz under Centers for Tobacco Addiction; the contribution can be reimbursed upon submission of a report on the treatment results and verifiable proof of payment.  More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "smoke",
                "url": "https://www.zpskoda.cz/odvykani-koureni"
              },
              {
                "type": "Corrective laser operations",
                "benefit": "Up to CZK 4 000 for laser eye operations",
                "description": "We contribute up to CZK 4 000 toward laser eye surgery. Once a year. CZK 2 000 for each eye.. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "eye",
                "url": "https://www.zpskoda.cz/ostatni"
              },
              {
                "type": "OCT examination",
                "benefit": "Up to CZK 800 for an OCT eye exam",
                "description": "We contribute up to CZK 800 toward OCT eye examinations. Can be provided twice a year. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "eye",
                "url": "https://www.zpskoda.cz/ostatni"
              },
              {
                "type": "Intraocular operations",
                "benefit": "Up to CZK 2 000 for eye operation",
                "description": "We contribute up to CZK 2 000 toward intraocular surgery using multifocal lenses, extended focus lenses, lenses for astigmatism correction, or intraocular lenses (CZK 1 000 per eye). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "eye",
                "url": "https://www.zpskoda.cz/ostatni"
              },
              {
                "type": "Plastic plaster",
                "benefit": "Up to CZK 300 for plastic plaster",
                "description": "We contribute up to CZK 300 towards plastic plaster casts. This contribution can be provided once a year. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.zpskoda.cz/ostatni"
              },
              {
                "type": "Contribution for cancer patients or other seriously ill patients",
                "benefit": "Up to CZK 4 000 for a wig or cooling cap after chemotherapy",
                "description": "We contribute up to CZK 4 000 to our clients who have undergone active oncological treatment (or treatment for other systemic diseases) resulting in hair loss. This can be used once a year to purchase a wig or cooling cap after chemotherapy.",
                "icon": "happy",
                "url": "https://www.zpskoda.cz/ostatni"
              },
              {
                "type": "SPORT contribution",
                "benefit": "Up to CZK 700 for physical activities",
                "description": "We contribute up to CZK 700 for regular sports activities, including swimming and sauna use, except for FBfit Mladá Boleslav, online courses, membership fees, and sports facility rentals and activities paid for with a MultiSport card. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "move",
                "url": "https://www.zpskoda.cz/sport"
              },
              {
                "type": "SPORT Senior contribution",
                "benefit": "Up to CZK 700 for physical activities, sports injury prevention equipment, etc.",
                "description": "We contribute up to CZK 700 to seniors over 65 for physical activities, including swimming and sauna, pedicures for diabetics, aids for preventing sports injuries, Nordic walking poles, specific aids for memory training, and prevention of Alzheimer's disease. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "move",
                "url": "https://www.zpskoda.cz/sport"
              },
              {
                "type": "Vaccination against shingles",
                "benefit": "Up to CZK 4 000 for vaccination against shingles",
                "description": "We contribute up to CZK 4 000 toward shingles vaccinations (CZK 2 000 per dose). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.zpskoda.cz/ockovani"
              },
              {
                "type": "Package of other vaccinations",
                "benefit": "Up to CZK 1 000 for vaccination",
                "description": "We contribute up to CZK 1 000 towards various vaccinations that are not covered by public health insurance. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.zpskoda.cz/ockovani"
              },
              {
                "type": "HPV infection",
                "benefit": "Up to CZK 4 000 for vaccination",
                "description": "We contribute up to CZK 4 000 for women (up to 45 years of age) who have commenced vaccination within 6 months after cervical conization due to a pre-cancerous condition. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.zpskoda.cz/ockovani"
              },
              {
                "type": "Meningococcus",
                "benefit": "Up to CZK 3 600 for vaccination against meningococus",
                "description": "We contribute up to CZK 3 600 for vaccination against meningococcus. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.zpskoda.cz/ockovani"
              },
              {
                "type": "Hepatitis",
                "benefit": "Up to CZK 2 400 for vaccination",
                "description": "We contribute up to CZK 2 400 for vaccination against hepatitis. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.zpskoda.cz/ockovani"
              },
              {
                "type": "Tick-borne encephalitis",
                "benefit": "Up to CZK 2 100 for vaccination",
                "description": "We contribute up to CZK 2 100 toward tick-borne encephalitis vaccinations for clients under 50 years of age. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.zpskoda.cz/ockovani"
              },
              {
                "type": "Flu",
                "benefit": "Up to CZK 400 for vaccination",
                "description": "We contribute up to CZK 400 towards flu vaccinations for clients under 65 years of age. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.zpskoda.cz/ockovani"
              },
              {
                "type": "Nutritional counselling support",
                "benefit": "Up to CZK 2 000 for dietary counselling",
                "description": "We contribute up to CZK 2 000 to our clients with a BMI above 30 or below 18.5, a contribution for the preparation of a diet plan by a nutrition therapist, obesity specialist, diabetologist, general practitioner, or nutrition consultant with a valid professional qualification certificate (can also be used for the \"Diabetes Uncovered\" program). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "cabbage",
                "url": "https://www.zpskoda.cz/zdrave-stravovani-metabolicke-poruchy"
              },
              {
                "type": "Low-protein diet and other rare metabolic disorders",
                "benefit": "Up to CZK 12 000 for a low-protein diet",
                "description": "We contribute up to CZK 12 000 to insured persons who have been prescribed a low-protein diet due to a metabolic disorder or specific diagnosis (maple syrup urine disease, homocystinuria, isovaleric aciduria, propionic and methylmalonic aciduria, tyrosinemia, glutaric aciduria type 1, urea cycle disorders). When claiming for the first time, it is necessary to provide confirmation from the attending physician justifying the necessity of this diet. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "nutrition",
                "url": "https://www.zpskoda.cz/zdrave-stravovani-metabolicke-poruchy"
              },
              {
                "type": "Celiac disease",
                "benefit": "Up to CZK 5 000 for a gluten-free diet",
                "description": "We contribute up to CZK 5 000 once a year for a gluten-free diet beyond the scope of the health insurance plan. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "gluten",
                "url": "https://www.zpskoda.cz/zdrave-stravovani-metabolicke-poruchy"
              },
              {
                "type": "Prevention of thyroid disease",
                "benefit": "Annual contribution",
                "description": "We contribute once a year to blood tests for thyroid hormone levels.",
                "icon": "shield-exclamation-marks",
                "url": "https://www.zpskoda.cz/prevence-zavaznych-onemocneni"
              },
              {
                "type": "A programme for the detection of tumours in the area of the abdominal cavity and the kidneys",
                "benefit": "Annual contribution",
                "description": "We contribute once a year to preventive sonographic examinations of the upper and lower abdomen. The program is intended primarily for insured persons with a positive family history of cancer or at risk of developing this disease. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.zpskoda.cz/prevence-zavaznych-onemocneni"
              },
              {
                "type": "Colon and anal cancer prevention",
                "benefit": "Annual contribution",
                "description": "We contribute once a year to insured persons (aged 35 to 45) who are not covered by occult blood testing as part of preventive check-ups. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "rectum",
                "url": "https://www.zpskoda.cz/prevence-zavaznych-onemocneni"
              },
              {
                "type": "Breast cancer prevention (ultrasound)",
                "benefit": "Up to CZK 800 for a breast ultrasound examination",
                "description": "We contribute up to CZK 800 towards breast ultrasound examinations for women who do not meet the conditions for reimbursement of the examination from public health insurance funds. Women undergo the examination at their own request with a recommendation from their attending physician. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "breasts-sono",
                "url": "https://www.zpskoda.cz/prevence-zavaznych-onemocneni"
              },
              {
                "type": "Breast cancer prevention (mammogram)",
                "benefit": "Up to CZK 1 000 for a mammogram",
                "description": "We contribute up to CZK 1,000 to women (aged 35 to 45) who are not eligible for the nationwide mammography screening program covered by health insurance funds due to their age. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "breasts-sono",
                "url": "https://www.zpskoda.cz/prevence-zavaznych-onemocneni"
              },
              {
                "type": "FREE travel insurance",
                "benefit": "FREE travel insurance for blood donors who have donated blood within the last 12 months",
                "description": "Travel insurance for blood donors from our partner VITALITAS pojišťovna a. s. covers medical expenses worldwide for up to 30 days. A copy of your blood donor card showing donations made within the last 12 months is required. ",
                "icon": "briefcase",
                "url": "https://www.zpskoda.cz/pro-darce-krve"
              },
              {
                "type": "Recuperative stay in the Czech Republic for bone marrow and organ donors",
                "benefit": "Up to CZK 10 000 for recuperative stays at one of our partner spa facilities",
                "description": "We contribute up to CZK 10 000 towards a recuperative stay for bone marrow donors and donors of vital organs for transplantation at one of our contracted spa facilities, as selected and agreed with the spa care representative. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "tent",
                "url": "https://www.zpskoda.cz/pro-darce-krve"
              },
              {
                "type": "For donors",
                "benefit": "Up to CZK 5 000 for those who show solidarity with the health of others",
                "description": "We contribute up to CZK 5 000 to blood, bone marrow, and organ donors. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "bloodtest",
                "url": "https://www.zpskoda.cz/pro-darce-krve"
              }
            ]
          },
          {
            "name": "Children",
            "benefitsCount": "26",
            "benefits": [
              {
                "type": "Dental hygiene",
                "benefit": "Up to CZK 1 000 for dental hygiene",
                "description": "We contribute up to CZK 1 000 towards the cost of dental hygiene and other dental care paid for in excess of the basic public health insurance fund. (This does not apply to cosmetic procedures, such as teeth whitening, decorative dental accessories, etc.). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "tooth",
                "url": "https://www.zpskoda.cz/pece-o-chrup"
              },
              {
                "type": "Braces",
                "benefit": "Up to CZK 4 000 for braces",
                "description": "We contribute up to CZK 2 000 for each jaw for fixed orthodontic appliances and invisible braces. This does not apply to removable appliances. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "braces",
                "url": "https://www.zpskoda.cz/pece-o-chrup"
              },
              {
                "type": "Mental health care support",
                "benefit": "Up to CZK 4 000 for mental health care",
                "description": "We contribute up to CZK 4 000 towards psychological or psychotherapeutic counseling provided by a certified specialist in psychology/psychotherapy registered with the Czech Association for Psychotherapy, excluding services covered by health insurance (including online counseling). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.zpskoda.cz/dusevni-zdravi"
              },
              {
                "type": "Recuperative stay for the ill",
                "benefit": "Up to CZK 1 000 for a recuperative stay",
                "description": "We contribute up to CZK 1 000 towards a seaside or mountain health retreat in 2026; the retreat must be booked through a travel agency or tour operator; on the recommendation of a pediatrician or specialist. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "bath",
                "url": "https://www.zpskoda.cz/ozdravne-pobyty"
              },
              {
                "type": "Recuperative stays for clients with chronic skin or respiratory disease",
                "benefit": "Up to CZK 5 000 for a recuperative stay",
                "description": "We contribute up to CZK 5 000 for a health stay in 2026; the stay must be supervised by a medical professional; on the recommendation of a pediatrician or specialist. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "tent",
                "url": "https://www.zpskoda.cz/ozdravne-pobyty"
              },
              {
                "type": "Modern diagnostic and treatment methods",
                "benefit": "Up to CZK 2 000 for various diagnostic and treatment methods",
                "description": "We contribute up to CZK 2 000 toward diagnostic and treatment methods, such as varicose vein surgery (laser), endoscopic carpal tunnel surgery, podiatric examinations, and more. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.zpskoda.cz/mdlm"
              },
              {
                "type": "Contribution towards medical aids for insured persons with diabetes and for diabetic diets",
                "benefit": "Up to CZK 5 000 for diabetic diet and aids",
                "description": "We contribute up to CZK 5,000 once a year towards a diabetic diet and aids for insured persons with diabetes beyond the scope of the basic health insurance. It is necessary to submit a confirmation from the attending physician regarding the necessary diet (we only require this when the contribution is drawn for the first time). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "diabetes",
                "url": "https://www.zpskoda.cz/ostatni"
              },
              {
                "type": "OCT examination",
                "benefit": "Up to CZK 800 for an OCT eye exam",
                "description": "We contribute up to CZK 800 toward OCT eye examinations. Can be provided twice a year. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "eye",
                "url": "https://www.zpskoda.cz/ostatni"
              },
              {
                "type": "Intraocular operations",
                "benefit": "Up to CZK 2 000 for eye operation",
                "description": "We contribute up to CZK 2 000 toward intraocular surgery using multifocal lenses, extended focus lenses, lenses for astigmatism correction, or intraocular lenses (CZK 1 000 per eye). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "eye",
                "url": "https://www.zpskoda.cz/ostatni"
              },
              {
                "type": "Plastic plaster",
                "benefit": "Up to CZK 300 for plastic plaster",
                "description": "We contribute up to CZK 300 towards plastic plaster casts. This contribution can be provided once a year. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.zpskoda.cz/ostatni"
              },
              {
                "type": "Contribution for cancer patients or other seriously ill patients",
                "benefit": "Up to CZK 4 000 for a wig or cooling cap after chemotherapy",
                "description": "We contribute up to CZK 4 000 to our clients who have undergone active oncological treatment (or treatment for other systemic diseases) resulting in hair loss. This can be used once a year to purchase a wig or cooling cap after chemotherapy.",
                "icon": "care",
                "url": "https://www.zpskoda.cz/ostatni"
              },
              {
                "type": "SPORT Junior contribution",
                "benefit": "Up to CZK 800 for physical activities",
                "description": "We contribute up to CZK 800 for physical activities, protective equipment for accident prevention, sports check-ups, sports camps, and sports clubs at school. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "move",
                "url": "https://www.zpskoda.cz/sport"
              },
              {
                "type": "Vaccination against shingles",
                "benefit": "Up to CZK 4 000 for vaccination against shingles",
                "description": "We contribute up to CZK 4 000 toward shingles vaccinations (CZK 2 000 per dose). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.zpskoda.cz/ockovani"
              },
              {
                "type": "Package of other vaccinations",
                "benefit": "Up to CZK 1 000 for vaccination",
                "description": "We contribute up to CZK 1 000 towards various vaccinations that are not covered by public health insurance. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.zpskoda.cz/ockovani"
              },
              {
                "type": "HPV infection",
                "benefit": "Up to CZK 4 000 for vaccination",
                "description": "We contribute up to CZK 4 000 for young people aged 15-18 for vaccination against HPV infection. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.zpskoda.cz/ockovani"
              },
              {
                "type": "Rotavirus infection",
                "benefit": "Up to CZK 3 000 for vaccination",
                "description": "We contribute up to CZK 3 000 for babies under 1 year of age for rotavirus vaccination. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.zpskoda.cz/ockovani"
              },
              {
                "type": "Meningococcus",
                "benefit": "Up to CZK 3 600 for vaccination against meningococus",
                "description": "We contribute up to CZK 3 600 for vaccination against meningococcus. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.zpskoda.cz/ockovani"
              },
              {
                "type": "Hepatitis",
                "benefit": "Up to CZK 2 400 for vaccination",
                "description": "We contribute up to CZK 2 400 for vaccination against hepatitis. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.zpskoda.cz/ockovani"
              },
              {
                "type": "Tick-borne encephalitis",
                "benefit": "Up to CZK 2 100 for vaccination",
                "description": "We contribute up to CZK 2 100 toward tick-borne encephalitis vaccinations for clients under 50 years of age. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.zpskoda.cz/ockovani"
              },
              {
                "type": "Flu",
                "benefit": "Up to CZK 400 for vaccination",
                "description": "We contribute up to CZK 400 towards flu vaccinations for clients under 65 years of age. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.zpskoda.cz/ockovani"
              },
              {
                "type": "Plusoptix examination",
                "benefit": "Up to CZK 200 for an eye examination",
                "description": "The Plusoptix examination contribution can be granted once a year. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "eye",
                "url": "https://www.zpskoda.cz/ostatni"
              },
              {
                "type": "Nutritional counselling support",
                "benefit": "Up to CZK 2 000 for dietary counselling",
                "description": "We contribute up to CZK 2 000 to our clients with a BMI above 30 or below 18.5, a contribution for the preparation of a diet plan by a nutrition therapist, obesity specialist, diabetologist, general practitioner, or nutrition consultant with a valid professional qualification certificate (can also be used for the \"Diabetes Uncovered\" program). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "cabbage",
                "url": "https://www.zpskoda.cz/zdrave-stravovani-metabolicke-poruchy"
              },
              {
                "type": "Low-protein diet and other rare metabolic disorders",
                "benefit": "Up to CZK 12 000 for a low-protein diet",
                "description": "We contribute up to CZK 12 000 to insured persons who have been prescribed a low-protein diet due to a metabolic disorder or specific diagnosis (maple syrup urine disease, homocystinuria, isovaleric aciduria, propionic and methylmalonic aciduria, tyrosinemia, glutaric aciduria type 1, urea cycle disorders). When claiming for the first time, it is necessary to provide confirmation from the attending physician justifying the necessity of this diet. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "nutrition",
                "url": "https://www.zpskoda.cz/zdrave-stravovani-metabolicke-poruchy"
              },
              {
                "type": "Celiac disease",
                "benefit": "Up to CZK 5 000 for a gluten-free diet",
                "description": "We contribute up to CZK 5 000 once a year for a gluten-free diet beyond the scope of the standard health insurance plan. We require a statement from the attending physician regarding the necessary diet (only for the first draw). More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "gluten",
                "url": "https://www.zpskoda.cz/zdrave-stravovani-metabolicke-poruchy"
              },
              {
                "type": "Prevention of thyroid disease",
                "benefit": "Annual contribution",
                "description": "We contribute once a year to blood tests for thyroid hormone levels.",
                "icon": "shield-exclamation-marks",
                "url": "https://www.zpskoda.cz/prevence-zavaznych-onemocneni"
              },
              {
                "type": "A programme for the detection of tumours in the area of the abdominal cavity and the kidneys",
                "benefit": "Annual contribution",
                "description": "We contribute once a year to preventive sonographic examinations of the upper and lower abdomen. The program is intended primarily for insured persons with a positive family history of cancer or at risk of developing this disease. More information (in Czech only) is available on the insurance company's website here: link.",
                "icon": "stop",
                "url": "https://www.zpskoda.cz/prevence-zavaznych-onemocneni"
              }
            ]
          }
        ]
      },
      {
        "slug": "union",
        "updateDate": "30.1.2026",
        "companyBenefitsLink": "https://www.union.sk/vyhody-pre-poistencov/",
        "gendersCount": "3",
        "genders": [
          {
            "name": "Men",
            "benefitsCount": "16",
            "benefits": [
              {
                "type": "Vaccination",
                "benefit": "Contributions of 50 to 100 % of the cost of vaccination",
                "description": "We reimburse our policyholders 50% of the cost of vaccines for several voluntary vaccinations. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.union.sk/ockovanie/"
              },
              {
                "type": "Contribution for artificial insemination",
                "benefit": "Up to EUR 1 200 contribution for artificial insemination",
                "description": "We'll contribute up to EUR 1200 for artificial insemination. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "payment",
                "url": "https://www.union.sk/umele-oplodnenie-union-family/"
              },
              {
                "type": "Contribution to the cost of medicines and dietary foods",
                "benefit": "We will refund up to EUR 300 for medicines and dietary foods",
                "description": "We will reimburse everyone, regardless of age or marital status, for additional payments for medicines and dietary foods up to EUR 300. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "zdravy-talir",
                "url": "https://www.union.sk/vratenie-doplatkov-za-lieky-pre-dospelych"
              },
              {
                "type": "Vision",
                "benefit": "Up to EUR 150 for vision examination",
                "description": "We will contribute up to EUR 150 towards above-standard healthcare at selected eye clinics and the purchase of high-quality glasses. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "eye",
                "url": "https://www.union.sk/ocny-balik/"
              },
              {
                "type": "weLive telephone support for cancer patients and their families",
                "benefit": "Free telephone support",
                "description": "In cooperation with weLive, we offer free telephone support for cancer patients and their families. Discuss your diagnosis and learn about your options and responsibilities. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "digitalni-zdravi",
                "url": "https://www.union.sk/benefit/telefonicka-podpora-welive-pre-onkologickych-pacientov-a-ich-rodiny/"
              },
              {
                "type": "Contribution to joint surgery",
                "benefit": "Up to EUR 3 000 for joint surgery and high-quality professional care at Clinica Orthopedica",
                "description": "If you need hip or knee joint surgery, treat yourself to something above standard. We cover EUR 3 000 for joint surgery and high-quality professional care at Clinica Orthopedica for our policyholders. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "osteoporosis",
                "url": "https://www.union.sk/prispevok-na-operaciu-klbov/"
              },
              {
                "type": "Above-standard OCT eye examination",
                "benefit": "Free examination",
                "description": "An early visit to an eye doctor can save your vision. Many eye diseases are easily treatable if diagnosed early. Don't underestimate the onset of problems. With us, you will receive a special OCT examination – optical coherence tomography – free of charge at selected clinics. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "eye",
                "url": "https://www.union.sk/opticka-koherentna-tomografia/"
              },
              {
                "type": "Discounts on selected commercial insurance policies from Union Insurance Company",
                "benefit": "Discounts of up to 30% on commercial insurance from Union Insurance Company",
                "description": "Union Health Insurance policyholders can get discounts of up to 30% on Union Insurance commercial insurance policies. You can use them right away, whether you're already insured or have just sent in your application. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "globus",
                "url": "https://www.union.sk/zlavy-na-komercne-poistenia/"
              },
              {
                "type": "Contribution for a comprehensive spermiogram examination",
                "benefit": "Up to EUR 100 for a comprehensive spermiogram examination",
                "description": "The Union health insurance company will contribute EUR 100 for a comprehensive spermiogram examination performed by a health services providers - authorized assisted reproduction centres. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "testicles",
                "url": "https://www.union.sk/spermiogram-komplexne-vysetrenie/"
              },
              {
                "type": "Contribution for ICSI (intracytoplasmic sperm injection)",
                "benefit": "A contribution of EUR 200 for ICSI",
                "description": "The Union health insurance company will contribute EUR 200 for intracytoplasmic sperm injection (ICSI) performed by a health services providers - authorized assisted reproduction centres. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "payment",
                "url": "https://www.union.sk/icsi-mikromanipulacna-technika/"
              },
              {
                "type": "Contribution for pre-implant genetic diagnostics",
                "benefit": "A contribution of EUR 900 for pre-implant genetic diagnostics",
                "description": "The Union health insurance company will contribute EUR 900 for pre-implant genetic diagnostics performed by a health services providers - authorized assisted reproduction centres. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "payment",
                "url": "https://www.union.sk/pgd-predimplantacna-geneticka-diagnostika/"
              },
              {
                "type": "Preventive examination for prostate cancer",
                "benefit": "Free examination",
                "description": "A preventive examination performed by a urologist helps detect prostate cancer it its early phase. At Union Health Insurance Company you can have a preventive examination as early as age 40. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "prostate",
                "url": "https://www.union.sk/rakovina-prostaty/"
              },
              {
                "type": "Preventive examination for colon and anal cancer",
                "benefit": "Free examination",
                "description": "Preventive examination for colon and anal cancer More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "rectum",
                "url": "https://www.union.sk/vysetrenie-hrube-crevo-konecnik/"
              },
              {
                "type": "Mental health test for dementia prevention",
                "benefit": "A free mental health test",
                "description": "Alzheimer's disease is one of the most serious diseases destroying memory and mental health. The preventive examination includes a free mental health test. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.union.sk/test-mentalneho-zdravia-ako-prevencia-demencie/"
              },
              {
                "type": "Union discounts",
                "benefit": "Discounts of up to EUR 1 000 per year",
                "description": "Exclusive discounts will save you up to EUR 1 000 per year, making it easier to take care of your health and the health of your loved ones. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "payment",
                "url": "https://www.union.sk/union-zlavy/#volnopredajne-lieky-a-vyzivove-doplnky"
              },
              {
                "type": "More services and benefits for you",
                "benefit": "Many other services, benefits, and discounts",
                "description": "Union Health Insurance Company provides many other services, benefits, and discounts. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "payment",
                "url": "https://www.union.sk/spolocne-za-zdravie-poistencov/"
              }
            ]
          },
          {
            "name": "Women",
            "benefitsCount": "18",
            "benefits": [
              {
                "type": "Vaccination",
                "benefit": "Contributions of 50 to 100 % of the cost of vaccination",
                "description": "We reimburse our policyholders 50% of the cost of vaccines for several voluntary vaccinations. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.union.sk/ockovanie/"
              },
              {
                "type": "Contribution for artificial insemination",
                "benefit": "Up to EUR 1 200 contribution for artificial insemination",
                "description": "We'll contribute up to EUR 1200 for artificial insemination. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "payment",
                "url": "https://www.union.sk/umele-oplodnenie-union-family/"
              },
              {
                "type": "Contribution to the cost of medicines and dietary foods",
                "benefit": "We will refund up to EUR 300 for medicines and dietary foods",
                "description": "We will reimburse everyone, regardless of age or marital status, for additional payments for medicines and dietary foods up to EUR 300. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "pill",
                "url": "https://www.union.sk/vratenie-doplatkov-za-lieky-pre-dospelych"
              },
              {
                "type": "Vision",
                "benefit": "Up to EUR 150 for vision examination",
                "description": "We will contribute up to EUR 150 towards above-standard healthcare at selected eye clinics and the purchase of high-quality glasses. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "eye",
                "url": "https://www.union.sk/ocny-balik/"
              },
              {
                "type": "weLive telephone support for cancer patients and their families",
                "benefit": "Free telephone support",
                "description": "In cooperation with weLive, we offer free telephone support for cancer patients and their families. Discuss your diagnosis and learn about your options and responsibilities. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "digitalni-zdravi",
                "url": "https://www.union.sk/benefit/telefonicka-podpora-welive-pre-onkologickych-pacientov-a-ich-rodiny/"
              },
              {
                "type": "Contribution to joint surgery",
                "benefit": "Up to EUR 3 000 for joint surgery and high-quality professional care at Clinica Orthopedica",
                "description": "If you need hip or knee joint surgery, treat yourself to something above standard. We cover EUR 3 000 for joint surgery and high-quality professional care at Clinica Orthopedica for our policyholders. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "osteoporosis",
                "url": "https://www.union.sk/prispevok-na-operaciu-klbov/"
              },
              {
                "type": "Above-standard OCT eye examination",
                "benefit": "Free examination",
                "description": "An early visit to an eye doctor can save your vision. Many eye diseases are easily treatable if diagnosed early. Don't underestimate the onset of problems. With us, you will receive a special OCT examination – optical coherence tomography – free of charge at selected clinics. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "eye",
                "url": "https://www.union.sk/opticka-koherentna-tomografia/"
              },
              {
                "type": "Discounts on selected commercial insurance policies from Union Insurance Company",
                "benefit": "Discounts of up to 30% on commercial insurance from Union Insurance Company",
                "description": "Union Health Insurance policyholders can get discounts of up to 30% on Union Insurance commercial insurance policies. You can use them right away, whether you're already insured or have just sent in your application. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "globus",
                "url": "https://www.union.sk/zlavy-na-komercne-poistenia/"
              },
              {
                "type": "Contribution for ICSI (intracytoplasmic sperm injection)",
                "benefit": "A contribution of EUR 200 for ICSI",
                "description": "The Union health insurance company will contribute EUR 200 for intracytoplasmic sperm injection (ICSI) performed by a health services providers - authorized assisted reproduction centres. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "payment",
                "url": "https://www.union.sk/icsi-mikromanipulacna-technika/"
              },
              {
                "type": "Contribution for pre-implant genetic diagnostics",
                "benefit": "A contribution of EUR 900 for pre-implant genetic diagnostics",
                "description": "The Union health insurance company will contribute EUR 900 for pre-implant genetic diagnostics performed by a health services providers - authorized assisted reproduction centres. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "payment",
                "url": "https://www.union.sk/pgd-predimplantacna-geneticka-diagnostika/"
              },
              {
                "type": "Preventive examination for colon and anal cancer",
                "benefit": "Free examination",
                "description": "Preventive examination for colon and anal cancer More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "rectum",
                "url": "https://www.union.sk/vysetrenie-hrube-crevo-konecnik/"
              },
              {
                "type": "A birth assistant in your home",
                "benefit": "A birth assistant in your home, completely free",
                "description": "The Union health insurance company will completely cover the services of a licensed assistant. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.union.sk/vyhody-porodna-asistencia/"
              },
              {
                "type": "Mental health test for dementia prevention",
                "benefit": "A free mental health test",
                "description": "Alzheimer's disease is one of the most serious diseases destroying memory and mental health. The preventive examination includes a free mental health test. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.union.sk/test-mentalneho-zdravia-ako-prevencia-demencie/"
              },
              {
                "type": "Union discounts",
                "benefit": "Discounts of up to EUR 1 000 per year",
                "description": "Exclusive discounts will save you up to EUR 1 000 per year, making it easier to take care of your health and the health of your loved ones. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "payment",
                "url": "https://www.union.sk/union-zlavy/#volnopredajne-lieky-a-vyzivove-doplnky"
              },
              {
                "type": "BRCA screening test for genetic predisposition to breast cancer",
                "benefit": "A test for genetic predisposition for breast cancer, worth EUR 145, free of charge",
                "description": "We will reimburse you for a special BRCA screening test that will reliably reveal breast cancer predisposition. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "ribbon",
                "url": "https://www.union.sk/brcascreen-test-na-zistenie-dna-predispozicie-k-rakovine-prsnika/"
              },
              {
                "type": "More services and benefits for you",
                "benefit": "Many other services, benefits, and discounts",
                "description": "Union Health Insurance Company provides many other services, benefits, and discounts. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "payment",
                "url": "https://www.union.sk/spolocne-za-zdravie-poistencov/"
              },
              {
                "type": "Liquid Based Cytology (LBC) test for cervical cancer prevention",
                "benefit": "One free LBC swab test per year",
                "description": "Cytological examination by the LBC method, which can also detect early stages of cervical cancer, indicated by a contracted gynaecologist once a year free of charge. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "ribbon",
                "url": "https://www.union.sk/vysetrenie-lbc-bez-doplatku/"
              },
              {
                "type": "A contribution for a baby breathing monitor",
                "benefit": "We will contribute €30 towards the purchase of a baby breathing monitor.",
                "description": "The breath monitor watches over your baby's sleep even when you are taking a well-deserved rest. We will contribute EUR 30 towards the purchase of your own device for monitoring your newborn's breathing. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.union.sk/monitor-dychu/"
              }
            ]
          },
          {
            "name": "Children",
            "benefitsCount": "11",
            "benefits": [
              {
                "type": "Vaccination",
                "benefit": "Contributions of 50 to 100 % of the cost of vaccination",
                "description": "We reimburse our policyholders 50% of the cost of vaccines for several voluntary vaccinations. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.union.sk/ockovanie/"
              },
              {
                "type": "Vision",
                "benefit": "Up to EUR 150 for vision examination",
                "description": "We will contribute up to EUR 150 towards above-standard healthcare at selected eye clinics and the purchase of high-quality glasses. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "eye",
                "url": "https://www.union.sk/ocny-balik/"
              },
              {
                "type": "Contribution towards prescription glasses for children",
                "benefit": "Up to EUR 70 for prescription glasses for children",
                "description": "Children's eyesight is constantly developing, and early detection of problems and proper correction are key. That's why we will contribute EUR 70 towards the purchase of glasses for your child under the age of 18 every year. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "glasses",
                "url": "https://www.union.sk/pomozeme-vam-s-doplatkom-na-okuliarove-ramy/"
              },
              {
                "type": "Discount on the purchase of Pampers diapers",
                "benefit": "Up to EUR 300 toward the purchase of Pampers diapers",
                "description": "Discount on Pampers premium diapers worth a total of 300 euros.\n The contribution is split into monthly contributions of EUR 10-25 for the purchase of diapers. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "payment",
                "url": "https://www.union.sk/prispevok-na-plienky-pampers/"
              },
              {
                "type": "Contribution towards infant milk, complementary foods, and HiPP cosmetics",
                "benefit": "Up to EUR 150 for HiPP baby milk, baby food and cosmetics",
                "description": "We will contribute more than €150 towards baby milk, baby food, drinks, and HiPP brand cosmetics for children insured with our Union Health Insurance Company. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "payment",
                "url": "https://www.union.sk/prispevok-na-hipp/"
              },
              {
                "type": "Contribution to a swimming course for your baby",
                "benefit": "Up to EUR 30 for swimming lessons ",
                "description": "Union Health Insurance Company will contribute up to EUR 30 for a swimming course for your baby. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "move",
                "url": "https://www.union.sk/prispevok-babatka/"
              },
              {
                "type": "Additional payments for medicines and dietetic foods without limit",
                "benefit": "We will reimburse co-payments for medicines and dietetic foods without limitation ",
                "description": "We will reimburse children under 18 for additional payments for medicines and dietary foods without restriction. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "pill",
                "url": "https://www.union.sk/vratenie-doplatkov-za-lieky-pre-deti/"
              },
              {
                "type": "Discount at MamaClass.sk",
                "benefit": "30% discount at MamaClass.sk",
                "description": "Gain more confidence in motherhood and find reliable answers to all your questions about pregnancy, childbirth, and baby care. We offer a discount of up to 30% on access to online classes at MamaClass.sk. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "pregnant",
                "url": "https://www.union.sk/materstvo-online-informacie-premamicky-na-portali-mamaclass/"
              },
              {
                "type": "The book Our Baby ",
                "benefit": "A memento of your first memories together",
                "description": "The book Our Baby is a keepsake that will help you record all the important moments in your baby's life. Every pregnant woman receives it as a gift. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "child-photo",
                "url": "https://www.union.sk/registracia-knizka-nase-dietatko/"
              },
              {
                "type": "Discounts on summer stays for children with posture disorders",
                "benefit": "Up to 100% discount on summer camps for children with posture disorders",
                "description": "Our child policyholders receive a 100% discount on the additional fee for a week-long summer recovery stay and a €35 discount on the additional fee for a daily recovery stay. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "tent",
                "url": "https://www.union.sk/pobyty-pre-deti-s-poruchami-drzania-tela/"
              },
              {
                "type": "More services and benefits for you",
                "benefit": "Many other services, benefits, and discounts",
                "description": "Union Health Insurance Company provides many other services, benefits, and discounts. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "payment",
                "url": "https://www.union.sk/spolocne-za-zdravie-poistencov/"
              }
            ]
          }
        ]
      },
      {
        "slug": "dovera",
        "updateDate": "2.2.2026",
        "companyBenefitsLink": "https://www.dovera.sk/poistenec/preco-byt-v-dovere",
        "gendersCount": "3",
        "genders": [
          {
            "name": "Men",
            "benefitsCount": "26",
            "benefits": [
              {
                "type": "Mental health support",
                "benefit": "Up to EUR 40 for an on-line consultation with a psychologist",
                "description": "Once per calendar year, you can redeem a discount coupon for online consultations worth EUR 40. With our partner Mojra, you can also take advantage of a 12% discount on any two sessions after using this coupon. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/podpora-dusevneho-zdravia"
              },
              {
                "type": "Remote doctor",
                "benefit": "Free remote consultation with a doctor",
                "description": "Don't spend hours in the waiting room. With the MEDDI app, you can conveniently address your health questions remotely, even in the evening or on weekends. Keep the app handy whenever you need expert advice. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "doctor",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/lekar-na-dialku"
              },
              {
                "type": "Discount on glasses and an eye exam",
                "benefit": "Discounts at FOKUS opticians",
                "description": "Up to 90% of all our perceptions come through our eyesight. We help you take care of your eyes. We offer adult policyholders discounts on the manufacture and repair of prescription glasses and comprehensive eye examinations at FOKUS opticians. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "glasses",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/zlavy-na-okuliare-a-vysetrenie-zraku"
              },
              {
                "type": "Online skin examination for free",
                "benefit": "Online skin examination for free",
                "description": "Do you have acne or another skin problem? Take a photo and send it quickly and securely to a doctor. A dermatologist will diagnose you and recommend treatment within 3 business days. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "dermatology",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/kozne-vysetrenie-online-a-zadarmo"
              },
              {
                "type": "Free online physical examination",
                "benefit": "Free online physical examination",
                "description": "Back, muscle, or joint pain – we've all been there. We can help you from the comfort of your own home. Describe your problem and a doctor will recommend treatment or exercises within 3 business days. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "running",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/fyzio-vysetrenie-online-a-zadarmo"
              },
              {
                "type": "Healthy teeth",
                "benefit": "We will contribute EUR 30 twice to adults for dental hygiene.",
                "description": "We will contribute EUR 30 twice to adults for dental hygiene. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "tooth",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/zdrave-zuby-pre-dospelych-aj-deti"
              },
              {
                "type": "Contribution to voluntary vaccination",
                "benefit": "Contribution for various types of vaccinations",
                "description": "We reimburse our policyholders for several voluntary vaccinations, such as against influenza, ticks, and HPV. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/prispejeme-vam-na-dobrovolne-ockovanie#tabpanel-ockovanie_1"
              },
              {
                "type": "Discount on eye surgery",
                "benefit": "Contribution of 500 eur for laser eye surgery",
                "description": "Want to enjoy life without glasses or contacts? Improve your vision with iLasik laser eye surgery. We offer Dôvera insurance policyholders a EUR 500 discount on laser surgery at the VESELY Eye Clinic. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "eye",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/zlava-500-eur-na-laserovu-operaciu-oci"
              },
              {
                "type": "Priority appointments for MRI, X-ray, ultrasound, and mammography",
                "benefit": "Priority appointments for MRI, X-ray, ultrasound, and mammography",
                "description": "Do you need to go for an MRI, X-ray, ultrasound, or mammogram? As a Dôvera policyholder, you can get a quick appointment at the Bezručova Polyclinic in Bratislava. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "calendar-previous",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/prednostne-objednanie-na-mr-rtg-sono-a-mamografiu"
              },
              {
                "type": "Transport to Bory Hospital",
                "benefit": "We will arrange free transportation to Bory Hospital in Bratislava for your hospitalization.",
                "description": "Are you awaiting surgery or another procedure and would like to have it done at one of the most modern hospitals in Central Europe? We will arrange free transportation to Bory Hospital in Bratislava for your hospitalization. Free transportation back home is also a matter of course. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "hospital",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/doprava-do-nemocnice-bory"
              },
              {
                "type": "Self-diagnostic tool",
                "benefit": "The self-diagnostic tool is free of charge for Dôvera policyholders.",
                "description": "Are you feeling unwell, experiencing mental distress, and your doctor is not available? Try the self-diagnostic tool, which is free for Dôvera policyholders. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/samodiagnosticky-nastroj"
              },
              {
                "type": "Discounts on stays at spas",
                "benefit": "Up to 70% discount on stays at Moderné kúpele Turčianske Teplice",
                "description": "You will pay less for relaxation and better health. We offer selected spa stays at Moderné kúpele Turčianske Teplice with a discount of up to 70% for Dôvera insurance policyholders. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "bath",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/zlavy-na-pobyty-v-modernych-kupeloch-turcianske-teplice"
              },
              {
                "type": "Discount on online therapy",
                "benefit": "Discount on online therapy with Mojra, Hedepy, and ksebe",
                "description": "Discount on online therapy with Mojra, Hedepy, and ksebe. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "phone-video",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/podpora-dusevneho-zdravia"
              },
              {
                "type": "Discounts on travel insurance from Generali",
                "benefit": "Discounts of up to 30% on travel insurance from Generali",
                "description": "Discounts of up to 30% on travel insurance from Generali. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "suitcase",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/zlavy-az-30-na-cestovne-poistenie"
              },
              {
                "type": "Allowance with a non-contractual doctor",
                "benefit": "We will reimburse you up to 80% for treatment at a non-contractual doctor",
                "description": "Do you need to see a doctor who does not have a contract with us? We will refund you 80% of the usual price, i.e. of the price we would pay the contracted doctor for the given examination. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "two-doctors",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/prispevok-az-80-u-nezmluvneho-lekara"
              },
              {
                "type": "Discount on spa stays",
                "benefit": "Discount up to 13% on spa stays",
                "description": "Leave your worries behind for a while and relax with Dôvera in the spa. With us, you can enjoy a therapeutic stay in the most important Slovak spas with a discount of up to 13%. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "bath",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/lacnejsie-kupele"
              },
              {
                "type": "Education for people with chronic illness",
                "benefit": "Free education for people with chronic illness",
                "description": "Do you have high blood pressure, diabetes, overweight, obesity or are you being treated for heart failure? Join the program and get non-medical education for free. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "webinar",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/poradenstvo-a-vzdelavanie-zdarma"
              },
              {
                "type": "Discount on online training program",
                "benefit": "30% discount on online training program",
                "description": "For supporters of a healthy lifestyle or for those who want to do something extra for their health, we have an interesting offer. Try the LIVE PLUS training program under the guidance of professional trainer Jany Landl and healthy, custom-made meals.  More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "muscle",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/zlava-30-na-online-treningovy-program"
              },
              {
                "type": "Discount on DNA tests",
                "benefit": "Discounts of up to EUR 800 on DNA tests",
                "description": "Discounts of up to EUR 800 on DNA tests. Would you like to know more about how your body works? DNA analysis can help you identify potential health risks, better understand how your body works, and discover your athletic potential. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "genes",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/zlava-az-do-800-eur-na-dna-testy"
              },
              {
                "type": "A free colon cancer examination",
                "benefit": "A free fecal occult (hidden) bleeding test",
                "description": "A fecal occult bleeding test can detect cancer before it truly starts. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "rectum",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/bezplatne-vysetrenie-rakoviny-hrubeho-creva"
              },
              {
                "type": "Discount on tests from Unilabs Slovakia",
                "benefit": "20% discount on tests from Unilabs Slovakia",
                "description": "20% discount on tests from Unilabs Slovakia. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "bloodtest",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/zlava-20-na-testy-od-unilabs-slovensko"
              },
              {
                "type": "We help to have a healthy heart",
                "benefit": "Dôvera helps to a healthy heart",
                "description": "Heart problems can affect us at any age. They cause short-term and long-term complications, but can be treated with proper lifestyle. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "heart",
                "url": "https://www.dovera.sk/srdce/uvod"
              },
              {
                "type": "We help with overweight and obesity",
                "benefit": "Dôvera helps with overweight",
                "description": "Change your lifestyle and support your health. We will help you navigate the changes you face in order to reach and maintain your goal.  More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "weight",
                "url": "https://www.dovera.sk/nadvaha/uvod"
              },
              {
                "type": "We help diabetics",
                "benefit": "The DôveraPomáha [TrustHelps] programme, free for diabetics",
                "description": "Our experts will teach you for free how to live a better life with diabetes. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "diabetes",
                "url": "https://www.dovera.sk/lepsizivotscukrovkou/uvod"
              },
              {
                "type": "Discounts for everyone",
                "benefit": "A broad range of discounts for everyone",
                "description": "Our broad range of discounts has something for everyone. Seniors, families, and young people. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "payment",
                "url": "https://www.dovera.sk/poistenec/preco-byt-v-dovere/zlavy"
              },
              {
                "type": "Benefits for blood donors",
                "benefit": "Vitamin supplements worth approximately €20 and discounts of up to 25% on spa stays",
                "description": "We value blood donors and take care of their health. Each of them can receive two vitamin supplements worth approximately €20 and discounts of up to 25% on a stay in the spa. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "bloodtest",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/vyhody-pre-darcov-krvi"
              }
            ]
          },
          {
            "name": "Women",
            "benefitsCount": "28",
            "benefits": [
              {
                "type": "A free Liquid Based Cytology (LBC) test performed by a gynaecologist",
                "benefit": "Free examination",
                "description": "For all women who go to a gynaecologist for a regular preventive examination. The LBC method is used to detect cancer. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "vulva",
                "url": "https://www.dovera.sk/poistenec/benefity/vsetky/cytologicke-vysetrenie-lbc-u-gynekologa-bezplatne"
              },
              {
                "type": "Discount on lactation consultation",
                "benefit": "Up to 25% discount on lactation consultation",
                "description": "Use the services of a lactation consultant and improve your breastfeeding technique. Experts from the We Care Center will advise you with a discount. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "birth",
                "url": "https://www.dovera.sk/poistenec/benefity/rodina/zlava-na-laktacne-poradenstvo-vanickovanie-a-baby-masaze"
              },
              {
                "type": "Remote doctor",
                "benefit": "Free remote consultation with a doctor",
                "description": "Don't spend hours in the waiting room. With the MEDDI app, you can conveniently address your health questions remotely, even in the evening or on weekends. Keep the app handy whenever you need expert advice. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "doctor",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/lekar-na-dialku"
              },
              {
                "type": "Discount on glasses and an eye exam",
                "benefit": "Discounts at FOKUS opticians",
                "description": "Up to 90% of all our perceptions come through our eyesight. We help you take care of your eyes. We offer adult policyholders discounts on the manufacture and repair of prescription glasses and comprehensive eye examinations at FOKUS opticians. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "glasses",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/zlavy-na-okuliare-a-vysetrenie-zraku"
              },
              {
                "type": "Online skin examination for free",
                "benefit": "Online skin examination for free",
                "description": "Do you have acne or another skin problem? Take a photo and send it quickly and securely to a doctor. A dermatologist will diagnose you and recommend treatment within 3 business days. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "dermatology",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/kozne-vysetrenie-online-a-zadarmo"
              },
              {
                "type": "Free online physical examination",
                "benefit": "Free online physical examination",
                "description": "Back, muscle, or joint pain – we've all been there. We can help you from the comfort of your own home. Describe your problem and a doctor will recommend treatment or exercises within 3 business days. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "running",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/fyzio-vysetrenie-online-a-zadarmo"
              },
              {
                "type": "Healthy teeth",
                "benefit": "We will contribute EUR 30 twice to adults for dental hygiene.",
                "description": "We will contribute EUR 30 twice to adults for dental hygiene. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "tooth",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/zdrave-zuby-pre-dospelych-aj-deti"
              },
              {
                "type": "Contribution to voluntary vaccination",
                "benefit": "Contribution for various types of vaccinations",
                "description": "We reimburse our policyholders for several voluntary vaccinations, such as against influenza, ticks, and HPV. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/prispejeme-vam-na-dobrovolne-ockovanie#tabpanel-ockovanie_1"
              },
              {
                "benefit": "Contribution of 500 eur for laser eye surgery",
                "description": "Want to enjoy life without glasses or contacts? Improve your vision with iLasik laser eye surgery. We offer Dôvera insurance policyholders a EUR 500 discount on laser surgery at the VESELY Eye Clinic. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "eye",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/zlava-500-eur-na-laserovu-operaciu-oci"
              },
              {
                "type": "Priority appointments for MRI, X-ray, ultrasound, and mammography",
                "benefit": "Priority appointments for MRI, X-ray, ultrasound, and mammography",
                "description": "Do you need to go for an MRI, X-ray, ultrasound, or mammogram? As a Dôvera policyholder, you can get a quick appointment at the Bezručova Polyclinic in Bratislava. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "calendar-previous",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/prednostne-objednanie-na-mr-rtg-sono-a-mamografiu"
              },
              {
                "type": "Transport to Bory Hospital",
                "benefit": "We will arrange free transportation to Bory Hospital in Bratislava for your hospitalization.",
                "description": "Are you awaiting surgery or another procedure and would like to have it done at one of the most modern hospitals in Central Europe? We will arrange free transportation to Bory Hospital in Bratislava for your hospitalization. Free transportation back home is also a matter of course. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "hospital",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/doprava-do-nemocnice-bory"
              },
              {
                "type": "Self-diagnostic tool",
                "benefit": "The self-diagnostic tool is free of charge for Dôvera policyholders.",
                "description": "Are you feeling unwell, experiencing mental distress, and your doctor is not available? Try the self-diagnostic tool, which is free for Dôvera policyholders. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/samodiagnosticky-nastroj"
              },
              {
                "type": "Mental health support",
                "benefit": "Up to EUR 40 for an on-line consultation with a psychologist",
                "description": "Once per calendar year, you can redeem a discount coupon for online consultations worth EUR 40. With our partner Mojra, you can also take advantage of a 12% discount on any two sessions after using this coupon. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/podpora-dusevneho-zdravia"
              },
              {
                "type": "Discounts on stays at spas",
                "benefit": "Up to 70% discount on stays at Moderné kúpele Turčianske Teplice",
                "description": "You will pay less for relaxation and better health. We offer selected spa stays at Moderné kúpele Turčianske Teplice with a discount of up to 70% for Dôvera insurance policyholders. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "bath",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/zlavy-na-pobyty-v-modernych-kupeloch-turcianske-teplice"
              },
              {
                "type": "Discount on online therapy",
                "benefit": "Discount on online therapy with Mojra, Hedepy, and ksebe",
                "description": "Discount on online therapy with Mojra, Hedepy, and ksebe. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "phone-video",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/podpora-dusevneho-zdravia"
              },
              {
                "type": "Discounts on travel insurance from Generali",
                "benefit": "Discounts of up to 30% on travel insurance from Generali",
                "description": "Discounts of up to 30% on travel insurance from Generali. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "suitcase",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/zlavy-az-30-na-cestovne-poistenie"
              },
              {
                "type": "Allowance with a non-contractual doctor",
                "benefit": "We will reimburse you up to 80% for treatment at a non-contractual doctor",
                "description": "Do you need to see a doctor who does not have a contract with us? We will refund you 80% of the usual price, i.e. of the price we would pay the contracted doctor for the given examination. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "two-doctors",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/prispevok-az-80-u-nezmluvneho-lekara"
              },
              {
                "type": "Discount on spa stays",
                "benefit": "Discount up to 13% on spa stays",
                "description": "Leave your worries behind for a while and relax with Dôvera in the spa. With us, you can enjoy a therapeutic stay in the most important Slovak spas with a discount of up to 13%. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "bath",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/lacnejsie-kupele"
              },
              {
                "type": "Education for people with chronic illness",
                "benefit": "Free education for people with chronic illness",
                "description": "Do you have high blood pressure, diabetes, overweight, obesity or are you being treated for heart failure? Join the program and get non-medical education for free. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "webinar",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/poradenstvo-a-vzdelavanie-zdarma"
              },
              {
                "type": "Discount on online training program",
                "benefit": "30% discount on online training program",
                "description": "For supporters of a healthy lifestyle or for those who want to do something extra for their health, we have an interesting offer. Try the LIVE PLUS training program under the guidance of professional trainer Jany Landl and healthy, custom-made meals.  More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "muscle",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/zlava-30-na-online-treningovy-program"
              },
              {
                "type": "Discount on DNA tests",
                "benefit": "Discounts of up to EUR 800 on DNA tests",
                "description": "Discounts of up to EUR 800 on DNA tests. Would you like to know more about how your body works? DNA analysis can help you identify potential health risks, better understand how your body works, and discover your athletic potential. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "genes",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/zlava-az-do-800-eur-na-dna-testy"
              },
              {
                "type": "A free colon cancer examination",
                "benefit": "A free fecal occult (hidden) bleeding test",
                "description": "A fecal occult bleeding test can detect cancer before it truly starts. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "rectum",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/bezplatne-vysetrenie-rakoviny-hrubeho-creva"
              },
              {
                "type": "Discount on tests from Unilabs Slovakia",
                "benefit": "20% discount on tests from Unilabs Slovakia",
                "description": "20% discount on tests from Unilabs Slovakia. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "bloodtest",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/zlava-20-na-testy-od-unilabs-slovensko"
              },
              {
                "type": "We help to have a healthy heart",
                "benefit": "Dôvera helps to a healthy heart",
                "description": "Heart problems can affect us at any age. They cause short-term and long-term complications, but can be treated with proper lifestyle. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "heart",
                "url": "https://www.dovera.sk/srdce/uvod"
              },
              {
                "type": "We help with overweight and obesity",
                "benefit": "Dôvera helps with overweight",
                "description": "Change your lifestyle and support your health. We will help you navigate the changes you face in order to reach and maintain your goal.  More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "weight",
                "url": "https://www.dovera.sk/nadvaha/uvod"
              },
              {
                "type": "We help diabetics",
                "benefit": "The DôveraPomáha [TrustHelps] programme, free for diabetics",
                "description": "Our experts will teach you for free how to live a better life with diabetes. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "diabetes",
                "url": "https://www.dovera.sk/lepsizivotscukrovkou/uvod"
              },
              {
                "type": "Discounts for everyone",
                "benefit": "A broad range of discounts for everyone",
                "description": "Our broad range of discounts has something for everyone. Seniors, families, and young people. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "payment",
                "url": "https://www.dovera.sk/poistenec/preco-byt-v-dovere/zlavy"
              },
              {
                "type": "Benefits for blood donors",
                "benefit": "Vitamin supplements worth approximately €20 and discounts of up to 25% on spa stays",
                "description": "We value blood donors and take care of their health. Each of them can receive two vitamin supplements worth approximately €20 and discounts of up to 25% on a stay in the spa. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "bloodtest",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/vyhody-pre-darcov-krvi"
              }
            ]
          },
          {
            "name": "Children",
            "benefitsCount": "14",
            "benefits": [
              {
                "type": "Reimbursement of medication surcharges",
                "benefit": "Up to EUR 300 for each family member",
                "description": "We reimburse surcharges for categorized medications and dietary foods prescribed by a doctor, partly covered by health insurance, and billed to the insurance company. This means for medications where the patient pays the remainder. These include: frequently prescribed medications, multiple antibiotics, allergy medications, vaccines, dietary foods (including infant formula). More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "pill",
                "url": "https://www.dovera.sk/poistenec/benefity/vsetky/vratime-az-300-eur-za-lieky-rodicom-aj-detom"
              },
              {
                "type": "New glasses",
                "benefit": "Up to EUR 100 for new glasses",
                "description": "We'll contribute once a year for glasses for children up to the age of 18. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "glasses",
                "url": "https://www.dovera.sk/poistenec/benefity/vsetky/detom-do-18-rokov-prispejeme-70-eur-na-nove-okuliare"
              },
              {
                "type": "Discounts for everyone",
                "benefit": "A broad range of discounts for everyone",
                "description": "Our broad range of discounts has something for everyone. Seniors, families, and young people. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "payment",
                "url": "https://www.dovera.sk/poistenec/preco-byt-v-dovere/zlavy"
              },
              {
                "type": "Discount on lactation consultation",
                "benefit": "Up to 25% discount on lactation consultation",
                "description": "Use the services of a lactation consultant and improve your breastfeeding technique. Experts from the We Care Center will advise you with a discount. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "birth",
                "url": "https://www.dovera.sk/poistenec/benefity/rodina/zlava-na-laktacne-poradenstvo-vanickovanie-a-baby-masaze"
              },
              {
                "type": "A gift for the littlest ones",
                "benefit": "A BabyBox full of cosmetics and other products for both mothers and children, worth EUR 80",
                "description": "Our gift bag is for our littlest clients, up to the age of 2. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "birth",
                "url": "https://www.dovera.sk/poistenec/benefity/vsetky/darcek-pre-najmensich-za-80-eur"
              },
              {
                "type": "Self-diagnostic tool",
                "benefit": "The self-diagnostic tool is free of charge for Dôvera policyholders.",
                "description": "Are you feeling unwell, experiencing mental distress, and your doctor is not available? Try the self-diagnostic tool, which is free for Dôvera policyholders. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/samodiagnosticky-nastroj"
              },
              {
                "type": "Remote doctor",
                "benefit": "Free remote consultation with a doctor",
                "description": "Don't spend hours in the waiting room. With the MEDDI app, you can conveniently address your health questions remotely, even in the evening or on weekends. Keep the app handy whenever you need expert advice. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "doctor",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/lekar-na-dialku"
              },
              {
                "type": "Online skin examination for free",
                "benefit": "Online skin examination for free",
                "description": "Do you have acne or another skin problem? Take a photo and send it quickly and securely to a doctor. A dermatologist will diagnose you and recommend treatment within 3 business days. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "dermatology",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/kozne-vysetrenie-online-a-zadarmo"
              },
              {
                "type": "Nutrition for children from the brands Hami and Nutrilon",
                "benefit": "Discount on nutrition for children from the brands Hami and Nutrilon",
                "description": "Quality nutrition is the basis for the proper development of the child. For Dôvera policyholders, we have a discount on the purchase of selected infant milks, porridges and snacks from the Hami and Nutrilon brands. You can redeem it in the e-shop Dr. Max. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "child-photo",
                "url": "https://www.dovera.sk/poistenec/benefity/babatko/zlava-na-vyzivu-pre-deti-od-znaciek-hami-a-nutrilon"
              },
              {
                "type": "Discount on Sudocrem, Bepanthen and Kamistad products",
                "benefit": "Discount up to 20% on Sudocrem, Bepanthen and Kamistad products",
                "description": "Children's skin requires sensitive care. Dôvera policyholders can use a discount on the purchase of selected products of the Sudocrem, Bepanthen and Kamistad brands in the e-shop and in the Dr. Max. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "payment",
                "url": "https://www.dovera.sk/poistenec/benefity/babatko/zlava-do-20-na-produkty-sudocrem-bepanthen-a-kamistad"
              },
              {
                "type": "Discount on products for newborns from the NUK brand",
                "benefit": "20% discount on products for newborns from the NUK brand",
                "description": "Every day with a baby is full of new challenges. With high-quality children's equipment, you can handle them more easily. For Dôvera policyholders, we have a 20% discount on all NUK brand products in the Dr. Max. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "payment",
                "url": "https://www.dovera.sk/poistenec/benefity/babatko/zlava-20-na-produkty-pre-novorodencov-od-znacky-nuk"
              },
              {
                "type": "Discount on the purchase of a sports stroller and car seat",
                "benefit": "15% discount on the purchase of a sports stroller and car seat",
                "description": "When your baby starts exploring the world, it's time to change both the car seat and the stroller. Our policyholders can buy them online or in brick-and-mortar Feedo stores with a discount. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "payment",
                "url": "https://www.dovera.sk/poistenec/benefity/babatko/zlava-15-na-nakup-sportoveho-kocika-a-autosedacky"
              },
              {
                "type": "Discount on the purchase of baby gear",
                "benefit": "15% discount on the purchase of baby gear",
                "description": "First stroller, car seat, breastfeeding aids. With the arrival of a baby, there are expenses that cannot be avoided. However, parents need much more for their child's safety and comfort. In cooperation with the Feedo brand, we offer our policyholders a discount on the purchase of their first piece of equipment online and in brick-and-mortar stores. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "birth",
                "url": "https://www.dovera.sk/poistenec/benefity/babatko/zlava-15-na-nakup-vybavicky-pre-babatko"
              },
              {
                "type": "Healthy teeth",
                "benefit": "We will contribute €5 x €30 to the children for sealing, treatment of tooth decay and dental hygiene",
                "description": "We will contribute €5 x €30 to the children for sealing, treatment of tooth decay and dental hygiene More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "tooth",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/zdrave-zuby-pre-dospelych-aj-deti"
              }
            ]
          }
        ]
      },
      {
        "genders": [
          {
            "name": "Men",
            "benefitsCount": "22",
            "benefits": [
              {
                "type": "Invisible braces ",
                "benefit": "A 22 % discount on invisible braces",
                "description": "Up to 22% discount on invisible braces + Dental monitoring at Family Dental Care - Ortho. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "tooth",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/zlava-neviditelny-zubny-strojcek-vo-family-dental-care-ortho.html"
              },
              {
                "type": "Discount on glasses",
                "benefit": "Up to 35% discount on glasses at selected branches",
                "description": "Up to 35% discount on glasses at selected branches. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "glasses",
                "url": "https://www.vszp.sk/benefity/?dospeli&checked0=490"
              },
              {
                "type": "Proton treatment for cancer patients",
                "benefit": "Treatment covered by insurance",
                "description": "Proton treatment is used primarily for tumours of the brain, head, and neck (tumours of the eye, nasal passages, parotid glands), tumours of the breast, prostate, and pancreas, and tumours in children. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "ribbon",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/protonova-liecba-onkologickych-pacientov.html"
              },
              {
                "type": "Occult bleeding test",
                "benefit": "An occult bleeding test starting at age 40 for free",
                "description": "A preventive examination that focuses on detecting hidden bleeding in the stool, which can help in early detection of colon and anal cancer. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "rectum",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/test-okultne-krvacanie-od-40-rokov-zdarma.html"
              },
              {
                "type": "Stroke Risk Assessment",
                "benefit": "Examination covered by insurance",
                "description": "Risk assessment for stroke covered by insurance. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "brain",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/vysetrenie-rizika-vzniku-cievnej-mozgovej-prihody.html"
              },
              {
                "type": "Ankle Brachial Index (ABI Test) - measurement of the ratio of blood pressure in the arms and legs",
                "benefit": "We pay for this test once every two years during a preventive check-up",
                "description": "This test plays an important part in the early diagnosis of peripheral vascular disease, and predicts the likelihood of heart attacks or strokes. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "heart-attack",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/stanovenie-pomeru-krvneho-tlaku-nohe-aruke-abi-index.html"
              },
              {
                "type": "Treatment of patients with high blood pressure by a general practitioner",
                "benefit": "Care provided directly by a GP",
                "description": "The patient doesn't need to wait for or make an appointment with a specialist; their GP will arrange diagnosis and treatment of selected groups of patients with hypertension. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "heart-attack",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/starostlivost-opacientov-svysokym-krvnym-tlakom-vambulancii-vseobecneho-lekara.html"
              },
              {
                "type": "Diagnosis and treatment of fat metabolism disorders by a general practitioner",
                "benefit": "Care provided directly by a GP",
                "description": "General practitioners also provide our clients with diagnosis and treatment of fat metabolism disorders without the need to make an appointment with a specialist. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "blood-fat",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/diagnostika-aliecbaporuchy-metabolizmu-tukov-vseobecneho-lekara.html"
              },
              {
                "type": "Preventive urology examination for men aged 40 and up",
                "benefit": "A free urology examination for men aged 40 and up",
                "description": "VšZP focuses on early detection of preventable oncological diseases, such as prostate cancer. This test is available to men once every three years starting at age 40. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "prostate",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/preventivna-urologicka-prehliadka-muzov-od-40-rokov.html"
              },
              {
                "type": "Comprehensive treatment of morbid obesity",
                "benefit": "Free comprehensive treatment for patients with morbid obesity",
                "description": "For our clients with morbid obesity, we cover comprehensive treatment that includes not only\nsurgery, but also treatment by a psychologist and other specialists. More information (in Slovak\nonly) is available on the insurance company's website here: link.",
                "icon": "weight",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/komplexna-liecba-morbidnej-obezity.html"
              },
              {
                "type": "Flu vaccination",
                "benefit": "Coverage of the full price of flu vaccines",
                "description": "Flu vaccination is an effective form of prevention that helps protect against serious complications of this disease. It is available to all VZP policyholders entitled to full healthcare. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/ockovanie-proti-chripke.html"
              },
              {
                "type": "Setting up a diabetic patient for an insulin pump in an outpatient clinic",
                "benefit": "Free installation of an insulin pump on an outpatient basis",
                "description": "The patient will receive several hours of training, will be prepared for pump use, and will obtain all information necessary for practical living with this medical device. They will leave the clinic with a functional pump, an implanted sensor, and an application in their smartphone. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "diabetes",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/nastavenie-diabetika-inzulinovu-pumpu-vambulancii.html"
              },
              {
                "type": "ECG test as part of a preventive check-up starting at age 40",
                "benefit": "An ECG test performed by a GP as part of a preventive check-up",
                "description": "An ECG test belongs among the basic examination methods used to detect the risk of stroke. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "heart-attack",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/ekg-vysetrenie-ako-sucast-preventivnej-prehliadky-od-40-rokov.html"
              },
              {
                "type": "Mental health test for early detection of memory disorders",
                "benefit": "Free MoCA (Montreal Cognitive Assessment) test for patients over 60 years of age",
                "description": "A MoCA test helps detect problems in their early stages. This test can be performed by your GP and is covered for patients over the age of 60. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/test-mentalneho-zdravia-skore-odhalenie-poruch-spamatou.html"
              },
              {
                "type": "Covid-19 vs. flu testing",
                "benefit": "A free complete differential diagnosis",
                "description": "The symptoms of Covid-19 are practically identical to flu symptoms. The advantage of this diagnosis is early and effective treatment of a patient with respiratory problems. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "danger",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/testovanie-covid-19-versus-chripka.html"
              },
              {
                "type": "Self-collection tests",
                "benefit": "Special self-collection tests with a EUR 5 discount",
                "description": "Special self-collection tests with a discount of EUR 5. With the self-test, you will receive results from a certified laboratory within 10 days of sending the sample. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "bloodtest",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/ziskajte-kontrolu-nad-vlastnym-zdravim-vdaka-medistom.html"
              },
              {
                "type": "Gluten-free foods YAMIS",
                "benefit": "YAMIS gluten-free food with a 10% discount",
                "description": "Visit the YAMIS e-shop and discover a wide range of high-quality gluten-free foods suitable for people with gluten intolerance and for supporters of a healthy lifestyle. Take advantage of a 10% discount and shop comfortably online. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "gluten",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/potraviny-bez-lepku-yamis.html"
              },
              {
                "type": "Introductory DIA FIT consultation and diet plan",
                "benefit": "Free initial consultation and DIA FIT diet plan for clients with diabetes",
                "description": "A healthy diet and exercise are key in diabetes. The DIA FIT program offers VšZP policyholders the opportunity to undergo an initial consultation and an individual diet completely free of charge, under the guidance of personal trainer Martin Tkáč, who has been active in sports and lives with diabetes for 27 years. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "zdravy-talir",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/konzultacia-jedalnicek-diafit-programu-diabetikov.html"
              },
              {
                "type": "Accident and life insurance SPIRIT at ČSOB",
                "benefit": "SPIRIT accident and life insurance at ČSOB with a 15% discount",
                "description": "SPIRIT accident and life insurance at ČSOB with a 15% discount. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "shield",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/poistenie-urazu-zivota-spirit-csob.html"
              },
              {
                "type": "Discount on medicines, nutritional supplements, and cosmetics",
                "benefit": "Up to 15% discount on medicines, nutritional supplements, and cosmetics",
                "description": "You can purchase over-the-counter medications, nutritional supplements, and even cosmetics on-line. Lieky24.sk is a trusted e-shop with a broad range of products, offering free shipping with guaranteed quick delivery. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "pill",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/e-shop-lieky24-sk.html"
              },
              {
                "type": "Wisdom tooth extraction and other dental procedures with discounts ",
                "benefit": "Wisdom tooth extraction and other dental procedures with discounts of up to 50%",
                "description": "Wisdom tooth extraction and other dental procedures with discounts of up to 50%. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "tooth",
                "url": "https://www.vszp.sk/benefity/?checked0=494&docId=6949&count=20"
              },
              {
                "type": "More benefits and discounts for all",
                "benefit": "Benefits for the whole family",
                "description": "Take advantage of more benefits and discounts offered by your insurer. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "payment",
                "url": "https://www.vszp.sk/benefity/?"
              }
            ]
          },
          {
            "name": "Women",
            "benefitsCount": "24",
            "benefits": [
              {
                "type": "Invisible braces",
                "benefit": "A 22 % discount on invisible braces",
                "description": "Up to 22% discount on invisible braces + Dental monitoring at Family Dental Care - Ortho. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "tooth",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/zlava-neviditelny-zubny-strojcek-vo-family-dental-care-ortho.html"
              },
              {
                "type": "Discount on glasses",
                "benefit": "Up to 35% discount on glasses at selected branches",
                "description": "Up to 35% discount on glasses at selected branches. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "glasses",
                "url": "https://www.vszp.sk/benefity/?dospeli&checked0=490"
              },
              {
                "type": "Proton treatment for cancer patients",
                "benefit": "Treatment covered by insurance",
                "description": "Proton treatment is used primarily for tumours of the brain, head, and neck (tumours of the eye, nasal passages, parotid glands), tumours of the breast, prostate, and pancreas, and tumours in children. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "ribbon",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/protonova-liecba-onkologickych-pacientov.html"
              },
              {
                "type": "Occult bleeding test",
                "benefit": "An occult bleeding test starting at age 40 for free",
                "description": "A preventive examination that focuses on detecting hidden bleeding in the stool, which can help in early detection of colon and anal cancer. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "rectum",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/test-okultne-krvacanie-od-40-rokov-zdarma.html"
              },
              {
                "type": "Stroke Risk Assessment",
                "benefit": "Examination covered by insurance",
                "description": "Risk assessment for stroke covered by insurance. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "brain",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/vysetrenie-rizika-vzniku-cievnej-mozgovej-prihody.html"
              },
              {
                "type": "Ankle Brachial Index (ABI Test) - measurement of the ratio of blood pressure in the arms and legs",
                "benefit": "We pay for this test once every two years during a preventive check-up",
                "description": "This test plays an important part in the early diagnosis of peripheral vascular disease, and predicts the likelihood of heart attacks or strokes. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "heart-attack",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/stanovenie-pomeru-krvneho-tlaku-nohe-aruke-abi-index.html"
              },
              {
                "type": "Treatment of patients with high blood pressure by a general practitioner",
                "benefit": "Care provided directly by a GP",
                "description": "The patient doesn't need to wait for or make an appointment with a specialist; their GP will arrange diagnosis and treatment of selected groups of patients with hypertension. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "heart-attack",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/starostlivost-opacientov-svysokym-krvnym-tlakom-vambulancii-vseobecneho-lekara.html"
              },
              {
                "type": "Diagnosis and treatment of fat metabolism disorders by a general practitioner",
                "benefit": "Care provided directly by a GP",
                "description": "General practitioners also provide our clients with diagnosis and treatment of fat metabolism disorders without the need to make an appointment with a specialist. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "blood-fat",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/diagnostika-aliecbaporuchy-metabolizmu-tukov-vseobecneho-lekara.html"
              },
              {
                "type": "Comprehensive treatment of morbid obesity",
                "benefit": "Free comprehensive treatment for patients with morbid obesity",
                "description": "For our clients with morbid obesity, we cover comprehensive treatment that includes not only\nsurgery, but also treatment by a psychologist and other specialists. More information (in Slovak\nonly) is available on the insurance company's website here: link.",
                "icon": "weight",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/komplexna-liecba-morbidnej-obezity.html"
              },
              {
                "type": "Flu vaccination",
                "benefit": "Coverage of the full price of flu vaccines",
                "description": "Flu vaccination is an effective form of prevention that helps protect against serious complications of this disease. It is available to all VZP policyholders entitled to full healthcare. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/ockovanie-proti-chripke.html"
              },
              {
                "type": "Flu vaccination for pregnant",
                "benefit": "Coverage of the full price of flu vaccines",
                "description": "Flu contracted during pregnancy can seriously endanger the baby. Pregnant women insured by VšZP no longer need to visit a general practitioner for vaccination; upon request, their gynecologist will also vaccinate them against flu during a routine check-up. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/ockovanie-proti-chripke-tehotne.html"
              },
              {
                "type": "Setting up a diabetic patient for an insulin pump in an outpatient clinic",
                "benefit": "Free installation of an insulin pump on an outpatient basis",
                "description": "The patient will receive several hours of training, will be prepared for pump use, and will obtain all information necessary for practical living with this medical device. They will leave the clinic with a functional pump, an implanted sensor, and an application in their smartphone. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "diabetes",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/nastavenie-diabetika-inzulinovu-pumpu-vambulancii.html"
              },
              {
                "type": "ECG test as part of a preventive check-up starting at age 40",
                "benefit": "An ECG test performed by a GP as part of a preventive check-up",
                "description": "An ECG test belongs among the basic examination methods used to detect the risk of stroke. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "heart-attack",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/ekg-vysetrenie-ako-sucast-preventivnej-prehliadky-od-40-rokov.html"
              },
              {
                "type": "Mental health test for early detection of memory disorders",
                "benefit": "Free MoCA (Montreal Cognitive Assessment) test for patients over 60 years of age",
                "description": "A MoCA test helps detect problems in their early stages. This test can be performed by your GP and is covered for patients over the age of 60. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "happy",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/test-mentalneho-zdravia-skore-odhalenie-poruch-spamatou.html"
              },
              {
                "type": "Covid-19 vs. flu testing",
                "benefit": "A free complete differential diagnosis",
                "description": "The symptoms of Covid-19 are practically identical to flu symptoms. The advantage of this diagnosis is early and effective treatment of a patient with respiratory problems. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "danger",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/testovanie-covid-19-versus-chripka.html"
              },
              {
                "type": "Self-collection tests",
                "benefit": "Special self-collection tests with a EUR 5 discount",
                "description": "Special self-collection tests with a discount of EUR 5. With the self-test, you will receive results from a certified laboratory within 10 days of sending the sample. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "bloodtest",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/ziskajte-kontrolu-nad-vlastnym-zdravim-vdaka-medistom.html"
              },
              {
                "type": "Gluten-free foods YAMIS",
                "benefit": "YAMIS gluten-free food with a 10% discount",
                "description": "Visit the YAMIS e-shop and discover a wide range of high-quality gluten-free foods suitable for people with gluten intolerance and for supporters of a healthy lifestyle. Take advantage of a 10% discount and shop comfortably online. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "gluten",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/potraviny-bez-lepku-yamis.html"
              },
              {
                "type": "Introductory DIA FIT consultation and diet plan",
                "benefit": "Free initial consultation and DIA FIT diet plan for clients with diabetes",
                "description": "A healthy diet and exercise are key in diabetes. The DIA FIT program offers VšZP policyholders the opportunity to undergo an initial consultation and an individual diet completely free of charge, under the guidance of personal trainer Martin Tkáč, who has been active in sports and lives with diabetes for 27 years. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "zdravy-talir",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/konzultacia-jedalnicek-diafit-programu-diabetikov.html"
              },
              {
                "type": "Accident and life insurance SPIRIT at ČSOB",
                "benefit": "SPIRIT accident and life insurance at ČSOB with a 15% discount",
                "description": "SPIRIT accident and life insurance at ČSOB with a 15% discount. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "shield",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/poistenie-urazu-zivota-spirit-csob.html"
              },
              {
                "type": "Discount on medicines, nutritional supplements, and cosmetics",
                "benefit": "Up to 15% discount on medicines, nutritional supplements, and cosmetics",
                "description": "You can purchase over-the-counter medications, nutritional supplements, and even cosmetics on-line. Lieky24.sk is a trusted e-shop with a broad range of products, offering free shipping with guaranteed quick delivery. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "pill",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/e-shop-lieky24-sk.html"
              },
              {
                "type": "Wisdom tooth extraction and other dental procedures with discounts ",
                "benefit": "Wisdom tooth extraction and other dental procedures with discounts of up to 50%",
                "description": "Wisdom tooth extraction and other dental procedures with discounts of up to 50%. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "tooth",
                "url": "https://www.vszp.sk/benefity/?checked0=494&docId=6949&count=20"
              },
              {
                "type": "More benefits and discounts for all",
                "benefit": "Benefits for the whole family",
                "description": "Take advantage of more benefits and discounts offered by your insurer. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "payment",
                "url": "https://www.vszp.sk/benefity/?"
              },
              {
                "type": "Fourth ultrasound examination for pregnant women",
                "benefit": "A free fourth ultrasound examination",
                "description": "Female VšZP clients will receive a free fourth ultrasound examination from us, over and above public health insurance. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "pregnant",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/stvrte-sonograficke-vysetrenie-tehotne.html"
              },
              {
                "type": "Prenatal and postnatal counseling",
                "benefit": "Free prenatal, postnatal, and lactation counseling",
                "description": "Free prenatal, postnatal, and lactation counseling available to new mothers five days a week. \nFor more information, visit the health insurance company’s website here: link.",
                "icon": "pregnant",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/bezplatne-predporodne-poporodne-poradenstvo.html"
              }
            ]
          },
          {
            "benefits": [
              {
                "type": "Invisible braces",
                "benefit": "A 22 % discount on invisible braces",
                "description": "Up to 22% discount on invisible braces + Dental monitoring at Family Dental Care - Ortho. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "tooth",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/zlava-neviditelny-zubny-strojcek-vo-family-dental-care-ortho.html"
              },
              {
                "type": "Wisdom tooth extraction and other dental procedures with discounts",
                "benefit": "Wisdom tooth extraction and other dental procedures with discounts of up to 50%",
                "description": "Wisdom tooth extraction and other dental procedures with discounts of up to 50%. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "tooth",
                "url": "https://www.vszp.sk/benefity/?checked0=494&docId=6949&count=20"
              },
              {
                "type": "At the dentist gently and painlessly",
                "benefit": "We cover anesthesia for children under 10 years of age.",
                "description": "Local anesthesia is intended for all children under 10 years of age, and can also be used for younger children. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "tooth",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/u-zubara-bez-bolesti-hradime-anesteziu-detom-do-10-rokov.html"
              },
              {
                "type": "Proton treatment for cancer patients",
                "benefit": "Treatment covered by insurance",
                "description": "Proton treatment is used primarily for tumours of the brain, head, and neck (tumours of the eye, nasal passages, parotid glands), tumours of the breast, prostate, and pancreas, and tumours in children. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "ribbon",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/protonova-liecba-onkologickych-pacientov.html"
              },
              {
                "type": "Comprehensive initial dental examination with X-ray and OPG image",
                "benefit": "Covered by insurance",
                "description": "Comprehensive initial dental examination with X-ray and OPG image covered by insurance. More information (in Slovak only) is available on the insurance company's website here: link. ",
                "icon": "tooth",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/komplexne-vstupne-stomatologicke-vysetrenie-rontgenovou-opg-snimkou.html"
              },
              {
                "icon": "gluten",
                "type": "Gluten-free foods YAMIS",
                "benefit": "YAMIS gluten-free food with a 10% discount",
                "description": "Visit the YAMIS e-shop and discover a wide range of high-quality gluten-free foods suitable for people with gluten intolerance and for supporters of a healthy lifestyle. Take advantage of a 10% discount and shop comfortably online. More information (in Slovak only) is available on the insurance company's website here: link.",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/potraviny-bez-lepku-yamis.html"
              },
              {
                "type": "Introductory DIA FIT consultation and diet plan",
                "benefit": "Free initial consultation and DIA FIT diet plan for clients with diabetes",
                "description": "A healthy diet and exercise are key in diabetes. The DIA FIT program offers VšZP policyholders the opportunity to undergo an initial consultation and an individual diet completely free of charge, under the guidance of personal trainer Martin Tkáč, who has been active in sports and lives with diabetes for 27 years. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "zdravy-talir",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/konzultacia-jedalnicek-diafit-programu-diabetikov.html"
              },
              {
                "type": "Discount on glasses",
                "benefit": "Up to 35% discount on glasses at selected branches",
                "description": "Up to 35% discount on glasses at selected branches. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "glasses",
                "url": "https://www.vszp.sk/benefity/?dospeli&checked0=490"
              },
              {
                "type": "Support for obesity prevention and obesity management in children",
                "benefit": "Free obesity prevention support",
                "description": "The goal of prevention support is early detection of risk factors for various diseases that is not routinely covered by public health insurance. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "care",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/podpora-prevencie-obezity-amanazovanie-obezity-udeti.html"
              },
              {
                "type": "Treatment of eating disorders in children",
                "benefit": "Free treatment at a specialized facility",
                "description": "This treatment is intended for children up to the age of 18 with serious cases of anorexia and bulimia that cannot be treated on an outpatient basis. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "nutrition",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/liecba-poruch-prijmu-potravy-deti-nad-ramec-zdravotneho-poistenia.html"
              },
              {
                "type": "Setting up a diabetic patient for an insulin pump in an outpatient clinic",
                "benefit": "Free installation of an insulin pump on an outpatient basis",
                "description": "The patient will receive several hours of training, will be prepared for pump use, and will obtain all information necessary for practical living with this medical device. They will leave the clinic with a functional pump, an implanted sensor, and an application in their smartphone. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "diabetes",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/nastavenie-diabetika-inzulinovu-pumpu-vambulancii.html"
              },
              {
                "type": "A gift box full of surprises for newborns",
                "benefit": "A gift box for babies",
                "description": "In most maternity hospitals in Slovakia, mothers will receive a free gift box. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "birth",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/balicek-novorodencov-plny-prekvapen.html"
              },
              {
                "type": "Flu vaccination",
                "benefit": "Coverage of the full price of flu vaccines",
                "description": "Flu vaccination is an effective form of prevention that helps protect against serious complications of this disease. It is available to all VZP policyholders entitled to full healthcare. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "vaccine",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/ockovanie-proti-chripke.html"
              },
              {
                "type": "More benefits and discounts for all",
                "benefit": "Benefits for the whole family",
                "description": "Take advantage of more benefits and discounts offered by your insurer. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "payment",
                "url": "https://www.vszp.sk/benefity/?"
              },
              {
                "type": "Discount on medicines, nutritional supplements, and cosmetics",
                "benefit": "Up to 15% discount on medicines, nutritional supplements, and cosmetics",
                "description": "You can purchase over-the-counter medications, nutritional supplements, and even cosmetics on-line. Lieky24.sk is a trusted e-shop with a broad range of products, offering free shipping with guaranteed quick delivery. More information (in Slovak only) is available on the insurance company's website here: link.",
                "icon": "pill",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/e-shop-lieky24-sk.html"
              },
              {
                "description": "The symptoms of Covid-19 are practically identical to flu symptoms. The advantage of this diagnosis is early and effective treatment of a patient with respiratory problems. More information (in Slovak only) is available on the insurance company's website here: link.",
                "type": "Covid-19 vs. flu testing",
                "benefit": "A free complete differential diagnosis",
                "icon": "danger",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/testovanie-covid-19-versus-chripka.html"
              }
            ],
            "name": "Children",
            "benefitsCount": "16"
          }
        ],
        "slug": "vzp-sk",
        "updateDate": "3.2.2026",
        "companyBenefitsLink": "https://www.vszp.sk/benefity/",
        "gendersCount": "3"
      }
    ]
  },
  "deleteAccount": {
    "checkPasswordCard": {
      "confirmButton": "Delete account",
      "cancelButton": "Back"
    }
  },
  "onboarding": {
    "slide": [
      {
        "title": "Doctor's Opinion 24/7",
        "text": "Ask online, wherever you are. General practitioners and pediatricians respond day and night.",
        "img": "onboarding/slide-1.png"
      },
      {
        "title": "Specialists Across All Fields",
        "text": "350+ doctors across specialties. When your condition requires a specialist, we'll connect you with the right one.",
        "img": "onboarding/slide-2.png"
      },
      {
        "title": "Prevention Under Control",
        "text": "Your health. From head to toe.<br/>Checkup calendar, doctor tips, and online<br/>tests all in one place.",
        "img": "onboarding/slide-3.png"
      },
      {
        "title": "Health at Your Fingertips",
        "text": "We'll notify you of doctor responses and new health tips so you never miss a thing.",
        "img": "onboarding/slide-4.png"
      }
    ],
    "cta": "Continue",
    "skip": "Skip",
    "start": "Start using the app",
    "ctaNotifications": "Enable Notifications"
  },
  "onobarding": {
    "ctaNotifications": "Turn on Notifications"
  },
  "selectRegion": "Select region",
  "infoPages": {
    "notFound": {
      "title": "Page not found",
      "text": "Sorry, this page is not available."
    }
  }
}